// This is auto generated and will be overwritten. Do not make changes in this file

export enum AccountOwnerType {
    USER = 'USER',
    CUSTOMER = 'CUSTOMER',
    SYSTEM = 'SYSTEM'
}
export enum TransactionFlow {
    INFLOW = 'INFLOW',
    OUTFLOW = 'OUTFLOW'
}
export enum TransactionCategory {
    SALES_RECEIPT = 'SALES_RECEIPT',
    SALES_REFUND = 'SALES_REFUND',
    DEBT_PAYMENT = 'DEBT_PAYMENT',
    LOAN_PAYMENT = 'LOAN_PAYMENT',
    LOAN_GIVEN = 'LOAN_GIVEN',
    TRANSFER_IN = 'TRANSFER_IN',
    TRANSFER_OUT = 'TRANSFER_OUT',
    INVESTMENT = 'INVESTMENT',
    DIVIDEND = 'DIVIDEND',
    SUPPLIER_PAYMENT = 'SUPPLIER_PAYMENT',
    SUPPLIER_REFUND = 'SUPPLIER_REFUND',
    EXPENSE = 'EXPENSE',
    CORRECTION = 'CORRECTION',
    OPENING_CORRECTION = 'OPENING_CORRECTION',
    CLOSING_CORRECTION = 'CLOSING_CORRECTION',
    DEBT_PAYMENT_REVERSAL = 'DEBT_PAYMENT_REVERSAL',
    LOAN_PAYMENT_REVERSAL = 'LOAN_PAYMENT_REVERSAL',
    LOAN_GIVEN_REVERSAL = 'LOAN_GIVEN_REVERSAL',
    EXPENSE_REVERSAL = 'EXPENSE_REVERSAL',
    DIVIDEND_REVERSAL = 'DIVIDEND_REVERSAL',
    INVESTMENT_REVERSAL = 'INVESTMENT_REVERSAL'
}
export interface StoreSnapshotsResult {
    at_time: string;
    snapshots: AccountSnapshotsByPaymentMethod[];
}
export interface CommentRef {
    comment_id: string;
    body: string;
    commenter: PersonRef;
    created_at: string;
}
export interface OriginEntityRef {
    entity_type: string;
    entity_id: string;
    description?: string;
    /**
     * Optional free-form key/value metadata for the origin entity. Used to
     * thread extra machine-readable identifiers (e.g. `debt_id` on a
     * DEBT_PAYMENT-origined transaction) without overloading `entity_id`.
     */
    metadata?: Record<string, string>;
}
export interface PersonRef {
    id: string;
    type: AccountOwnerType;
    name?: string;
    note?: string;
}
export interface AccountTransaction extends Timestamps {
    account_id: string;
    owner: PersonRef;
    merchant_id: string;
    store_id: string;
    shift_id?: string;
    flow: TransactionFlow;
    category: TransactionCategory;
    payment_type: PaymentMethodType;
    payment_method_id: string;
    payment_method_metadata?: Record<string, any>;
    origin_entity?: OriginEntityRef;
    creator: PersonRef;
    approver?: PersonRef | null;
    forced?: boolean;
    without_consent?: boolean;
    amount: number;
    currency: Currency;
    comments?: CommentRef[];
    approved_at?: string | null;
    involved_parties?: PersonRef[];
    version: number;
    reverses_transaction_id?: string;
    reversed_by_transaction_id?: string;
    reversal_reason?: string;
}
export interface AccountSnapshotDBItem extends AccountSnapshot {
    /**
     * Main table keys
     * Partitioned by merchant + store for natural "by store" queries.
     */
    PK: string;
    SK: string;
    GSI1PK: string;
    GSI1SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}
export interface AccountTransactionDBItem extends AccountTransaction {
    PK: string;
    SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
    GSI1PK: string;
    GSI1SK: string;
    GSI2PK?: string;
    GSI2SK?: string;
    GSI3PK: string;
    GSI3SK: string;
    GSI4PK?: string;
    GSI4SK?: string;
    GSI5PK?: string;
    GSI5SK?: string;
    GSI6PK?: string;
    GSI6SK?: string;
    GSI7PK?: string;
    GSI7SK?: string;
}
export interface SummaryByPaymentMethod {
    payment_type: PaymentMethodType;
    payment_method_id: string;
    total_inflow: number;
    total_outflow: number;
    net_amount: number;
}
export interface AccountTransactionChangeSummary {
    items: AccountTransaction[];
    summary: SummaryByPaymentMethod[];
    cursor?: string;
    count?: number;
    /**
     * Partner transactions resolved for items that carry a reversal link
     * (`reverses_transaction_id` or `reversed_by_transaction_id`) whose
     * counterpart is not already included in `items`.
     */
    reversals?: AccountTransaction[];
}
export interface AccountSnapshotBalances {
    [payment_type: string]: {
        [payment_method_id: string]: number;
    };
}
export interface AccountSnapshot extends Timestamps {
    account_id: string;
    amount: number;
    created_by: 'SYSTEM' | string;
    version: number;
    store_id: string;
    merchant_id: string;
    payment_type: PaymentMethodType;
    payment_method_id: string;
}
export interface AccountSnapshotsByPaymentMethod {
    account_id: string;
    merchant_id: string;
    store_id: string;
    created_at: string;
    account_snapshots: AccountSnapshot[];
}
export type BalancesByPaymentMethod = {
    [payment_method_id: string]: number;
};
export type StoreSnapshots = {
    [account_id: string]: AccountSnapshotsByPaymentMethod[];
};
export interface TransferApproval {
    transfer_id: string;
    approver: PersonRef;
    approved_at: string;
    notes?: string;
    transferer_owner?: PersonRef;
    transferee_owner?: PersonRef;
    currency?: Currency;
    shift_id?: string;
}
export interface TransferAudit {
    status: TransferStatus;
    created_at: string;
    actor?: PersonRef;
    notes?: string;
}
export enum TransferStatus {
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    CANCELLED = 'CANCELLED'
}
export interface TransferRequest extends Timestamps, Versioned {
    transfer_id: string;
    merchant_id: string;
    store_id: string;
    transferer_account_id: string;
    transferee_account_id: string;
    amount: number;
    payment_type: PaymentMethodType;
    payment_method_id: string;
    status: TransferStatus;
    forced?: boolean;
    without_consent?: boolean;
    approvals: TransferApproval[];
    rejection_reason?: string;
    shift_id?: string;
    currency: Currency;
    transferer_owner?: PersonRef;
    transferee_owner?: PersonRef;
    creator?: PersonRef;
    audit_history?: TransferAudit[];
    comments?: CommentRef[];
    /**
     * Set while an approval moves the money (claimed while PENDING, removed
     * when it is APPROVED), so a second approval, a reject or a cancel
     * cannot run at the same time. Optional; missing = not claimed.
     */
    approval_claimed_at?: string | null;
    approval_claimed_by_id?: string | null;
}
export interface CreateTransferRequest {
    merchant_id: string;
    store_id: string;
    transferer_account_id: string;
    transferee_account_id: string;
    amount: number;
    payment_type: PaymentMethodType;
    payment_method_id: string;
    forced?: boolean;
    without_consent?: boolean;
    shift_id?: string;
    currency: Currency;
    transferer_owner: PersonRef;
    transferee_owner: PersonRef;
    creator: PersonRef;
    approver?: PersonRef;
}
export interface TransactionIngestEvent {
    source_system: string;
    source_reference: string;
    payload: AccountTransaction;
}
export interface TransferEvent {
    source_system: string;
    transfer: TransferRequest;
}
export interface SnapshotRequestEvent {
    account_id: string;
    trigger: 'AUTO' | 'MANUAL';
}
export interface TransferRequestDBItem extends TransferRequest {
    /** --------------
     * MAIN TABLE KEYS
     * --------------*/
    PK: string;
    // PK: MERCHANT#<merchant_id>#STORE#<store_id>
    SK: string;
    // SK: TRANSFER#DATE#<created_at>#TRANSFER#<transfer_id>
    /** --------------
     * ENTITY INDEX (optional; for full scans by entity type)
     * --------------*/
    EntityIndexPK: string;
    // EntityIndexPK: TRANSFER
    EntityIndexSK: string;
    // EntityIndexSK: MERCHANT#<merchant_id>#STORE#<store_id>#DATE#<created_at>#TRANSFER#<transfer_id>
    /** --------------
     * GSI1 — BY TRANSFERER (with date sorting)
     * --------------*/
    GSI1PK: string;
    // GSI1PK: TRANSFERER#<transferer_account_id>
    GSI1SK: string;
    // GSI1SK: DATE#<created_at>#MERCHANT#<merchant_id>#STORE#<store_id>#TRANSFER#<transfer_id>
    /** --------------
     * GSI2 — BY TRANSFEREE (with date sorting)
     * --------------*/
    GSI2PK: string;
    // GSI2PK: TRANSFEREE#<transferee_account_id>
    GSI2SK: string;
    // GSI2SK: DATE#<created_at>#MERCHANT#<merchant_id>#STORE#<store_id>#TRANSFER#<transfer_id>
    /** --------------
     * GSI3 — BY STATUS (PENDING, APPROVED, etc.)
     * --------------*/
    GSI3PK: string;
    // GSI3PK: STATUS#<status>
    GSI3SK: string;
}
export interface ListAccountTransactionsBase {
    cursor?: string;
    limit?: number;
    start_date?: string;
    end_date?: string;
}
export interface ListAccountTransactionsByStore extends ListAccountTransactionsBase {
    merchant_id: string;
    store_id: string;
}
export interface ListAccountTransactionsByOwner extends ListAccountTransactionsBase {
    owner_id: string;
    owner_type: AccountOwnerType;
}
export interface ListAccountTransactionsByShift extends ListAccountTransactionsBase {
    shift_id: string;
}
export interface AccountTransactionsPage {
    items: AccountTransaction[];
    cursor?: string;
    count?: number;
}
export interface CreateAccountTransaction {
    account_id: string;
    owner: PersonRef;
    merchant_id: string;
    store_id: string;
    shift_id?: string;
    flow: TransactionFlow;
    category: TransactionCategory;
    payment_type: PaymentMethodType;
    payment_method_id: string;
    payment_method_metadata?: Record<string, any>;
    origin_entity?: OriginEntityRef;
    creator: PersonRef;
    approver?: PersonRef | null;
    forced?: boolean;
    without_consent?: boolean;
    amount: number;
    currency: Currency;
    comments?: CommentRef[];
    approved_at?: string | null;
    involved_parties?: PersonRef[];
    reverses_transaction_id?: string;
    reversal_reason?: string;
}
export interface GetAccountsByStore {
    merchant_id: string;
    store_id: string;
    start_date?: string;
    end_date?: string;
    cursor?: string;
    limit?: number;
}
export interface GetAccountsByOwner {
    owner_id: string;
    owner_type: AccountOwnerType;
    start_date?: string;
    end_date?: string;
    cursor?: string;
    limit?: number;
}
export interface GetAccountsByShift {
    shift_id: string;
    start_date?: string;
    end_date?: string;
    cursor?: string;
    limit?: number;
}
export interface GetAccountsByAccount {
    account_id: string;
    store_id: string;
    start_date?: string;
    end_date?: string;
    cursor?: string;
    limit?: number;
}
export interface GetTransfers {
    merchant_id: string;
    store_id: string;
    transferer_id?: string;
    transferee_id?: string;
    status?: TransferStatus;
    date_from?: string;
    date_to?: string;
    cursor?: string;
    limit?: number;
}
export interface RejectTransferRequest {
    transfer_id: string;
    reason: string;
    actor: PersonRef;
    shift_id?: string;
}
export interface CancelTransferRequest {
    transfer_id: string;
    reason: string;
    actor: PersonRef;
    shift_id?: string;
}
export interface ReverseLoanGivenRequest {
    merchant_id: string;
    store_id: string;
    debt_id: string;
    creator: PersonRef;
    owner?: PersonRef;
    shift_id?: string;
    reason: string;
    currency?: Currency;
}
/**
 * Generic request to reverse any previously recorded AccountTransaction.
 * The original transaction is located by its composite key:
 * (account_id, payment_type, payment_method_id, store_id, version).
 * The reversal category is derived automatically from the original category.
 */
export interface ReverseAccountTransactionRequest {
    merchant_id: string;
    store_id: string;
    account_id: string;
    payment_type: PaymentMethodType;
    payment_method_id: string;
    version: number;
    creator: PersonRef;
    shift_id?: string;
    reason: string;
}
export interface ReverseDebtPaymentTransactionRequest {
    merchant_id: string;
    store_id: string;
    payment_id: string;
    debt_id: string;
    creator: PersonRef;
    shift_id?: string;
    reason: string;
}

// =============================================================================
// Shared request/response types for the Admin Dashboard aggregated endpoints.
// Used by both frontend (web-app-admin) and backend (service-reports).
// =============================================================================
// ---------------------------------------------------------------------------
// Store Time Series
// ---------------------------------------------------------------------------
export type TimeSeriesInterval = 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
export interface GetStoreTimeSeriesRequest {
    merchant_id: string;
    store_id: string;
    from: string;
    to: string;
    interval: TimeSeriesInterval;
}
export interface TimeSeriesPoint {
    label: string;
    start: string;
    end: string;
    receiptCount: number;
    transactionCount: number;
    inventoryCount: number;
    inventoryCountCorrections: number;
    inventoryValueEnd: number;
    purchaseOrderCount: number;
    debtCount: number;
    totalDebtsOutstanding: number;
    grossSales: number;
    netSales: number;
    expenses: number;
    moneyEnd: number;
}
// ---------------------------------------------------------------------------
// Store Payments
// ---------------------------------------------------------------------------
export type AgreementFilter = 'all' | 'has_agreement' | 'no_agreement';
export interface GetStorePaymentsRequest {
    agreement_filter?: AgreementFilter;
    sort_field?: string;
    sort_direction?: 'asc' | 'desc';
    merchant_ids?: string;
}
export interface StorePaymentRow {
    storeId: string;
    storeName: string;
    merchantId: string;
    storeCreatedAt: string;
    hasAgreement: boolean;
    agreementType: string | null;
    agreementStatus: CustomerAgreementStatus | null;
    nextPaymentDate: string | null;
    totalPaid: number;
    totalPending: number;
    totalOverdue: number;
    walletBalance: number;
    currency: string;
    /**
     * Per-currency sums. Invoices retained across an agreement-currency
     * change and wallet snapshots can span currencies, so the scalar totals
     * above are cross-currency sums — render these maps when present.
     */
    totalPaidByCurrency?: Record<string, number>;
    totalPendingByCurrency?: Record<string, number>;
    totalOverdueByCurrency?: Record<string, number>;
    walletBalanceByCurrency?: Record<string, number>;
    invoiceCount: number;
    overdueInvoiceCount: number;
    failedInvoiceCount: number;
}
export interface StorePaymentsResponse {
    rows: (StorePaymentRow | null)[];
    total: number;
}
// ---------------------------------------------------------------------------
// Store Activity
// ---------------------------------------------------------------------------
export type ActivityFilter = 'no_sales' | 'sales' | 'all_sales' | 'no_transactions' | 'transactions' | 'all_transactions';
export interface GetStoreActivityRequest {
    from: string;
    to: string;
    filter?: ActivityFilter;
    relative_from?: string;
    relative_to?: string;
    merchant_ids?: string;
}
export interface StoreActivityRow {
    storeId: string;
    storeName: string;
    merchantId: string;
    merchantName: string;
    merchantPhone: string | null;
    storeCreatedAt: string;
    receiptCount: number;
    transactionCount: number;
    inventoryCount: number;
    inventoryCountCorrections: number;
    inventoryValueEnd: number;
    purchaseOrderCount: number;
    debtCount: number;
    totalDebtsOutstanding: number;
    grossSales: number;
    netSales: number;
    expenses: number;
    moneyEnd: number;
    currency: string;
}
export interface StoreActivityResponse {
    rows: (StoreActivityRow | null)[];
    total: number;
    filtered: number;
    currency: string;
}
// ---------------------------------------------------------------------------
// Platform Metrics
// ---------------------------------------------------------------------------
export interface GetPlatformMetricsRequest {
    from?: string;
    to?: string;
}
export interface PlatformMetricsResponse {
    // Invoice / billing
    /** The dominant invoice currency (largest billed total); every AR
     *  figure in this response is computed over that currency's invoices
     *  only, and every GMV figure over stores whose resolved display
     *  currency matches it. */
    currency: string;
    /** Billed totals of invoices in OTHER currencies, excluded from the
     *  figures above rather than silently mixed into mislabeled sums. */
    excludedBilledByCurrency?: Record<string, number>;
    /** Gross sales of stores selling in OTHER currencies, excluded from
     *  the GMV figures the same way. Receipt and active-store counts stay
     *  platform-wide — they carry no monetary unit. */
    excludedGmvByCurrency?: Record<string, number>;
    billedTrailing30d: number;
    billedTrailing12m: number;
    collectedTrailing30d: number;
    collectionRatePct90d: number | null;
    momGrowthPct: number | null;
    arOutstanding: number;
    arOverdue: number;
    failedInvoiceCount: number;
    failedInvoiceAmount: number;
    monthlyRevenue: Array<{
        month: string;
        billed: number;
        collected: number;
    }>;
    arAging: Array<{
        bucket: string;
        amount: number;
    }>;
    // AR detail
    billedThisMonth: number;
    collectedThisMonth: number;
    totalOutstanding: number;
    totalOverdue: number;
    pendingInvoiceCount: number;
    dso: number | null;
    avgDaysToPay: number | null;
    monthlyAr: Array<{
        month: string;
        billed: number;
        collected: number;
        outstanding: number;
    }>;
    expectedByMonth: Array<{
        month: string;
        amount: number;
        invoiceCount: number;
    }>;
    storeRows: PlatformStoreArRow[];
    // Sales
    gmvThisMonth: number;
    gmvTrailing12m: number;
    activeStoresThisMonth: number;
    receiptsTrailing12m: number;
    failedStores: number;
    activationRatePct: number | null;
    activatedStores: number;
    activationEligibleStores: number;
    monthlySales: Array<{
        month: string;
        gmv: number;
        receipts: number;
        activeStores: number;
    }>;
    // Agreements
    activeAgreements: number;
    payingStores: number;
    freeStores: number;
    payingSharePct: number | null;
    churnRateLastMonthPct: number | null;
    monthlyChurn: Array<{
        month: string;
        churned: number;
        activeAtStart: number;
        churnRatePct: number | null;
    }>;
    // Registry
    totalMerchants: number;
    totalStores: number;
    totalUsers: number;
    monthlyJoiningTrends: Array<{
        month: string;
        merchants: number;
        stores: number;
        seats: number;
    }>;
    // Operations
    /** Cross-currency sum kept for compatibility — platform wallets are
     *  credited per invoice currency, so render the per-currency map below
     *  when present. */
    platformWalletBalance: number;
    platformWalletByCurrency?: Record<string, number>;
    platformWalletMethodCount: number;
    topupsProcessed: number;
    topupsUnprocessed: number;
    lastBillingRun: PlatformBillingRunInfo | null;
}
export interface PlatformStoreArRow {
    storeId: string;
    storeName: string;
    merchantId: string;
    totalBilled: number;
    totalPaid: number;
    outstanding: number;
    overdue: number;
    pendingCount: number;
    failedCount: number;
    maxDaysOverdue: number | null;
    earliestDueDate: string | null;
    collectionRatePct: number | null;
}
export interface PlatformBillingRunInfo {
    status: string;
    startedAt: string | null;
    invoicesCreated: number;
    invoicesPaid: number;
    invoicesUnpaid: number;
}
// ---------------------------------------------------------------------------
// Platform Metrics — grouped endpoints
// ---------------------------------------------------------------------------
// The dashboard loads each group with its own request so a slow group never
// blocks the others. Every figure is computed in UTC; `from`/`to` are the
// ISO instants of the selected range. Point-in-time figures (receivables,
// MRR) are "as of now" and say so in their doc comment.
export interface GetPlatformMetricsRangeRequest {
    from: string;
    to: string;
}
export interface PlatformMonthlyBilling {
    /** Month label, e.g. "Jan 2026" (UTC). */
    month: string;
    /** Sum of final_amount on store invoices billed (period_end) in the month. */
    billed: number;
    /** amount_paid on those same invoices (cohort collection). */
    collected: number;
    /** amount_due still open on those same invoices, as of now. */
    outstanding: number;
    invoiceCount: number;
}
export interface PlatformBillingMetrics {
    /** Dominant invoice currency (largest billed total); every amount below is in it. */
    currency: string;
    /** Billed totals of invoices in OTHER currencies, excluded from the figures. */
    excludedBilledByCurrency: Record<string, number>;
    from: string;
    to: string;
    /** Sum of final_amount on non-cancelled store invoices billed in the range. */
    billedInRange: number;
    invoicesInRange: number;
    /** amount_paid on invoices billed in the range (cohort). */
    collectedOnRangeInvoices: number;
    /** Sum of amount_paid on invoices whose paid_at falls in the range (cash basis). */
    collectedInRange: number;
    /** collectedOnRangeInvoices ÷ billedInRange (%). */
    collectionRatePct: number | null;
    /** Billed in the last complete month vs the month before (%), independent of the range. */
    momGrowthPct: number | null;
    /** AR outstanding ÷ billedInRange × days in range. */
    dso: number | null;
    /** Average days from bill date (period_end) to paid_at, invoices paid in the range. */
    avgDaysToPay: number | null;
    // Point in time, as of now
    arOutstanding: number;
    arOverdue: number;
    pendingInvoiceCount: number;
    overdueInvoiceCount: number;
    failedInvoiceCount: number;
    failedInvoiceAmount: number;
    arAging: Array<{
        bucket: string;
        amount: number;
        invoiceCount: number;
    }>;
    /** Open amount_due grouped by due month, as of now. */
    expectedByMonth: Array<{
        month: string;
        amount: number;
        /** Part of `amount` whose due_date has already passed. */
        overdueAmount: number;
        invoiceCount: number;
    }>;
    monthly: PlatformMonthlyBilling[];
    /** Per store, over invoices billed in the range; outstanding/overdue as of now. */
    storeRows: PlatformStoreArRow[];
    lastBillingRun: PlatformBillingRunInfo | null;
}
export interface PlatformMonthlySales {
    month: string;
    /** Gross sales of stores selling in the reporting currency. */
    gmv: number;
    netSales: number;
    refunds: number;
    receipts: number;
    refundReceipts: number;
    /** Stores with at least one sale receipt in the month (all currencies). */
    activeStores: number;
    /** Stores created in the month. */
    newStores: number;
    /** Stores created in the month that sold at least once in that month. */
    activatedStores: number;
}
export interface PlatformSalesMetrics {
    currency: string;
    excludedGmvByCurrency: Record<string, number>;
    from: string;
    to: string;
    gmv: number;
    netSales: number;
    refunds: number;
    receipts: number;
    refundReceipts: number;
    /** Distinct stores with at least one sale receipt in the range. */
    activeStores: number;
    totalStores: number;
    /** Stores whose sales could not be read; GMV is incomplete when > 0. */
    failedStores: number;
    monthly: PlatformMonthlySales[];
}
export interface PlatformRegistryMetrics {
    from: string;
    to: string;
    /** Non-deleted merchants that own at least one store. */
    totalMerchants: number;
    /** Merchants without any store, excluded from every merchant figure. */
    merchantsWithoutStores: number;
    totalStores: number;
    /** Non-deleted users of merchants that own at least one store. */
    totalUsers: number;
    /** Merchants whose users could not be read; user figures are incomplete when > 0. */
    failedUserMerchants: number;
    /** Non-deleted customers of merchants that own at least one store.
     *  Optional for backwards compatibility; missing = 0. */
    totalCustomers?: number;
    /** Merchants whose customers could not be read; customer figures are
     *  incomplete when > 0. Optional for backwards compatibility; missing = 0. */
    failedCustomerMerchants?: number;
    monthly: Array<{
        month: string;
        merchants: number;
        stores: number;
        users: number;
        /** Optional for backwards compatibility; missing = 0. */
        customers?: number;
    }>;
}
export interface PlatformOperationsMetrics {
    currency: string;
    /** Platform wallet balance per currency (money owed to/held by the platform ledger). */
    platformWalletByCurrency: Record<string, number>;
    platformWalletMethodCount: number;
    /** Payment methods whose wallet balance could not be read; balances are incomplete when > 0. */
    failedWalletMethods: number;
    topupsProcessed: number;
    topupsUnprocessed: number;
}

/**
 * Admin web app login (phone + WhatsApp OTP) contract.
 *
 * The admin web app replaces the legacy password login with a two-step flow:
 * 1. POST /admin/login/request-code — validates the phone number against the
 *    server-side allowlist and sends a WhatsApp OTP.
 * 2. POST /admin/login/verify-code — validates the OTP and returns a 7-day
 *    session token used to authenticate admin API calls.
 */
/**
 * Request a WhatsApp OTP for an admin login attempt.
 */
export interface RequestAdminLoginCode {
    /** Phone number in E.164 format, e.g. "+32481000000". */
    phone_number: string;
}
export interface RequestAdminLoginCodeResponse {
    message: string;
}
/**
 * Verify a WhatsApp OTP and obtain an admin session token.
 */
export interface VerifyAdminLoginCode {
    /** Phone number in E.164 format, e.g. "+32481000000". */
    phone_number: string;
    /** The 6-digit code received via WhatsApp. */
    code: string;
}
export interface VerifyAdminLoginCodeResponse {
    /** Opaque session token to send as `Authorization: Bearer <token>`. */
    token: string;
    /** Unix timestamp (milliseconds) when the session expires. */
    expires_at: number;
}
/** `POST /admin/login/email/request-code`: a 6-digit code by email. */
export interface RequestAdminLoginEmailCode {
    /** An admin email (allowlist in SSM). */
    email: string;
}
/** `POST /admin/login/email/verify-code`: same session as the WhatsApp code. */
export interface VerifyAdminLoginEmailCode {
    email: string;
    /** The 6-digit code received by email. */
    code: string;
}
/**
 * Last-resort sign-in with the shared admin password
 * (`POST /admin/login/password`). Same session as the codes.
 */
export interface VerifyAdminLoginPassword {
    /** An admin phone number (E.164) or email. */
    identifier: string;
    password: string;
}

/** Banner colors (readable on mobile and in dark mode). */
export enum AnnouncementColor {
    ORANGE = 'ORANGE',
    RED = 'RED',
    BLUE = 'BLUE',
    GREEN = 'GREEN',
    PURPLE = 'PURPLE'
}
/** Who sees an announcement. */
export enum AnnouncementScope {
    ALL = 'ALL',
    MERCHANTS = 'MERCHANTS',
    STORES = 'STORES'
}
/** The message in every app language; all three are required. */
export interface AnnouncementMessages {
    en: string;
    pt: string;
    fr: string;
}
/**
 * A banner platform admins show in the web apps (service-admin). Live
 * from `starts_at` until `ends_at`, or until an admin ends it.
 */
export interface Announcement extends Timestamps, Versioned {
    id: string;
    messages: AnnouncementMessages;
    color: AnnouncementColor;
    scope: AnnouncementScope;
    /**
     * With scope MERCHANTS: every store of these merchants. With STORES: the
     * merchants of the chosen stores (display only).
     */
    merchant_ids: string[];
    /** With scope STORES: only these stores. */
    store_ids: string[];
    /** ISO time it starts showing. */
    starts_at: string;
    /** ISO time it stops showing. */
    ends_at: string;
    /** Set when an admin ended it early. */
    ended_at?: string | null;
}
/** `POST /admin/announcements` (admin session). */
export interface CreateAnnouncement {
    messages: AnnouncementMessages;
    color: AnnouncementColor;
    scope: AnnouncementScope;
    merchant_ids?: string[] | null;
    store_ids?: string[] | null;
    /** Missing = now. */
    starts_at?: string | null;
    ends_at: string;
}
/** `PUT /admin/announcements/{id}`: the whole announcement. */
export interface UpdateAnnouncement extends CreateAnnouncement {
    /** The version read; a stale one is refused (409). */
    version: number;
}
/** `GET /admin/announcements` (admin session), newest first. */
export interface AnnouncementsResponse {
    announcements: Announcement[];
}
/** One live announcement as the apps get it (no actor fields). */
export interface ActiveAnnouncement {
    id: string;
    /** Changes on every edit: a user's dismissal applies to one version. */
    version: number;
    messages: AnnouncementMessages;
    color: AnnouncementColor;
}
/** `GET /admin/announcements/active?merchant_id=&store_id=` (public). */
export interface GetActiveAnnouncements {
    merchant_id?: string | null;
    store_id?: string | null;
}
export interface ActiveAnnouncementsResponse {
    announcements: ActiveAnnouncement[];
}
export interface AnnouncementDBItem extends Announcement {
    PK: string;
    SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}

/**
 * Documents, photos and signatures of the Orders & Transfers module
 * (docs/plans/orders-and-transfers.md §4.8), kept in a private bucket.
 */
export enum AttachmentKind {
    SIGNATURE = 'SIGNATURE',
    DOCUMENT = 'DOCUMENT',
    PROOF = 'PROOF',
    INVOICE = 'INVOICE',
    QUOTATION = 'QUOTATION',
    /** A voice note (a manual task's recording). */
    AUDIO = 'AUDIO'
}
/** INTENT until the uploaded file is checked, then VERIFIED or REJECTED. */
export enum AttachmentStatus {
    INTENT = 'INTENT',
    VERIFIED = 'VERIFIED',
    REJECTED = 'REJECTED'
}
/** What an attachment belongs to. The flow using it checks the match. */
export enum AttachmentEntityType {
    STOCK_ORDER = 'STOCK_ORDER',
    TRANSFER = 'TRANSFER',
    PURCHASE_ORDER = 'PURCHASE_ORDER',
    GOODS_RECEIPT = 'GOODS_RECEIPT',
    SUPPLIER_PAYMENT = 'SUPPLIER_PAYMENT',
    /** A manual task (§4.13); `entity_id` is the ULID the client made for it. */
    TASK = 'TASK'
}
/** The file types accepted, recognised by their first bytes on confirm. */
export enum AttachmentContentType {
    PDF = 'application/pdf',
    JPEG = 'image/jpeg',
    PNG = 'image/png',
    WEBP = 'image/webp',
    HEIC = 'image/heic',
    /** Recorded in the browser (Chrome, Edge, Firefox, Safari). */
    WEBM_AUDIO = 'audio/webm',
    OGG_AUDIO = 'audio/ogg',
    MP4_AUDIO = 'audio/mp4'
}
export interface Attachment extends Timestamps, Versioned {
    id: string;
    merchant_id: string;
    store_id: string;
    entity_type: AttachmentEntityType;
    entity_id: string;
    kind: AttachmentKind;
    /** The name shown when the file is opened. */
    file_name: string;
    /** Declared at intent; the upload link only accepts this type and size. */
    expected_content_type: AttachmentContentType;
    expected_size: number;
    status: AttachmentStatus;
    /** Why the file was refused on confirm (REJECTED only). */
    rejected_reason?: string;
    verified_at?: string;
    created_by_id: string;
    created_by_name: string;
}
/**
 * `GET /inventory-transfers/{merchant_id}/attachments/{attachment_id}`:
 * service-only (IAM), for a service that references a file (a manual task)
 * to check its status, owner entity and store.
 */
export interface GetAttachment {
    merchant_id: string;
    attachment_id: string;
}
/** `POST /inventory-transfers/{merchant_id}/attachments` */
export interface CreateAttachmentIntent {
    store_id: string;
    entity_type: AttachmentEntityType;
    entity_id: string;
    kind: AttachmentKind;
    file_name: string;
    content_type: AttachmentContentType;
    /** Bytes, at most 10 MB. */
    size: number;
}
export interface AttachmentIntentResult {
    attachment: Attachment;
    /** PUT the file here within 10 minutes, with exactly `upload_headers`. */
    upload_url: string;
    upload_headers: Record<string, string>;
    expires_at: string;
}
/** `GET /inventory-transfers/{merchant_id}/attachments/{attachment_id}/url` */
export interface AttachmentViewUrl {
    attachment: Attachment;
    /** Opens the file inline for 15 minutes. */
    url: string;
    expires_at: string;
}
/**
 * A signature bound to what was signed: `document_hash` is the SHA-256 of
 * the canonical JSON of the signed content (`documentHash`). Changing any
 * signed value, or the document's version, voids it (`isSignatureCurrent`).
 */
export interface SignatureRecord {
    /** Who signs in the flow, e.g. `SENDER`, `DRIVER`, `RECEIVER`. */
    role: string;
    /** A VERIFIED SIGNATURE attachment holding the drawn signature. */
    attachment_id: string;
    signer_id: string;
    signer_name: string;
    signed_at: string;
    document_hash: string;
    document_version: number;
    method: 'CANVAS';
}
export interface AttachmentDBItem extends Attachment {
    PK: string;
    SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
    /** The object's key in the private bucket. */
    key: string;
    /** Epoch seconds: an INTENT never confirmed is purged after 24 h. */
    ttl?: number;
}

export enum AuditTrailAction {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
    DELETE = 'DELETE'
}
export interface AuditTrailEntry {
    timestamp: string;
    employee_id: string;
    employee_name: string;
    action: AuditTrailAction;
    entity_type: string;
    entity_id: string;
    description: string;
    source: string;
}
export interface AuditTrailPage {
    entries: AuditTrailEntry[];
    count: number;
}
export interface GetEmployeeTimeline {
    merchant_id: string;
    employee_id: string;
    start_date: string;
    end_date: string;
    store_id?: string;
}

export enum AuthType {
    Admin = 'Admin',
    Customer = 'Customer',
    Merchant = 'Merchant'
}
export enum CognitoAttributeDataType {
    STRING = 'String',
    NUMBER = 'Number',
    DATETIME = 'DateTime',
    BOOLEAN = 'Boolean'
}
export interface CognitoAttributeDefinition {
    AttributeDataType?: CognitoAttributeDataType;
    Mutable: boolean;
    Name: string;
    Required?: boolean;
}
export interface MerchantAuthStore {
    store_id: string;
    store_name: string;
    merchant_id: string;
    roles: string[];
}
export interface MerchantAuthStoreWithRoles {
    store_id: string;
    roles: string[];
}
export interface AuthenticateUserResponse {
    encryptedCredentials: string;
    userData: MerchantUserAttributes;
    employee: Employee;
    credentials: EncryptCredentialsDto;
}
export interface AuthenticateUserRequest {
    phone_number: string;
    pin: string;
    client_id: string;
}
export interface DecryptCredentialsRequestBody {
    encryptedCredentials: string;
}
export interface SignOutUserRequestBody {
    accessToken: string;
}
export interface SignOutUserResponse {
    message: string;
}
export interface CreateMerchantUserRequestBody {
    phone_number: string;
    email?: string;
    address?: string;
    family_name?: string;
    given_name?: string;
    auth_type: AuthType;
    business_name: string;
    created_by: string;
    stores: MerchantAuthStore[];
    pin: string;
}
export interface CreateAdminUserRequestBody {
    phone_number: string;
    email: string;
    address?: string;
    family_name?: string;
    given_name?: string;
    auth_type: AuthType;
    password: string;
}
export interface UpdateAdminUserRequestBody {
    user_id: string;
    email: string;
    address?: string;
    family_name?: string;
    given_name?: string;
    stores?: MerchantAuthStore[];
}
export interface CreateAuthUserResponse {
    message: string;
    userSub?: string;
}
export interface CustomerAuthStore {
    store_id: string;
    store_name: string;
    merchant_id: string;
}
export interface CustomerUserAttributes {
    username: string;
    phone_number: string;
    email: string;
    address: string;
    family_name: string;
    given_name: string;
    gender: string;
    profile_picture: string;
    auth_type: AuthType;
    created_by: string;
    pin: string;
    stores: CustomerAuthStore[];
}
export interface MerchantUserAttributes {
    username: string;
    phone_number: string;
    email: string;
    address: string;
    family_name: string;
    given_name: string;
    auth_type: AuthType;
    business_name: string;
    created_by: string;
    pin: string;
    stores: MerchantAuthStore[];
    /** Whether the user authenticates via WhatsApp OTP. Defaults to false if not set. */
    use_whatsapp_otp?: boolean;
}
export interface AdminUserAttributes {
    username: string;
    phone_number: string;
    email: string;
    address: string;
    family_name: string;
    given_name: string;
    auth_type: AuthType;
}
export interface UpdateMerchantUserRequestBody {
    user_id: string;
    email?: string;
    address?: string;
    family_name?: string;
    given_name?: string;
    business_name?: string;
    pin?: string;
    add_to_stores?: MerchantAuthStore[];
    remove_from_stores?: MerchantAuthStore[];
    is_email_verified?: boolean;
    add_to_roles?: MerchantAuthStoreWithRoles[];
    remove_from_roles?: MerchantAuthStoreWithRoles[];
}
export interface CreateCustomerUserRequestBody {
    phone_number: string;
    email?: string;
    address?: string;
    family_name?: string;
    given_name?: string;
    auth_type: AuthType;
    created_by: string;
    stores: MerchantAuthStore[];
    pin: string;
    gender?: string;
    profile_picture?: string;
}
export interface UpdateCustomerUserRequestBody {
    user_id: string;
    email?: string;
    address?: string;
    family_name?: string;
    given_name?: string;
    stores?: CustomerAuthStore[];
    pin?: string;
    gender?: string;
    profile_picture?: string;
}
export interface UpdateAuthUserResponse {
    message: string;
}
export type UserAttribute = {
    Name: string;
    Value: string;
};
export interface ResetUserPasswordRequestBody {
    user_id: string;
    new_pin?: string;
    auth_type: AuthType;
    new_password?: string;
}
export interface EncryptCredentialsDto {
    AccessToken: string;
    ExpiresIn: number;
    Employee: Employee;
    TokenType: string;
}
// ─── WhatsApp OTP ────────────────────────────────────
export interface SendWhatsappOtpRequest {
    /** The customer's phone number in international format (e.g., "254712345678") */
    phone_number: string;
    /** The one-time password/code to send (max 15 chars per WhatsApp limit) */
    otp: string;
    /** Template language — English (en_US) or European Portuguese (pt_PT) */
    language: Language;
    /** OTP expiration in minutes (1–90). Controls the footer "Expires in X minutes." Defaults server-side when omitted. */
    code_expiration_minutes?: number;
}
export interface SendWhatsappOtpResponse {
    message: string;
    /** WhatsApp message ID (prefixed with "wamid.") for tracking delivery status */
    whatsapp_message_id: string;
}
// ─── WhatsApp OTP Settings ──────────────────────────
export interface UpdateOtpSettingsRequest {
    user_id: string;
    use_whatsapp_otp: boolean;
}
export interface UpdateOtpSettingsResponse {
    message: string;
}
// ─── Auth Challenge (split-auth for OTP) ─────────────
export interface CreateAuthChallengeRequest {
    client_id: string;
    phone_number: string;
}
export interface CreateAuthChallengeResponse {
    session: string;
    message: string;
}
export interface VerifyAuthChallengeRequest {
    client_id: string;
    phone_number: string;
    session: string;
    answer: string;
}
// ─── PIN Recovery (Forgot PIN → WhatsApp OTP) ──────
export interface InitiatePinRecoveryRequest {
    client_id: string;
    phone_number: string;
}
export interface InitiatePinRecoveryResponse {
    session: string;
    message: string;
}
export interface CompletePinRecoveryRequest {
    client_id: string;
    phone_number: string;
    session: string;
    answer: string;
}

export interface Principal {
    id: string;
    created_at: string;
    deleted_at: string;
    updated_history: string[];
    merchant_id: string;
    role_id: string;
}
export interface PrincipalList {
    principals: Principal[];
    meta: Meta;
}
export interface Policy {
    id: string;
    policy: string;
    action_id: string;
    resource_id: string;
    description: string;
    created_at: string;
    deleted_at: string;
    updated_history: string[];
}
export interface Action {
    id: string;
    description: string;
    verb: string;
    resource_id: string;
    created_at: string;
    updated_at: string;
    deleted_at: string;
    update_history: string[];
}
export interface Resource {
    id: string;
    description: string;
    path: string;
    created_at: string;
    updated_at: string;
    deleted_at: string;
    update_history: string;
}
export interface Meta {
    num_read: number;
    next_cursor: string;
}
export interface ActionList {
    actions: Action[];
    meta: Meta;
}
export interface ResourceList {
    resources: Resource[];
    meta: Meta;
}
export interface PolicyList {
    policies: Policy[];
    meta: Meta;
}
export interface Role {
    id: string;
    description: string;
    policies: string[];
    created_at: string;
    resources: string[];
    deleted_at: string;
    updated_history: string[];
    role_id: string;
}
export interface RoleList {
    roles: Role[];
    meta: Meta;
}
export interface MultiplePolicyList {
    policies: Policy[];
    meta: {
        items_created: number;
    };
}
export interface MultiplePolicyBody {
    merchant_id: string;
    policies: PolicyBody[];
}
export interface PolicyBody {
    action_id: string;
    resource_id: string;
    description: string;
}
// V2 types
export enum ResourceTypeV2 {
    PATH = 'PATH',
    APP = 'APP',
    /** A business action (`orders:transfer.dispatch`), checked server-side. */
    ACTION = 'ACTION'
}
export enum ActionV2 {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE',
    OPEN = 'OPEN',
    /** The only verb of an `ACTION` resource. */
    PERFORM = 'PERFORM'
}
export interface ResourceV2 {
    name: string;
    type: ResourceTypeV2;
}
export interface PermissionV2 extends Timestamps, Versioned {
    id: string;
    resource: ResourceV2;
    action: ActionV2;
    description: string;
}
export interface CreatePermissionV2 {
    resource: ResourceV2;
    action: ActionV2;
    description: string;
}
export interface GetPermissionV2 {
    id: string;
}
export interface GetAllPermissionsV2 {
    cursor?: string;
    count?: number;
    include_deleted?: SoftDeleteFlag;
}
export interface PermissionsPageV2 {
    count: number;
    cursor?: string;
    permissions: PermissionV2[];
}
export enum UpdatePermissionCommandV2 {
    UPDATE_RESOURCE = 'UPDATE_RESOURCE',
    UPDATE_ACTION = 'UPDATE_ACTION',
    UPDATE_DESCRIPTION = 'UPDATE_DESCRIPTION',
    DELETE_PERMISSION = 'DELETE_PERMISSION'
}
export interface UpdatePermissionV2 {
    id: string;
    command: UpdatePermissionCommandV2;
    resource?: ResourceV2;
    action?: ActionV2;
    description?: string;
}
export interface RoleV2 extends Timestamps, Versioned {
    id: string;
    merchant_id: string;
    permissions: PermissionV2[];
    name: string;
    description: string;
}
export interface ProtoRoleV2 extends Omit<RoleV2, 'permissions'> {
    permissions: string[];
}
export interface CreateRoleV2 {
    merchant_id: string;
    name: string;
    description: string;
}
export interface GetRoleV2 {
    id: string;
    include_permissions?: boolean;
}
export interface GetAllRolesV2 {
    merchant_id: string;
    principal_id?: string;
    store_id?: string;
    by_principal?: boolean;
    by_principal_and_store?: boolean;
    by_merchant?: boolean;
    count?: number;
    cursor?: string;
    include_permissions?: boolean;
    include_deleted: SoftDeleteFlag;
}
export interface RolesPageV2 {
    count: number;
    cursor?: string;
    roles: RoleV2[];
}
export enum UpdateRoleCommandV2 {
    ADD_PERMISSIONS = 'ADD_PERMISSIONS',
    REMOVE_PERMISSIONS = 'REMOVE_PERMISSIONS',
    ADD_PRINCIPALS = 'ADD_PRINCIPALS',
    REMOVE_PRINCIPALS = 'REMOVE_PRINCIPALS',
    DELETE_ROLE = 'DELETE_ROLE',
    UPDATE_OTHER = 'UPDATE_OTHER'
}
export interface AddPrincipalToRole {
    principal_id: string;
    store_id: string;
}
export interface UpdateRoleV2 {
    id: string;
    command: UpdateRoleCommandV2;
    permissions?: string[];
    principals?: AddPrincipalToRole[];
    description?: string;
    name?: string;
}
export interface PrincipalV2 extends Timestamps, Versioned {
    id: string;
    merchant_id: string;
}
export interface CreatePrincipalV2 {
    id: string;
    merchant_id: string;
}
export interface GetPrincipalV2 {
    id: string;
}
export enum UpdatePrincipalCommandV2 {
    ADD_ROLES = 'ADD_ROLES',
    REMOVE_ROLES = 'REMOVE_ROLES',
    DELETE_PRINCIPAL = 'DELETE_PRINCIPAL'
}
export interface AddRoleToPrincipal {
    role_id: string;
    store_id: string;
}
export interface UpdatePrincipalV2 {
    id: string;
    command: UpdatePrincipalCommandV2;
    roles: AddRoleToPrincipal[];
}
export interface GetAllPrincipalsByRoleV2 {
    role_id: string;
}
export interface PrincipalsPageV2 {
    count: number;
    cursor?: string;
    principals: string[];
}
export interface PrincipalIdsPageV2 {
    ids: string[];
}
export interface RolePrincipalV2 {
    role_id: string;
    principal_id: string;
    store_id: string;
}
export interface PrincipalRoleV2 extends RolePrincipalV2 {
}
export interface PolicyV2 {
    principalId: string;
    policyDocument?: {
        Version: string;
        Statement: Array<{
            Action: string;
            Effect: 'Allow' | 'Deny';
            Resource: string;
        }>;
    };
    context?: {
        [key: string]: string | number | boolean;
    };
}
export enum PolicyDecision {
    Allow = 'Allow',
    Deny = 'Deny'
}
export interface AuthorizeOpenApp {
    app_names: string[];
    principal_id: string;
    store_id?: string;
    merchant_id?: string;
}
export interface VerifyCedarBody {
    policy_string: string;
    principal: string;
    action: string;
    resource: string;
}
export interface VerifyCedarResult {
    allow: boolean;
}
export interface AuthorizeOpenAppResult {
    results: {
        resource: string;
        allow: boolean;
    }[];
}
export interface CreateMerchantRole {
    merchant_id: string;
    store_id: string;
}
/** One decision request: may `principal_id` perform `action` in every store listed. */
export interface AuthorizeActionRequest {
    /** Resource name of an ACTION permission, e.g. `orders:order.create`. */
    action: string;
    /** Every store the action touches; all must allow. */
    store_ids: string[];
}
/** Body of `POST authorizations-v2/authorizer/decisions/{merchant_id}` (service-signed). */
export interface AuthorizeActions {
    principal_id: string;
    actions: AuthorizeActionRequest[];
}
export interface AuthorizeActionDecision extends AuthorizeActionRequest {
    allow: boolean;
}
export interface AuthorizeActionsResult {
    /** Bumped on every role or assignment change of the merchant; cache key. */
    permissions_version: number;
    results: AuthorizeActionDecision[];
}
/** Query of `GET authorizations-v2/authorizer/my-actions/{merchant_id}` (verified user). */
export interface GetMyActions {
    merchant_id: string;
    store_id: string;
}
export interface MyActionsResult {
    permissions_version: number;
    /** Resource names of the ACTION permissions the user holds in the store. */
    actions: string[];
}
/**
 * Body of `POST authorizations-v2/authorizer/team-actions/{merchant_id}`
 * (service-signed): the actions of several principals in one store, for the
 * POS offline credentials. An owner's principal is the merchant id.
 */
export interface GetTeamActions {
    store_id: string;
    principal_ids: string[];
}
/**
 * `GET /authorizer/principal-store-roles/{merchant_id}?principal_id=`
 * (service-only, IAM): the roles a principal holds, per store (role tasks).
 */
export interface GetPrincipalStoreRoles {
    merchant_id: string;
    principal_id: string;
}
export interface PrincipalStoreRoles {
    /** Per store id: the ids of the principal's live roles there. */
    stores: Record<string, string[]>;
}
/**
 * `GET /authorizer/role-principals/{merchant_id}?role_id=&store_id=`
 * (service-only, IAM): who holds a role in one store (role tasks).
 */
export interface GetRolePrincipalsInStore {
    merchant_id: string;
    role_id: string;
    store_id: string;
}
export interface RolePrincipalsInStore {
    role_id: string;
    role_name: string;
    principal_ids: string[];
}
export interface TeamActionsResult {
    permissions_version: number;
    /** Per principal id: resource names of the ACTION permissions it holds. */
    actions: Record<string, string[]>;
}

export interface Customer extends Timestamps, Versioned {
    id: string; // The customer ID. If included in the POST request, it will cause an update instead of creating a new object.
    name: string; // <= 64 characters. The customer's name.
    email?: string; // <= 100 characters. The customer's email.
    phone_number?: string; // <= 15 characters. The customer's phone number.
    address?: string; // <= 192 characters. The customer's address.
    city?: string; // <= 64 characters. The customer's city, town, or village.
    region?: string; // <= 64 characters. The customer's region (province, state, or prefecture).
    postal_code?: string; // <= 20 characters. The customer's postal code.
    country_code?: string; // The two-letter country code in ISO 3166-1-alpha-2 format.
    customer_code?: string; // <= 40 characters.
    note?: string; // <= 255 characters. Note about the customer.
    first_visit?: string | null; // ISO 8601 date-time string. Default: null. The date of the first customer visit.
    last_visit?: string | null; // ISO 8601 date-time string. Default: null. The date of the most recent customer visit.
    total_visits: number; // Default: 0. The total number of visits.
    total_spent: number; // Default: 0. The total amount the customer has spent.
    total_points: number; // Default: 0. The customer's current points balance.
    permanent_deletion_at?: string | null; // ISO 8601 date-time string. The time when the customer data will be permanently deleted.
    pin?: string; // <= 4 characters. The customer's personal identification number.
    merchant_id: string; // The merchant ID.
    date_of_birth?: string;
    debtor_summary?: DebtorSummary;
    /** Set to true once the customer's phone number has been verified via OTP. */
    is_number_verified?: boolean;
}
export interface CreateCustomer {
    name: string; // <= 64 characters.
    email?: string; // <= 100 characters.
    phone_number?: string; // <= 15 characters.
    address?: string; // <= 192 characters.
    city?: string; // <= 64 characters.
    region?: string; // <= 64 characters.
    postal_code?: string; // <= 20 characters.
    country_code?: string; // The two-letter country code in ISO 3166-1-alpha-2 format.
    customer_code?: string; // <= 40 characters.
    note?: string; // <= 255 characters.
    first_visit?: string | null; // ISO 8601 date-time string. Default: null.
    last_visit?: string | null; // ISO 8601 date-time string. Default: null.
    pin: string; // <= 4 characters.
    merchant_id: string; // The merchant ID.
    id?: string; // The customer ID.
}
export interface UpdateCustomer {
    id: string; // The customer ID to update.
    name?: string; // <= 64 characters.
    email?: string; // <= 100 characters.
    phone_number?: string; // <= 15 characters.
    address?: string; // <= 192 characters.
    city?: string; // <= 64 characters.
    region?: string; // <= 64 characters.
    postal_code?: string; // <= 20 characters.
    country_code?: string; // The two-letter country code in ISO 3166-1-alpha-2 format.
    customer_code?: string; // <= 40 characters.
    note?: string; // <= 255 characters.
    first_visit?: string | null; // ISO 8601 date-time string.
    last_visit?: string | null; // ISO 8601 date-time string.
    pin?: string; // <= 4 characters.
    debtor_summary?: DebtorSummary;
    /** Set to true once the customer's phone number has been verified via OTP. */
    is_number_verified?: boolean;
}
export interface CustomerPage {
    cursor?: string;
    count?: number;
    customers: Customer[];
}
export interface GetCustomer {
    id: string;
    include_deleted?: SoftDeleteFlag;
    store_id?: string;
    with_debt?: boolean; // unused, kept for compatibility. We always fetch debt if store_id is provided.
}
export interface GetCustomers {
    cursor?: string;
    limit?: number;
    merchant_id: string;
    include_deleted?: SoftDeleteFlag;
    store_id?: string;
    with_debt?: boolean;
}
export interface CustomerDBItem extends Customer {
    PK: string; // CUSTOMER#id
    SK: string; // CUSTOMER#id
    GSI1PK: string; // MERCHANT#merchant_id
    GSI1SK: string; // CUSTOMER#id
    EntityIndexPK: string; // CUSTOMER
    EntityIndexSK: string; // DATE#created_at
}
export enum TransactionType {
    Sale = 'Sale',
    Refund = 'Refund'
}
export interface LoyaltyTransactionItem {
    product_id: string;
    product_name: string;
    price: number;
    quantity: number;
    eligible_for_points: boolean;
}
export interface LoyaltyTransaction {
    id: string;
    customer_id: string;
    type: TransactionType;
    items: LoyaltyTransactionItem[];
    total_amount: number;
    date: string;
    merchant_id: string;
}
export interface LoyaltyProduct {
    id: string;
    name: string;
    price: number;
    eligible_for_points: boolean;
    category?: string;
    store_id: string;
}
export interface UpdateLoyaltyAfterSaleOrRefund {
    customer_id: string;
    /**
     * The receipt being applied. When sent, a redelivered receipt is applied
     * only once. Optional for backwards compatibility: older callers omit it.
     */
    receipt_id?: string | null;
    total_spent: number;
    visit_count: number;
    merchant_id: string;
    store_id: string;
    points_earned: number;
    points_deducted: number;
}
export interface RedeemPoints {
    merchant_id: string;
    customer_id: string;
    points_to_redeem: number;
    store_id: string;
}
export interface RedeemPointOutput {
    transaction: LoyaltyTransaction;
    discount_amount: number;
}
export enum LoyaltyType {
    MONEY_BASED = 'MONEY_BASED',
    VISIT_BASED = 'VISIT_BASED',
    PERCENTAGE_BASED = 'PERCENTAGE_BASED'
}
export interface LoyaltyProgram extends Timestamps, Versioned {
    id: string;
    name: string;
    loyalty_type: LoyaltyType;
    description: string;
    points_per_threshold: number;
    threshold_amount: number;
    merchant_id: string;
    store_id: string;
    is_active: boolean;
}
export interface CreateLoyaltyProgram {
    name: string;
    loyalty_type: LoyaltyType;
    description: string;
    points_per_threshold: number;
    threshold_amount: number;
    merchant_id: string;
    is_active: boolean;
    store_id: string;
}
export interface UpdateLoyaltyProgram {
    id: string;
    merchant_id: string;
    store_id: string;
    name?: string;
    loyalty_type?: LoyaltyType;
    description?: string;
    points_per_threshold?: number;
    threshold_amount?: number;
    is_active?: boolean;
}
export interface LoyaltyProgramDBItem extends LoyaltyProgram {
    PK: string; // LOYALTY#id
    SK: string; // LOYALTY#id
    GSI1PK: string; // MERCHANT#merchant_id
    GSI1SK: string; // LOYALTY#id
    GSI2PK: string; // STORE#store_id
    GSI2SK: string; // LOYALTY#id
    EntityIndexPK: string; // LOYALTY
    EntityIndexSK: string; // DATE#created_at
}
export interface LoyaltyProgramPage {
    cursor?: string;
    count?: number;
    programs: LoyaltyProgram[];
}
export interface GetLoyaltyPrograms {
    cursor?: string;
    limit?: number;
    merchant_id: string;
    include_deleted?: SoftDeleteFlag;
}

export enum DailyCountItemStatus {
    PENDING = 'PENDING',
    COUNTED = 'COUNTED',
    CARRIED_OVER = 'CARRIED_OVER'
}
export interface DailyCountAuditEntry {
    counted_by: string;
    counted_by_name: string;
    counted_stock: number;
    expected_stock: number;
    counted_at: string;
    recount_reason?: string;
}
export interface DailyCountItem {
    product_id: string;
    product_name: string;
    status: DailyCountItemStatus;
    expected_stock: number | null;
    counted_stock: number | null;
    counted_by: string | null;
    counted_by_name: string | null;
    counted_at: string | null;
    carried_from_date: string | null;
    is_short: boolean;
    recount_reason?: string;
    count_audit?: DailyCountAuditEntry[];
}
export interface DailyCountList extends Timestamps, Versioned {
    id: string;
    store_id: string;
    merchant_id: string;
    count_date: string;
    items: DailyCountItem[];
    generated_at: string;
    target_count: number;
    fresh_count: number;
    carried_over_count: number;
}
export interface DailyCountListPage extends Paginated {
    daily_count_lists: DailyCountList[];
}
export interface RecordDailyCount {
    store_id: string;
    count_date: string;
    product_id: string;
    counted_by: string;
    counted_stock: number;
    expected_stock: number;
    recount_reason?: string;
}
export interface GetDailyCountLists {
    store_id: string;
    merchant_id: string;
    date?: string;
    start_date?: string;
    end_date?: string;
    limit?: number;
    cursor?: string;
}
export interface TriggerDailyCountList {
    store_id: string;
    /** When true, replaces today's list even if one already exists. */
    force?: boolean;
    /**
     * When true, the generated list ignores carry-over from yesterday and is
     * built only from freshly-selected products. Used by the manual "Reset"
     * action so the operator gets a clean slate regardless of the store's
     * daily_count_carry_over_enabled flag.
     */
    fresh?: boolean;
}
export interface DailyCountListDBItem extends DailyCountList {
    /**
     * PK: STORE#{store_id}
     * SK: DAILY_COUNT#DATE#{count_date}
     * GSI1PK: DAILY_COUNT#MERCHANT#{merchant_id}
     * GSI1SK: DATE#{count_date}#STORE#{store_id}
     * EntityIndexPK: DAILY_COUNT
     * EntityIndexSK: MERCHANT#{merchant_id}#DATE#{count_date}
     */
    PK: string;
    SK: string;
    GSI1PK: string;
    GSI1SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}

export enum DebtOriginType {
    RECEIPT = 'RECEIPT',
    LOAN = 'LOAN',
    TRANSFER = 'TRANSFER'
}
export interface DebtorGroup {
    debtor_id: string;
    debtor_type: EntityTypes;
    debtor_name: string;
    debts: Debt[];
    total_outstanding_amount: number;
    total_paid_amount: number;
    total_amount: number;
}
/**
 * Enum representing the current status of a debt.
 */
export enum DebtStatus {
    ACTIVE = 'ACTIVE',
    CLOSED = 'CLOSED',
    OVERDUE = 'OVERDUE',
    DEFAULTED = 'DEFAULTED',
    CANCELLED = 'CANCELLED',
    TRANSFERRED = 'TRANSFERRED',
    REVERSED = 'REVERSED'
}
export interface DebtTransfer extends Timestamps {
    id: string;
    from_debt_id: string;
    to_debt_id: string;
    store_id: string;
    merchant_id: string;
    note: string;
    creator_id: string;
    creator_name: string;
    creator_type: EntityTypes;
    amount: number;
}
export interface Debt extends Timestamps {
    id: string;
    creator_type: EntityTypes; // Employees(user) or Receipts
    creator_id: string;
    creator_name: string;
    debtor_id: string; // Employee or Customer
    debtor_name: string;
    debtor_type: EntityTypes;
    store_id: string;
    merchant_id: string;
    transfers: DebtTransfer[];
    origin_type: DebtOriginType;
    principal_amount: number;
    outstanding_balance: number;
    interest_rate: number; // e.g., 5.5 for 5.5%
    status: DebtStatus;
    next_due_date: string | null | undefined; // ISO 8601 date string, null if auto-calculated
    closed_date: string | null | undefined;
    payment_plans: PaymentPlan[]; // The latest payment plan is the active one
    last_payment_date?: string;
    is_due_date_auto_calculated: boolean;
    reason: string;
    receipt_id?: string;
    version: string; // Version of the debt
    /**
     * The row's numeric version for the versioned-write helper (`version`
     * above is the change-log id). Optional for backwards compatibility;
     * missing = 0.
     */
    row_version?: number | null;
    /** Who made the latest change. Optional for backwards compatibility. */
    updated_by_id?: string | null;
    updated_by_name?: string | null;
    cancellation_reason?: string;
    cancelled_at?: string;
    reversed_at?: string;
    reversed_by_user_id?: string;
    reversal_reason?: string;
    shift_id?: string; // TODO: Make Optional // Shift during which the debt was created
}
export enum DebtEvent {
    DEBT_STATUS_UPDATED = 'debt_status_updated',
    DEBT_CREATED = 'debt_created',
    DEBT_TRANSFERRED = 'debt_transferred',
    DEBT_INTEREST_UPDATED = 'debt_interest_updated',
    DEBT_DUE_DATE_UPDATED = 'debt_due_date_updated',
    DEBT_CLOSING_DATE_UPDATED = 'debt_closing_date_updated',
    DEBT_PLAN_AMOUNT_UPDATED = 'debt_payment_plan_amount_updated',
    DEBT_PLAN_FREQUENCY_UPDATED = 'debt_payment_plan_frequency_updated',
    DEBT_PLAN_NOTE_UPDATED = 'debt_payment_plan_note_updated',
    DEBT_PAYMENT_TYPE_UPDATED = 'debt_payment_type_updated',
    DEBT_CREATOR_NAME_UPDATED = 'debt_creator_name_updated',
    DEBTOR_NAME_UPDATED = 'debtor_name_updated',
    DEBT_PRINCIPAL_AMOUNT_UPDATED = 'debt_principal_amount_updated',
    DEBT_OUTSTANDING_BALANCE_UPDATED = 'debt_outstanding_balance_updated',
    DEBT_PAYMENT_OUTSTANDING_BALANCE_UPDATED = 'debt_payment_outstanding_balance_updated',
    DEBT_DELETED = 'debt_deleted',
    DEBT_PAYMENT_UPDATED = 'debt_payment_updated',
    AUTO_CALCULATED_DUE_DATE_UPDATED = 'auto_calculated_due_date_updated',
    DEBT_SHIFT_ID_UPDATED = 'debt_shift_id_updated',
    DEBT_PAYMENT_REVERSED = 'debt_payment_reversed',
    DEBT_REVERSED = 'debt_reversed'
}
export interface DebtChange extends Timestamps {
    id: string;
    event: DebtEvent;
    version: string;
    debt_version: string;
    updator_id: string;
    updator_name: string;
    updator_type: EntityTypes;
    changed_attributes: ChangedAttributes;
    store_id: string;
    merchant_id: string;
}
export interface GetDebtChanges {
    by_event: boolean; // get all changes for a specific event: use GSI2PK, GSI2SK
    by_event_and_debt: boolean; // get all changes for a specific event and debt: use GSI2PK, GSI2SK
    by_event_and_date_range: boolean; // get all changes for a specific event within a date range: use GSI2PK, GSI2SK
    by_debt: boolean; // get all changes for a debt: use PK, SK
    by_debt_and_date_range: boolean; // get all changes for a debt within a date range: use EntityIndexPK, EntityIndexSK
    by_updator: boolean; // get all changes made by a user: use GSI1PK, GSI1SK
    by_updator_and_date_range: boolean; // get all changes made by a user within a date range: use GSI1PK, GSI1SK
    by_updator_and_debt: boolean; // get all changes made by a user for a debt: use GSI1PK, GSI1SK
    event?: DebtEvent;
    debt_id?: string;
    updator_id?: string;
    updator_type?: EntityTypes;
    start_date?: string;
    end_date?: string;
    store_id?: string;
    merchant_id: string;
    limit?: number;
    cursor?: string;
}
export interface DebtPayment extends Timestamps, Versioned {
    id: string;
    debt_id: string;
    amount: number;
    outstanding_balance: number;
    initial_amount: number;
    payment_type: PaymentMethodType;
    user_id: string;
    payer_name: string;
    payer_id: string;
    payer_type: EntityTypes;
    store_id: string;
    merchant_id: string;
    note: string;
    origin_type?: DebtOriginType;
    plan_id?: string; // ID of the payment plan if applicable
    shift_id?: string;
    payment_type_id?: string;
    payment_type_name?: string;
    is_reversal?: boolean;
    reverses_payment_id?: string;
    reversed_by_payment_id?: string;
}
export interface PaymentPlan extends Timestamps {
    amount: number;
    frequency: number; // in days
    store_id: string;
    merchant_id: string;
    note: string;
    id: string;
}
export interface DebtChangeEvent {
    changes: ChangedAttributes;
    event: DebtEvent;
}
export interface CreateDebtCommandPayload {
    creator_id: string;
    creator_type: EntityTypes; // e.g., 'EMPLOYEE' or 'RECEIPT' if using snake case for enums, adjust accordingly
    creator_name: string;
    debtor_id: string;
    debtor_type: EntityTypes;
    debtor_name: string;
    shift_id?: string; // TODO: Make Optional
    store_id: string;
    merchant_id: string;
    origin_type: DebtOriginType; // e.g., 'sale' | 'loan' | 'transfer'
    principal_amount: number;
    interest_rate: number; // e.g., 5.5 for 5.5%
    reason: string;
    payment_type_id?: string;
    is_due_date_auto_calculated?: boolean;
    initial_outstanding_balance?: number;
    next_due_date?: string; // ISO 8601, optional if auto-calculated
    receipt_id?: string;
    payment_plan?: {
        amount: number;
        frequency: number; // in days
        note?: string;
    };
}
export interface UpdateDebtStatusCommandPayload {
    debt_id: string;
    store_id: string;
    merchant_id: string;
    updator_id: string;
    updator_type: EntityTypes;
    updator_name: string;
    status: DebtStatus; // e.g., 'ACTIVE', 'OVERDUE', etc.
}
export interface CancelDebtCommandPayload {
    debt_id: string;
    store_id: string;
    merchant_id: string;
    updator_id: string;
    updator_type: EntityTypes;
    updator_name: string;
    reason: string;
}
export interface TransferDebtCommandPayload {
    from_debt_id: string;
    new_debtor_id: string;
    new_debtor_type: EntityTypes;
    new_debtor_name: string;
    amount: number;
    note: string;
    shift_id?: string; // TODO: Make Optional
    store_id: string;
    merchant_id: string;
    creator_id: string;
    creator_type: EntityTypes;
    creator_name: string;
}
export interface UpdateDateInterestRateCommandPayload {
    debt_id: string;
    store_id: string;
    merchant_id: string;
    updator_id: string;
    updator_type: EntityTypes;
    updator_name: string;
    interest_rate: number;
}
export interface UpdateDebtPrincipalCommandPayload {
    debt_id: string;
    store_id: string;
    merchant_id: string;
    updator_id: string;
    updator_type: EntityTypes;
    updator_name: string;
    principal_amount: number;
}
//
// Payment Commands Payloads
//
export interface AddDebtPaymentCommandPayload {
    debt_id: string;
    amount: number;
    payment_type: PaymentMethodType; // e.g., 'CASH', 'CARD'
    payment_type_id?: string; // ID of the payment type if selected from PaymentType entity
    payment_type_name?: string; // Name of the payment type if selected from PaymentType entity
    payer_id: string;
    payer_type: EntityTypes;
    payer_name: string;
    store_id: string;
    merchant_id: string;
    user_id: string; // who is recording the payment
    note?: string;
    shift_id?: string;
}
export interface UpdateDebtPaymentPlanCommandPayload {
    debt_id: string;
    amount?: number;
    frequency?: number;
    note?: string;
    store_id: string;
    merchant_id: string;
    updator_id: string;
    updator_type: EntityTypes;
    updator_name: string;
}
//
// Reversal Command Payloads
//
export interface ReverseDebtPaymentCommandPayload {
    debt_id: string;
    payment_id: string;
    store_id: string;
    merchant_id: string;
    user_id: string;
    updator_type: EntityTypes;
    updator_name: string;
    reason: string;
    shift_id?: string;
}
export interface ReverseDebtCommandPayload {
    debt_id: string;
    store_id: string;
    merchant_id: string;
    user_id: string;
    updator_type: EntityTypes;
    updator_name: string;
    reason: string;
    shift_id?: string;
    payment_type_id: string;
}
export enum DebtCommandType {
    CREATE_DEBT = 'CREATE_DEBT',
    UPDATE_DEBT_STATUS = 'UPDATE_DEBT_STATUS',
    CANCEL_DEBT = 'CANCEL_DEBT',
    TRANSFER_DEBT = 'TRANSFER_DEBT',
    UPDATE_INTEREST_RATE = 'UPDATE_INTEREST_RATE',
    UPDATE_PRINCIPAL_AMOUNT = 'UPDATE_PRINCIPAL_AMOUNT',
    ADD_PAYMENT = 'ADD_PAYMENT',
    UPDATE_PAYMENT_PLAN = 'UPDATE_PAYMENT_PLAN',
    REVERSE_PAYMENT = 'REVERSE_PAYMENT',
    REVERSE_DEBT = 'REVERSE_DEBT'
}
export interface DebtCommand {
    command: DebtCommandType;
    createDebtCommandPayload?: CreateDebtCommandPayload;
    updateDebtStatusCommandPayload?: UpdateDebtStatusCommandPayload;
    cancelDebtCommandPayload?: CancelDebtCommandPayload;
    transferDebtCommandPayload?: TransferDebtCommandPayload;
    updateDateInterestRateCommandPayload?: UpdateDateInterestRateCommandPayload;
    updateDebtPrincipalCommandPayload?: UpdateDebtPrincipalCommandPayload;
    addDebtPaymentCommandPayload?: AddDebtPaymentCommandPayload;
    updateDebtPaymentPlanCommandPayload?: UpdateDebtPaymentPlanCommandPayload;
    reverseDebtPaymentCommandPayload?: ReverseDebtPaymentCommandPayload;
    reverseDebtCommandPayload?: ReverseDebtCommandPayload;
}
export interface DebtDBItem extends Debt {
    PK: string; // MERCHANT#<merchant_id>#STORE#<store_id>
    SK: string; // DEBT#<debt_id>
    EntityIndexPK: string; // DEBT
    EntityIndexSK: string; // MERCHANT#<merchant_id>#STORE#<store_id>#DATE#<created_at>
    GSI1PK: string; // STORE#<store_id>#DEBT_STATUS#<debt_status>
    GSI1SK: string; // DEBT#DATE#<created_at>
    GSI2PK: string; // STORE#<store_id>#DEBT_ORGIN#<debt_orign>
    GSI2SK: string; // DEBT#DATE#<created_at>
    GSI3PK: string; // <debtor_type>#<debtor_id>
    GSI3SK: string; // DEBT#MERCHANT#<merchant_id>#STORE#<store_id>#DATE#<created_at>
    GSI4PK: string; // <creator_type>#<creator_id>
    GSI4SK: string; // DEBT#MERCHANT#<merchant_id>#STORE#<store_id>#DATE#<created_at>
    GSI5PK?: string; // MERCHANT#<merchant_id>#STORE#<store_id>#RECEIPT#<receipt_id>
    GSI5SK?: string; // DEBT#<debt_id>#DATE#<created_at>
}
export interface DebtChangeDBItem extends DebtChange {
    PK: string; // DEBT#<debt_id>
    SK: string; // DEBT_CHANGE#<version>
    EntityIndexPK: string; // DEBT_CHANGE
    EntityIndexSK: string; // MERCHANT#<merchant_id>#STORE#<store_id>#DATE#<created_at>
    GSI1PK: string; // <updator_type>#<updator_id>
    GSI1SK: string; // DEBT_CHANGE#DEBT#<debt_id>#DATE#<created_at>
    GSI2PK: string; // STORE#<store_id>#DEBT_CHANGE#<event>
    GSI2SK: string; // DEBT#<debt_id>#DATE#<created_at>
}
export interface DebtPaymentDBItem extends DebtPayment {
    PK: string; // DEBT#<debt_id>
    SK: string; // DEBT_PAYMENT#<payment_id>
    EntityIndexPK: string; // DEBT_PAYMENT
    EntityIndexSK: string; // DEBT_PAYMENT#MERCHANT#<merchant_id>#STORE#<store_id>#DATE#<created_at>
    GSI1PK: string; // <payer_type>#<payer_id>
    GSI1SK: string; // DEBT_PAYMENT#DATE#<created_at>
    GSI2PK: string; // STORE#<store_id>
    GSI2SK: string; // DEBT_PAYMENT#DATE#<created_at>
    GSI3PK: string; // USER#<user_id>
    GSI3SK: string; // DEBT_PAYMENT#DATE#<created_at>
    GSI4PK: string; // DEBT#<debt_id>
    GSI4SK: string; // DEBT_PAYMENT#DATE#<created_at>
}
export interface GetDebtAggregate {
    debt_id: string;
    merchant_id: string;
    store_id: string;
    change_cursor?: string;
    payment_cursor?: string;
    change_limit?: number;
    payment_limit?: number;
}
export interface GetDebts {
    by_store?: boolean; // get all debts for a store: use PK, SK
    by_store_and_date_range?: boolean; // get all debts for a store within a date range: use EntityIndexPK, EntityIndexSK
    by_store_and_status?: boolean; // get all debts for a store with a specific status: use GSI1PK, GSI1SK
    by_store_and_status_and_date_range?: boolean; // get all debts for a store with a specific status within a date range: use GSI1PK, GSI1SK
    by_store_and_origin?: boolean; // get all debts for a store with a specific origin: use GSI2PK, GSI2SK
    by_store_and_origin_and_date_range?: boolean; // get all debts for a store with a specific origin within a date range: use GSI2PK, GSI2SK
    by_creator?: boolean; // get all debts created by a user: use GSI4PK, GSI4SK
    by_creator_and_date_range?: boolean; // get all debts created by a user within a date range: use GSI4PK, GSI4SK
    by_debtor?: boolean; // get all debts for a debtor: use GSI3PK, GSI3SK
    by_debtor_and_store?: boolean; // get all debts for a debtor for a store: use GSI3PK, GSI3SK
    by_debtor_and_date_range?: boolean; // get all debts for a debtor within a date range: use GSI3PK, GSI3SK
    by_merchant?: boolean; // get all debts for a merchant: use EntityIndexPK, EntityIndexSK
    by_merchant_and_date_range?: boolean; // get all debts for a merchant within a date range: use EntityIndexPK, EntityIndexSK
    by_receipt?: boolean; // get all debts for a receipt: use GSI5PK, GSI5SK
    store_id?: string;
    merchant_id: string;
    status?: DebtStatus;
    origin?: DebtOriginType;
    debtor_id?: string;
    debtor_type?: EntityTypes;
    creator_id?: string;
    creator_type?: EntityTypes;
    start_date?: string;
    end_date?: string;
    receipt_id?: string;
    limit?: number;
    cursor?: string;
    with_debts?: boolean;
}
export interface GetDebtPayments {
    by_debt?: boolean; // get all payments for a debt: use PK, SK
    by_debt_and_date_range?: boolean; // get all payments for a debt within a date range: use GSI4PK, GSI4SK
    by_payer?: boolean; // get all payments made by a payer: use GSI1PK, GSI1SK
    by_payer_and_date_range?: boolean; // get all payments made by a payer within a date range: use GSI1PK, GSI1SK
    by_merchant?: boolean; // get all payments for a merchant: use EntityIndexPK, EntityIndexSK
    by_merchant_and_date_range?: boolean; // get all payments for a merchant within a date range: use EntityIndexPK, EntityIndexSK
    by_store?: boolean; // get all payments for a store: use GSI2PK, GSI2SK
    by_store_and_date_range?: boolean; // get all payments for a store within a date range: use GSI2PK, GSI2SK
    debt_id?: string;
    payer_id?: string;
    payer_type?: EntityTypes;
    store_id?: string;
    merchant_id: string;
    start_date?: string;
    end_date?: string;
    limit?: number;
    cursor?: string;
}
export interface DebtPaymentsPage {
    payments: DebtPayment[];
    cursor: string;
    count: number;
}
export interface DebtChangesPage {
    changes: DebtChange[];
    cursor: string;
    count: number;
}
export interface DebtsPage {
    debts: Debt[];
    cursor: string;
    count: number;
}
export interface DebtAggregate {
    debt: Debt;
    changes: DebtChangesPage;
    payments: DebtPaymentsPage;
}
export interface DebtorSummary {
    debtor_id: string;
    debtor_type: EntityTypes;
    debtor_name: string;
    total_money_debt: number;
    total_money_payments: number;
    total_money_outstanding: number;
    total_money_overdue: number;
    total_money_defaulted: number;
    total_money_closed: number;
    total_money_interest: number;
    total_money_principal: number;
    total_money_transferred_out: number;
    total_money_transferred_in: number;
    next_due_date: string;
    stores: string[];
    overdue_count: number;
    debt_count: number;
    closed_count: number;
    debts: DebtAggregate[];
    /** Cursor for paginating closed/terminal debts. Undefined when there are no more pages. */
    closed_debt_cursor?: string;
    /** Whether there are more closed debts beyond the current page. */
    has_more_closed_debts?: boolean;
}
// =============================================================================
// Outstanding Balance (aggregate endpoint)
// =============================================================================
export interface OutstandingBalanceResponse {
    outstanding_balance: number;
    debt_count: number;
}
export interface GetOutstandingBalanceDto {
    merchant_id: string;
    store_id: string;
    as_of: string;
}
export interface GetDebtorSummary {
    debtor_id: string;
    debtor_type: EntityTypes;
    merchant_id: string;
    store_id: string;
    with_debts?: boolean;
    /** Cursor for paginating closed/terminal debts. Omit for the first page. */
    closed_debt_cursor?: string;
    /** Number of closed debts per page (default 10). */
    closed_debt_limit?: number;
}

//help.loyverse.com/help/how-discounts-are-calculated
export enum DiscountType {
    FIXED_PERCENT = 'FIXED_PERCENT',
    FIXED_AMOUNT = 'FIXED_AMOUNT',
    VARIABLE_PERCENT = 'VARIABLE_PERCENT',
    VARIABLE_AMOUNT = 'VARIABLE_AMOUNT',
    DISCOUNT_BY_POINTS = 'DISCOUNT_BY_POINTS'
}
/**
 * How a discount reaches a sale.
 * - AUTOMATIC: the POS applies it to every sale of the assigned products
 *   (each product belongs to at most one automatic discount; membership
 *   enables allow_below_cost_sale).
 * - MANUAL: a predefined discount (e.g. "10MT", "5%") the cashier picks per
 *   cart line at checkout. Products subscribe to it (many-to-many); it is
 *   never applied automatically and never touches allow_below_cost_sale.
 */
export enum DiscountApplication {
    AUTOMATIC = 'AUTOMATIC',
    MANUAL = 'MANUAL'
}
export interface Discount extends Timestamps, Versioned {
    id: string; // UUID. Optional for creation, required for update.
    type: DiscountType; // Discount type.
    name: string; // Discount name. Length between 1 and 40 characters.
    discount_amount?: number; // Discount value in money, required only for FIXED_AMOUNT.
    discount_percent?: number; // Discount value in percentage, required only for FIXED_PERCENT.
    store_id: string;
    restricted_access?: boolean; // If true, password verification is required to apply.
    /** Absent on rows stored before this field existed: treated as AUTOMATIC. */
    application?: DiscountApplication;
    /**
     * Optional ISO deadline. Once it passes the discount can no longer be
     * applied (calculation rejects it, receipts record a failed check) and
     * the expiry sweeper turns allow_below_cost_sale back off on every
     * product in product_ids. Null/absent = no deadline.
     */
    valid_until?: string | null;
    /**
     * Store products assigned to this discount. For AUTOMATIC discounts each
     * product can belong to at most one discount and membership enables
     * allow_below_cost_sale (removing membership disables it). For MANUAL
     * discounts this is the list of products the cashier may apply it to.
     */
    product_ids?: string[];
    /**
     * Merchant the discount's store belongs to. Required for product
     * assignments so the discount service can call the products service.
     */
    merchant_id?: string;
    /**
     * User who configured the deadline. The expiry sweeper acts as this
     * user when resetting product flags, so the audit trail attributes the
     * change to the person who scheduled it.
     */
    deadline_set_by?: string | null;
    /**
     * Set by the expiry sweeper once the product flags for this deadline
     * have been reset, so a deadline is processed exactly once. Cleared
     * whenever a new valid_until is set.
     */
    expiry_processed_at?: string | null;
    /** Number of consecutive failed attempts to clean up expired products. */
    expiry_attempt_count?: number;
    /** Set after cleanup reaches its retry limit and needs manager attention. */
    expiry_failed_at?: string | null;
    /** Last cleanup error, shown to managers when automatic cleanup gives up. */
    expiry_error?: string | null;
}
/** Immutable discount details stored on product audit records. */
export interface DiscountAuditSnapshot {
    id: string;
    name: string;
    type: DiscountType;
    discount_amount?: number;
    discount_percent?: number;
    valid_until?: string | null;
}
export enum ProductDiscountChangeAction {
    ASSIGNED = 'ASSIGNED',
    REASSIGNED = 'REASSIGNED',
    UNASSIGNED = 'UNASSIGNED',
    UPDATED = 'UPDATED',
    EXPIRED = 'EXPIRED',
    DELETED = 'DELETED',
    PRODUCT_PRICE_UPDATED = 'PRODUCT_PRICE_UPDATED'
}
/** Structured metadata sent to the products service for history and realtime. */
export interface ProductDiscountChange {
    action: ProductDiscountChangeAction;
    previous_discount?: DiscountAuditSnapshot | null;
    discount?: DiscountAuditSnapshot | null;
    occurred_at: string;
}
export interface DiscountPage {
    discounts: Discount[];
    count: number;
    cursor?: string;
}
export interface CreateDiscount {
    type: DiscountType;
    name: string;
    discount_amount?: number;
    discount_percent?: number;
    store_id: string;
    restricted_access?: boolean;
    /** Defaults to AUTOMATIC when absent. */
    application?: DiscountApplication;
    valid_until?: string | null;
    /** Accepted only for MANUAL discounts (the products the cashier may apply it to). */
    product_ids?: string[];
    merchant_id?: string;
    deadline_set_by?: string | null;
    updator_id?: string;
}
export interface UpdateDiscount {
    id: string;
    type?: DiscountType;
    name?: string;
    discount_amount?: number;
    discount_percent?: number;
    store_id: string;
    restricted_access?: boolean;
    /** Must equal the stored value; the application of a discount cannot change. */
    application?: DiscountApplication;
    /**
     * Set a new deadline (ISO string), or null to remove the deadline.
     * Setting a non-null deadline clears expiry_processed_at so the sweeper
     * treats it as a fresh deadline.
     */
    valid_until?: string | null;
    /**
     * Rejected on update: replacing the list would discard concurrent changes.
     * Send subscribe_product_ids / unsubscribe_product_ids instead.
     */
    product_ids?: string[];
    /** Manual discounts only: merged into the subscribed products on the server. */
    subscribe_product_ids?: string[];
    unsubscribe_product_ids?: string[];
    merchant_id?: string;
    deadline_set_by?: string | null;
    updator_id?: string;
}
/** Assigns one product to at most one discount, or removes its assignment. */
export interface SetProductDiscount {
    store_id: string;
    merchant_id: string;
    product_id: string;
    discount_id: string | null;
    updator_id: string;
}
export interface ProductDiscountAssignment {
    product_id: string;
    discount_id: string | null;
}
export interface DiscountDBItem extends Discount {
    PK: string;
    SK: string;
    GSI1PK: string;
    GSI1SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
    /** Sparse expiry index; present only while a deadline is unprocessed. */
    GSI8PK?: string;
    GSI8SK?: string;
}
export interface GetDiscountById {
    id: string;
    include_deleted?: SoftDeleteFlag;
}
export interface GetDiscounts {
    store_id: string;
    limit?: number;
    cursor?: string;
    include_deleted?: SoftDeleteFlag;
    /**
     * Manual (cashier-applied) discounts are only returned when true, so clients
     * built before they existed cannot apply them automatically.
     */
    include_manual?: boolean;
}
export interface DiscountPage {
    discounts: Discount[];
    cursor?: string;
    count: number;
}
export enum CalculateDiscountCommands {
    PERCENTAGE = 'PERCENTAGE',// Apply a percentage discount to the item or receipt
    FIXED = 'FIXED',// Apply a fixed amount discount to the item or receipt
    MULTIPLE_DISCOUNTS = 'MULTIPLE_DISCOUNTS',// Apply multiple discounts (percentage + fixed) to the item or receipt
    ITEM_LEVEL_DISCOUNT = 'ITEM_LEVEL_DISCOUNT',// Apply item-level discounts where each item can have its own discounts
    RECEIPT_LEVEL_DISCOUNT = 'RECEIPT_LEVEL_DISCOUNT',// Apply receipt-level discount across all items in the receipt
    TAX_AFTER_DISCOUNT = 'TAX_AFTER_DISCOUNT',// Apply tax after discounts have been applied
    TAX_BEFORE_DISCOUNT = 'TAX_BEFORE_DISCOUNT'
}
export interface CalculateDiscount {
    item_price: number;
    discount_ids: string[];
    added_discount_id: string;
    included_discount_ids: string[];
    command: CalculateDiscountCommands;
}
export interface CalculateDiscountResultItem {
    // The list of items, used for item-level discounts
    price: number; // Original price of the item
    finalPrice: number; // Final price of the item after applying discounts
    discount_value?: number; // Total discount applied to this item
    discount_ids: string[]; // List of discount IDs applied to the item
}
export interface CalculateDiscountResult {
    discount_command: CalculateDiscountCommands; // The command that was used for this discount calculation
    item_price?: number; // The original item price (for single-item discounts)
    final_price?: number; // The final price after discounts (and possibly taxes) have been applied
    discount_value?: number; // The total amount discounted
    total_discount?: number; // The total discount applied across all items or to the receipt
    total_tax?: number; // The total tax applied (used in tax-before/after scenarios)
    items?: CalculateDiscountResultItem[]; // The list of items with their final prices and discounts
}

export interface ShopAndSmileEventMetadata {
    correlation_id?: string; // Id of the transaction this event is part of
    causation_id: string; // Id of the event that caused this event
    event_id: string;
    event_version: number;
    time: string;
    source: ShopAndSmileEventSource;
    stage: string;
    service: string;
    tags: string[];
    creator_id: string;
    creator_type: EntityTypes;
    creator_name: string;
}
export interface EventStoreKeys {
    PK: string; // EVENT#<eventId>
    SK: string; // EVENT#<eventId>
    GSI1PK: string; // CORRELATION#<correlationId>
    GSI1SK: string; // EVENT#<eventId>
    GSI2PK: string; // <entityType>#<entityId>
    GSI2SK: string; // EVENT#DATE#<eventTime>
    GSI3PK: string; // <event>
    GSI3SK: string; // EVENT#<eventId>
    GSI4PK: string; // DOMAIN#<domain>
    GSI4SK: string; // <event>#DATE#<eventTime>#EVENT#<eventId>
    GSI5PK: string; // <creatorType>#<creatorId>
    GSI5SK: string; // <entityType>#<entityId>#EVENT#<eventId>
    GSI6PK: string; // <isSuccess>
    GSI6SK: string; // <entityType>#<entityId>#DATE#<eventTime>#EVENT#<eventId>
    EntityIndexPK: string; // EntityType
    EntityIndexSK: string; // DATE#<eventTime>#EVENT#<eventId>
}
export interface TimeRange {
    from: string;
    to: string;
}

/**
 * Types for the Dead Letter Queue failed-event archive system.
 *
 * These types are shared between:
 *  - The DLQ archiver Lambda (writes events to DynamoDB)
 *  - The service-admin API (reads, searches, redrives, deletes)
 *  - The admin web UI (displays events)
 *  - The API adapter in @bofrak-backend/shared (typed HTTP client)
 */
/** Status of a failed event in the archive */
export type FailedEventStatus = 'FAILED' | 'REDRIVEN' | 'DELETED';
/** A single failed event as stored in the FailedEvents DynamoDB table */
export interface FailedEvent {
    PK: string; // QUEUE#<queueName>
    SK: string; // FAILED_AT#<isoTimestamp>#MSG#<messageId>
    EntityIndexPK: string; // literal 'FAILED_EVENT'
    EntityIndexSK: string; // QUEUE#<queue>#FAILED_AT#<iso>
    GSI1PK: string; // SERVICE#<serviceName>
    GSI1SK: string; // FAILED_AT#<isoTimestamp>
    queueName: string;
    sourceQueue: string;
    dlqName: string;
    service: string;
    messageId: string;
    receiptHandle: string;
    /** Original SQS message body (JSON string) */
    body: string;
    /** Parsed message body for structured queries */
    bodyParsed: Record<string, unknown>;
    /** SQS message system attributes (ApproximateReceiveCount, SentTimestamp, etc.) */
    attributes: Record<string, string>;
    /** SQS message attributes */
    messageAttributes: Record<string, unknown>;
    /** ISO 8601 timestamp when the event was archived */
    failedAt: string;
    /** How many times SQS delivered this message before it landed in the DLQ */
    receiveCount: number;
    /** Full JSON.stringify of the entire event — used for contains() text search */
    searchText: string;
    status: FailedEventStatus;
    /** ISO 8601 timestamp when the event was redriven (if applicable) */
    redrivenAt?: string;
    /** New SQS message ID assigned after redrive */
    redriveMessageId?: string;
    /**
     * ISO 8601 time a redrive claimed the event before sending; removed once it
     * is REDRIVEN. Kept when the send's outcome was unknown, until it is older
     * than 5 minutes. Optional for backwards compatibility; missing = not claimed.
     */
    redriveClaimedAt?: string;
    /** ISO 8601 timestamp when the event was deleted (if applicable) */
    deletedAt?: string;
    /** User/admin who deleted the event */
    deletedBy?: string;
}
/** Parameters for searching failed events */
export interface FailedEventSearchParams {
    /** Search term — matches any substring in the stringified event (searchText field) */
    q: string;
    /** Filter by a specific queue name */
    queueName?: string;
    /** Filter by service name */
    service?: string;
    /** Filter by event status (default: FAILED) */
    status?: FailedEventStatus;
    /** ISO date string — earliest failedAt to include */
    from?: string;
    /** ISO date string — latest failedAt to include */
    to?: string;
    /** Maximum results per page (1–200, default 50) */
    limit?: number;
    /** Pagination cursor from a previous response */
    cursor?: string;
}
/** A page of search results */
export interface FailedEventPage {
    /** The original search query */
    query: string;
    /** Filter criteria that were applied */
    queueName?: string;
    service?: string;
    status?: string;
    /** Number of items in this page */
    count: number;
    /** The failed events in this page */
    items: FailedEvent[];
    /** Opaque cursor for the next page, or null if this is the last page */
    nextCursor: string | null;
    /**
     * False when the queue's events cannot be sent back to a queue (a Lambda
     * failure destination). Optional for backwards compatibility; missing = true.
     */
    redrivable?: boolean;
}
/** Summary metadata for a queue that has failed events */
export interface QueueSummary {
    queueName: string;
    sourceQueue: string;
    service: string;
    /** Number of events with status FAILED */
    failedCount: number;
    /** Number of events with status REDRIVEN */
    redrivenCount: number;
    /** ISO timestamp of the most recent failure, or null if empty */
    lastFailedAt: string | null;
    /**
     * False when the queue's events cannot be sent back to a queue (a Lambda
     * failure destination). Optional for backwards compatibility; missing = true.
     */
    redrivable?: boolean;
}
/** Response from listing all queues */
export interface QueueSummaryPage {
    queues: QueueSummary[];
}
/** Request body for redriving a failed event */
export interface RedriveFailedEventRequest {
    queueName: string;
    messageId: string;
    /** Full SK of the DynamoDB item (needed to look up the event) */
    sk: string;
}
/** Result of a redrive operation */
export interface RedriveResult {
    message: string;
    oldMessageId: string;
    newMessageId: string;
    sourceQueue: string;
}
/** Request body for deleting a failed event */
export interface DeleteFailedEventRequest {
    queueName: string;
    messageId: string;
    sk: string;
}
/** Result of a delete operation */
export interface DeleteResult {
    message: string;
    messageId: string;
    deletedAt: string;
}
/** A problem with a queue, shown on the admin Queues page. */
export enum QueueWarning {
    /** A main queue without a dead-letter queue: failures retry until they expire. */
    NO_DLQ = 'NO_DLQ',
    /** A dead-letter queue nothing archives: its messages are only visible in AWS. */
    DLQ_NOT_ARCHIVED = 'DLQ_NOT_ARCHIVED',
    /** A dead-letter queue holding messages. */
    DLQ_HAS_MESSAGES = 'DLQ_HAS_MESSAGES',
    /** Messages are kept under 14 days and can expire before they are processed. */
    SHORT_RETENTION = 'SHORT_RETENTION',
    /** The oldest message has waited longer than 15 minutes. */
    STUCK = 'STUCK'
}
/** A Lambda function reading from a queue. */
export interface QueueConsumer {
    function_name: string;
    enabled: boolean;
}
/** One SQS queue of the stage, with its live counts (admin Queues page). */
export interface QueueStatus {
    /** Physical SQS queue name. */
    name: string;
    /** The service that owns it, e.g. `service-receipts`. */
    service: string;
    fifo: boolean;
    role: 'main' | 'dlq';
    /** A main queue's dead-letter queue (name). */
    dead_letter_queue?: string | null;
    /** Receives before a message moves to the dead-letter queue. */
    max_receive_count?: number | null;
    /** The queues that redrive to this dead-letter queue (names). */
    source_queues: string[];
    /** This DLQ's name in the failed-events archive, when it is archived. */
    archive_queue_name?: string | null;
    consumers: QueueConsumer[];
    /** Messages waiting. */
    visible: number;
    /** Messages being processed (or waiting for a retry). */
    in_flight: number;
    delayed: number;
    /** Seconds; null when CloudWatch has no datapoint (an idle queue). */
    oldest_message_age_seconds?: number | null;
    sent_24h?: number | null;
    deleted_24h?: number | null;
    visibility_timeout_seconds: number;
    retention_seconds: number;
    warnings: QueueWarning[];
}
/** Every SQS queue of the stage. */
export interface QueueStatusPage {
    stage: string;
    retrieved_at: string;
    queues: QueueStatus[];
}
/** A message read (not removed) from a dead-letter queue. */
export interface PeekedQueueMessage {
    message_id: string;
    body: string;
    sent_at?: string | null;
    receive_count?: number | null;
    message_group_id?: string | null;
}
/** A sample of up to 10 messages of a dead-letter queue. */
export interface PeekedQueueMessages {
    queue_name: string;
    messages: PeekedQueueMessage[];
}

export enum ApprovalStatus {
    UNAPPROVED = 'UNAPPROVED',
    APPROVED = 'APPROVED'
}
export interface GlobalProduct extends Timestamps, Versioned {
    id: string;
    name: string;
    description: string;
    images: string[];
    quantity_in_unit_package: number;
    suggested_cost?: number;
    weight_kg: number;
    unit: string | number;
    unit_of_measurement: string;
    /** ISO 3166-1 alpha-2 country code the product belongs to (e.g. "MZ").
     * Legacy scalar kept for older clients; always the first of `countries`. */
    country?: string;
    /** ISO 3166-1 alpha-2 codes of every country the product is sold in.
     * Optional for backwards compatibility; missing = `country ? [country] : []`. */
    countries?: string[];
    fraction: number;
    parent_id: string;
    is_parent: boolean;
    product_fractions: GlobalProductFraction[];
    barcodes: Barcode[];
    tags: string[];
    import_ids?: string[];
    approval_status: ApprovalStatus;
    issues: ProductIssue[];
}
export interface ProductIssue {
    issue_type: ProductIssueType;
    message: string;
    created_at: string;
    is_resolved: boolean;
    metadata?: Record<string, any>;
}
export enum ProductIssueType {
    CONFLICTING_BARCODES = 'CONFLICTING_BARCODES',
    MISSING_PARENT = 'MISSING_PARENT',
    CONFLICTING_ATTRIBUTES = 'CONFLICTING_ATTRIBUTES'
}
export interface GlobalProductFraction extends Timestamps, Versioned {
    parent_id: string;
    fraction_id: string;
    fraction: number;
    fraction_name: string;
    parent_name: string;
}
export interface GlobalProductPage {
    products: GlobalProduct[];
    cursor?: string;
    count: number;
}
export interface GlobalProductFractionPage {
    fractions: GlobalProductFraction[];
    cursor?: string;
    count: number;
}
export interface CreateGlobalProduct {
    name: string;
    description: string;
    images?: string[];
    quantity_in_unit_package: number;
    suggested_cost?: number;
    weight_kg: number;
    unit: string | number;
    unit_of_measurement: string;
    /** ISO country code the product belongs to (e.g. "MZ"). A country name
     * is also accepted and normalized to its code. */
    country?: string;
    /** Every country the product is sold in (codes or names). Merged with
     * `country`; defaults to `["MZ"]` when both are omitted. */
    countries?: string[];
    barcodes?: Barcode[];
    tags?: string[];
    import_ids?: string[];
    parent_id?: string;
}
export interface UpdateGlobalProduct {
    id: string;
    name?: string;
    description?: string;
    images?: string[];
    parent_id?: string;
    quantity_in_unit_package?: number;
    suggested_cost?: number | null;
    weight_kg?: number;
    unit?: string | number;
    unit_of_measurement?: string;
    add_barcodes?: Barcode[];
    remove_barcodes?: Barcode[];
    add_tags?: string[];
    remove_tags?: string[];
    add_import_ids?: string[];
    approval_status?: ApprovalStatus;
    add_images?: string[];
    remove_images?: string[];
    /** ISO country code the product belongs to (e.g. "MZ"). A country name
     * is also accepted and normalized to its code. */
    country?: string;
    /** Replaces the full list of countries the product is sold in. */
    countries?: string[];
}
export interface GetGlobalProducts {
    cursor?: string;
    limit?: number;
    approval_status?: ApprovalStatus;
    include_children?: boolean;
    hydrate_fractions?: boolean;
    /** Only return products sold in this country code (e.g. "MZ"): matches
     * `countries` or the legacy `country` of rows without a list. */
    country?: string;
}
export interface GetGlobalProductsByBarcode {
    barcode: string | number;
    approval_status?: ApprovalStatus;
    include_children?: boolean;
}
export interface GetGlobalProductsByTags {
    tags: string[];
    cursor?: string;
    limit?: number;
    approval_status?: ApprovalStatus;
    include_children?: boolean;
}
export interface GetGlobalProductFractions {
    parent_id: string;
    cursor?: string;
    limit?: number;
}
export interface CreateGlobalProductFraction {
    fraction_id: string;
    parent_id: string;
}
export interface GlobalProductDBItem extends GlobalProduct {
    PK: string;
    SK: string;
    GSI1PK: string;
    GSI1SK: string;
    GSI2PK: string;
    GSI2SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}
export interface GlobalProductFractionDBItem extends GlobalProductFraction {
    PK: string;
    SK: string;
    GSI1PK: string;
    GSI1SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}
export interface GlobalProductBarcodeIndexItem {
    PK: string;
    SK: string;
    GSI1PK: string;
    GSI1SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
    barcode_value: string;
    global_product_id: string;
}
export interface GlobalProductTagIndexItem {
    PK: string;
    SK: string;
    GSI1PK: string;
    GSI1SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
    tag: string;
    global_product_id: string;
}

/**
 * Activity Timeline (docs/plans/concurrency-safe-writes.md §4.3): the
 * history table's changes, as read by the back office. No snapshots and no
 * secret values are ever returned.
 */
/** What happened to the entity. */
export enum ActivityAction {
    CREATED = 'CREATED',
    UPDATED = 'UPDATED',
    DELETED = 'DELETED',
    RESTORED = 'RESTORED'
}
/** AUTOMATIC: made by the system (e.g. stock moved by a sale). */
export enum ActivityOrigin {
    MANUAL = 'MANUAL',
    AUTOMATIC = 'AUTOMATIC'
}
export interface ActivityChange {
    field: string;
    old?: unknown;
    new?: unknown;
    /** True when the values were too large to send; only the field changed. */
    truncated?: boolean;
}
export interface Activity {
    /** Opaque, unique per change (list key). */
    id: string;
    changed_at: string;
    actor_id?: string;
    actor_name?: string;
    /** INSERT, MODIFY or REMOVE. */
    event: string;
    action: ActivityAction;
    /** The entity's `EntityIndexPK` (e.g. STORE_PRODUCT). */
    entity_type: string;
    entity_label?: string;
    origin: ActivityOrigin;
    /** Empty for creates and hard deletes (nothing to compare). */
    changes: ActivityChange[];
}
export interface ActivityPage {
    activities: Activity[];
    /** Absent on the last page. */
    cursor?: string;
}
/**
 * GET /history/{merchant_id}/stores/{store_id}/activities
 * `from` / `to` are ISO timestamps (default: the last 30 days).
 */
export interface GetActivities {
    merchant_id: string;
    store_id: string;
    from?: string;
    to?: string;
    user_id?: string;
    entity_type?: string;
    /** Default false: automatic changes are hidden. */
    include_automatic?: boolean;
    cursor?: string;
    /** Default 50, at most 100. */
    limit?: number;
}

export interface Image extends Timestamps {
    image_s3_url: string;
    image_url: string;
    image_s3_key: string;
    entity_type: EntityTypes;
    entity_id: string;
    image_id: string;
    merchant_id: string;
}
export interface CreateImage {
    image_id: string;
    base64Image?: string;
    entity_type: EntityTypes;
    entity_id: string;
    merchant_id: string;
    imageUrl?: string;
    isGlobalImage?: boolean;
}
export interface ImagePage {
    images: Image[];
    cursor?: string;
    count: number;
}
export enum ImageFileTypes {
    PNG = 'png',
    JPG = 'jpg',
    JPEG = 'jpeg',
    BMP = 'bmp'
}
export interface UploadImageResponse {
    image_s3_key: string;
    image_id: string;
    file_name: string;
}
export interface UploadItemImageRequest {
    metadata: UploadImageRequest;
    base64Image: string;
}
export interface UploadImageRequest {
    entity_type: EntityTypes;
    entity_id: string;
    updator_id: string;
    store_id: string;
    updator_type: EntityTypes;
}
export interface UploadPromoImageRequest {
    store_id: string;
    merchant_id: string;
    updator_id: string;
    updator_type: EntityTypes;
    base64Image: string;
    item_id: string;
}
export interface ImageMetadata {
    file_type: string;
    entity_type: string;
    entity_id: string;
    image_id: string;
    image_s3_key: string;
    has_been_processed: StringBoolean;
    updator_id: string;
    updator_type: EntityTypes;
    store_id: string;
    merchant_id: string;
    [key: string]: string;
}

/**
 * Integrations with other POS systems (service-integrations). QuickBooks POS
 * is the first provider; Square, Loyverse and others slot in beside it.
 */
export type IntegrationProvider = 'quickbooks';
export type QuickBooksConnectionStatus = 'none' | 'pending_code' | 'connected';
/** One Shop & Smile store ↔ one QuickBooks POS store. */
export interface QuickBooksStoreLink {
    store_id: string;
    qb_store_id: string;
    qb_store_name: string;
    linked_at: string;
    linked_by_id: string;
    linked_by_name: string;
}
/**
 * The merchant's connection to the QuickBooks cloud, keyed by the owner's phone.
 * Made once per merchant; later visits need no code.
 */
export interface QuickBooksConnection extends Timestamps, Versioned {
    merchant_id: string;
    provider: 'quickbooks';
    status: QuickBooksConnectionStatus;
    /** The owner's number as the QuickBooks cloud shows it, e.g. `+258 ••• ••67`. */
    owner_phone_masked: string;
    qb_merchant_id?: string | null;
    qb_merchant_name?: string | null;
    /** True when the QuickBooks business was created by this connection. */
    qb_merchant_created?: boolean | null;
    connected_at?: string | null;
    connected_by_id?: string | null;
    connected_by_name?: string | null;
    /**
     * The token the QuickBooks cloud issued for this business, sent on every
     * partner call. Server-side only: never returned by the API, never in history.
     */
    partner_token?: string | null;
    store_links: QuickBooksStoreLink[];
}
/** Attribute maps chosen once per merchant and reused by every import. */
export interface QuickBooksMappings extends Timestamps, Versioned {
    merchant_id: string;
    /** QuickBooks tax code → Shop & Smile tax id. */
    tax_codes: Record<string, string>;
    /** QuickBooks unit-of-measure name → unit text shown in Shop & Smile. */
    units: Record<string, string>;
}
/** A Shop & Smile product that came from one unit of one QuickBooks item. */
export interface QuickBooksProductLink extends Timestamps, Versioned {
    merchant_id: string;
    /** QuickBooks ListID. */
    qb_list_id: string;
    /** 0 = the item's base unit, 1–3 = UnitOfMeasure1..3. */
    qb_unit: number;
    product_id: string;
    /** Stores this product was imported into. */
    store_ids: string[];
    qb_item_number: string;
    qb_department: string;
    imported_at: string;
}
export type QuickBooksProposalStatus = 'ready' | 'imported' | 'needs_mapping' | 'rejected';
/** One Shop & Smile product proposed from one QuickBooks unit. */
export interface QuickBooksProposedProduct {
    qb_unit: number;
    unit_name: string;
    quantity_in_unit_package: number;
    price: number;
    barcode: string;
    barcodes: Barcode[];
    is_parent: boolean;
    /**
     * A Shop & Smile product this unit already is: imported into another store
     * earlier (its stock and prices are created for this store), or a product
     * of this store with the same barcode (linked instead of duplicated).
     */
    existing_product_id?: string | null;
    existing_product_name?: string | null;
    /** True when `existing_product_id` is already sold in this store. */
    existing_in_store?: boolean | null;
}
/** One QuickBooks item as a Shop & Smile family: the largest unit is the parent. */
export interface QuickBooksProposedFamily {
    qb_list_id: string;
    qb_item_number: string;
    qb_item_type: string;
    name: string;
    description: string;
    department: string;
    tax_code: string;
    tax_id: string | null;
    vendor_name: string;
    /** Parent cost: QuickBooks cost × the parent's base units. */
    cost: number;
    /** Opening stock in parent units. */
    inventory: number;
    /** Minimum stock in parent units. */
    low_stock_threshold: number;
    /** True when a selling price is below cost; the product is imported with below-cost sales allowed. */
    allow_below_cost_sale: boolean;
    parent: QuickBooksProposedProduct;
    children: QuickBooksProposedProduct[];
    status: QuickBooksProposalStatus;
    reasons: string[];
    /** When already imported: the Shop & Smile parent product id. */
    product_id?: string | null;
}
export interface QuickBooksExcludedItem {
    qb_list_id: string;
    name: string;
}
export interface QuickBooksExcludedGroup {
    item_type: string;
    count: number;
    items: QuickBooksExcludedItem[];
}
export interface QuickBooksCatalogCounts {
    total: number;
    ready: number;
    imported: number;
    needs_mapping: number;
    rejected: number;
}
/** The QuickBooks store's catalog as Shop & Smile would import it. */
export interface QuickBooksCatalogPreview {
    store_id: string;
    qb_store_id: string;
    qb_store_name: string;
    online: boolean;
    items_synced_at: string | null;
    families: QuickBooksProposedFamily[];
    excluded: QuickBooksExcludedGroup[];
    unmapped_tax_codes: string[];
    unmapped_units: string[];
    counts: QuickBooksCatalogCounts;
}
export type QuickBooksCatalogPreviewState = 'none' | 'building' | 'ready' | 'failed';
/**
 * The preview is built in the background (a big catalog takes minutes, longer
 * than one request may last); the page asks for a build and polls this.
 */
export interface QuickBooksCatalogPreviewStatus {
    status: QuickBooksCatalogPreviewState;
    /** The build this status is about; a build that was superseded publishes nothing. */
    build_id?: string | null;
    requested_at?: string | null;
    built_at?: string | null;
    /** Why the last build failed, e.g. the store's computer is offline. */
    error?: string | null;
    /** The last preview built, also while a newer one is building. */
    preview?: QuickBooksCatalogPreview | null;
}
/** A QuickBooks POS store as the partner API lists it. */
export interface QuickBooksStoreOption {
    id: string;
    name: string;
    company_name: string;
    online: boolean;
    last_seen_at: string | null;
    items_synced_at: string | null;
    /** The Shop & Smile store it is linked to, if any. */
    linked_store_id: string | null;
}
export interface RequestQuickBooksConnection {
    requested_by: string;
}
export interface RequestQuickBooksConnectionResponse {
    connection: QuickBooksConnection;
    /** False when the business was already connected and no code was sent. */
    code_sent: boolean;
    resend_in_sec?: number;
    expires_in_min?: number;
}
export interface VerifyQuickBooksConnection {
    requested_by: string;
    code: string;
}
export interface LinkQuickBooksStore {
    requested_by: string;
    qb_store_id: string;
}
export interface UpdateQuickBooksMappings {
    updated_by: string;
    tax_codes: Record<string, string>;
    units: Record<string, string>;
}
export type QuickBooksImportAction = 'create' | 'link' | 'skip';
export interface QuickBooksImportItem {
    family: QuickBooksProposedFamily;
    action: QuickBooksImportAction;
}
export interface CreateQuickBooksImport {
    requested_by: string;
    items: QuickBooksImportItem[];
}
export type QuickBooksImportStatus = 'queued' | 'running' | 'done' | 'failed';
export interface QuickBooksImportError {
    qb_list_id: string;
    name: string;
    message: string;
}
/** An import run: progress is updated as each family is created. */
export interface QuickBooksImportJob extends Timestamps, Versioned {
    id: string;
    merchant_id: string;
    store_id: string;
    status: QuickBooksImportStatus;
    total: number;
    done: number;
    failed: number;
    skipped: number;
    errors: QuickBooksImportError[];
    requested_by_id: string;
    requested_by_name: string;
    started_at?: string | null;
    finished_at?: string | null;
    /** S3 key of the items to import. */
    /** Where the items live (private bucket). Server-side only: never returned by the API. */
    payload_key?: string | null;
    /** The next item to process (the job resumes here after a worker time-out). */
    next_index: number;
}
export interface QuickBooksImportJobPage {
    jobs: QuickBooksImportJob[];
    cursor?: string;
}
export interface QuickBooksImportSQSMessage {
    /** `preview` builds the store's catalog preview; missing or `import` runs the job. */
    kind?: 'import' | 'preview' | null;
    /** The run to execute (import messages). */
    job_id?: string | null;
    /** The build to publish (preview messages). */
    build_id?: string | null;
    merchant_id: string;
    store_id: string;
}

/**
 * Data model for the "Relatório de Valor do Inventário" PDF: the signed
 * stock-count sheet generated alongside the inventory value / store product
 * CSV exports. One row per product family (parent product plus its unit
 * fractions), with the live stock of every unit so the person counting the
 * store can verify and sign each family off.
 */
export interface InventoryCountUnitLine {
    product_id: string;
    /** Unit label shown before the quantity, e.g. "Caixa" or "Emb=6". */
    label: string;
    /** quantity_in_unit_package of the member product. */
    quantity: number;
    price: number;
    cost: number;
    /**
     * Live stock recorded against this member's own product id in the
     * inventory service. Stock is consolidated on the parent (a sale of a
     * fraction decrements the parent by `fraction`), so typically only the
     * parent line carries a value here — legacy families with their own child
     * inventory rows are still handled. Kept as the valuation input.
     */
    stock: number;
    /**
     * Units of this unit the family's consolidated stock decomposes into,
     * via the same `calculateInventoryBreakdown` every screen uses. This is
     * the number rendered in the "STOCK POR UNIDADE" / "STOCK PER UNIT"
     * column — e.g. a family holding 3.5 boxes of 24 shows 3 boxes + 12
     * units instead of 3.5 on the parent and 0 everywhere else.
     * Duplicated units are excluded from the split and stay at 0.
     */
    stock_units: number;
    /**
     * True when an earlier unit of the same family has the same
     * quantity_in_unit_package. Duplicated units are rendered flagged in red
     * ("DUPLICADO - NÃO CONTABILIZADO") and excluded from the family value.
     */
    is_duplicate: boolean;
}
export interface InventoryCountFamily {
    /** Parent product id (family key). */
    family_id: string;
    name: string;
    image?: string;
    /** Units sorted by quantity descending (parent wins ties). */
    units: InventoryCountUnitLine[];
    /**
     * The family's whole stock in parent units, and the figure `stock_value`
     * is computed from — so TOTAL × the mother's cost reproduces the printed
     * value for every family.
     *
     * Printed under the split because the per-unit lines cannot show it: they
     * are whole packs, so they account for this number only down to the
     * smallest pack size. Anything below that — the 0.345 of a weighed
     * family, the 12 loose units under a box of 24 — lives only here.
     */
    consolidated_stock: number;
    /**
     * `consolidated_stock` × the mother's cost — the valuation method the
     * sheet states in its summary band. Duplicated units are excluded, since
     * they are excluded from `consolidated_stock`.
     */
    stock_value: number;
}
export interface InventoryCountReport {
    /** Families sorted by stock_value descending. */
    families: InventoryCountFamily[];
    /** Σ stock_value over all families (unrounded). */
    total_value: number;
    family_count: number;
}
/**
 * Languages the inventory-count PDF is rendered in. Every export generates
 * one PDF per language; the merchant's country decides which one the export
 * record points to, defaulting to English.
 */
export type InventoryCountPdfLanguage = 'en' | 'pt';

export enum InventoryTemplateStatus {
    PENDING = 'PENDING',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    INCOMPLETE = 'INCOMPLETE',
    CANCELLED = 'CANCELLED'
}
export interface InventoryTemplate extends Timestamps, Versioned {
    creator_id: string;
    creator_type: EntityTypes;
    counter_id: string;
    counter_type: EntityTypes;
    status: InventoryTemplateStatus;
    count_day: string;
    id: string;
    uncounted_items: string[];
    counted_items: string[];
    store_id: string;
    title: string;
    week_number: number;
}
export interface CreateInventoryTemplate {
    creator_id: string;
    creator_type: EntityTypes;
    counter_id: string;
    counter_type: EntityTypes;
    count_day: string;
    uncounted_items: string[];
    store_id: string;
    title: string;
}
export interface InventoryTemplatesPage extends Paginated {
    inventory_templates: InventoryTemplate[];
}
export interface GetInventoryTemplate {
    store_id: string;
    id: string;
    include_deleted?: SoftDeleteFlag;
}
export interface UpdateInventoryTemplate {
    store_id: string;
    counter_id?: string;
    counter_type?: EntityTypes;
    id: string;
    status?: InventoryTemplateStatus;
    counted_items?: string[];
    uncounted_items?: string[];
    title?: string;
    count_day?: string;
}
export interface DeleteInventoryTemplate {
    store_id: string;
    id: string;
}
export interface GetInventoryTemplates {
    by_count_day?: boolean;
    by_status?: boolean;
    by_counter?: boolean;
    by_year_and_week?: boolean;
    year?: number;
    week?: number;
    store_id?: string;
    counter_id?: string;
    status?: InventoryTemplateStatus;
    count_day?: string;
    limit?: number;
    cursor?: string;
    include_deleted?: SoftDeleteFlag;
}
export interface InventoryTemplateDBItem extends InventoryTemplate {
    /**
     * PK: STORE#<store_id>
     * SK: INVENTORY_TEMPLATE#<id>
     * GS1PK: <status>
     * GS1SK: INVENTORY_TEMPLATE#STORE#<store_id>
     * GS2PK: DATE#<count_day>
     * GS2SK: INVENTORY_TEMPLATE#STORE#<store_id>
     * GS3PK: USER#<counter_id>
     * GS3SK: INVENTORY_TEMPLATE#STORE#<store_id>
     * GSI3PK: INVENTORY_TEMPLATE#<YYYY-WK#>
     * GSI3SK: STORE#<store_id>#INVENTORY_TEMPLATE#<id>
     * EntityIndexPK: INVENTORY_TEMPLATE
     * EntityIndexSK: DATE#<created_at>
     */
    PK: string;
    SK: string;
    GSI1PK: string;
    GSI1SK: string;
    GSI2PK: string;
    GSI2SK: string;
    GSI3PK: string;
    GSI3SK: string;
    GSI4PK: string;
    GSI4SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}

export enum InventoryChangeReason {
    SALE = 'Sale',
    REFUND = 'Refund',
    PURCHASE_ORDER = 'Purchase Order',
    INVENTORY_TRANSFER_IN = 'Inventory Transfer In',
    INVENTORY_TRANSFER_OUT = 'Inventory Transfer Out',
    INVENTORY_COUNT = 'Inventory Count',
    INVENTORY_CORRECTION = 'Inventory Correction'
}
/**
 * Where stock sits (docs/plans/orders-and-transfers.md §4.3). AVAILABLE is
 * the approved on-hand outside reservations; NONE is outside the store (a
 * correction that adds or writes off stock).
 */
export enum StockBucket {
    AVAILABLE = 'AVAILABLE',
    RESERVED = 'RESERVED',
    PENDING = 'PENDING',
    BLOCKED = 'BLOCKED',
    NONE = 'NONE'
}
/**
 * The stock operations of `POST /inventory/{merchant_id}/operations`, the
 * only writer of the bucket counters. More types (returns, purchase
 * receive) arrive with their first caller.
 */
export enum StockOperationType {
    /** AVAILABLE → RESERVED, refused beyond the sellable stock. */
    RESERVE = 'RESERVE',
    /** RESERVED → AVAILABLE. */
    RELEASE = 'RELEASE',
    /** Between AVAILABLE, PENDING and BLOCKED. */
    BUCKET_MOVE = 'BUCKET_MOVE',
    /** Into a bucket from NONE, or out of one to NONE. */
    CORRECTION = 'CORRECTION',
    /**
     * A transfer leaves its source: `quantity` comes out of the approved
     * on-hand and the line's own reservation (`reserved_quantity`) is freed
     * in the same operation, so a shortfall's reservation is released too.
     * Refused beyond `cumulative − (reserved − own reservation)`.
     */
    TRANSFER_DISPATCH = 'TRANSFER_DISPATCH',
    /**
     * A transfer arrives: `quantity` goes into `to_bucket` (AVAILABLE,
     * PENDING or BLOCKED) at the carried `unit_cost`; into AVAILABLE the
     * store's cost is re-weighted with it.
     */
    TRANSFER_RECEIVE = 'TRANSFER_RECEIVE',
    /**
     * Goods of a transfer come back to their source (PR 7): like a receipt,
     * into AVAILABLE (good, re-weighted at the carried `unit_cost`) or
     * BLOCKED (damaged).
     */
    RETURN_RECEIVE = 'RETURN_RECEIVE'
}
/** What a stock operation belongs to; ids only. */
export interface StockOperationReference {
    stock_order_id?: string;
    transfer_id?: string;
    line_id?: string;
    purchase_order_id?: string;
    goods_receipt_id?: string;
}
export interface ApplyStockOperation {
    /**
     * Deterministic id (e.g. `transfer:TR-1:line-1:reserve`): the operation
     * is applied once; a replay returns the recorded result.
     */
    operation_id: string;
    store_id: string;
    product_id: string;
    type: StockOperationType;
    /** Parent units, > 0. */
    quantity: number;
    /** Required for BUCKET_MOVE and CORRECTION. */
    from_bucket?: StockBucket;
    to_bucket?: StockBucket;
    reference?: StockOperationReference;
    /** Free-text reason, kept on the operation record. */
    note?: string;
    /** When it happened at its source; missing = now. */
    occurred_at?: string;
    /** Product name for the stock row and ledger, when known. */
    product_name?: string;
    /**
     * TRANSFER_DISPATCH only: the line's own reservation, freed by the
     * dispatch (may exceed `quantity`: the shortfall is released). Missing = 0.
     */
    reserved_quantity?: number;
    /**
     * TRANSFER_RECEIVE and RETURN_RECEIVE: the cost per unit carried from the
     * source. A BUCKET_MOVE PENDING → AVAILABLE (price approval, PR 7) with a
     * `unit_cost` re-weights the store's cost with it, as a receipt does.
     */
    unit_cost?: number;
    /**
     * Price approval only: the cost the goods were carried at. When it
     * differs from `unit_cost` (the owner's), the ledger row records the
     * valuation adjustment. Missing = no adjustment.
     */
    carried_unit_cost?: number;
}
/** The buckets after an operation, as recorded on its marker. */
export interface StockOperationCounters {
    cumulative_quantity: number;
    reserved_quantity: number;
    pending_quantity: number;
    blocked_quantity: number;
    /** Optional for backwards compatibility (records before PR 4c); missing = 0. */
    manual_reserved_quantity?: number;
}
/**
 * A stock operation as recorded by service-inventory: its replay marker and
 * the audit of a reservation (reservations write no ledger row).
 */
export interface StockOperationRecord {
    operation_id: string;
    merchant_id: string;
    store_id: string;
    product_id: string;
    type: StockOperationType;
    quantity: number;
    from_bucket?: StockBucket;
    to_bucket?: StockBucket;
    reference?: StockOperationReference;
    note?: string;
    /** Reserved or released by hand (Products app). Missing = false. */
    manual?: boolean;
    /**
     * A manual release that could free any reservation: first the stock
     * reserved by hand, then the rest. Missing = false.
     */
    release_any?: boolean;
    /** TRANSFER_DISPATCH: the own reservation it was asked to free. */
    reserved_quantity?: number;
    /**
     * A transfer's RELEASE or TRANSFER_DISPATCH: the reservation actually
     * freed, when part of it had already been released from Products
     * (release_any). Missing = what was asked.
     */
    freed_quantity?: number;
    /**
     * The cost per unit the operation moved stock at: the source's cost for
     * TRANSFER_DISPATCH, the carried cost for TRANSFER_RECEIVE.
     */
    unit_cost?: number;
    /**
     * TRANSFER_RECEIVE into AVAILABLE: the store's new cost, computed in the
     * stock transaction. A replay pushes it again (the store product skips
     * a valuation it already has).
     */
    valuation?: InventoryValuation;
    /** Identifies the request: a replay with another payload is refused. */
    fingerprint: string;
    /** The counters right after it was applied. */
    counters: StockOperationCounters;
    actor_id: string;
    actor_name: string;
    occurred_at: string;
    applied_at: string;
}
/**
 * `POST /inventory/{merchant_id}/stores/{store_id}/products/{product_id}/reservations`:
 * reserve or release stock by hand (Products app). Needs the
 * `orders:stock.reserve` permission in the store and an `Idempotency-Key`
 * header (the operation's id). RESERVE needs the Orders & Transfers module
 * ENABLED; RELEASE works unless it is FROZEN, so held stock never gets stuck.
 */
export interface ManualStockReservation {
    /** RESERVE or RELEASE. */
    type: StockOperationType;
    /** Parent units, > 0. */
    quantity: number;
    /** Why, kept on the operation record. */
    note?: string;
    /**
     * RELEASE only: free any reserved stock, the stock reserved by hand
     * first, then the rest (needs `orders:stock.release_any`).
     * Optional for backwards compatibility; missing = false (only stock
     * reserved by hand).
     */
    release_any?: boolean;
}
export interface StockOperationResult {
    operation_id: string;
    /** False when the operation had been applied before (a replay). */
    applied: boolean;
    /** The counters right after the operation was first applied. */
    counters: StockOperationCounters;
    /** As recorded (TRANSFER_DISPATCH: the source's cost per unit). */
    unit_cost?: number;
}
/** What the quantity of a count (COUNT / CORRECTION) means. */
export enum CountBasis {
    /** Everything counted on the shelf, held stock included. */
    ON_HAND = 'ON_HAND',
    /** The stock to sell (a CSV import): held stock stays where it is. */
    SELLABLE = 'SELLABLE'
}
export enum ReasonCounted {
    SALE = 'Sale',
    REFUND = 'Refund',
    PURCHASE = 'Purchase Order',
    INVENTORY_COUNT = 'Inventory Count',
    INVENTORY_CORRECTION = 'Inventory Correction'
}
export enum InventoryChangeEvent {
    INVENTORY_CHANGE_QUANTITY_UPDATED = 'INVENTORY_CHANGE_QUANTITY_UPDATED',
    INVENTORY_CUMULATIVE_QUANTITY_UPDATED = 'INVENTORY_CUMULATIVE_QUANTITY_UPDATED',
    INVENTORY_CHANGE_REASON_UPDATED = 'INVENTORY_CHANGE_REASON_UPDATED',
    INVENTORY_CHANGE_SOURCE_UPDATED = 'INVENTORY_CHANGE_SOURCE_UPDATED',
    INVENTORY_CHANGE_DELETED_AT_UPDATED = 'INVENTORY_CHANGE_DELETED_AT_UPDATED',
    INVENTORY_CHANGE_SOURCE_ID_UPDATED = 'INVENTORY_CHANGE_SOURCE_ID_UPDATED',
    INVENTORY_CHANGE_SOURCE_TYPE_UPDATED = 'INVENTORY_CHANGE_SOURCE_TYPE_UPDATED'
}
export interface FractionCountItem {
    id: string;
    unit: string;
    fraction: number;
    expectedStock: number;
    qty_in_package: number;
    is_sold_by_weight: boolean;
    unit_of_measurement: string;
}
export interface PurchaseOrderDetails {
    id: string;
    supplier: Supplier;
}
export interface InventoryChange extends Timestamps {
    id: string; // Unique change_id
    store_id: string;
    product_id: string;
    product_name: string;
    change_quantity: number;
    cumulative_quantity: number;
    reason: InventoryChangeReason;
    merchant_id: string;
    created_at: string; // ISO 8601 date string. Represents the time the change actually occurred (e.g. sale/refund time at POS), NOT necessarily the time it was persisted.
    type: 'CHANGE';
    // Additional attributes
    source_id: string;
    source_type: EntityTypes;
    cost: number;
    price: number;
    source_name: string;
    purchase_order_details?: PurchaseOrderDetails;
    transfer_store_id?: string;
    inventory_value_change: number;
    retail_value_change: number;
    change_fraction: number;
    // Optional ISO 8601 timestamp recording when the inventory change record was actually written/processed.
    // Useful for offline-sync scenarios where created_at reflects the original sale time and processed_at reflects ingest time.
    processed_at?: string;
    /**
     * Set on rows written by a stock operation: the bucket the quantity moved
     * into (or out of, for a negative change). Optional for backwards
     * compatibility; missing = AVAILABLE (every older row).
     */
    bucket?: StockBucket;
    /** The operation type behind the row (e.g. `BUCKET_MOVE`). Optional; missing on older rows. */
    sub_reason?: string;
    /** What the operation belongs to. Optional; missing on older rows. */
    reference?: StockOperationReference;
    /** The stock operation that wrote the row. Optional; missing on older rows. */
    operation_id?: string;
    /**
     * Price approval with an owner cost (PR 7): (approved − carried cost) ×
     * quantity, the explicit valuation adjustment reports show on its own
     * line. Optional; missing = none.
     */
    valuation_adjustment?: number;
    /**
     * Free text from the writer, e.g. `POS Caixa 1, OFFLINE` for a count made
     * on a till. Optional for backwards compatibility; missing = no note.
     */
    note?: string;
}
export interface CreateInventoryChange {
    store_id: string;
    product_id: string;
    change_quantity: number;
    reason: InventoryChangeReason;
    merchant_id: string;
    source_id: string;
    cost: number;
    source_type: EntityTypes;
    source_name: string;
    product_name: string;
    purchase_order_details?: PurchaseOrderDetails;
    price: number;
    transfer_store_id?: string;
    inventory_value_change: number;
    retail_value_change: number;
    change_fraction: number;
    // ISO 8601 timestamp of when the change actually occurred at its source (e.g. receipt.created_at on the POS device).
    // This becomes the persisted created_at on the InventoryChange record so date-keyed indexes reflect business-occurrence time,
    // not arrival/processing time. Required so offline-synced sales/refunds land on the correct day.
    source_created_at: string;
    /**
     * Makes a redelivered change a no-op: the first change with this key is
     * applied, later ones return the current stock unchanged. Receipts send
     * `<receipt_number>#<line id>`. Optional for backwards compatibility;
     * missing = every delivery is applied (legacy behaviour).
     */
    idempotency_key?: string;
    /**
     * For COUNT / CORRECTION: what `change_quantity` means. The server turns
     * it into `cumulative_quantity` from the stock it reads (and re-reads on
     * a conflict), so a SELLABLE target never goes stale against a
     * reservation that changed meanwhile. Optional for backwards
     * compatibility; missing = ON_HAND.
     */
    count_basis?: CountBasis;
    /** Stored on the change as `note`. Optional; missing = no note. */
    note?: string;
    /**
     * For COUNT / CORRECTION: the time the stock was counted (ISO 8601). The
     * count is taken as true at that time: the movements that occurred after
     * it (sales, receipts, transfers) are added on top, so a count uploaded
     * late never erases them. A count or correction recorded after this time
     * wins and the request is refused with 409. Needs `idempotency_key`; at
     * most 35 days old, not in the future; the change is dated at this time.
     * Optional for backwards compatibility; missing = the count replaces the
     * stock as it is now.
     */
    count_as_of?: string;
}
export interface CurrentInventory extends Timestamps, Versioned {
    id: string;
    store_id: string;
    product_id: string;
    cumulative_quantity: number;
    merchant_id: string;
    type: 'CURRENT';
    cost: number;
    price: number;
    inventory_value_change: number;
    retail_value_change: number;
    change_fraction: number;
    change_quantity: number;
    /** ISO 8601 timestamp of the last write/processing of this record. */
    processed_at?: string;
    /** Product name at the latest change, for the audit trail. Optional; missing on older rows. */
    product_name?: string | null;
    /**
     * Authorized for a transfer, not yet dispatched. Part of
     * `cumulative_quantity` (sellable = cumulative − reserved).
     * Optional for backwards compatibility; missing = 0.
     */
    reserved_quantity?: number;
    /**
     * The part of `reserved_quantity` set aside by hand (Products app); only a
     * manual release frees it, and a transfer's release never does.
     * Optional for backwards compatibility; missing = 0.
     */
    manual_reserved_quantity?: number;
    /**
     * Received, waiting for price approval. Not in `cumulative_quantity`.
     * Optional for backwards compatibility; missing = 0.
     */
    pending_quantity?: number;
    /**
     * Extra goods awaiting validation and damaged returns. Not in
     * `cumulative_quantity`. Optional for backwards compatibility; missing = 0.
     */
    blocked_quantity?: number;
    /**
     * The cost per unit the last transfer receipt valued the stock at, inside
     * the stock transaction (so receipts are weighted in commit order) and
     * pushed to the store product. Optional; missing = the store product's
     * cost is the base of the next valuation.
     */
    valuation_cost?: number;
    /** When `valuation_cost` was computed. Optional; set with it. */
    valuation_at?: string;
    /**
     * The store product's `cost_changed_at` that `valuation_cost` started
     * from (null: none). While the store product still has it, the
     * valuation is the store's cost even before products has heard of it;
     * once it differs (a hand edit, a purchase-order receive), the store
     * product's cost is. Optional; set with `valuation_cost`.
     */
    valuation_base_changed_at?: string | null;
}
/**
 * Where a store's stock of a product sits, in parent units
 * (docs/plans/orders-and-transfers.md §4.3). `on_hand` is what a count
 * finds: cumulative + pending + blocked. Sellable stock is the store
 * product's `inventory`.
 */
export interface StockBreakdown {
    on_hand: number;
    reserved: number;
    pending: number;
    blocked: number;
    /**
     * The part of `reserved` set aside by hand, which a manual release may
     * free. Optional for backwards compatibility; missing = 0.
     */
    manual_reserved?: number | null;
}
export interface InventoryChangeDBItem extends InventoryChange {
    // PK: `STORE#${store_id}#PRODUCT#${product_id}`
    // SK: `INVENTORY_CHANGE#DATE#${created_at}#INVENTORY_CHANGE#${id}`
    PK: string;
    SK: string;
    // GSI1PK: `PRODUCT#${product_id}`
    // GSI1SK: `INVENTORY_CHANGE#STORE#${store_id}#DATE#${created_at}`
    GSI1PK: string;
    GSI1SK: string;
    // GSI2PK: `REASON#${reason}#STORE#${store_id}`
    // GSI2SK: `INVENTORY_CHANGE#PRODUCT#${product_id}#DATE#${created_at}`
    GSI2PK: string;
    GSI2SK: string;
    // GSI3PK: `SOURCE#${source}#STORE#${store_id}`
    // GSI3SK: `INVENTORY_CHANGE#PRODUCT#${product_id}#DATE#${created_at}`
    GSI3PK: string;
    GSI3SK: string;
    // GSI4PK: `REASON#${reason}#SOURCE#${source}#STORE#${store_id}`
    // GSI4SK: `INVENTORY_CHANGE#PRODUCT#${product_id}#DATE#${created_at}`
    GSI4PK: string;
    GSI4SK: string;
    // GSI5PK: `REASON#${reason}`
    // GSI5SK: `INVENTORY_CHANGE#PRODUCT#${product_id}#STORE#${store_id}#DATE#${created_at}`
    GSI5PK: string;
    GSI5SK: string;
    // GSI6PK: `SOURCE#${source}`
    // GSI6SK: `INVENTORY_CHANGE#PRODUCT#${product_id}#STORE#${store_id}#DATE#${created_at}`
    GSI6PK: string;
    GSI6SK: string;
    // GSI7PK: `REASON#${reason}#SOURCE#${source}`
    // GSI7SK: `INVENTORY_CHANGE#PRODUCT#${product_id}#STORE#${store_id}#DATE#${created_at}`
    GSI7PK: string;
    GSI7SK: string;
    // EntityIndexPK: `INVENTORY_CHANGE`
    // EntityIndexSK: `MERCHANT#${merchant_id}#STORE#${store_id}#PRODUCT#${product_id}#DATE#${created_at}`
    EntityIndexPK: string;
    EntityIndexSK: string;
    /**
     * Processed-time index (when the change was applied, not when it
     * happened). Optional for backwards compatibility: missing on rows written
     * before it existed until the repair backfills them.
     */
    // GSI8PK: `INVENTORY_CHANGE#MERCHANT#${merchant_id}#STORE#${store_id}`
    // GSI8SK: `PROCESSED#${processed_at}#INVENTORY_CHANGE#${id}`
    GSI8PK?: string;
    GSI8SK?: string;
}
export interface CurrentInventoryDBItem extends CurrentInventory {
    // PK: `STORE#${store_id}#PRODUCT#${product_id}`
    // SK: `TYPE#CURRENT`
    PK: string;
    SK: string;
    // GSI1PK: `PRODUCT#${product_id}`
    // GSI1SK: `TYPE#CURRENT#STORE#${store_id}`
    GSI1PK: string;
    GSI1SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}
export interface GetInventoryChanges {
    /**
     * Flags to determine which query to perform.
     * Only one should be true per request.
     */
    by_store_and_product_and_date_range?: boolean;
    by_store_and_date_range?: boolean;
    by_reason_and_store_and_product_and_date_range?: boolean;
    by_reason_and_store?: boolean;
    by_reason_across_stores?: boolean;
    by_source_and_store?: boolean;
    by_source_across_stores?: boolean;
    by_reason_and_source_and_store?: boolean;
    by_reason_and_source_across_stores?: boolean;
    by_product_and_store?: boolean;
    by_product_across_stores?: boolean;
    by_reason_and_product_and_store?: boolean;
    by_reason_and_product_across_stores?: boolean;
    by_source_and_product_and_store?: boolean;
    by_source_and_product_across_stores?: boolean;
    by_source_and_reason_and_product?: boolean;
    by_source_and_reason_and_store?: boolean;
    by_source_and_reason_across_stores?: boolean;
    /**
     * Common query parameters.
     */
    limit?: number;
    cursor?: string;
    sort_order?: SortOrder;
    /**
     * Filter parameters.
     */
    store_id?: string;
    product_id?: string;
    reason?: InventoryChangeReason;
    source_type?: EntityTypes;
    source_id?: string;
    merchant_id: string; // For merchant-level queries
    start_date?: string; // ISO 8601 date string
    end_date?: string; // ISO 8601 date string
}
export interface InventoryChangePage {
    changes: InventoryChange[];
    cursor?: string;
    count: number;
}
/**
 * GET {merchant_id}/stores/{store_id}/changes/applied-late: changes that
 * happened before `start_date` but were applied (processed) after
 * `applied_after` and up to `applied_until`, e.g. a sale synced late by an
 * offline POS. The valuation report passes its opening and closing value
 * snapshots' times: a snapshot holds the changes applied before it was
 * taken, so these are in the closing value but not in the period's changes.
 */
export interface GetInventoryChangesAppliedLate {
    /** Period start (ISO 8601): only changes that happened before it. */
    start_date: string;
    /** Applied after this time (ISO 8601, exclusive): the opening snapshot's. */
    applied_after: string;
    /** Applied up to this time (ISO 8601, inclusive): the closing snapshot's. */
    applied_until: string;
}
export interface InventoryChangesAppliedLate {
    store_id: string;
    start_date: string;
    applied_after: string;
    applied_until: string;
    /** Number of changes. */
    count: number;
    /** Sum of their signed inventory (cost) value changes. */
    inventory_value_change: number;
    /** Sum of their signed retail value changes. */
    retail_value_change: number;
}
/**
 * POST {merchant_id}/stores/{store_id}/changes/repair-processed-index:
 * adds the processed-time index to one page of the store's changes written
 * before it existed. Idempotent and resumable; dry run unless
 * `dry_run` is false.
 */
export interface RepairInventoryChangesProcessedIndex {
    cursor?: string;
    /** Changes read per call (default 500). */
    limit?: number;
    /** Optional for backwards compatibility; missing = true (nothing written). */
    dry_run?: boolean;
}
export interface RepairInventoryChangesProcessedIndexResult {
    dry_run: boolean;
    /** Changes read in this page. */
    scanned: number;
    /** Changes among them without the index. */
    missing: number;
    /** Changes indexed by this call (0 in a dry run). */
    written: number;
    /** Next page, or null when the store is done. */
    cursor: string | null;
}
export interface GetStoreInventories {
    store_id: string;
    merchant_id: string;
}
export interface StoreInventoriesResponse {
    inventories: CurrentInventory[];
    count: number;
}

/**
 * Billing types — owned by the Billing service.
 *
 * Billing owns invoices, payment attempts, and billing runs. It asks Pricing
 * how much to charge and asks Wallets to collect from merchant wallets.
 */
export enum InvoiceStatus {
    UNPAID = 'unpaid',
    PARTIALLY_PAID = 'partially_paid',
    PAID = 'paid',
    PAYMENT_FAILED = 'payment_failed',
    CANCELLED = 'cancelled'
}
export enum PaymentAttemptStatus {
    SUCCESS = 'success',
    FAILED = 'failed',
    SKIPPED = 'skipped'
}
export enum BillingRunStatus {
    RUNNING = 'running',
    COMPLETED = 'completed',
    COMPLETED_WITH_ERRORS = 'completed_with_errors',
    FAILED = 'failed'
}
export enum BillingTriggerType {
    MANUAL = 'manual',
    CRON = 'cron',
    API = 'api'
}
export enum InvoiceCollectionMethod {
    WALLET = 'wallet'
}
export interface InvoiceLine {
    label: string;
    amount: number;
    metadata?: Record<string, unknown>;
}
export interface PricingCalculationResultForBilling {
    merchant_id: string;
    store_id?: string;
    agreement_id: string;
    pricing_plan_id?: string;
    pricing_type: PricingType;
    billing_period: BillingPeriod;
    currency: string;
    base_amount: number;
    discount_amount: number;
    final_amount: number;
    is_billable: boolean;
    period_start: string;
    period_end: string;
    breakdown: InvoiceLine[];
    reason?: string;
}
export interface WalletDebitResultForBilling {
    balance: number;
    transaction_id: string;
    transaction_version: number;
    reference_type: string;
    reference_id: string;
    amount: number;
    currency: string;
    payment_method_id: string;
    payment_method_name: string;
    payment_method_type: PaymentMethodType;
    created_at: string;
}
export enum InvoiceType {
    /** Standard per-store invoice. */
    STORE_INVOICE = 'store_invoice',
    /** Merchant-level summary that aggregates child store invoices. */
    MERCHANT_SUMMARY = 'merchant_summary',
    /** Monthly WhatsApp notification fee for stores without a monthly invoice. */
    NOTIFICATION_ONLY = 'notification_only'
}
export const NOTIFICATION_INVOICE_LINE_KIND = 'whatsapp_notifications';
export interface Invoice extends Omit<Timestamps, 'deleted_on'>, Versioned {
    id: string;
    invoice_number?: string;
    /** Distinguishes store invoices from merchant summaries. Defaults to STORE_INVOICE. */
    invoice_type?: InvoiceType;
    merchant_id: string;
    store_id: string;
    store_name?: string;
    agreement_id: string;
    pricing_plan_id?: string;
    /** For MERCHANT_SUMMARY: IDs of the store invoices this summary aggregates. */
    child_invoice_ids?: string[];
    period_start: string;
    period_end: string;
    due_date: string;
    currency: string;
    base_amount: number;
    discount_amount: number;
    final_amount: number;
    amount_due: number;
    amount_paid: number;
    status: InvoiceStatus;
    pricing_type: PricingType;
    billing_period: BillingPeriod;
    pricing_breakdown?: InvoiceLine[];
    pricing_calculation?: PricingCalculationResultForBilling | Record<string, unknown>;
    wallet_debit_reference_type?: string;
    wallet_debit_reference_id?: string;
    wallet_transaction_version?: number;
    wallet_balance_after?: number;
    last_payment_attempt_at?: string;
    paid_at?: string;
    cancelled_at?: string;
    cancelled_by?: string;
    cancellation_reason?: string;
    created_by?: string;
    /**
     * Set while a collection debits wallets (R4 claim), so a second collect or
     * a cancel cannot run at the same time; expires after 10 minutes so a
     * crashed run can be retried. Optional; missing = not being collected.
     */
    collection_claimed_at?: string | null;
    collection_claim_id?: string | null;
}
export interface InvoiceDBItem extends Invoice {
    PK: string; // INVOICE#{invoice_id}
    SK: string; // INVOICE#{invoice_id}
    EntityIndexPK: string; // INVOICE
    EntityIndexSK: string; // DATE#{created_at}
    GSI1PK: string; // MERCHANT#{merchant_id}
    GSI1SK: string; // INVOICE#{created_at}#{invoice_id}
    GSI2PK: string; // INVOICE_STATUS#{status}
    GSI2SK: string; // DATE#{created_at}#{invoice_id}
    GSI3PK?: string; // MERCHANT#{merchant_id}#STORE#{store_id}
    GSI3SK?: string; // INVOICE#{created_at}#{invoice_id}
}
export interface InvoicePeriodLockDBItem {
    PK: string; // INVOICE_PERIOD#{merchant_id}#{store_id}#{agreement_id}#{period_start}#{period_end}
    SK: string; // INVOICE_PERIOD_LOCK
    invoice_id: string;
    merchant_id: string;
    store_id: string;
    agreement_id: string;
    period_start: string;
    period_end: string;
    created_at: string;
}
export interface InvoicePaymentAttempt {
    id: string;
    invoice_id: string;
    merchant_id: string;
    store_id?: string;
    amount: number;
    currency: string;
    collection_method: InvoiceCollectionMethod;
    status: PaymentAttemptStatus;
    wallet_reference_type: string;
    wallet_reference_id: string;
    wallet_id?: string;
    payment_method_id?: string;
    payment_method_name?: string;
    payment_method_type?: PaymentMethodType;
    wallet_transaction_version?: number;
    wallet_balance_after?: number;
    error_code?: string;
    error_message?: string;
    attempted_at: string;
    created_by?: string;
}
export interface InvoicePaymentAttemptDBItem extends InvoicePaymentAttempt {
    PK: string; // INVOICE#{invoice_id}
    SK: string; // PAYMENT_ATTEMPT#{attempted_at}#{attempt_id}
    EntityIndexPK: string; // PAYMENT_ATTEMPT
    EntityIndexSK: string; // DATE#{attempted_at}
}
export interface BillingRunError {
    merchant_id?: string;
    store_id?: string;
    message: string;
}
export interface BillingRun extends Versioned {
    id: string;
    trigger_type: BillingTriggerType;
    status: BillingRunStatus;
    period_start?: string;
    period_end?: string;
    merchant_ids?: string[];
    store_ids?: string[];
    total_merchants: number;
    total_stores?: number;
    invoices_created: number;
    invoices_paid: number;
    invoices_partially_paid?: number;
    invoices_unpaid: number;
    invoices_skipped: number;
    errors_count: number;
    errors?: BillingRunError[];
    started_at: string;
    completed_at?: string;
    created_by?: string;
}
export interface BillingRunDBItem extends BillingRun {
    PK: string; // BILLING_RUN#{billing_run_id}
    SK: string; // BILLING_RUN#{billing_run_id}
    EntityIndexPK: string; // BILLING_RUN
    EntityIndexSK: string; // DATE#{started_at}
}
export interface GenerateInvoice {
    merchant_id: string;
    store_id: string;
    /**
     * Short alphanumeric store prefix used in invoice numbering
     * (e.g. "ST01" produces INV-ST01-202606-ABC123).
     */
    store_prefix?: string;
    /**
     * Store credit limit in minor units. When set, invoice generation
     * is blocked if the store's outstanding balance + new invoice
     * would exceed this amount. null = unlimited.
     */
    credit_limit?: number | null;
    store_name?: string;
    due_date?: string;
    usage?: {
        receipts?: number;
        transactions?: number;
    };
    auto_collect?: boolean;
    created_by?: string;
    /**
     * Re-issue a CANCELLED invoice (e.g. a removed subscription waiver). The new
     * invoice reuses the cancelled invoice's period and due date instead of the
     * agreement's next billing period. Optional; missing = normal generation.
     */
    replaces_invoice_id?: string;
    /** Optional tax-inclusive monthly WhatsApp notification fee. */
    notification_fee?: {
        amount: number;
        service_month: string;
        source_amount_usd?: number;
        exchange_rate?: number;
        exchange_rate_date?: string;
        exchange_rate_source?: string;
    };
}
export interface GenerateInvoicesForMerchant {
    merchant_id: string;
    store_ids?: string[];
    auto_collect?: boolean;
    created_by?: string;
}
export interface RunBilling {
    merchant_ids?: string[] | null | undefined;
    store_ids?: string[] | null | undefined;
    trigger_type: BillingTriggerType;
    created_by?: string | null | undefined;
}
export interface CollectInvoice {
    invoice_id: string;
    collected_by?: string | null | undefined;
}
/**
 * Pays a store's outstanding invoices from its store wallet, oldest first.
 * Each invoice is paid in full or not at all; the run stops at the first
 * invoice the wallet cannot cover.
 */
export interface PayOutstandingStoreInvoices {
    merchant_id: string;
    store_id: string;
    collected_by?: string | null | undefined;
}
export interface PayOutstandingStoreInvoicesResult {
    /** Invoices fully paid by this run, oldest first. */
    paid: Invoice[];
    /** Still owed after this run, in `currency`. 0 when nothing is owed. */
    outstanding: number;
    /** Store wallet money available in `currency`. */
    available: number;
    /** What to top up so everything can be paid: outstanding - available, never below 0. */
    top_up_amount: number;
    currency?: string;
}
export interface RetryInvoicePayment {
    invoice_id: string;
    retried_by?: string;
}
export interface CancelInvoice {
    invoice_id: string;
    cancelled_by: string;
    reason: string;
}
export interface GetInvoice {
    id: string;
}
export interface GetInvoices {
    merchant_id?: string;
    store_id?: string;
    status?: InvoiceStatus;
    cursor?: string;
    limit?: number;
}
export interface GetInvoicePaymentAttempts {
    invoice_id: string;
    cursor?: string;
    limit?: number;
}
export interface GetBillingRun {
    id: string;
}
export interface GetBillingRuns {
    status?: BillingRunStatus;
    trigger_type?: BillingTriggerType;
    cursor?: string;
    limit?: number;
}
export interface InvoicesPage {
    invoices: Invoice[];
    count?: number;
    cursor?: string;
}
/** One month of billed vs collected revenue. Amounts in minor units. */
export interface InvoiceSummaryMonth {
    /** Month label, e.g. "Jan 2026". */
    month: string;
    billed: number;
    collected: number;
}
/** One accounts-receivable aging bucket. Amount in minor units. */
export interface InvoiceArAgingBucket {
    bucket: string;
    amount: number;
}
/**
 * Platform-level invoice rollup for dashboards. All amounts are in minor
 * units. Store invoices only — cancelled invoices and merchant-summary
 * aggregates are excluded from revenue figures.
 */
export interface InvoiceSummary {
    currency: string;
    /** Last 12 months of billed vs collected revenue by period month, oldest first. */
    monthly_revenue: InvoiceSummaryMonth[];
    /** final_amount on invoices billed (period_end) in the trailing 30 days. */
    billed_trailing_30d: number;
    /** amount_paid on invoices billed in the trailing 30 days. */
    collected_trailing_30d: number;
    billed_trailing_12m: number;
    /** Billed-revenue growth between the last two complete bill months (%). */
    mom_growth_pct: number | null;
    /** amount_paid / final_amount over the trailing 90 days (%). */
    collection_rate_pct_90d: number | null;
    /** amount_due on unpaid + partially paid invoices. */
    ar_outstanding: number;
    /** Portion of ar_outstanding past its due_date. */
    ar_overdue: number;
    /** Outstanding amount_due grouped by days past due_date. */
    ar_aging: InvoiceArAgingBucket[];
    failed_invoice_count: number;
    failed_invoice_amount: number;
    /** Store invoices considered (after exclusions). */
    invoice_count: number;
    generated_at: string;
}
export interface InvoicePaymentAttemptsPage {
    attempts: InvoicePaymentAttempt[];
    count?: number;
    cursor?: string;
}
export interface BillingRunsPage {
    runs: BillingRun[];
    count?: number;
    cursor?: string;
}

export enum LoanStatus {
    LOAN_PENDING = 'LOAN_PENDING',
    LOAN_PAID = 'LOAN_PAID',
    LOAN_OVERDUE = 'LOAN_OVERDUE',
    LOAN_PARTIALLY_PAID = 'LOAN_PARTIALLY_PAID',
    LOAN_NEEDS_REVIEW = 'LOAN_NEEDS_REVIEW'
}
export interface Loan extends Timestamps, CommonEmployeeAsCreatorAttributes {
    id: string;
    paid_amount: number;
    total_amount: number;
    unpaid_amount: number;
    borrower_id: string;
    borrower_type: EntityTypes;
    borrower_loan_id: string;
    due_date: string;
    overdue_amount: number;
    status: LoanStatus;
    reason: string;
    associated_payments: string[];
    loan_history: LoanHistoryItem[];
    store_id: string;
    shift_id?: string; // TODO: Make Optional // Shift during which the loan was created
}
export interface LoanHistoryItem extends Timestamps {
    event: LoanHistoryEvent;
    created_at: string;
    creator_id: string;
    creator_name: string;
    creator_type: string;
    paid_amount: number;
    total_amount: number;
    unpaid_amount: number;
    due_date: string;
    overdue_amount: number;
}
export enum LoanHistoryEvent {
    LOAN_CREATED = 'LOAN CREATED',
    LOAN_PAID = 'LOAN PAID',
    LOAN_OVERDUE = 'LOAN OVERDUE',
    LOAN_PARTIALLY_PAID = 'LOAN PARTIALLY PAID',
    LOAN_REFUNDED = 'LOAN REFUNDED'
}
export interface BorrowerLoan extends Timestamps, CommonEmployeeAsCreatorAttributes {
    id: string;
    borrower_id: string;
    borrower_type: EntityTypes;
    total_amount: number;
    total_paid_amount: number;
    total_value_of_completed_loans: number;
    total_number_of_loans: number;
    total_number_of_completed_loans: number;
    total_unpaid_amount: number;
    total_overdue_amount: number;
    oldest_due_date: string;
    status: LoanStatus;
    incomplete_loans: Loan[];
    reason: string;
}
export interface GetLoansByCreatorDto extends Paginated {
    creator_id: string;
    by_creator_id?: boolean;
    is_borrower_loan?: boolean;
}
export interface GetLoansByBorrowerIdDto extends Paginated {
    borrower_id: string;
    by_borrower_id?: boolean;
    is_borrower_loan?: boolean;
}
export interface GetLoanByLoanIdDto {
    loan_id: string;
    by_loan_id?: boolean;
    by_borrower_loan_id?: boolean;
    borrower_loan_id?: string;
}
export interface GetLoansByStatusesDto extends Paginated {
    statuses: LoanStatus[];
    by_statuses?: boolean;
    by_borrower_id_and_status?: boolean;
    by_statuses_and_borrower_loan_id?: boolean;
    is_borrower_loan?: boolean;
    borrower_id?: string;
    borrower_loan_id?: string;
    borrower_type?: EntityTypes;
}
export interface BorrowerLoanPage {
    borrower_loans: BorrowerLoan[];
    cursor: string | null;
    count: number;
}
export interface CreateLoanDto extends CommonEmployeeAsCreatorAttributes {
    borrower_id: string;
    borrower_type: EntityTypes;
    total_amount: number;
    reason: string;
}
export interface CreateLoanAfterFailureDto {
    creator: CommonEmployeeAsCreatorAttributes;
    borrower_id: string;
    borrower_type: EntityTypes;
    total_amount: number;
    reason: string;
    previousEventId: string;
}
export interface UpdateLoanDto {
    borrower_id: string;
    borrower_type: EntityTypes;
    status: LoanStatus;
}
export interface LoanDBItem extends Loan {
    PK: string; // PK: `BORROWER_LOAN#${borrower_loan_id}`
    SK: string; // SK: `LOAN#${loan_id}`
    GSI1PK: string; // <status>
    GSI1SK: string; // LOAN#<id>
    GSI2PK: string; // <creator_type>#<creator_id>
    GSI2SK: string; // LOAN#<id>
    GSI3PK: string; // <borrower_type>#<borrower_id>
    GSI3SK: string; // LOAN#<id>
    GSI4PK: string; // <borrower_type>#<borrower_id>
    GSI4SK: string; // <status>#LOAN#<id>
    GSI5PK: string; // BORROWER_LOAN#<borrower_loan_id>
    GSI5SK: string; // <status>#LOAN#<id>
    GSI6PK: string; // LOAN#${loan_id}
    GSI6SK: string; // BORROWER_LOAN#${borrower_loan_id}
    EntityIndexPK: string; // LOAN
    EntityIndexSK: string; // LOAN#DATE#<created_at>
}
export interface BorrowerLoanDBItem extends Omit<BorrowerLoan, 'incomplete_loans'> {
    PK: string; // PK: `BORROWER_LOAN#${borrower_loan_id}`
    SK: string; // SK: `BORROWER_LOAN#${borrower_loan_id}`
    GSI1PK: string; // <status>
    GSI1SK: string; // BORROWER_LOAN#<id>
    GSI2PK: string; // <creator_type>#<creator_id>
    GSI2SK: string; // BORROWER_LOAN#<id>
    GSI3PK: string; // <borrower_type>#<borrower_id>
    GSI3SK: string; // BORROWER_LOAN#<id>
    EntityIndexPK: string; // BORROWER_LOAN
    EntityIndexSK: string; // BORROWER_LOAN#DATE#<created_at>
}
export interface LoanPage {
    loans: Loan[];
    cursor: string | null;
    count: number;
}
export interface BorrowerLoanSummary {
    borrower_loan: BorrowerLoan;
    incomplete_loans_cursor: string | null;
    incomplete_loans_count: number;
}
export interface BorrowerLoanPage {
    borrower_loans: BorrowerLoan[];
    cursor: string | null;
    count: number;
}

export interface Merchant extends Timestamps, Versioned {
    id: string;
    business_name: string;
    email: string;
    country: string;
    currency: Currency;
    phone_number: string;
    address: string;
    contact_person: string;
    stores: string[];
    monthly_fee: number; // Monthly fee for the merchant (NOT USED)
    /**
     * Interface language for users who have not picked one, derived from
     * `country` and never stored. Returned by `GET /merchants/{id}`.
     */
    default_language?: UiLanguage;
    /**
     * Optional modules switched on by platform admins (never through
     * `PUT /merchants`). Optional for backwards compatibility; missing =
     * every module DISABLED.
     */
    modules?: MerchantModules;
}
/**
 * Lifecycle of a module (docs/plans/orders-and-transfers.md §4.2):
 * ENABLED works; SUSPENDED refuses new work but lets open work finish;
 * FROZEN stops every stock and money operation except admin recovery;
 * DISABLED hides the module, its records stay readable.
 */
export enum ModuleStatus {
    ENABLED = 'ENABLED',
    SUSPENDED = 'SUSPENDED',
    FROZEN = 'FROZEN',
    DISABLED = 'DISABLED'
}
export interface OrdersTransfersModule {
    status: ModuleStatus;
    /** When the status last changed (ISO). */
    status_changed_at?: string;
    /**
     * Owner setting: transfers wait for price approval before the goods are
     * sellable. Read and edited from PR 7 (price approval); optional until then.
     */
    price_approval_required?: boolean;
    /**
     * Days a stock order waits before it expires (PR 6b): a reminder task at
     * 80 %, then its undispatched transfers are cancelled and the rest of its
     * demand closed. Optional; missing = 30.
     */
    order_expiry_days?: number;
}
export interface MerchantModules {
    orders_transfers?: OrdersTransfersModule;
}
/** `PUT /merchants/{id}/modules/orders-transfers` (platform admin session). */
export interface SetOrdersTransfersModuleStatus {
    status: ModuleStatus;
}
/**
 * `PUT /merchants/{id}/modules/orders-transfers/settings`
 * (`orders:settings.manage` in every store, module ENABLED). A missing
 * field keeps its value.
 */
export interface UpdateOrdersTransfersSettings {
    price_approval_required?: boolean;
    /** Whole days, 1 to 365. Applies to orders created from now on. */
    order_expiry_days?: number;
}
/** One kind of open work that keeps the module from being DISABLED. */
export interface DrainOpenItem {
    /** Stable key, e.g. `reservations`, `transfers_in_transit`. */
    source: string;
    /** English description for the admin. */
    description: string;
    count: number;
}
/**
 * `GET /inventory-transfers/{merchant_id}/drain-status` (service-only):
 * what is still open. Every source reports zero until the PR that creates
 * that kind of work adds it.
 */
export interface DrainStatus {
    merchant_id: string;
    /** True when nothing is open: the module may be DISABLED. */
    is_drained: boolean;
    open_items: DrainOpenItem[];
    checked_at: string;
}
export interface MerchantPage {
    merchants: Merchant[];
    count: number;
    cursor?: string;
}
export interface CreateMerchant {
    business_name: string;
    email: string;
    country: string;
    currency: Currency;
    phone_number: string;
    address: string;
    contact_person: string;
    stores: string[];
}
export interface UpdateMerchant {
    business_name?: string;
    email?: string;
    country?: string;
    currency?: Currency;
    phone_number?: string;
    address?: string;
    contact_person?: string;
    id: string;
    add_stores?: string[];
    remove_stores?: string[];
    monthly_fee?: number; // Monthly fee for the merchant
}
export interface MerchantDBItem extends Merchant {
    /*
    "Entity": "MERCHANT",
    "PK": "MERCHANT#{merchant_id}#ENTITY_TYPE#MERCHANT",
    "SK": "MERCHANT#{merchant_id}",
    "EntityIndexPK": "MERCHANT",
    "EntityIndexSK": "MERCHANT#{merchant_id}#DATE#{created_at}"
    */
    PK: string;
    SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}
export enum MerchantPaymentStatus {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    OVERDUE = 'OVERDUE',
    PARTIALLY_PAID = 'PARTIALLY_PAID'
}
// This is a monthly payment for a merchant for each store
export interface MerchantPayment extends Timestamps {
    id: string;
    merchant_id: string;
    store_id: string;
    total_amount: number;
    amount_due: number;
    amount_paid: number;
    payment_status: MerchantPaymentStatus;
    payment_date: string; // YYYY-MM-DD
    currency: Currency;
    created_at: string;
    updated_at: string;
    due_date: string; // YYYY-MM-DD
    payment_month: Month; // YYYY-MM
    payer_name: string;
    payer_phone_number: string | number;
    payment_type: PaymentMethodType;
    note?: string;
    receiver_name: string;
}
export type Month = `${number | string}-${number | string}`; // YYYY-MM
export interface MerchantPaymentPage {
    merchant_payments: MerchantPayment[];
    count: number;
    cursor?: string;
}
export interface CreateMerchantPayment {
    merchant_id: string;
    store_id: string;
    amount_paid: number;
    payment_month: Month; // YYYY-MM
    payer_name: string;
    payer_phone_number: string | number;
    payment_type: PaymentMethodType;
    note?: string;
    receiver_name: string;
}
export interface GetAllMerchantPayments {
    by_merchant?: boolean;
    by_date?: boolean;
    by_store?: boolean;
    cursor?: string;
    limit?: number;
    merchant_id: string;
    store_id?: string;
    month?: Month; // YYYY-MM
}

export enum NotificationEvents {
    IFTTT_SMS_RECEIVED = 'IFTTT_SMS_RECEIVED'
}
/** The SMS fields forwarded on the bus (never the raw body/payload). */
export interface IftttSmsReceivedEventData {
    /** IftttSmsMessage.id (ULID) — stable idempotency key. */
    id: string;
    /** Originating number or alphanumeric SMS id, e.g. "eMola". */
    sender: string;
    sender_name?: string;
    message_content?: string;
    /** Receive timestamp reported by IFTTT, verbatim. */
    received_at?: string;
    /** IFTTT DeviceLabel of the phone that received the SMS. */
    device_name?: string;
    /** Server ingestion timestamp (ISO-8601). */
    created_at: string;
}
export interface IftttSmsReceivedEvent {
    bus_name: string;
    source: ShopAndSmileEventSource;
    detail_type: NotificationEvents.IFTTT_SMS_RECEIVED;
    detail: {
        filter?: Record<string, any>;
        data: IftttSmsReceivedEventData;
        metadata: ShopAndSmileEventMetadata;
    };
}

export interface EmailParams {
    bccEmailAddresses?: string[];
    ccEmailAddresses?: string[];
    toEmailAddresses: string[];
    bodyData: string;
    bodyCharset: EmailCharset;
    subjectdata: string;
    subjectCharset: EmailCharset;
    sourceEmail: string;
    replyToAddresses?: string[];
}
export enum EmailCharset {
    UTF8 = 'UTF-8',
    ISO88591 = 'ISO-8859-1',// Western European languages
    ISO885915 = 'ISO-8859-15',// Western European languages + Euro symbol
    USASCII = 'US-ASCII',// Basic English characters
    UTF16 = 'UTF-16',// Unicode characters (less commonly used)
    WINDOWS1252 = 'Windows-1252'
}
// ─── WhatsApp Webhook Event Persistence ───────────────────────────
export interface WhatsappWebhookEvent {
    /** Stable ULID generated at write time — use as a unique row key. */
    id?: string;
    phone_number_id: string;
    payload: WhatsappWebhookPayload;
    created_at: string;
    event_type: string;
}
export interface GetWhatsappEvents {
    phone_number_id?: string;
    event_type?: string;
    start_date?: string;
    end_date?: string;
    cursor?: string;
    count?: number;
}
export interface WhatsappEventsPage {
    events: WhatsappWebhookEvent[];
    count: number;
    cursor?: string;
}
/**
 * WhatsApp Business Platform webhook payload (Meta Cloud API).
 *
 * Deliberately permissive: only the envelope (`object`/`entry`/`changes`/`field`)
 * is validated, while each change's `value` is left open. This lets us ingest the
 * many field variants (messages, statuses, template_*, account_*) without rejecting
 * shapes we have not modelled yet. See docs:
 * https://developers.facebook.com/documentation/business-messaging/whatsapp/webhooks
 */
export interface WhatsappWebhookPayload {
    object: string;
    entry: WhatsappWebhookEntry[];
}
export interface WhatsappWebhookEntry {
    id: string;
    changes: WhatsappWebhookChange[];
}
export interface WhatsappWebhookChange {
    field: string;
    value: Record<string, unknown>;
}
// ─── IFTTT SMS Message Persistence ────────────────────────────────
/**
 * Body posted by the IFTTT "Make a web request" action when the Android
 * applet forwards a received SMS. The applet's body template is
 * user-configured, so no shape is guaranteed — anything JSON is accepted.
 */
export interface IftttSmsWebhookPayload {
    [key: string]: unknown;
}
/**
 * A raw SMS forwarded from the Android phone by IFTTT to the
 * `/notifications/sms/ifttt` webhook.
 *
 * `raw_body` always holds the request body exactly as received (the source
 * of truth); `sender`, `message_content` and `received_at` are best-effort
 * extractions from the well-known IFTTT body shapes.
 */
export interface IftttSmsMessage {
    /** Stable ULID generated at write time — use as a unique row key. */
    id?: string;
    /**
     * Queryable sender key: the originating number or alphanumeric SMS id
     * (e.g. "+258841234567", "M-Pesa"), falling back to the contact name and
     * then "unknown". Sender queries match this value.
     */
    sender: string;
    /** Contact name the phone resolved for the sender, when present. */
    sender_name?: string;
    /** SMS text extracted from the payload, when present. */
    message_content?: string;
    /** Receive timestamp reported by the phone/IFTTT, verbatim, when present. */
    received_at?: string;
    /** Name of the Android device that forwarded the SMS, when present. */
    device_name?: string;
    /** The raw request body exactly as received. */
    raw_body: string;
    /** Parsed JSON body, when the raw body is a JSON object. */
    payload?: Record<string, unknown>;
    /** Server-side ingestion timestamp (ISO-8601) — the query sort key. */
    created_at: string;
}
export interface GetIftttSmsMessages {
    sender?: string;
    start_date?: string;
    end_date?: string;
    cursor?: string;
    count?: number;
}
export interface IftttSmsMessagesPage {
    messages: IftttSmsMessage[];
    count: number;
    cursor?: string;
}
// ─── Notification Request (source services → service-notifications) ───
export enum NotificationRequestType {
    BUSINESS_SUMMARY = 'BUSINESS_SUMMARY',
    SHIFT_REPORT = 'SHIFT_REPORT',
    LOW_STOCK = 'LOW_STOCK',
    INVENTORY_COUNT_SUMMARY = 'INVENTORY_COUNT_SUMMARY',
    PRICE_CHANGES = 'PRICE_CHANGES',
    PURCHASE_ORDER_CHANGES = 'PURCHASE_ORDER_CHANGES',
    RECEIPT = 'RECEIPT',
    /** Covers both Debt Created and Debt Payment events. */
    DEBTS = 'DEBTS',
    DEBT_PAYMENT_REMINDER = 'DEBT_PAYMENT_REMINDER',
    EXPENSE = 'EXPENSE',
    AVAILABLE_MONEY = 'AVAILABLE_MONEY',
    INVOICE = 'INVOICE',
    TOPUP = 'TOPUP',
    /** Daily: purchase-order stock whose expiry date is inside its warning window. */
    EXPIRING_PRODUCTS = 'EXPIRING_PRODUCTS',
    /** A stock change service-inventory could not record (any caller). */
    INVENTORY_UPDATE_FAILED = 'INVENTORY_UPDATE_FAILED',
    /**
     * An urgent manual task (§4.13), sent to its assignee (or the members of
     * its role), never to subscribers. Off until a manager turns it on.
     */
    TASK_ASSIGNED = 'TASK_ASSIGNED'
}
export enum NotificationTrigger {
    EVENT = 'EVENT',
    SCHEDULED = 'SCHEDULED'
}
/**
 * Payload contract published by source services to the
 * `notification-requested` SNS topic (Phase 6 emitters).
 *
 * - `event_id` is required for EVENT-triggered notifications
 *   (dedupe key `EVENT#<eventId>`).
 * - `period_key` is required for SCHEDULED notifications
 *   (dedupe key `<type>#<periodKey>#<storeId>`, e.g. `LOW_STOCK#W2026-33#store-1`).
 * - `payload` carries the per-type render payload (Phase 3 renders it).
 */
export interface NotificationRequest {
    merchant_id: string;
    store_id: string;
    type: NotificationRequestType;
    trigger: NotificationTrigger;
    event_id?: string;
    period_key?: string;
    payload: Record<string, unknown>;
    /**
     * Only for `assignee_only` types (TASK_ASSIGNED): the employees to send
     * to, instead of the type's subscribers.
     */
    recipient_employee_ids?: string[];
}
export enum NotificationKind {
    EMPLOYEE = 'EMPLOYEE',
    CUSTOMER = 'CUSTOMER',
    INDEPENDENT = 'INDEPENDENT'
}
export enum NotificationStatus {
    PENDING = 'PENDING',
    SENT = 'SENT',
    DELIVERED = 'DELIVERED',
    READ = 'READ',
    FAILED = 'FAILED'
}
/**
 * One logical notification (notifications.md §7): one `MSG-` ID shared by
 * all recipient copies.
 */
export interface Notification {
    message_id: string;
    type: NotificationRequestType;
    trigger: NotificationTrigger;
    event_id?: string;
    period_key?: string;
    language: Language;
    merchant_id: string;
    store_id: string;
    payload: Record<string, unknown>;
    /** Rendered report media (set by the send worker after the first render). */
    media?: NotificationMedia;
    created_at: string;
    updated_at: string;
}
export interface NotificationDBItem extends Notification {
    PK: string;
    SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}
/** One recipient copy of a notification. */
export interface NotificationRecipient {
    message_id: string;
    /** ULID identifying this recipient copy (stable across retries). */
    recipient_id: string;
    kind: NotificationKind;
    entity_id: string;
    phone_number: string;
    status: NotificationStatus;
    /** WhatsApp message id (wamid) of the sent message (Phase 3). */
    whatsapp_message_id?: string;
    /** Set when Meta reports the number invalid (error 131026) — never retry. */
    wa_id_invalid?: boolean;
    created_at: string;
}
export interface NotificationRecipientDBItem extends NotificationRecipient {
    PK: string;
    SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}
/**
 * Dedupe marker (FR-13). Claimed with a conditional PutItem before any
 * other work so retries can never duplicate a notification.
 */
export interface NotificationDedupeMarker {
    dedupe_key: string;
    created_at: string;
}
export interface NotificationDedupeMarkerDBItem extends NotificationDedupeMarker {
    PK: string;
    SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
    /** Epoch-seconds TTL so stale markers expire (requires table TTL). */
    ttl?: number;
    /**
     * ISO time until which a leased claim is held; once past, another
     * delivery may take the key over. Missing = the claim is final (every
     * marker written without a lease).
     */
    lease_until?: string;
}
/** Per-store × type subscription parent record. */
export interface NotificationSubscription extends Versioned {
    store_id: string;
    type: NotificationRequestType;
    /** Whether this type is enabled for the store (defaults to true). */
    enabled?: boolean;
    /** Omitted means dynamically use the merchant-country default. */
    language?: Language;
    created_at: string;
    updated_at: string;
}
export interface NotificationSubscriptionDBItem extends NotificationSubscription {
    PK: string;
    SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}
/**
 * Subscription membership row — one per (store, type, user) recording the
 * date the user subscribed. (User decision 2026-08-25: subscriptions are
 * their own entity rows, no `subscriber_ids` array on the parent.)
 */
export interface NotificationSubscriber {
    store_id: string;
    type: NotificationRequestType;
    user_id: string;
    /** Defaults to EMPLOYEE for rows created before independent contacts. */
    kind?: NotificationKind.EMPLOYEE | NotificationKind.INDEPENDENT;
    subscribed_at: string;
}
export interface NotificationSubscriberDBItem extends NotificationSubscriber {
    PK: string;
    SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}
/**
 * Internal send-task message published by persist to the notification send
 * queue — one message per recipient so delivery status is tracked per
 * recipient (Phase 3 worker consumes this).
 */
export interface SendNotificationTask {
    message_id: string;
    recipient_id: string;
    kind: NotificationKind;
    entity_id: string;
    phone_number: string;
    type: NotificationRequestType;
    language: Language;
    merchant_id: string;
    store_id: string;
    payload: Record<string, unknown>;
    /** Merchant currency used to format money in the rendered report. */
    currency?: Currency;
    /** Store IANA time zone used to format dates in the rendered report. */
    timezone?: string;
    notification_created_at: string;
}
// ─── Notification media (rendered report stored in S3 — FR-14) ───
export interface NotificationMedia {
    jpeg_url: string;
    pdf_url: string;
    jpeg_key: string;
    pdf_key: string;
}
// ─── Schedules (notifications.md §9 / FR-08, FR-09) ───
export enum NotificationScheduleFrequency {
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY'
}
/** Minutes since store-local midnight; must be a multiple of 30 (FR-08). */
export const NOTIFICATION_SCHEDULE_TIME_STEP_MIN = 30;
export const NOTIFICATION_SCHEDULE_TIME_MAX_MIN = 23 * 60 + 30;
/** `month_day` value meaning "last day of the month" (FR-09 clamp). */
export const NOTIFICATION_SCHEDULE_LAST_DAY_OF_MONTH = 31;
/**
 * Manager-selected schedule for one store × type (item `NOTIFICATION_SCHEDULE`
 * in the POS main table). One EventBridge Scheduler entry per record fires
 * daily at `time_min` in `timezone`; the generator applies the weekly /
 * monthly guard (`isScheduledToday`).
 */
export interface NotificationSchedule extends Versioned {
    store_id: string;
    type: NotificationRequestType;
    frequency: NotificationScheduleFrequency;
    /** Store-local minutes since midnight in 30-minute steps (0 … 1410). */
    time_min: number;
    /** 0 = Sunday … 6 = Saturday. Required when `frequency` is WEEKLY. */
    weekday?: number;
    /** 1 … 31; 31 means "last day of the month". Required when MONTHLY. */
    month_day?: number;
    /** IANA time zone the schedule is evaluated in (store-local). */
    timezone: string;
    enabled: boolean;
    /** Name of the EventBridge Scheduler schedule once synced. */
    schedule_name?: string;
    /** ISO timestamp of the last generator run that emitted a request. */
    last_run_at?: string;
    /** periodKey of the last emitted request (e.g. `D2026-08-08`). */
    last_period_key?: string;
    created_at: string;
    updated_at: string;
}
export interface NotificationScheduleDBItem extends NotificationSchedule {
    PK: string;
    SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}
/** Schedule fields a manager can set through the settings API. */
export interface NotificationScheduleInput {
    frequency: NotificationScheduleFrequency;
    time_min: number;
    weekday?: number;
    month_day?: number;
}
// ─── Settings API (notifications.md §11) ───
/** `PUT /notifications/settings/{merchant_id}/{store_id}/{type}` body. */
export interface UpdateNotificationSettings {
    enabled: boolean;
    /** Employee ids that receive this type (FR-02 / FR-07). */
    subscriber_ids: string[];
    /** Independent notification-contact ids. */
    contact_ids?: string[];
    /** null/omitted keeps the merchant-country default dynamic. */
    language?: Language | null;
    /**
     * Schedule for scheduled-capable types. `null`/omitted removes the
     * schedule (for PRICE_CHANGES this means "as it happens").
     */
    schedule?: NotificationScheduleInput | null;
}
export interface NotificationTypeSettings {
    type: NotificationRequestType;
    enabled: boolean;
    /** null means the merchant-country default is used dynamically. */
    language?: Language | null;
    subscribers: NotificationSubscriber[];
    /** Whether this type supports a D/W/M schedule. */
    schedulable: boolean;
    /** Whether this type also fires on domain events. */
    event_driven: boolean;
    schedule?: NotificationSchedule | null;
    /** ISO timestamps (UTC) of the next runs of the schedule, if any. */
    next_runs: string[];
}
export interface NotificationSettingsResponse {
    store_id: string;
    timezone: string;
    billing: NotificationBillingStatus;
    types: NotificationTypeSettings[];
}
// â”€â”€â”€ Merchant-wide independent notification contacts â”€â”€â”€
export interface NotificationContact extends Versioned {
    id: string;
    merchant_id: string;
    name: string;
    /** Normalized E.164 number; unique within a merchant. */
    phone_number: string;
    is_number_verified: boolean;
    created_at: string;
    updated_at: string;
}
export interface NotificationContactDBItem extends NotificationContact {
    PK: string;
    SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}
export interface NotificationContactsResponse {
    contacts: NotificationContact[];
}
export interface CreateNotificationContact {
    name: string;
    phone_number: string;
}
export interface UpdateNotificationContact {
    name: string;
    phone_number: string;
}
export interface SendNotificationContactVerificationResponse {
    expires_at: string;
}
export interface VerifyNotificationContact {
    code: string;
}
export interface NotificationContactVerification {
    merchant_id: string;
    contact_id: string;
    /**
     * Identifies this challenge: attempts and cleanup apply only to it, never
     * to a code sent after it. Optional for backwards compatibility; a
     * challenge without it asks for a new code.
     */
    challenge_id?: string;
    /**
     * The number the code was sent to: only that number can be verified with
     * it. Optional for backwards compatibility; a challenge without it asks
     * for a new code.
     */
    phone_number?: string;
    code_hash: string;
    expires_at: string;
    attempts: number;
    created_at: string;
    /** DynamoDB TTL in epoch seconds. */
    ttl: number;
}
export interface NotificationBillingStatus {
    blocked: boolean;
    reason?: 'OVERDUE_NOTIFICATION_INVOICE';
    overdue_invoice_id?: string;
    overdue_invoice_number?: string;
    due_date?: string;
}
export interface NotificationUsage {
    merchant_id: string;
    store_id: string;
    /** Calendar month in UTC, YYYY-MM. */
    month: string;
    activated_at: string;
}
export interface NotificationUsageDBItem extends NotificationUsage {
    PK: string;
    SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}
// ─── History API (notifications.md §11) ───
export interface GetNotificationsHistory {
    merchant_id: string;
    store_id: string;
    type?: NotificationRequestType;
    /** ISO date-time lower bound (inclusive) on `created_at`. */
    from?: string;
    /** ISO date-time upper bound (inclusive) on `created_at`. */
    to?: string;
    cursor?: string;
    count?: number;
}
export interface NotificationWithRecipients extends Notification {
    recipients: NotificationRecipient[];
}
export interface NotificationsHistoryPage {
    notifications: NotificationWithRecipients[];
    count: number;
    cursor?: string;
}
/** Manual resend request for one PENDING recipient copy. */
export interface ResendNotificationRecipient {
    merchant_id: string;
    store_id: string;
    message_id: string;
    recipient_id: string;
}
export interface ResendNotificationRecipientResponse {
    message: string;
    message_id: string;
    recipient_id: string;
}
// ─── Scheduler → generator invocation payload ───
/** Input the EventBridge Scheduler entry passes to the generator Lambdas. */
export interface ScheduledNotificationInvocation {
    merchant_id: string;
    store_id: string;
    type: NotificationRequestType;
}
// ─── Per-type render payloads (notifications.md §13) ───
//
// Source services publish these as `NotificationRequest.payload`; the send
// worker's layout builders read them. Money values are plain numbers in the
// merchant currency (the send worker formats them); dates are ISO strings.
export interface NotificationMoneyLine {
    name: string;
    amount: number;
}
export interface NotificationPaymentMethodBreakdown {
    name: string;
    sales: number;
    refunds: number;
    net: number;
}
export interface BusinessSummaryPayload {
    /** Human label, e.g. `8 Aug 2026 00:00 - 23:59`. */
    period_label: string;
    period_start: string;
    period_end: string;
    gross_sales: number;
    refunds: number;
    discounts: number;
    net_sales: number;
    cost_of_goods: number;
    gross_profit: number;
    expenses: number;
    net_profit: number;
    by_payment_method: NotificationPaymentMethodBreakdown[];
    by_employee: NotificationMoneyLine[];
}
export interface ShiftCountLine {
    name: string;
    payment_type: PaymentMethodType;
    expected: number;
    counted: number;
    difference: number;
}
export interface ShiftReportPayload {
    shift_id: string;
    opened_by: string;
    opened_at: string;
    closed_by: string;
    closed_at: string;
    duration_minutes: number;
    gross_sales: number;
    refunds: number;
    discounts: number;
    net_sales: number;
    /** Net sales per payment method. */
    payment_methods: NotificationMoneyLine[];
    /** Expected vs counted per payment method. */
    counts: ShiftCountLine[];
    total_difference: number;
    closing_note?: string;
}
export interface LowStockItem {
    product_id: string;
    name: string;
    in_stock: number;
    threshold: number;
}
export interface LowStockPayload {
    period_label: string;
    period_start: string;
    period_end: string;
    items: LowStockItem[];
    total_below_threshold: number;
}
export interface ExpiringProductItem {
    product_id: string;
    name: string;
    po_id: string;
    /** YYYY-MM-DD */
    expiry_date: string;
    /** Whole days until the expiry date; negative = already past. */
    days_left: number;
    /** Quantity received on the purchase-order line. */
    quantity: number;
    in_stock: number;
}
export interface ExpiringProductsPayload {
    period_label: string;
    period_start: string;
    period_end: string;
    items: ExpiringProductItem[];
    total_expiring: number;
}
export interface InventoryCountDifferenceItem {
    product_id: string;
    name: string;
    /** Signed quantity change in base units. */
    quantity_change: number;
    /** Optional human breakdown, e.g. `-504 × Caixa=10 + 1 × Unidade`. */
    quantity_label?: string;
    /** Signed inventory value change (cost). */
    value_change: number;
}
export interface InventoryCountSummaryPayload {
    period_label: string;
    period_start: string;
    period_end: string;
    report_date: string;
    counted_by: string[];
    items_with_changes: number;
    total_difference_value: number;
    largest_negative: InventoryCountDifferenceItem[];
    largest_positive: InventoryCountDifferenceItem[];
    net_difference_value: number;
}
export interface PriceChangeItem {
    product_id: string;
    name: string;
    old_price: number;
    new_price: number;
    changed_by?: string;
    changed_at?: string;
}
export interface PriceChangesPayload {
    /**
     * Period label of a scheduled digest. Omitted for event notifications,
     * which are dated by the first change's `changed_at` at render time.
     */
    date_label?: string;
    changed_by?: string;
    changes: PriceChangeItem[];
}
export enum PurchaseOrderNotificationEvent {
    CREATED = 'CREATED',
    UPDATED = 'UPDATED',
    RECEIVED = 'RECEIVED',
    CANCELLED = 'CANCELLED'
}
export interface PurchaseOrderNotificationItem {
    name: string;
    quantity: number;
    cost: number;
    total: number;
}
export interface PurchaseOrderChangesPayload {
    po_id: string;
    event: PurchaseOrderNotificationEvent;
    ordered_by: string;
    supplier_name: string;
    purchase_date: string;
    items: PurchaseOrderNotificationItem[];
    total_cost: number;
    paid: number;
    amount_due: number;
    status: string;
    note?: string;
}
export interface ReceiptNotificationDiscount {
    name: string;
    amount: number;
}
export interface ReceiptNotificationLineItem {
    name: string;
    quantity: number;
    price: number;
    total: number;
    is_sold_by_weight?: boolean;
    note?: string;
    discounts?: ReceiptNotificationDiscount[];
}
export interface ReceiptNotificationTax {
    name: string;
    amount: number;
    type: 'INCLUDED' | 'ADDED';
}
export interface ReceiptNotificationPayment {
    name: string;
    payment_type: PaymentMethodType;
    amount: number;
    total_given?: number;
    change?: number;
}
export interface ReceiptNotificationDebt {
    starting: number;
    refunded: number;
    borrowed: number;
    ending: number;
    due_date?: string;
}
export interface ReceiptNotificationPoints {
    earned: number;
    deducted: number;
    balance: number;
}
/** Mirrors the printed classic receipt (native_app_pos ReceiptFormatter). */
export interface ReceiptPayload {
    receipt_number: string;
    custom_receipt_number: string;
    receipt_type: 'SALE' | 'REFUND';
    created_at: string;
    /** Verified customer copy is resolved from this id (FR-03). */
    customer_id?: string;
    customer_name?: string;
    employee_name: string;
    pos_device_name: string;
    refund_for?: string;
    associated_refunds?: string[];
    line_items: ReceiptNotificationLineItem[];
    subtotal: number;
    total_discount: number;
    tip: number;
    surcharge: number;
    total: number;
    taxes: ReceiptNotificationTax[];
    payments: ReceiptNotificationPayment[];
    debt?: ReceiptNotificationDebt;
    points?: ReceiptNotificationPoints;
}
export enum DebtNotificationEvent {
    DEBT_CREATED = 'DEBT_CREATED',
    DEBT_PAYMENT = 'DEBT_PAYMENT'
}
export interface DebtNotificationItem {
    name: string;
    quantity: number;
    price: number;
    total: number;
}
export interface DebtsPayload {
    event: DebtNotificationEvent;
    debt_id: string;
    /**
     * Debtor customer id — the verified customer copy is resolved from it
     * (FR-04). Omitted when the debtor is not a customer (e.g. an employee).
     */
    customer_id?: string;
    customer_name: string;
    employee_name: string;
    receipt_number?: string;
    date: string;
    /** DEBT_CREATED only. */
    items?: DebtNotificationItem[];
    purchase_total?: number;
    paid_today?: number;
    new_debt?: number;
    /** DEBT_PAYMENT only. */
    payment_amount?: number;
    payment_method?: string;
    previous_balance: number;
    total_outstanding: number;
    due_date?: string;
}
export enum DebtReminderTier {
    /** Sent once at T−3 days before the due date (FR-16). */
    DUE_SOON = 'DUE_SOON',
    /** Sent once per ISO week while unpaid and past due (FR-16). */
    OVERDUE = 'OVERDUE'
}
export interface DebtPaymentReminderPayload {
    tier: DebtReminderTier;
    debt_id: string;
    /** Debtor customer id; omitted when the debtor is not a customer. */
    customer_id?: string;
    customer_name: string;
    due_date: string;
    days_remaining?: number;
    days_overdue?: number;
    outstanding_balance: number;
    supplier_contact?: string;
}
export interface ExpensePayload {
    transaction_id: string;
    recorded_by: string;
    date: string;
    shift_id?: string;
    amount: number;
    paid_from: string;
    comments?: string;
}
/**
 * A stock change `POST /inventory/{m}/stores/{s}/products/{p}` could not
 * record: who made it, when, what and why it failed.
 */
export interface InventoryUpdateFailedPayload {
    product_id: string;
    product_name: string;
    /** `InventoryChangeReason`: Sale, Purchase Order, Inventory Count… */
    reason: string;
    /** Counts: the quantity counted; other changes: the change (+/−). */
    quantity: number;
    /** Who made the change (the cashier, the receiver, the counter). */
    actor_name: string;
    /** When the change happened at its source. */
    occurred_at: string;
    failed_at: string;
    /** What caused it, e.g. `Receipt 1-1042` or the purchase order. */
    source?: string;
    /** The server's reason. */
    error: string;
    status_code?: number;
}
export interface AvailableMoneyAccount {
    owner_name: string;
    balances: NotificationMoneyLine[];
}
export interface AvailableMoneyPayload {
    snapshot_at: string;
    snapshot_label: string;
    accounts: AvailableMoneyAccount[];
    totals: NotificationMoneyLine[];
}
export interface InvoicePayload {
    invoice_id: string;
    invoice_number: string;
    period_start: string;
    period_end: string;
    due_date: string;
    subscription_fee: number;
    discounts: number;
    total: number;
    amount_due: number;
    status: string;
    currency?: string;
    /**
     * What the store must top up so its wallet covers everything it owes.
     * Optional for backwards compatibility; missing or 0 = nothing to top up.
     */
    top_up_amount?: number;
}
export interface TaskAssignedPayload {
    task_id: string;
    title: string;
    /** Written description, if any (an audio note is only mentioned). */
    description?: string;
    has_audio?: boolean;
    attachment_count?: number;
    due_at?: string;
    created_by: string;
    /** The person, or the role, it is assigned to. */
    assigned_to: string;
    created_at: string;
}
export interface TopupPayload {
    transaction_id: string;
    operator: string;
    sender: string;
    receiver_number: string;
    amount: number;
    status: string;
    claimed_by?: string;
    wallet_credited?: string;
    date: string;
}

/**
 * Native-app observability — the self-hosted replacement for Sentry.
 *
 * The POS apps record everything they do into an in-memory ring buffer,
 * spool it to their local SQLite database, and upload it in gzipped batches
 * to `POST /observability/ingest`. Rows land in the platform's technical
 * store — the same DynamoDB table that archives dead-letter-queue events,
 * never POSTable, so business records stay clear of diagnostics — and expire
 * on their own via TTL.
 *
 * Two shapes are stored:
 *
 *  - `ObservabilityBatch` — the raw firehose, one row per upload, holding a
 *    gzipped NDJSON blob of every event in the batch. This is what the
 *    "session replay" view streams.
 *
 *  - `ObservabilityEvent` — a signal (error, user action, business event)
 *    lifted out of its batch into its own indexed row so it can be searched,
 *    filtered and correlated.
 */
/** Severity, ordered least → most severe. Mirrors the app's `appLog` levels. */
export type ObservabilityLevel = 'trace' | 'debug' | 'info' | 'warning' | 'error' | 'fatal';
export const OBSERVABILITY_LEVELS: ObservabilityLevel[] = [
    'trace',
    'debug',
    'info',
    'warning',
    'error',
    'fatal',
];
/**
 * Severity filter for the fleet feed. `'all'` merges every level stream —
 * the "show me everything ingested in this window" view.
 */
export type ObservabilityFeedLevel = ObservabilityLevel | 'all';
/**
 * What kind of thing happened. `kind` answers "what class of activity is
 * this", `name` answers "which one" (e.g. kind `print`, name
 * `shift_report`).
 */
export type ObservabilityKind = 
/** A line that went through `appLog` — the general log stream. */
'log'
/** A thrown exception or a failed operation, with stack trace. */
 | 'error'
/** Something the operator physically did: tap, key press, scan, submit. */
 | 'action'
/** A screen/route change. */
 | 'navigation'
/** An outbound HTTP call and its result. */
 | 'network'
/** A local database read/write worth timing. */
 | 'database'
/** A background/foreground sync run. */
 | 'sync'
/** Something sent to a printer, including the exact rendered contents. */
 | 'print'
/** Hardware interaction: scale, scanner, cash drawer, card terminal. */
 | 'device'
/** A domain outcome: sale completed, debt paid, shift closed. */
 | 'business'
/** App start, resume, pause, crash, update. */
 | 'lifecycle'
/** A timed span with a duration, opened and closed around an action. */
 | 'trace';
export const OBSERVABILITY_KINDS: ObservabilityKind[] = [
    'log',
    'error',
    'action',
    'navigation',
    'network',
    'database',
    'sync',
    'print',
    'device',
    'business',
    'lifecycle',
    'trace',
];
/**
 * Where an event's heavy payload ended up. Payloads are gzipped by the
 * ingest handler; anything still over `PAYLOAD_INLINE_LIMIT_BYTES` after
 * compression is written to S3 and the row keeps only a pointer, so a single
 * enormous report can never blow the 400KB DynamoDB item limit.
 */
export type ObservabilityPayloadLocation = 'inline' | 's3' | 'dropped';
/** Compression applied to `payload_gz` / the S3 object. */
export type ObservabilityCompression = 'gzip' | 'none';
/**
 * Context every event from a given device carries. The app sets this once
 * per session and the uploader stamps it onto the batch envelope rather than
 * onto each event, so it costs nothing on the hot path.
 */
export interface ObservabilityContext {
    merchant_id: string;
    store_id?: string;
    pos_device_id: string;
    pos_device_name?: string;
    /** Stable hardware fingerprint — survives reinstalls, unlike session id. */
    fingerprint?: string;
    user_id?: string;
    user_name?: string;
    /** App session: one app launch. Resets on cold start. */
    session_id: string;
    app_version?: string;
    build_number?: string;
    /** 'android' | 'windows' | 'linux' | 'macos' | 'ios' | 'web' */
    platform?: string;
    os_version?: string;
    device_model?: string;
    /** Deployment stage the app was built against. */
    stage?: string;
    locale?: string;
}
/** A single recorded event, exactly as the device serialises it. */
export interface ObservabilityEventInput {
    /** ULID/UUID minted on the device — makes ingest idempotent on retry. */
    id: string;
    /** Monotonic counter within the session. Orders events sharing a ms. */
    seq: number;
    kind: ObservabilityKind;
    level: ObservabilityLevel;
    /** Logical name: 'print_receipt', 'GET /products', 'checkout'. */
    name: string;
    /** One-line human-readable summary. Truncated by the device. */
    message?: string;
    /** ISO-8601 UTC. */
    occurred_at: string;
    /** Correlates every event emitted while one user action ran. */
    trace_id?: string;
    /** Parent span, for nesting spans inside a trace. */
    parent_id?: string;
    /** Wall-clock duration of a span, in milliseconds. */
    duration_ms?: number;
    /** Whether the operation succeeded. Absent for events with no outcome. */
    ok?: boolean;
    /** Exception class or error code, for grouping like Sentry issues. */
    error_type?: string;
    /** Stack trace, when there is one. */
    stack_trace?: string;
    /**
     * Small, flat, searchable key/values: the button that was pressed, the
     * inputs that were typed, amounts, ids, counts. Keep it under ~2KB — the
     * bulky stuff belongs in `payload`.
     */
    attributes?: Record<string, string | number | boolean | null>;
    /**
     * The heavy body: the exact receipt/shift-report text that went to the
     * printer, a request/response dump, a full state snapshot. Stored gzipped,
     * spilled to S3 when large.
     */
    payload?: string;
    /** Screen/route the app was on when this happened. */
    screen?: string;
    /**
     * Set by the device when this event should also be lifted into its own
     * indexed row. Errors, actions and business events default to true.
     */
    signal?: boolean;
}
/** One upload from a device: shared context plus the events it collected. */
export interface ObservabilityIngestBatch {
    /** ULID minted on the device. Re-uploading the same id is a no-op. */
    batch_id: string;
    context: ObservabilityContext;
    events: ObservabilityEventInput[];
    /** When the device closed this batch. ISO-8601 UTC. */
    created_at: string;
    /** Events the device dropped since the last batch (buffer overflow). */
    dropped_count?: number;
    /** Schema version, so old builds keep ingesting after a format change. */
    schema_version: number;
}
/**
 * The ingest request body. `events_gz` is a base64 gzipped NDJSON stream of
 * `ObservabilityEventInput` — the device never has to build one giant JSON
 * document, and the wire payload is ~10x smaller. `events` is the plain
 * fallback used by tests and by clients without a gzip implementation.
 */
export interface ObservabilityIngestRequest {
    /** ULID minted on the device. Re-uploading the same id is a no-op. */
    batch_id: string;
    context: ObservabilityContext;
    /** When the device closed this batch. ISO-8601 UTC. */
    created_at: string;
    /** Events the device dropped since the last batch (buffer overflow). */
    dropped_count?: number;
    /** Schema version, so old builds keep ingesting after a format change. */
    schema_version: number;
    events?: ObservabilityEventInput[];
    events_gz?: string;
}
export interface ObservabilityIngestResponse {
    batch_id: string;
    /** Events read out of the envelope. */
    received: number;
    /** Events promoted to their own indexed row. */
    signals: number;
    /** True when this batch_id had already been ingested. */
    duplicate: boolean;
}
/** A stored signal row, as returned by the query endpoints. */
export interface ObservabilityEvent {
    id: string;
    batch_id: string;
    seq: number;
    kind: ObservabilityKind;
    level: ObservabilityLevel;
    name: string;
    message?: string;
    occurred_at: string;
    /** When the backend accepted it — the gap reveals offline devices. */
    received_at: string;
    trace_id?: string;
    parent_id?: string;
    duration_ms?: number;
    ok?: boolean;
    error_type?: string;
    stack_trace?: string;
    attributes?: Record<string, string | number | boolean | null>;
    screen?: string;
    merchant_id: string;
    store_id?: string;
    pos_device_id: string;
    pos_device_name?: string;
    fingerprint?: string;
    user_id?: string;
    user_name?: string;
    session_id: string;
    app_version?: string;
    build_number?: string;
    platform?: string;
    os_version?: string;
    device_model?: string;
    stage?: string;
    /** Size of the uncompressed payload, before storage. */
    payload_bytes?: number;
    payload_location?: ObservabilityPayloadLocation;
    /**
     * Only populated by the single-event detail endpoint — list endpoints omit
     * it so a feed of 100 rows never drags along 100 report bodies.
     */
    payload?: string;
}
/** A stored raw-firehose row. `events` is filled in only on detail reads. */
export interface ObservabilityBatch {
    batch_id: string;
    created_at: string;
    received_at: string;
    event_count: number;
    dropped_count: number;
    signal_count: number;
    first_seq: number;
    last_seq: number;
    compressed_bytes: number;
    payload_location: ObservabilityPayloadLocation;
    context: ObservabilityContext;
    /** Decompressed events, returned by the batch detail endpoint only. */
    events?: ObservabilityEventInput[];
}
export interface ObservabilityEventsPage {
    events: ObservabilityEvent[];
    count: number;
    cursor?: string;
}
export interface ObservabilityBatchesPage {
    batches: ObservabilityBatch[];
    count: number;
    cursor?: string;
}
/** Query params shared by every list endpoint. */
export interface ObservabilityListQuery {
    limit?: number;
    cursor?: string;
    /** ISO-8601 UTC — inclusive lower bound on `occurred_at`. */
    from?: string;
    /** ISO-8601 UTC — inclusive upper bound on `occurred_at`. */
    to?: string;
    /** Newest first when true (the default). */
    descending?: boolean;
}
export interface ListObservabilityByDevice extends ObservabilityListQuery {
    pos_device_id: string;
    /** 'events' returns signals only, 'batches' the raw firehose. */
    entity?: 'events' | 'batches';
}
export interface ListObservabilityBySession extends ObservabilityListQuery {
    session_id: string;
}
export interface ListObservabilityByTrace {
    trace_id: string;
    limit?: number;
    cursor?: string;
}
export interface ListObservabilityByLevel extends ObservabilityListQuery {
    level: ObservabilityFeedLevel;
    /**
     * How many hourly buckets back from `to` to scan. The severity feed walks
     * one bucket per query so a fleet-wide error stream never hammers a single
     * partition. Defaults to 24.
     */
    hours?: number;
}
export interface ListObservabilityByMerchant extends ObservabilityListQuery {
    merchant_id: string;
    /** yyyy-MM-dd. Defaults to today (UTC). */
    date?: string;
    /** How many daily buckets back from `date` to scan. Defaults to 1. */
    days?: number;
}
/** Path + query params for one signal detail read. */
export interface GetObservabilityEvent {
    pos_device_id: string;
    id: string;
    /** ISO-8601 UTC `occurred_at`, used to address the row's sort key. */
    occurred_at: string;
}
/** Path + query params for one raw-batch detail read. */
export interface GetObservabilityBatch {
    pos_device_id: string;
    batch_id: string;
    /** ISO-8601 UTC `created_at`, used to address the row's sort key. */
    created_at: string;
}
/** Query params for the grouped issues view. */
export interface ListObservabilityIssues {
    level?: ObservabilityFeedLevel;
    hours?: number;
    merchant_id?: string;
    /** ISO-8601 UTC lower bound; overrides `hours`. */
    from?: string;
    to?: string;
}
/**
 * Grouped view of recurring errors — the "Issues" list. Computed on read
 * over a bounded window rather than maintained as counters, so ingest stays
 * a single write with no read-modify-write.
 */
export interface ObservabilityIssue {
    /** Stable grouping key: `${kind}:${error_type ?? name}`. */
    fingerprint: string;
    kind: ObservabilityKind;
    level: ObservabilityLevel;
    title: string;
    count: number;
    first_seen: string;
    last_seen: string;
    affected_devices: number;
    affected_users: number;
    sample_event_id: string;
    sample_pos_device_id: string;
}
export interface ObservabilityIssuesPage {
    issues: ObservabilityIssue[];
    count: number;
    /** Window the grouping was computed over. */
    from: string;
    to: string;
    /** True when the window was truncated by the scan budget. */
    truncated: boolean;
}
/** Current schema version emitted by the apps. */
export const OBSERVABILITY_SCHEMA_VERSION = 1;
/**
 * Compressed payloads at or below this stay on the DynamoDB row; anything
 * larger is written to S3. Sized so a typical 80mm receipt (~2KB) or shift
 * report (~8KB) always lands inline, while a pathological dump does not.
 */
export const OBSERVABILITY_PAYLOAD_INLINE_LIMIT_BYTES = 100 * 1024;
/** Hard ceiling on a payload the backend will accept before dropping it. */
export const OBSERVABILITY_PAYLOAD_MAX_BYTES = 5 * 1024 * 1024;
/** Retention, in days, applied via the row's TTL attribute. */
export const OBSERVABILITY_RETENTION_DAYS = {
    /** Raw firehose — bulky, only useful while an incident is fresh. */
    batch: 14,
    /** Signals — searched long after the fact. */
    event: 90,
    /** Backend spans and failure rows (OTLP ingest). */
    span: 14,
    /** Aggregated backend metric windows. */
    metric: 30,
    /** Captured Lambda function logs (index rows and S3 objects). */
    logs: 14,
} as const;
// ── Backend (Lambda) telemetry ─────────────────────────────────────────────
// Produced by the OpenTelemetry Lambda extension and ingested as OTLP/JSON.
// Spans reuse the ObservabilityEvent row (kind 'trace' / 'error') so the
// trace pages work unchanged; metrics get their own compact rows.
/**
 * Query params for the backend metrics summary and timeseries.
 *
 * `from`/`to` select any window inside the metric retention; `hours` is the
 * older "last N hours" shorthand and is ignored when `from` is set. The
 * timeseries is paginated: pass the returned `cursor` back until it is
 * absent, each page covering the next run of hour buckets.
 */
export interface ListObservabilityBackendMetrics {
    /** Hourly buckets to walk back from `to` (default 24). */
    hours?: number;
    /** ISO-8601 UTC, inclusive lower bound on the metric window end. */
    from?: string;
    /** ISO-8601 UTC, inclusive upper bound. Defaults to now. */
    to?: string;
    /** Cursor returned from a previous timeseries page. */
    cursor?: string;
}
/** One aggregated metric window as stored (delta temporality). */
export interface ObservabilityMetricPoint {
    service: string;
    function_name: string;
    name: string;
    unit: string;
    kind: 'sum' | 'histogram';
    /** Inclusive ISO window the delta covers. */
    window_start: string;
    window_end: string;
    /** Sum value for `sum` metrics; histogram sum for `histogram` metrics. */
    sum: number;
    count?: number;
    min?: number;
    max?: number;
    /** Explicit histogram bounds and per-bucket counts (last is +Inf). */
    bounds?: number[];
    bucket_counts?: number[];
    attributes?: Record<string, string | number | boolean>;
}
/** Per-function rollup of the platform (FaaS) metrics over the window. */
export interface ObservabilityFunctionMetrics {
    service: string;
    function_name: string;
    invocations: number;
    errors: number;
    timeouts: number;
    cold_starts: number;
    duration_avg_ms?: number;
    duration_max_ms?: number;
    /** Estimated from the histogram buckets. */
    duration_p95_ms?: number;
    init_duration_avg_ms?: number;
    billed_ms: number;
    max_memory_used_mb?: number;
    /** Merged duration histogram over the window (last bucket is +Inf). */
    duration_bounds?: number[];
    duration_bucket_counts?: number[];
    last_seen: string;
}
/** One hourly point of the per-function rollup. */
export interface ObservabilityBackendTimeseriesPoint {
    /** Hour bucket, `yyyy-MM-ddTHH` (UTC). */
    bucket: string;
    service: string;
    function_name: string;
    invocations: number;
    errors: number;
    timeouts: number;
    cold_starts: number;
    duration_avg_ms?: number;
    duration_p95_ms?: number;
    duration_max_ms?: number;
    billed_ms: number;
    /**
     * Raw accumulators, so any run of hourly points (one page, or every page
     * of a long window) can be merged into exact window totals on the client
     * with `mergeBackendFunctionPoints`.
     */
    duration_count?: number;
    duration_sum_ms?: number;
    duration_bounds?: number[];
    duration_bucket_counts?: number[];
    init_count?: number;
    init_sum_ms?: number;
    max_memory_used_mb?: number;
    last_seen?: string;
}
/** One hourly point of an application metric series. */
export interface ObservabilityBackendCustomTimeseriesPoint {
    bucket: string;
    service?: string;
    function_name: string;
    name: string;
    unit: string;
    kind: 'sum' | 'histogram';
    sum: number;
    count: number;
    min?: number;
    max?: number;
    attributes?: Record<string, string | number | boolean>;
}
export interface ObservabilityBackendTimeseriesPage {
    /** The whole requested window, identical on every page of one walk. */
    from: string;
    to: string;
    /** Hour buckets covered by this page, oldest first, including empty ones. */
    buckets: string[];
    points: ObservabilityBackendTimeseriesPoint[];
    custom: ObservabilityBackendCustomTimeseriesPoint[];
    /** Present while more hour buckets remain; pass it back for the next page. */
    cursor?: string;
    /** Hour buckets in the whole window, for a progress indicator. */
    total_buckets?: number;
}
/** Rollup of one application metric (`metrics.count` / `metrics.record`). */
export interface ObservabilityCustomMetric {
    service: string;
    function_name: string;
    name: string;
    unit: string;
    kind: 'sum' | 'histogram';
    sum: number;
    count: number;
    min?: number;
    max?: number;
    attributes?: Record<string, string | number | boolean>;
}
export interface ObservabilityBackendMetricsPage {
    from: string;
    to: string;
    functions: ObservabilityFunctionMetrics[];
    custom: ObservabilityCustomMetric[];
    /** True when the window was too large to finish inside one request. */
    partial?: boolean;
}
export interface ObservabilityMetricDBItem extends ObservabilityMetricPoint {
    PK: string; // OBS_METRIC#<yyyy-MM-ddTHH>
    SK: string; // TS#<window_end>#<function_name>#<name>#<series hash>
    ttl: number;
}
// ── DynamoDB item shapes ───────────────────────────────────────────────────
// These rows share the platform's technical store with the dead-letter-queue
// archive. Every partition key is prefixed so the two tenants never collide;
// the full key layout is documented on the FailedEventsStack CDK construct.
//
// GSI1/GSI2/GSI3 are sparse: batch rows (and failed-event rows) omit them, so
// the high-volume firehose is only ever charged for the base table.
export interface ObservabilityEventDBItem extends Omit<ObservabilityEvent, 'payload'> {
    PK: string; // DEVICE#<pos_device_id>
    SK: string; // OBS_EVENT#<occurred_at>#<id>
    EntityIndexPK: string; // OBS_LEVEL#<level>#<yyyy-MM-ddTHH>
    EntityIndexSK: string; // TS#<occurred_at>#<id>
    GSI1PK: string; // OBS_SESSION#<session_id>
    GSI1SK: string; // SEQ#<zero-padded seq>#<id>
    GSI2PK?: string; // OBS_TRACE#<trace_id>
    GSI2SK?: string; // SEQ#<zero-padded seq>#<id>
    GSI3PK: string; // OBS_MERCHANT#<merchant_id>#<yyyy-MM-dd>
    GSI3SK: string; // TS#<occurred_at>#<id>
    /** Base64 gzipped payload, when it fit inline. */
    payload_gz?: string;
    /** S3 key, when the payload was spilled. */
    payload_key?: string;
    compression?: ObservabilityCompression;
    ttl: number;
}
export interface ObservabilityBatchDBItem extends Omit<ObservabilityBatch, 'events'> {
    PK: string; // DEVICE#<pos_device_id>
    SK: string; // OBS_BATCH#<created_at>#<batch_id>
    /** Base64 gzipped NDJSON of every event in the batch, when it fit inline. */
    events_gz?: string;
    /** S3 key, when the envelope was spilled. */
    events_key?: string;
    compression?: ObservabilityCompression;
    ttl: number;
}
// ── Lambda function logs ──────────────────────────────────────────────────
// Captured by the telemetry extension from the Lambda Telemetry API
// (`function` stream), never read from CloudWatch Logs. The log lines of
// every invocation are stored as gzipped NDJSON in the observability bucket;
// DynamoDB only keeps one small index row per invocation.
export type LambdaInvocationStatus = 'success' | 'error' | 'failure' | 'timeout';
/** One captured stdout/stderr line. */
export interface LambdaLogLine {
    /** ISO-8601 UTC. */
    time: string;
    /** Normalised severity when the line carried one (Powertools, console.*). */
    level?: ObservabilityLevel;
    message: string;
}
/** Summary of one Lambda invocation, as listed in the admin. */
export interface LambdaInvocation {
    request_id: string;
    service: string;
    function_name: string;
    started_at: string;
    ended_at?: string;
    status: LambdaInvocationStatus;
    ok: boolean;
    duration_ms?: number;
    billed_ms?: number;
    max_memory_used_mb?: number;
    memory_size_mb?: number;
    cold_start?: boolean;
    init_duration_ms?: number;
    error_type?: string;
    error_message?: string;
    trace_id?: string;
    line_count: number;
    error_line_count: number;
    /** Lines the extension dropped because the invocation hit its log cap. */
    dropped_lines?: number;
    stage?: string;
}
export interface LambdaInvocationsPage {
    invocations: LambdaInvocation[];
    count: number;
    cursor?: string;
}
/** Query params for the invocation list of one function. */
export interface ListLambdaInvocations {
    function_name: string;
    /** ISO-8601 UTC, inclusive. Defaults to 24 hours before `to`. */
    from?: string;
    /** ISO-8601 UTC, inclusive. Defaults to now. */
    to?: string;
    /** `errors` keeps failed and timed-out invocations only. */
    status?: 'all' | 'errors';
    limit?: number;
    cursor?: string;
}
/** Every captured line of one invocation, oldest first. */
export interface LambdaInvocationLogs {
    invocation?: LambdaInvocation;
    lines: LambdaLogLine[];
    /** True when the extension dropped lines over its per-invocation cap. */
    truncated: boolean;
}
/** Share of successful invocations kept when no admin setting exists. */
export const OBSERVABILITY_DEFAULT_SUCCESS_SAMPLE_PERCENT = 5;
/**
 * Admin-set sampling of Lambda invocation rows (one platform-wide record).
 * Failed, timed-out and slow invocations, and those that logged an error,
 * are always kept; this only thins out the successful ones. Log lines of
 * every invocation still reach the bucket.
 */
export interface ObservabilitySettings {
    /** 0–100. Missing record = OBSERVABILITY_DEFAULT_SUCCESS_SAMPLE_PERCENT. */
    success_sample_percent: number;
    updated_at?: string;
    updated_by_name?: string;
}
export interface UpdateObservabilitySettings {
    /** 0–100, whole or decimal (e.g. 0.5). */
    success_sample_percent: number;
}
/** One index row per invocation (part 0) or late-arriving log part. */
export interface LambdaInvocationDBItem extends Partial<LambdaInvocation> {
    PK: string; // OBS_LAMBDA_INV#<function_name>#<yyyy-MM-dd> | OBS_LAMBDA_LOGPART#<request_id>
    SK: string; // TS#<started_at>#<request_id> | PART#<received_at>#<message_id>
    GSI1PK: string; // OBS_SESSION#<request_id>
    GSI1SK: string; // LOGS#<received_at>#<message_id>
    request_id: string;
    /** S3 key of the gzipped NDJSON object holding this part's lines. */
    log_key: string;
    part: number;
    ttl: number;
}

/**
 * Enum representing the various payment method types.
 */
export enum PaymentMethodType {
    /** Cash payment */
    CASH = 'CASH',
    /** Card payment */
    CARD = 'CARD',
    /** Debt payment */
    DEBT = 'DEBT',
    /** Mobile money payment */
    MOBILE_MONEY = 'MOBILE_MONEY',
    /** Payment by cheque */
    CHEQUE = 'CHEQUE',
    /** Bank transfer */
    BANK_TRANSFER = 'BANK_TRANSFER',
    /** Coupon payment */
    COUPON = 'COUPON',
    /** Payment using loyalty points */
    LOYALTY_POINTS = 'LOYALTY_POINTS',
    /** Other types of payment */
    OTHER = 'OTHER'
}
/**
 * Represents a payment type in the Loyverse system.
 */
export interface PaymentType extends Timestamps, Versioned {
    /**
     * The unique identifier of the payment type.
     * If included in a POST request, it will update the existing payment type instead of creating a new one.
     */
    id: string;
    /**
     * The name of the payment type.
     */
    name: string;
    /**
     * The payment method type.
     */
    payment_type: PaymentMethodType;
    /**
     * The list of store IDs where this payment type is available.
     */
    stores: string[];
    /**
     * The ID of the merchant who owns this payment type.
     */
    merchant_id: string;
}
/**
 * Represents a create payment type request.
 */
export interface CreatePaymentType {
    /**
     * The name of the payment type.
     */
    name: string;
    /**
     * The payment method type.
     */
    payment_type: PaymentMethodType;
    /**
     * The list of store IDs where this payment type is available.
     */
    stores: string[];
    /**
     * The ID of the merchant who owns this payment type.
     */
    merchant_id: string;
}
/**
 * Represents a payment type update request.
 */
export interface UpdatePaymentType {
    /**
     * The name of the payment type.
     */
    name?: string;
    /**
     * The payment method type.
     */
    payment_type?: PaymentMethodType;
    /**
     * The list of store IDs where this payment type is available.
     */
    add_stores?: string[];
    /**
     * The list of store IDs where this payment type is no longer available.
     */
    remove_stores?: string[];
    /**
     * The ID of the payment type to update.
     */
    id: string;
}
/**
 * Represents a payment type page
 */
export interface PaymentTypePage {
    /**
     * The list of payment types.
     */
    payment_types: PaymentType[];
    /**
     * The total number of payment types.
     */
    count: number;
    /**
     * The cursor for the next page of payment types.
     */
    cursor: string;
}
/**
 * Represents a Get Payment Type request.
 */
export interface GetPaymentType {
    /**
     * The ID of the payment type to get.
     */
    id: string;
    /**
     * The flag to include deleted payment types.
     */
    include_deleted?: SoftDeleteFlag;
}
/**
 * Represents a Get List of Payment Type request.
 */
export interface GetPaymentTypes {
    /**
     * The cursor for the next page of payment types.
     */
    cursor?: string;
    /**
     * The number of payment types to get.
     */
    limit?: number;
    /**
     * The ID of the merchant who owns this payment type.
     */
    merchant_id: string;
    /**
     * The list of store IDs where this payment type is available.
     */
    stores?: string[];
    /**
     * The flag to include deleted payment types.
     */
    include_deleted?: SoftDeleteFlag;
}
/**
 * Represents a Payment Type DB Item.
 */
export interface PaymentTypeDBItem extends Timestamps, PaymentType {
    /**
     * The Primary Key.
     */
    PK: string;
    /**
     * The Sort Key.
     */
    SK: string;
    /**
     * The 1st GSI PK.
     */
    GSI1PK: string;
    /**
     * The 1st GSI SK.
     */
    GSI1SK: string;
    /**
     * The Entity Index PK.
     */
    EntityIndexPK: string;
    /**
     * The Entity Index SK.
     */
    EntityIndexSK: string;
}

export enum PaymentReason {
    DEBT = 'DEBT',
    LOAN = 'LOAN',
    RECEIPT = 'RECEIPT',
    REFUND = 'REFUND'
}
export interface ReceiptPaymentDetails {
    receipt_id: string;
    payment: ReceiptPayment;
    customer_id: string;
}
export interface RefundReceiptPaymentDetails {
    receipt_id: string;
    payment: ReceiptPayment;
    customer_id: string;
    refund_for: string;
}
export interface LoanPaymentDetails {
    borrower_id: string;
    borrower_type: EntityTypes;
    borrower_loan_id: string;
}
export interface DebtPaymentDetails {
    customer_id: string;
    customer_debt_id: string;
}
export type PaymentDetails = LoanPaymentDetails | DebtPaymentDetails | ReceiptPaymentDetails | RefundReceiptPaymentDetails;
export interface CommonPaymentAttributes {
    amount: number;
    reason: PaymentReason;
    employee: CommonEmployeeAsCreatorAttributes;
    note: string;
    payer_id: string;
    payer_type: EntityTypes;
    store_id: string;
    shift_id?: string; // TODO: Make Optional // Shift during which the payment was created
}
export interface Allocation extends Timestamps {
    allocation_entity_type: EntityTypes;
    allocation_entity_id: string;
    amount: number;
}
export interface Payment extends Timestamps, CommonPaymentAttributes {
    id: string;
    payment_details: PaymentDetails;
    owner_id: string;
    owner_type: EntityTypes;
    allocations: Allocation[];
    shift_id?: string; // TODO: Make Optional // Shift during which the payment was created
}
export interface PaymentsPage extends Paginated {
    payments: Payment[];
}
export interface CreateLoanPaymentDto extends CommonPaymentAttributes {
    borrower_loan_id: string;
}
export interface CreateDebtPaymentDto extends CommonPaymentAttributes {
    customer_debt_id: string;
}
export interface CreateReceiptPaymentDto extends CommonPaymentAttributes, ReceiptPaymentDetails {
}
export interface CreateRefundReceiptPaymentDto extends CommonPaymentAttributes, RefundReceiptPaymentDetails {
}
export interface PaymentDBItem extends Payment {
    PK: string; // <owner_type>#<owner_id>
    SK: string; // PAYMENT#<id>
    GSI1PK: string; // <reason>
    GSI1SK: string; // PAYMENT#<id>
    GSI2PK: string; // <creator_type>#<creator_id>
    GSI2SK: string; // PAYMENT#DATE#<created_at>
    GSI3PK: string; // <owner_type>#<owner_id>
    GSI3SK: string; // PAYMENT#DATE#<created_at>
    GSI4PK: string; // <owner_type>#<owner_id>
    GSI4SK: string; // <reason>#PAYMENT#<id>
    GSI5PK: string; // PAYMENT#<id>
    GSI5SK: string; // PAYMENT#<id>
    GSI6PK: string; // <payer_type>#<payer_id>
    GSI6SK: string; // PAYMENT#DATE#<created_at>
    GSI7PK: string; // <entity_type>#<entity_id>
    GSI7SK: string; // PAYMENT#DATE#<created_at>
    EntityIndexPK: string; // PAYMENT
    EntityIndexSK: string; // PAYMENT#DATE#<created_at>
}
export interface GetPaymentByPayerDto extends PaginationParams {
    payer_id: string;
    payer_type: EntityTypes;
}
export interface GetPaymentsByPayerAndDateRangeDto extends PaginationParams {
    payer_id: string;
    payer_type: EntityTypes;
    from: string;
    to: string;
}
export interface GetPaymentsByCreatorDto extends PaginationParams {
    creator_id: string;
    creator_type: EntityTypes;
}
export interface GetPaymentsByOwnerDto extends PaginationParams {
    owner_id: string;
    owner_type: EntityTypes;
}
export interface GetPaymentByIdDto {
    payment_id: string;
}
export interface GetPaymentsByEntityDto extends PaginationParams {
    entity_id: string;
    entity_type: EntityTypes;
}
export interface GetPaymentsByEntityAndDateRangeDto extends PaginationParams, DateRange {
    entity_id: string;
    entity_type: EntityTypes;
}
export interface GetPaymentsByReasonDto extends PaginationParams {
    reason: PaymentReason;
}
export interface GetPaymentsByOwnerAndReasonDto extends GetPaymentsByOwnerDto {
    reason: PaymentReason;
}
export interface GetPaymentsByOwnerAndDateRangeDto extends GetPaymentsByOwnerDto, DateRange {
}
export interface GetPaymentsByCreatorAndDateRangeDto extends GetPaymentsByCreatorDto, DateRange {
}
export interface GetPaymentsByDateRangeDto extends PaginationParams, DateRange {
}
export interface UpdatePaymentAllocations extends CommonEmployeeAsCreatorAttributes {
    allocations: Allocation[];
    payment_id: string;
}

/**
 * The one global admin setting that decides which permissions merchants see
 * in Settings → Roles and in what order (docs/plans/orders-and-transfers.md
 * §4.11). Permissions are named by their stable key (`permissionKey`:
 * `GET receipts/{}`, `APP <name>`, `ACTION <name>`) because a deploy creates
 * new ids. No record means today's behaviour (every used permission, default
 * order).
 */
export interface PermissionVisibility extends Timestamps, Versioned {
    /** Always `PERMISSION_VISIBILITY`: there is one record. */
    id: string;
    /** Group keys (`apps`, `actions`, service prefixes), in display order. */
    group_order: string[];
    /** Stable keys of the permissions shown, in display order. */
    visible_permissions: string[];
}
/** `PUT /admin/permission-visibility`: the whole setting in one call. */
export interface UpdatePermissionVisibility {
    group_order: string[];
    visible_permissions: string[];
    /**
     * The `version` read before editing (missing or 0 before the first save).
     * A save on a stale version is refused (409) instead of overwriting.
     */
    version?: number | null;
}
/**
 * One page of the job a save starts (service-admin `merchantRoleGrantsQueue`):
 * every visible permission is added to the `Merchant` role of each merchant
 * of the page that misses it, then the next page is queued.
 */
export interface MerchantRoleGrantsMessage {
    /** The merchants page to process; missing = the first page. */
    cursor?: string | null;
    /** The admin who saved the setting, recorded on the roles it changes. */
    actor_id: string;
    actor_name: string;
}
/** `GET /admin/permission-visibility`: `setting` is null before the first save. */
export interface PermissionVisibilityResponse {
    setting: PermissionVisibility | null;
}
export interface PermissionVisibilityDBItem extends PermissionVisibility {
    PK: string;
    SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}

/**
 * Platform finance: the mobile-money ledger of the platform's own receiving
 * numbers (Top-up Numbers), matched to merchants/stores (billing), other
 * income, and expenses. Operator-neutral: works for any mobile-money operator.
 */
export enum PlatformFinanceCategory {
    /** Money in used to pay a store's invoices (subscription). */
    INC_SUBSCRIPTION = 'INC_SUBSCRIPTION',
    /** Money in credited to a merchant/store wallet (claimed top-up). */
    INC_TOPUP = 'INC_TOPUP',
    /** Money in for materials sold to a client. Credits the platform wallet. */
    INC_MATERIAL = 'INC_MATERIAL',
    /** Any other money in. Credits the platform wallet. */
    INC_OTHER = 'INC_OTHER',
    EXP_TRANSPORT = 'EXP_TRANSPORT',
    EXP_INTERNET = 'EXP_INTERNET',
    EXP_MATERIAL = 'EXP_MATERIAL',
    EXP_SALARY = 'EXP_SALARY',
    EXP_OTHER = 'EXP_OTHER',
    /** AI subscriptions and API credits (Claude, ChatGPT, DeepSeek). */
    EXP_AI = 'EXP_AI',
    /** Cloud hosting (AWS). */
    EXP_CLOUD = 'EXP_CLOUD',
    /** Software development tools (GitHub). */
    EXP_DEV_TOOLS = 'EXP_DEV_TOOLS',
    /**
     * Pays a founder back for business costs they paid personally. Settles
     * what the business owes; not counted again as an expense.
     */
    EXP_FOUNDER_REIMBURSEMENT = 'EXP_FOUNDER_REIMBURSEMENT'
}
export enum PlatformFinanceAssignmentStatus {
    ASSIGNED = 'ASSIGNED',
    UNASSIGNED = 'UNASSIGNED',
    /** Posting to wallets/billing failed; retry from the transaction. */
    FAILED = 'FAILED',
    /** The SMS could not be fully read (operator review needed). */
    NEEDS_REVIEW = 'NEEDS_REVIEW'
}
export enum PlatformFinanceAllocationStatus {
    PENDING = 'PENDING',
    POSTED = 'POSTED',
    FAILED = 'FAILED'
}
export interface PlatformFinanceSplit {
    /** Stable split id (ULID) — used as the posting idempotency suffix. */
    id: string;
    amount: number;
    category: PlatformFinanceCategory;
    /** Money in: the store the money is for. */
    store_id?: string;
    store_name?: string;
    /** Money out: the Sales Agent paid (optional; free-text recipient allowed). */
    employee_id?: string;
    recipient_name?: string;
    /** Set once the split was posted to wallets (idempotent retries skip it). */
    posted_at?: string;
    /** Wallet reference_id used for this split's posting. */
    posted_reference_id?: string;
}
/** An admin classification of one ledger transaction. */
export interface PlatformFinanceAllocation extends Versioned {
    receiver_number: string;
    transaction_id: string;
    direction: WalletTransferDirection.IN | WalletTransferDirection.OUT;
    /** Primary category (the category of the first split). */
    category: PlatformFinanceCategory;
    /** Money in: the single merchant the splits belong to. */
    merchant_id?: string;
    merchant_name?: string;
    splits: PlatformFinanceSplit[];
    note?: string;
    status: PlatformFinanceAllocationStatus;
    error?: string;
    /** INC_SUBSCRIPTION: invoices collected after the wallet credit. */
    collected_invoice_ids?: string[];
    /** The transaction's time (ISO UTC), copied for month grouping. */
    occurred_at: string;
    /** The transaction's amount (+ fee for money out), copied for reports. */
    total_amount: number;
    /** Optimistic-concurrency counter. */
    version: number;
    created_at: string;
    updated_at: string;
    updated_by_id?: string;
    updated_by_name?: string;
    /**
     * Set when the transaction moved to another account (a merged
     * needs-setup number): this copy is hidden. Optional for backwards
     * compatibility; missing = live.
     */
    deleted_at?: string;
    deleted_by_id?: string;
    deleted_by_name?: string;
    /** The account the allocation moved to. */
    moved_to?: string;
}
export interface PlatformFinanceAllocationDBItem extends PlatformFinanceAllocation {
    PK: string; // PLATFORM_FINANCE_ALLOCATION#<receiver_number>
    SK: string; // TX#<transaction_id>
    EntityIndexPK: string; // PLATFORM_FINANCE_ALLOCATION
    EntityIndexSK: string; // DATE#<occurred_at>#<transaction_id>
}
export enum PlatformFinancePhoneEntity {
    STORE = 'STORE',
    EMPLOYEE = 'EMPLOYEE'
}
export enum PlatformFinancePhoneStatus {
    LEARNING = 'LEARNING',
    SUGGEST = 'SUGGEST',
    TRUSTED = 'TRUSTED'
}
/** A learned link between a counterparty phone number and a store/agent. */
export interface PlatformFinancePhoneAssociation extends Versioned {
    phone_number: string;
    entity_type: PlatformFinancePhoneEntity;
    entity_id: string;
    merchant_id?: string;
    confirmations: number;
    conflicts: number;
    confidence: number;
    status: PlatformFinancePhoneStatus;
    first_seen_at: string;
    last_confirmed_at: string;
}
export interface PlatformFinancePhoneAssociationDBItem extends PlatformFinancePhoneAssociation {
    PK: string; // PLATFORM_FINANCE_PHONE#<phone_number>
    SK: string; // STORE#<id> | EMPLOYEE#<id>
    EntityIndexPK: string; // PLATFORM_FINANCE_PHONE
    EntityIndexSK: string; // PHONE#<phone_number>#<SK>
}
export enum PlatformFinanceWaiverReason {
    REFERRAL_REWARD = 'REFERRAL_REWARD',
    STORE_CLOSED = 'STORE_CLOSED',
    GOODWILL = 'GOODWILL',
    SPECIAL_AGREEMENT = 'SPECIAL_AGREEMENT',
    OTHER = 'OTHER'
}
export enum PlatformFinanceWaiverStatus {
    ACTIVE = 'ACTIVE',
    REMOVED = 'REMOVED'
}
/** A free month: the invoice is cancelled and the reason kept here. */
export interface PlatformFinanceWaiver extends Versioned {
    invoice_id: string;
    merchant_id: string;
    store_id: string;
    period_start: string;
    period_end: string;
    amount: number;
    reason: PlatformFinanceWaiverReason;
    note?: string;
    status: PlatformFinanceWaiverStatus;
    waived_by: string;
    waived_at: string;
    removed_by?: string;
    removed_at?: string;
    /** The invoice re-issued when the waiver was removed. */
    replacement_invoice_id?: string;
}
export interface PlatformFinanceWaiverDBItem extends PlatformFinanceWaiver {
    PK: string; // PLATFORM_FINANCE_WAIVER#<invoice_id>
    SK: string; // PLATFORM_FINANCE_WAIVER#<invoice_id>
    EntityIndexPK: string; // PLATFORM_FINANCE_WAIVER
    EntityIndexSK: string; // DATE#<waived_at>
    GSI1PK: string; // PLATFORM_FINANCE_WAIVER#STORE#<store_id>
    GSI1SK: string; // DATE#<period_start>
}
export enum PlatformFinanceAuditAction {
    ASSIGN_IN = 'ASSIGN_IN',
    ASSIGN_OUT = 'ASSIGN_OUT',
    WAIVE_INVOICE = 'WAIVE_INVOICE',
    REMOVE_WAIVER = 'REMOVE_WAIVER',
    REPLAY_SMS = 'REPLAY_SMS',
    /** A needs-setup (device) account merged into a Top-up Number. */
    MERGE_ACCOUNT = 'MERGE_ACCOUNT',
    /** A phone assigned to a Top-up Number (its held SMS replayed). */
    ASSIGN_DEVICE = 'ASSIGN_DEVICE'
}
export interface PlatformFinanceAuditEntry {
    id: string;
    action: PlatformFinanceAuditAction;
    record_type: string;
    record_id: string;
    old_value?: string;
    new_value?: string;
    reason?: string;
    actor_id: string;
    actor_name: string;
    created_at: string;
}
export interface PlatformFinanceAuditEntryDBItem extends PlatformFinanceAuditEntry {
    PK: string; // PLATFORM_FINANCE_AUDIT#<id>
    SK: string; // PLATFORM_FINANCE_AUDIT#<id>
    EntityIndexPK: string; // PLATFORM_FINANCE_AUDIT
    EntityIndexSK: string; // DATE#<created_at>#<id>
}
export enum PlatformFinanceReconciliationStatus {
    OK = 'OK',
    GAP = 'GAP',
    /** First transaction or missing balance: nothing to compare with. */
    REVIEW = 'REVIEW'
}
export interface PlatformFinanceSuggestion {
    category?: PlatformFinanceCategory;
    merchant_id?: string;
    store_id?: string;
    employee_id?: string;
    reason?: string;
}
/** A ledger row enriched with its classification (read model). */
export interface PlatformFinanceTransaction {
    transaction_id: string;
    receiver_number: string;
    direction: WalletTransferDirection.IN | WalletTransferDirection.OUT;
    operator?: MessageOperator;
    amount: number;
    fee: number;
    balance_after?: number;
    /** Inferred by reconciliation. */
    balance_before?: number;
    counterparty_number?: string;
    counterparty_name?: string;
    content?: string;
    message_content: string;
    occurred_at: string;
    subtype?: TxSubtype;
    reversed_by?: string;
    claim_status?: ClaimStatus;
    claimed_merchant_id?: string;
    claimed_store_id?: string;
    claimed_at?: string;
    assignment_status: PlatformFinanceAssignmentStatus;
    category?: PlatformFinanceCategory;
    /** Display label of who the money is from/for (store, merchant or recipient). */
    assigned_to?: string;
    allocation?: PlatformFinanceAllocation;
    suggestion?: PlatformFinanceSuggestion;
    reconciliation_status?: PlatformFinanceReconciliationStatus;
}
/** One Top-up Number (mobile-money account) with its SIM balance. */
export interface PlatformFinanceAccount {
    phone_number: string;
    label: string;
    operator?: MessageOperator;
    device_label?: string;
    status: TopupNumberStatus;
    platform_payment_type_id: string;
    balance?: number;
    balance_as_of?: string;
}
export interface PlatformFinanceDashboard {
    currency: string;
    /** Latest SIM balance of the selected account. */
    current_balance: number;
    balance_as_of?: string;
    month: string; // yyyy-MM (Africa/Maputo)
    money_in: number;
    subscription_income: number;
    /** Money in that is not subscription (top-ups, materials, other). */
    other_income: number;
    money_out: number;
    expenses: number;
    material_purchases: number;
    net: number;
    subscription_expected: number;
    subscription_received: number;
    subscription_outstanding: number;
    collection_pct: number;
    overdue_count: number;
    due_this_week: number;
    installation_count: number;
    non_active_count: number;
    unassigned_count: number;
    unassigned_amount: number;
    attention_count: number;
    /** Platform wallet this month: money paid to us. */
    platform_credits: number;
    /** Platform wallet this month: money we paid out. */
    platform_debits: number;
    recent: PlatformFinanceTransaction[];
}
export enum PlatformFinanceBillingStatus {
    PAYING = 'PAYING',
    INSTALLATION = 'INSTALLATION',
    NON_ACTIVE = 'NON_ACTIVE'
}
export interface PlatformFinanceClient {
    merchant_id: string;
    merchant_name: string;
    store_id: string;
    store_name: string;
    phone_number?: string;
    billing_status: PlatformFinanceBillingStatus;
    subscription_amount: number;
    /** Day of the month the store is billed on. */
    payment_day?: number;
    current_invoice_id?: string;
    current_invoice_number?: string;
    current_invoice_status?: string;
    current_due_date?: string;
    current_expected: number;
    current_paid: number;
    current_outstanding: number;
    current_waived: number;
    is_paid: boolean;
    is_overdue: boolean;
    is_waived: boolean;
    waiver_reason?: PlatformFinanceWaiverReason;
    waiver_note?: string;
    assigned_agent_name?: string;
}
export interface PlatformFinanceEmployee {
    id: string;
    name: string;
    phone_number?: string;
    cost_this_month: number;
}
export interface PlatformFinanceReportBucket {
    /** yyyy-MM (Africa/Maputo). */
    period: string;
    money_in: number;
    money_out: number;
    expenses: number;
    material_purchases: number;
    net: number;
}
export interface PlatformFinanceSystem {
    last_sms_at?: string;
    reconciliation_gaps: number;
    reconciliation_review: number;
    pending_setup_numbers: number;
    /** Phones whose SMS are held until they are assigned to a number. */
    unassigned_devices?: number;
}
export interface PlatformFinanceBootstrap {
    accounts: PlatformFinanceAccount[];
    /** The account the ledger data below belongs to. */
    receiver_number?: string;
    dashboard: PlatformFinanceDashboard;
    transactions: PlatformFinanceTransaction[];
    clients: PlatformFinanceClient[];
    employees: PlatformFinanceEmployee[];
    reports: PlatformFinanceReportBucket[];
    system: PlatformFinanceSystem;
    generated_at: string;
}
export interface GetPlatformFinanceBootstrap {
    /** Account to load; defaults to the first account. */
    receiver_number?: string;
}
export interface GetPlatformFinanceTransaction {
    receiver_number: string;
    transaction_id: string;
}
export interface PlatformFinanceIncomeSplitInput {
    store_id: string;
    amount: number;
}
export interface AssignPlatformFinanceIncome {
    receiver_number: string;
    transaction_id: string;
    category: PlatformFinanceCategory;
    /** Required for INC_SUBSCRIPTION / INC_TOPUP. */
    merchant_id?: string;
    /** INC_SUBSCRIPTION / INC_TOPUP: stores of `merchant_id`. May sum to less than the amount. */
    splits?: PlatformFinanceIncomeSplitInput[];
    note?: string;
    actor_id?: string;
    actor_name?: string;
}
export interface PlatformFinanceExpenseSplitInput {
    employee_id?: string;
    recipient_name?: string;
    category: PlatformFinanceCategory;
    amount: number;
}
export interface AssignPlatformFinanceExpense {
    receiver_number: string;
    transaction_id: string;
    splits: PlatformFinanceExpenseSplitInput[];
    note?: string;
    actor_id?: string;
    actor_name?: string;
}
export interface GetPlatformFinanceClient {
    merchant_id: string;
    store_id: string;
}
export interface PlatformFinanceClientDetail {
    client: PlatformFinanceClient;
    invoices: Invoice[];
    waivers: PlatformFinanceWaiver[];
    payments: PlatformFinanceTransaction[];
}
export interface WaivePlatformFinanceInvoice {
    invoice_id: string;
    reason: PlatformFinanceWaiverReason;
    note?: string;
    actor_id?: string;
    actor_name?: string;
}
export interface RemovePlatformFinanceWaiver {
    invoice_id: string;
    actor_id?: string;
    actor_name?: string;
}
export interface GetPlatformFinanceEmployee {
    employee_id: string;
    /** yyyy-MM; defaults to the current month. */
    month?: string;
}
export interface PlatformFinanceEmployeeLine {
    transaction_id: string;
    receiver_number: string;
    occurred_at: string;
    category: PlatformFinanceCategory;
    amount: number;
    note?: string;
}
export interface PlatformFinanceEmployeeDetail {
    employee: PlatformFinanceEmployee;
    totals: {
        category: PlatformFinanceCategory;
        amount: number;
    }[];
    lines: PlatformFinanceEmployeeLine[];
}
export interface GetPlatformFinanceReconciliation {
    receiver_number: string;
}
export interface PlatformFinanceReconciliationGap {
    previous_transaction_id: string;
    current_transaction_id: string;
    previous_balance_after: number;
    current_balance_before: number;
    difference: number;
    missing_direction?: WalletTransferDirection.IN | WalletTransferDirection.OUT;
    missing_amount: number;
    explanation: string;
    previous?: PlatformFinanceTransaction;
    current?: PlatformFinanceTransaction;
}
export interface PlatformFinanceReconciliation {
    receiver_number: string;
    checked: number;
    gaps: PlatformFinanceReconciliationGap[];
}
export interface ReplayPlatformFinanceSms {
    start_date: string;
    end_date: string;
    /** Only the SMS of this phone (IFTTT device name). */
    device_name?: string;
    actor_id?: string;
    actor_name?: string;
}
/**
 * Merge a needs-setup (device) account into a Top-up Number: its
 * transactions, SMS and classifications move there. Preview by default.
 */
export interface MergePlatformFinanceAccount {
    /** The PENDING_SETUP `device:...` number. */
    from_phone_number: string;
    /** An existing Top-up Number. */
    to_phone_number: string;
    /** Preview only (the default); false applies it. */
    dry_run?: boolean;
    /** Also give the number the merged account's payment type. */
    use_from_payment_type?: boolean;
    actor_id?: string;
    actor_name?: string;
}
export interface PlatformFinanceAccountMergeResult {
    dry_run: boolean;
    topups: TopupNumberMergeResult;
    /** Classifications moved (or to move). */
    classifications: number;
    /**
     * Transactions the number already classifies differently: both
     * classifications are kept as they are, for review.
     */
    classification_conflicts: number;
    /** SMS the phone holds until it is assigned (processed by the merge). */
    held_sms: number;
    /** Held SMS of the phone re-published after the merge (0 in a preview). */
    replayed: number;
}
/** Assign a phone to a Top-up Number and process its held SMS. */
export interface AssignPlatformFinanceDevice {
    device_label: string;
    phone_number: string;
    actor_id?: string;
    actor_name?: string;
}
export interface PlatformFinanceDeviceAssignResult {
    device: TopupDevice;
    /** Held SMS re-published to be stored on the number. */
    replayed: number;
}
/** Stored IFTTT SMS re-published as IFTTT_SMS_RECEIVED (consumers are idempotent). */
export interface ReplayPlatformFinanceSmsResult {
    scanned: number;
    published: number;
}
export interface GetPlatformFinanceAuditLog {
    cursor?: string;
    limit?: number;
}
export interface PlatformFinanceAuditLogPage {
    items: PlatformFinanceAuditEntry[];
    cursor?: string;
    count: number;
}
// ---------------------------------------------------------------------------
// Business finances: founders, general expenses and manual income. These are
// paid or received outside the platform payment methods (e.g. a founder's
// personal card), so they never touch the platform wallet.
// ---------------------------------------------------------------------------
/** A founder who may pay business costs from a personal account. */
export interface PlatformFounder extends Versioned, Timestamps {
    id: string;
    name: string;
    /** Lower-case email addresses the founder's receipts come from. */
    emails: string[];
    created_by_id?: string;
    created_by_name?: string;
}
export interface PlatformFounderDBItem extends PlatformFounder {
    PK: string; // PLATFORM_FOUNDER#<id>
    SK: string; // identical to PK
    EntityIndexPK: string; // PLATFORM_FOUNDER
    EntityIndexSK: string; // DATE#<created_at>#<id>
}
export enum PlatformExpenseStatus {
    PAID = 'PAID',
    /** Billed or still accruing; not paid yet. */
    PENDING = 'PENDING',
    /** Expected later (a forecast or an upcoming renewal). */
    PROJECTED = 'PROJECTED',
    /** Read automatically; a founder has to check it before it counts. */
    NEEDS_REVIEW = 'NEEDS_REVIEW'
}
export enum PlatformExpenseSource {
    MANUAL = 'MANUAL',
    EMAIL = 'EMAIL',
    API = 'API'
}
/** A receipt or invoice file in the private receipts bucket. */
export interface PlatformFinanceReceipt {
    /** S3 object key. */
    key: string;
    file_name: string;
    content_type: string;
    /** Bytes. */
    size?: number;
}
/** A business cost paid outside the platform payment methods. */
export interface PlatformExpense extends Versioned, Timestamps {
    id: string;
    /** Who billed us, e.g. "AWS", "Anthropic", "GitHub". */
    provider: string;
    /** Which account or plan, e.g. "prod", "shopnsmile org", "Claude Max". */
    account?: string;
    description?: string;
    category: PlatformFinanceCategory;
    amount: number;
    /** ISO 4217 code of `amount`, e.g. USD. */
    currency: string;
    status: PlatformExpenseStatus;
    /** ISO UTC: when it was paid (PAID), billed (PENDING) or expected (PROJECTED). */
    occurred_at: string;
    /** ISO UTC: when a PENDING bill is due. */
    due_date?: string;
    source: PlatformExpenseSource;
    /** The founder who paid it personally; empty when the business paid. */
    paid_by_founder_id?: string;
    /** The founder's name when it was saved. */
    paid_by_name?: string;
    invoice_number?: string;
    receipt?: PlatformFinanceReceipt;
    /** ISO UTC: when the business paid the founder back. */
    reimbursed_at?: string;
    reimbursed_by_name?: string;
    note?: string;
    created_by_id?: string;
    created_by_name?: string;
}
export interface PlatformExpenseDBItem extends PlatformExpense {
    PK: string; // PLATFORM_EXPENSE#<id>
    SK: string; // identical to PK
    EntityIndexPK: string; // PLATFORM_EXPENSE
    EntityIndexSK: string; // DATE#<occurred_at>#<id>
}
/** Money the business received outside the mobile-money accounts. */
export interface PlatformIncome extends Versioned, Timestamps {
    id: string;
    /** Who paid us, e.g. a client, an investor or a founder. */
    source_name: string;
    description?: string;
    /** A money-in category other than INC_TOPUP. */
    category: PlatformFinanceCategory;
    amount: number;
    /** ISO 4217 code of `amount`. */
    currency: string;
    /** ISO UTC. */
    received_at: string;
    receipt?: PlatformFinanceReceipt;
    note?: string;
    created_by_id?: string;
    created_by_name?: string;
}
export interface PlatformIncomeDBItem extends PlatformIncome {
    PK: string; // PLATFORM_INCOME#<id>
    SK: string; // identical to PK
    EntityIndexPK: string; // PLATFORM_INCOME
    EntityIndexSK: string; // DATE#<received_at>#<id>
}
/** One category total. No category: not classified yet. */
export interface PlatformFinanceCategoryAmount {
    category?: PlatformFinanceCategory;
    amount: number;
}
/** Mobile-money totals of one month, across every Top-up Number. */
export interface PlatformMobileMoneyMonth {
    /** yyyy-MM (Africa/Maputo). */
    period: string;
    money_in: PlatformFinanceCategoryAmount[];
    /** Amount plus fee. */
    money_out: PlatformFinanceCategoryAmount[];
}
/** Everything the Business tab needs for one year, in one call. */
export interface PlatformBusinessFinance {
    year: number;
    /** Currency of the mobile-money amounts. */
    mobile_money_currency: string;
    mobile_money: PlatformMobileMoneyMonth[];
    /** True when a ledger read hit its row limit: totals may be too low. */
    mobile_money_capped: boolean;
    /** Top-up Numbers whose ledger could not be read (missing from totals). */
    mobile_money_errors: string[];
    founders: PlatformFounder[];
    /** General expenses of the year (any status). */
    expenses: PlatformExpense[];
    /** Founder-paid expenses of any year not paid back yet. */
    owed_expenses: PlatformExpense[];
    incomes: PlatformIncome[];
    generated_at: string;
}
export interface GetPlatformBusinessFinance {
    /** Calendar year; defaults to the current year. */
    year?: number;
}
export interface CreatePlatformFounder {
    name: string;
    emails?: string[];
    actor_id?: string;
    actor_name?: string;
}
/** Replaces the founder's editable fields. */
export interface UpdatePlatformFounder {
    id: string;
    /**
     * The version the form was opened at: a newer stored version is a 409.
     * Optional for backwards compatibility; missing = not checked.
     */
    version?: number;
    name: string;
    emails?: string[];
    actor_id?: string;
    actor_name?: string;
}
export interface DeletePlatformFounder {
    id: string;
    actor_id?: string;
    actor_name?: string;
}
export interface CreatePlatformExpense {
    provider: string;
    account?: string;
    description?: string;
    category: PlatformFinanceCategory;
    amount: number;
    currency: string;
    /** Defaults to PAID. */
    status?: PlatformExpenseStatus;
    occurred_at: string;
    due_date?: string;
    paid_by_founder_id?: string;
    invoice_number?: string;
    receipt?: PlatformFinanceReceipt;
    note?: string;
    actor_id?: string;
    actor_name?: string;
}
/** Replaces the expense's editable fields (a missing optional one is cleared). */
export interface UpdatePlatformExpense {
    id: string;
    /**
     * The version the form was opened at: a newer stored version is a 409.
     * Optional for backwards compatibility; missing = not checked.
     */
    version?: number;
    provider: string;
    account?: string;
    description?: string;
    category: PlatformFinanceCategory;
    amount: number;
    currency: string;
    status: PlatformExpenseStatus;
    occurred_at: string;
    due_date?: string;
    paid_by_founder_id?: string;
    invoice_number?: string;
    receipt?: PlatformFinanceReceipt;
    note?: string;
    actor_id?: string;
    actor_name?: string;
}
export interface DeletePlatformExpense {
    id: string;
    actor_id?: string;
    actor_name?: string;
}
/** Marks founder-paid expenses as paid back (or undoes it). */
export interface ReimbursePlatformExpenses {
    expense_ids: string[];
    /** False undoes the reimbursement. */
    reimbursed: boolean;
    actor_id?: string;
    actor_name?: string;
}
export interface ReimbursePlatformExpensesResult {
    expenses: PlatformExpense[];
}
export interface CreatePlatformIncome {
    source_name: string;
    description?: string;
    category: PlatformFinanceCategory;
    amount: number;
    currency: string;
    received_at: string;
    receipt?: PlatformFinanceReceipt;
    note?: string;
    actor_id?: string;
    actor_name?: string;
}
/** Replaces the income's editable fields (a missing optional one is cleared). */
export interface UpdatePlatformIncome {
    id: string;
    /**
     * The version the form was opened at: a newer stored version is a 409.
     * Optional for backwards compatibility; missing = not checked.
     */
    version?: number;
    source_name: string;
    description?: string;
    category: PlatformFinanceCategory;
    amount: number;
    currency: string;
    received_at: string;
    receipt?: PlatformFinanceReceipt;
    note?: string;
    actor_id?: string;
    actor_name?: string;
}
export interface DeletePlatformIncome {
    id: string;
    actor_id?: string;
    actor_name?: string;
}
/** Asks for a short-lived URL to upload one receipt (PDF or image). */
export interface CreatePlatformFinanceReceiptUpload {
    file_name: string;
    content_type: string;
    /** Bytes; at most 10 MB. */
    size: number;
}
export interface PlatformFinanceReceiptUpload {
    /** PUT the file here with the same Content-Type. */
    upload_url: string;
    /** Save this on the expense or income once the upload succeeded. */
    receipt: PlatformFinanceReceipt;
    expires_at: string;
}
export interface GetPlatformFinanceReceiptUrl {
    key: string;
}
export interface PlatformFinanceReceiptUrl {
    url: string;
    expires_at: string;
}

/**
 * A system-wide (platform) payment type owned by Shop & Smile.
 *
 * Unlike merchant-scoped `PaymentType`, these are global and available
 * to all merchants for wallets, billing, and topup operations.
 *
 * Individual phone numbers are managed via the linked `TopupNumber` entity
 * which references back via `platform_payment_type_id`.
 */
export interface PlatformPaymentType extends Timestamps, Versioned {
    /** Unique identifier (ULID). */
    id: string;
    /** Display name (1-40 characters). */
    name: string;
    /** The payment method category. */
    payment_type: PaymentMethodType;
    /** Optional description of the payment type. */
    description?: string;
}
/**
 * Payload for creating a platform payment type.
 */
export interface CreatePlatformPaymentType {
    name: string;
    payment_type: PaymentMethodType;
    description?: string | null | undefined;
}
/**
 * Payload for updating a platform payment type.
 */
export interface UpdatePlatformPaymentType {
    id: string;
    name?: string;
    payment_type?: PaymentMethodType;
    description?: string;
}
/**
 * Paginated list of platform payment types.
 */
export interface PlatformPaymentTypePage {
    payment_types: PlatformPaymentType[];
    count: number;
    cursor: string;
}
/**
 * Query parameters for listing platform payment types.
 */
export interface GetPlatformPaymentTypes {
    cursor?: string;
    limit?: number;
    include_deleted?: SoftDeleteFlag;
}
/**
 * DynamoDB item representation of a platform payment type.
 */
export interface PlatformPaymentTypeDBItem extends Timestamps, PlatformPaymentType {
    PK: string;
    SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}

/**
 * Per-POS-device feature toggles. Persisted server-side so the same
 * device gets the same UX after a reinstall and so admins can enable
 * features for specific devices/stores without an app release.
 *
 * Add new flags here as they're introduced. All flags should default
 * to `false`/disabled when the field is missing or `undefined`.
 */
export interface PosDeviceFeatureFlags {
    /**
     * Show the "Weighted Sales" tab on the POS home page and enable the
     * weighted-sales acquisition pipeline (manual/automatic/scanning) on
     * this device.
     */
    weighted_sales_enabled?: boolean;
    /**
     * Show the "Favourites" tab on the POS home page. Cells bind to
     * individual products and add them to the cart on tap. Defaults to
     * enabled when the field is `undefined` — both for newly registered
     * devices and for legacy devices that don't yet have the flag set.
     */
    favourites_tab_enabled?: boolean;
}
/**
 * Optional sales location limit for a POS device. When set, the POS only
 * allows a session to be claimed and sales to be made while the device
 * is within `radius_meters` of the centre. Enforced on the POS; the
 * server only stores it. Missing or `null` = no restriction.
 */
export interface PosDeviceGeofence {
    latitude: number;
    longitude: number;
    /** Whole metres. */
    radius_meters: number;
}
export interface PosDevice extends Timestamps, Versioned {
    id: string;
    name: string;
    store_id: string;
    activated: boolean;
    merchant_id: string;
    prefix: string;
    mac_address?: string;
    current_user_id?: string;
    current_user_claimed_at?: string;
    current_user_fingerprint?: string;
    current_user_device_label?: string;
    current_user_last_seen_at?: string;
    current_user_latitude?: number | null | undefined;
    current_user_longitude?: number | null | undefined;
    current_user_accuracy_meters?: number | null | undefined;
    current_user_location_source?: LocationSource;
    feature_flags?: PosDeviceFeatureFlags;
    /** Optional for backwards compatibility; missing or null = no limit. */
    geofence?: PosDeviceGeofence | null;
    /**
     * POS app version last reported by the heartbeat, e.g. `1.0.0+49`.
     * Optional for backwards compatibility; missing = unknown (a build that
     * predates version reporting, or one that has not sent a heartbeat yet).
     */
    app_version?: string;
    /**
     * Release channel of `app_version`. Optional for backwards compatibility;
     * missing = unknown.
     */
    app_platform?: PosAppPlatform;
    /**
     * Last heartbeat from any POS build. Unlike `current_user_last_seen_at` it
     * is kept when the session ends, so it tells whether the device is still
     * in use. Optional for backwards compatibility; missing = no heartbeat
     * since this field was introduced.
     */
    last_heartbeat_at?: string;
    /**
     * When the last claim (online, or an offline sign-in replayed later) took
     * effect: an older replayed sign-in never overwrites a newer holder.
     * Optional for backwards compatibility; missing = no claim recorded yet.
     */
    last_session_event_at?: string;
}
/**
 * `POST sessions/claim` response: the device plus a secret issued to the
 * install that now holds it. The install proves possession with it on the
 * offline routes (`x-pos-device-secret`); the server keeps only its hash.
 * Old builds ignore it.
 */
export interface ClaimPosDeviceResponse extends PosDevice {
    session_secret?: string;
}
/** POS release channel: desktop builds (Windows, Linux, macOS) use `windows`. */
export type PosAppPlatform = 'android' | 'windows';
/**
 * Request body for `PATCH /{merchant_id}/{id}/geofence`. `null` clears
 * the limit.
 */
export interface UpdatePosDeviceGeofenceRequest {
    id: string;
    merchant_id: string;
    geofence: PosDeviceGeofence | null;
}
/**
 * Request body for `PATCH /{merchant_id}/{id}/feature-flags`. Each
 * supplied field is merged onto the existing `feature_flags` object;
 * fields that are not present are left unchanged.
 */
export interface UpdatePosDeviceFeatureFlagsRequest {
    id: string;
    merchant_id: string;
    feature_flags: PosDeviceFeatureFlags;
}
export interface CreatePosDevice {
    name: string;
    store_id: string;
    activated: boolean;
    merchant_id: string;
    prefix: string;
    mac_address?: string;
}
export interface UpdatePosDevice {
    name?: string;
    activated?: boolean;
    prefix?: string;
    mac_address?: string;
    merchant_id: string;
    current_user_id?: string;
    id: string;
    fingerprint?: string;
    device_label?: string;
    force?: boolean;
}
export interface GetPosDevices {
    /** Missing = every device of the merchant (`GetPosDevicesByMerchant`). */
    store_id?: string;
    limit?: number;
    cursor?: string;
    include_deleted?: SoftDeleteFlag;
}
export interface GetPosDevicesByMerchant extends GetPosDevices {
    merchant_id: string;
}
export interface GetPosDevice {
    id: string;
    merchant_id: string;
    include_deleted?: SoftDeleteFlag;
}
export interface PosDeviceDBItem extends PosDevice {
    PK: string; // MERCHANT#{merchant_id}#ENTITY_TYPE#POS_DEVICE
    SK: string; // POS_DEVICE#<id>
    GSI1PK: string; // STORE#<store_id>
    GSI1SK: string; // POS_DEVICE#<id>
    GSI2PK?: string; // USER#<current_user_id> (sparse - only when claimed)
    GSI2SK?: string; // POS_DEVICE#<id> (sparse - only when claimed)
    EntityIndexPK: string; // POS_DEVICE
    EntityIndexSK: string; // MERCHANT#{merchant_id}#STORE#DATE#{created_at}
}
export interface PosDevicePage {
    pos_devices: PosDevice[];
    count: number;
    cursor?: string;
}
/**
 * Request body for atomically claiming a POS device for a user.
 * Enforces single-active-device-per-user-per-store. If the user already
 * holds another device in the same store and `force` is false, the
 * endpoint responds 409 with the conflicting devices.
 */
export interface ClaimPosDeviceRequest {
    id: string;
    merchant_id: string;
    current_user_id: string;
    fingerprint: string;
    device_label: string;
    force?: boolean;
    latitude?: number | null | undefined;
    longitude?: number | null | undefined;
    accuracy_meters?: number | null | undefined;
}
export interface PosDeviceConflict {
    id: string;
    name: string;
    store_id: string;
    merchant_id: string;
    current_user_claimed_at?: string;
    current_user_device_label?: string;
    current_user_last_seen_at?: string;
    current_user_latitude?: number | null | undefined;
    current_user_longitude?: number | null | undefined;
    current_user_accuracy_meters?: number | null | undefined;
    current_user_location_source?: LocationSource;
}
/**
 * 409 response payload returned by the claim endpoint when there are
 * other devices currently held by the same user in the same store.
 */
export interface ClaimPosDeviceConflictResponse {
    message: string;
    conflicting_devices: PosDeviceConflict[];
}
export interface PosDeviceSession {
    device_id: string;
    name: string;
    store_id: string;
    merchant_id: string;
    current_user_id: string;
    current_user_fingerprint?: string;
    current_user_device_label?: string;
    current_user_claimed_at?: string;
    current_user_last_seen_at?: string;
    current_user_latitude?: number | null | undefined;
    current_user_longitude?: number | null | undefined;
    current_user_accuracy_meters?: number | null | undefined;
    current_user_location_source?: LocationSource;
}
export interface GetPosDeviceSessionsByUser {
    user_id: string;
}
export interface PosDeviceSessionsPage {
    sessions: PosDeviceSession[];
    count: number;
}
export interface PosDeviceHeartbeatRequest {
    device_id: string;
    merchant_id: string;
    user_id: string;
    fingerprint: string;
    latitude?: number | null | undefined;
    longitude?: number | null | undefined;
    accuracy_meters?: number | null | undefined;
    /** Optional for backwards compatibility; missing = keep the stored value. */
    app_version?: string | null | undefined;
    /**
     * `android` or `windows`; anything else is ignored (never a 400, so a
     * heartbeat cannot fail on it). Optional for backwards compatibility;
     * missing = keep the stored value.
     */
    app_platform?: string | null | undefined;
}
export type PosDeviceHeartbeatReason = 'OK' | 'NOT_FOUND' | 'NOT_HOLDER' | 'FINGERPRINT_MISMATCH' | 'EVICTED';
export interface PosDeviceHeartbeatResponse {
    still_valid: boolean;
    reason?: PosDeviceHeartbeatReason;
}
export interface EvictPosDeviceRequest {
    device_id: string;
    merchant_id: string;
    latitude?: number | null | undefined;
    longitude?: number | null | undefined;
    accuracy_meters?: number | null | undefined;
}
export interface EvictUserFromAllDevicesRequest {
    user_id: string;
}
export interface EvictUserFromAllDevicesResponse {
    evicted_count: number;
    evicted: PosDevice[];
}
/**
 * Permanent journal of every claim/evict/heartbeat-fail event for a POS
 * device. Stored in the same POSTable as a separate entity, indexed on
 * GSI1 (by user), GSI2 (by store) and GSI3 (by pos device).
 */
export type PosSessionEventType = 'CLAIM' | 'EVICT' | 'HEARTBEAT_FAIL'
/** Signed in on the till while the backend was unreachable (replayed). */
 | 'OFFLINE_SIGN_IN' | 'OFFLINE_SIGN_OUT';
export interface PosSessionEvent {
    id: string; // ULID, monotonic by time
    event_type: PosSessionEventType;
    occurred_at: string;
    /** The POS op that produced a replayed event; its idempotency key. */
    op_id?: string;
    merchant_id: string;
    store_id: string;
    pos_device_id: string;
    pos_device_name: string;
    user_id: string;
    fingerprint: string;
    device_label: string;
    /**
     * For EVICT events: identifies the device/fingerprint that took over and
     * caused this device to be cleared. Absent for plain manual sign-outs
     * triggered from "My connected devices".
     */
    evicted_by_fingerprint?: string;
    evicted_by_device_label?: string;
    /**
     * Free-form reason: 'manual', 'force-claim', 'FINGERPRINT_MISMATCH',
     * 'NOT_HOLDER', 'EVICTED', 'NOT_FOUND'.
     */
    reason?: string;
    /**
     * Snapshot of where the originating device was when the event was
     * recorded. Source indicates whether the coordinates came from the
     * device's GPS, an IP-derived approximation, or are unknown.
     */
    latitude?: number | null | undefined;
    longitude?: number | null | undefined;
    accuracy_meters?: number | null | undefined;
    location_source?: LocationSource;
}
export interface PosSessionEventDBItem extends PosSessionEvent {
    PK: string; // MERCHANT#<merchant_id>
    SK: string; // POS_SESSION_EVENT#<id>
    GSI1PK: string; // USER#<user_id>
    GSI1SK: string; // POS_SESSION_EVENT#<id>
    GSI2PK: string; // STORE#<store_id>
    GSI2SK: string; // POS_SESSION_EVENT#<id>
    GSI3PK: string; // POS_DEVICE#<pos_device_id>
    GSI3SK: string; // POS_SESSION_EVENT#<id>
    EntityIndexPK: string; // POS_SESSION_EVENT
    EntityIndexSK: string; // MERCHANT#<merchant_id>#DATE#<occurred_at>
}
export interface PosSessionEventsPage {
    events: PosSessionEvent[];
    count: number;
    cursor?: string;
}
export interface ListPosSessionEventsByUser {
    user_id: string;
    limit?: number;
    cursor?: string;
}
export interface ListPosSessionEventsByStore {
    store_id: string;
    limit?: number;
    cursor?: string;
}
export interface ListPosSessionEventsByDevice {
    merchant_id: string;
    pos_device_id: string;
    limit?: number;
    cursor?: string;
}
/** One offline sign-in or sign-out the POS journaled while unreachable. */
export interface PosSessionReplayEvent {
    op_id: string;
    event_type: 'OFFLINE_SIGN_IN' | 'OFFLINE_SIGN_OUT';
    user_id: string;
    fingerprint: string;
    device_label: string;
    occurred_at: string;
    /** Empty when the user signed in before picking a till. */
    pos_device_id?: string | null;
    store_id?: string | null;
}
/**
 * Body of `POST /pos-devices/sessions/replay` (idempotent by `op_id`). The
 * `x-pos-device-secret` header must hold the secret issued to this install
 * for `device_id`; every event is about that device (or no device).
 */
export interface PosSessionReplayRequest {
    merchant_id: string;
    device_id: string;
    events: PosSessionReplayEvent[];
}
export interface PosSessionReplayRefusal {
    op_id: string;
    /** `user-inactive`, `not-in-store`, `device-not-found`, `stale`. */
    reason: string;
}
export interface PosSessionReplayResponse {
    recorded: number;
    duplicates: number;
    /** Journaled, but the holder was not changed for them. */
    refused?: PosSessionReplayRefusal[];
}
/**
 * Path of `GET /pos-devices/{merchant_id}/{id}/offline-credentials`; the
 * `x-pos-device-secret` header must hold the secret issued at the claim.
 */
export interface GetPosDeviceOfflineCredentials {
    merchant_id: string;
    id: string;
}

/**
 * Pricing types — owned by the Pricing service.
 *
 * Pricing answers ONE question: "how much should this merchant be charged
 * for a given billing window?" It does not touch wallets, ledgers, or
 * invoices. All amounts are in major units of whatever
 * currency the plan/agreement carries — Pricing is currency-agnostic and
 * never hardcodes MZN.
 */
/* ------------------------------------------------------------------ */
/*  Enums                                                              */
/* ------------------------------------------------------------------ */
export enum PricingType {
    /** Flat amount regardless of usage. */
    FIXED_AMOUNT = 'fixed_amount',
    /** `usage.receipts * per_receipt_amount`. */
    PER_RECEIPT = 'per_receipt',
    /** Stepped tiers keyed off `usage.receipts`. */
    RECEIPT_TIER = 'receipt_tier',
    /** `usage.transactions * per_transaction_amount`. */
    PER_TRANSACTION = 'per_transaction',
    /** Stepped tiers keyed off `usage.transactions`. */
    TRANSACTION_TIER = 'transaction_tier',
    /** Always zero. */
    FREE = 'free',
    /** Charged exactly once for the lifetime of the merchant. */
    ONE_TIME_LIFETIME = 'one_time_lifetime'
}
export enum BillingPeriod {
    DAILY = 'daily',
    WEEKLY = 'weekly',
    MONTHLY = 'monthly',
    QUARTERLY = 'quarterly',
    YEARLY = 'yearly',
    ONCE = 'once',
    CUSTOM = 'custom'
}
export enum PricingPlanStatus {
    ACTIVE = 'active',
    ARCHIVED = 'archived'
}
export enum CustomerAgreementStatus {
    ACTIVE = 'active',
    CANCELLED = 'cancelled',
    EXPIRED = 'expired',
    PENDING = 'pending'
}
export enum PricingDiscountType {
    /** `value` interpreted as a percentage in [0, 100]. */
    PERCENT = 'percent',
    /** `value` interpreted as minor units. */
    FIXED_AMOUNT = 'fixed_amount'
}
/* ------------------------------------------------------------------ */
/*  Building blocks                                                    */
/* ------------------------------------------------------------------ */
/**
 * A single tier in a tiered receipt-count pricing plan.
 * If `max_receipts` is null, the tier is the catch-all upper bound.
 */
export interface ReceiptTier {
    max_receipts: number | null;
    amount: number;
}
/**
 * A single tier in a tiered transaction-count pricing plan.
 * If `max_transactions` is null, the tier is the catch-all upper bound.
 */
export interface TransactionTier {
    max_transactions: number | null;
    amount: number;
}
export interface PricingDiscount {
    type: PricingDiscountType;
    value: number;
    description?: string;
}
/* ------------------------------------------------------------------ */
/*  Pricing Plan                                                       */
/* ------------------------------------------------------------------ */
export interface PricingPlan extends Omit<Timestamps, 'deleted_on'>, Omit<Versioned, 'version'> {
    id: string;
    name: string;
    description?: string;
    currency: string;
    pricing_type: PricingType;
    billing_period: BillingPeriod;
    status: PricingPlanStatus;
    version: number;
    /** Required when `pricing_type` is `fixed_amount` or `one_time_lifetime`. */
    fixed_amount?: number;
    /** Required when `pricing_type` is `per_receipt`. */
    per_receipt_amount?: number;
    /** Required when `pricing_type` is `receipt_tier`. Last tier must have `max_receipts: null`. */
    receipt_tiers?: ReceiptTier[];
    /** Required when `pricing_type` is `per_transaction`. */
    per_transaction_amount?: number;
    /** Required when `pricing_type` is `transaction_tier`. Last tier must have `max_transactions: null`. */
    transaction_tiers?: TransactionTier[];
    /**
     * Required when `billing_period` is `custom`.
     * Duration in hours. Minimum 24, maximum 8,760 (1 year).
     * This is the plan-level default; individual agreements may override it.
     */
    custom_billing_period_in_hours?: number;
    /**
     * Suggested anchor date for the first billing cycle.
     * Only a suggestion — the actual next_bill_date lives on the CustomerAgreement.
     */
    default_next_bill_date?: string;
}
export interface PricingPlanDBItem extends PricingPlan {
    PK: string; // PRICING_PLAN
    SK: string; // PLAN#{plan_id}
    EntityIndexPK: string;
    EntityIndexSK: string;
    GSI1PK: string; // PRICING_PLAN_STATUS#{status}
    GSI1SK: string; // PLAN#{plan_id}
}
export interface CreatePricingPlan {
    name: string;
    description?: string;
    currency: string;
    pricing_type: PricingType;
    billing_period: BillingPeriod;
    fixed_amount?: number;
    per_receipt_amount?: number;
    receipt_tiers?: ReceiptTier[];
    per_transaction_amount?: number;
    transaction_tiers?: TransactionTier[];
    /** Required when `billing_period` is `custom`. Duration in hours (min 24, max 8760). */
    custom_billing_period_in_hours?: number;
    /** Optional suggested first billing date to show as a default when creating agreements. */
    default_next_bill_date?: string;
}
export interface UpdatePricingPlan {
    id: string;
    name?: string;
    description?: string;
    billing_period?: BillingPeriod;
    fixed_amount?: number;
    per_receipt_amount?: number;
    receipt_tiers?: ReceiptTier[];
    per_transaction_amount?: number;
    transaction_tiers?: TransactionTier[];
    /** Required when changing `billing_period` to `custom`. Duration in hours (min 24, max 8760). */
    custom_billing_period_in_hours?: number;
    /** Optional suggested first billing date. */
    default_next_bill_date?: string;
}
export interface GetPricingPlan {
    id: string;
}
export interface ArchivePricingPlan {
    id: string;
}
export interface GetPricingPlans {
    status?: PricingPlanStatus;
    cursor?: string;
    limit?: number;
}
export interface PricingPlansPage {
    plans: PricingPlan[];
    count?: number;
    cursor?: string;
}
/* ------------------------------------------------------------------ */
/*  Customer Agreement                                                 */
/* ------------------------------------------------------------------ */
/**
 * Snapshot of the plan fields at the moment an agreement was signed.
 * The Pricing calculator operates on this snapshot, NOT on the live plan,
 * so editing a plan never retroactively changes existing agreements.
 */
export interface PricingPlanSnapshot {
    plan_id: string;
    plan_version: number;
    name: string;
    pricing_type: PricingType;
    billing_period: BillingPeriod;
    currency: string;
    fixed_amount?: number;
    per_receipt_amount?: number;
    receipt_tiers?: ReceiptTier[];
    per_transaction_amount?: number;
    transaction_tiers?: TransactionTier[];
    /**
     * The store this snapshot was created for.
     * Only populated for store-scoped agreements (post-migration).
     * Absent for legacy merchant-level agreements.
     */
    store_id?: string;
    /** Frozen from the plan at agreement creation time. */
    custom_billing_period_in_hours?: number;
    /** Frozen from the agreement at creation time — the billing cycle anchor date. */
    next_bill_date?: string;
}
/**
 * Binds a store (or legacy merchant) to a pricing plan via an
 * immutable `plan_snapshot`. Each (merchant, store) pair may have
 * at most one ACTIVE agreement.
 *
 * `store_id` is required for all agreements created after the
 * store-scoped pricing migration. Legacy merchant-level agreements
 * will have `store_id` absent until manually migrated.
 */
export interface CustomerAgreement extends Omit<Timestamps, 'deleted_on'>, Versioned {
    id: string;
    merchant_id: string;
    /** The store this agreement applies to. Required for post-migration agreements. */
    store_id: string;
    plan_id: string;
    status: CustomerAgreementStatus;
    currency: string;
    plan_snapshot: PricingPlanSnapshot;
    discounts: PricingDiscount[];
    active_from: string;
    active_to?: string;
    /**
     * Billing cycle anchor date. All billing periods are calculated from this date.
     * Must be >= active_from. If not provided, defaults to active_from + 1 billing period.
     */
    next_bill_date?: string;
    /**
     * Overrides the plan-level custom_billing_period_in_hours for this agreement.
     * Only relevant when the plan's billing_period is CUSTOM.
     */
    custom_billing_period_in_hours?: number;
    /**
     * Free months an admin granted on this agreement, oldest first.
     * Optional for backwards compatibility; missing = none.
     */
    free_months?: FreeMonthsGrant[];
}
/**
 * A free period granted by an admin: the invoices due in it are skipped
 * (next_bill_date moves forward) and billing resumes on `next_bill_date`.
 */
export interface FreeMonthsGrant {
    id: string;
    /** Number of free months (1–3). */
    months: number;
    reason?: string;
    /** The agreement's next_bill_date before the grant — the first skipped bill. */
    previous_next_bill_date: string;
    /** The agreement's next_bill_date after the grant — billing resumes here. */
    next_bill_date: string;
    /** Service months (YYYY-MM) whose WhatsApp notification fee is waived. */
    waived_notification_months: string[];
    granted_at: string;
    granted_by_id: string;
    granted_by_name: string;
}
export interface CustomerAgreementDBItem extends CustomerAgreement {
    PK: string;
    SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
    GSI1PK: string;
    GSI1SK: string;
    GSI2PK: string;
    GSI2SK: string;
}
/**
 * Pointer item enforcing the rule "at most one active agreement per store".
 * PK = MERCHANT#{merchant_id}#STORE#{store_id}, SK = ACTIVE_CUSTOMER_AGREEMENT.
 */
export interface ActiveAgreementPointerDBItem {
    PK: string;
    SK: string; // ACTIVE_CUSTOMER_AGREEMENT
    merchant_id: string;
    store_id: string;
    agreement_id: string;
    plan_id: string;
    created_on: string;
}
export interface CreateCustomerAgreement {
    merchant_id: string;
    /** Required for all post-migration agreements. The store being priced. */
    store_id: string;
    plan_id: string;
    discounts?: PricingDiscount[];
    active_from?: string;
    active_to?: string;
    custom_billing_period_in_hours?: number;
    /**
     * Billing cycle anchor date. Must be >= active_from.
     * Defaults to active_from + 1 billing period if not provided.
     */
    next_bill_date?: string;
}
export interface GetCustomerAgreement {
    id: string;
    merchant_id: string;
    store_id: string;
}
export interface GetActiveCustomerAgreement {
    merchant_id: string;
    store_id: string;
}
export interface GetCustomerAgreements {
    merchant_id: string;
    store_id?: string;
    status?: CustomerAgreementStatus;
    cursor?: string;
    limit?: number;
}
export interface CustomerAgreementsPage {
    agreements: CustomerAgreement[];
    count?: number;
    cursor?: string;
}
/** One month of logo churn derived from agreement history. */
export interface AgreementChurnMonth {
    /** Month label, e.g. "Jan 2026". */
    month: string;
    /** Agreements that ended (cancelled/expired) during the month. */
    churned: number;
    /** Agreements active at the start of the month. */
    active_at_start: number;
    /** churned / active_at_start (%), null when nothing was active. */
    churn_rate_pct: number | null;
    /** Stores whose first agreement started in the month. Optional for backwards compatibility; missing = 0. */
    new_stores?: number;
    /** new_stores − churned. Optional for backwards compatibility; missing = 0. */
    net_new_stores?: number;
}
/** Platform-level customer-agreement rollup for dashboards. */
export interface AgreementsSummary {
    /** Agreements currently ACTIVE (one per store, max). */
    active_agreements: number;
    /** Active agreements on a paid pricing type. */
    paying_stores: number;
    /** Active agreements on the free pricing type. */
    free_stores: number;
    /** paying_stores / active_agreements (%). */
    paying_share_pct: number | null;
    /** Last 12 months of logo churn, oldest first. */
    monthly_churn: AgreementChurnMonth[];
    /** Churn rate of the last complete month (%). */
    churn_rate_last_month_pct: number | null;
    /** Total agreements considered (all statuses). */
    agreement_count: number;
    generated_at: string;
    /**
     * Contracted Monthly Recurring Revenue: the monthly-normalised fixed
     * amount (after agreement discounts) of every ACTIVE fixed-amount
     * agreement in `mrr_currency`. Optional for backwards compatibility.
     */
    mrr?: number;
    mrr_currency?: string;
    /** Active fixed-amount agreements counted in `mrr`. */
    mrr_agreements?: number;
    /** Active agreements priced by usage (per receipt/transaction); not in MRR. */
    usage_based_agreements?: number;
    /** MRR of active agreements in other currencies, excluded from `mrr`. */
    excluded_mrr_by_currency?: Record<string, number>;
    /** Range the `monthly_churn` series covers (ISO). */
    from?: string;
    to?: string;
}
export interface GetAgreementsSummary {
    /** Start of the monthly series (ISO); defaults to 11 months before `to`. */
    from?: string;
    /** End of the monthly series (ISO); defaults to now. */
    to?: string;
}
export interface CancelCustomerAgreement {
    id: string;
    merchant_id: string;
    store_id: string;
}
export interface SwitchCustomerAgreement {
    merchant_id: string;
    store_id: string;
    /** The plan to switch to. */
    plan_id: string;
    discounts?: PricingDiscount[];
    /** Required. When the new plan takes effect. If future, the switch is scheduled. */
    active_from: string;
    active_to?: string;
    /**
     * Billing cycle anchor date for the new agreement.
     * Must be >= active_from. Defaults to active_from + 1 billing period.
     */
    next_bill_date?: string;
}
/**
 * POST /agreements/free-months — make the store's next 1–3 months free.
 * Applies to the active agreement, or to the pending one while the store
 * is still in its grace period (extending it).
 */
export interface GrantFreeMonths {
    merchant_id: string;
    store_id: string;
    /** Number of free months (1–3). */
    months: number;
    reason?: string;
    /**
     * Client-generated id of this confirmation: a retry with the same id
     * returns the agreement instead of granting again. Optional for backwards
     * compatibility; missing = a new grant on every call.
     */
    grant_id?: string;
}
/** Returned by POST /agreements/switch — old is null when switching from FREE. */
export interface SwitchCustomerAgreementResponse {
    old: CustomerAgreement | null;
    new: CustomerAgreement;
}
/**
 * Fields of a PricingPlanSnapshot that an admin may edit on a store-scoped
 * agreement without switching to a different plan.  Identity fields
 * (pricing_type, plan_id, plan_version, name, store_id) are excluded —
 * changing those requires a Switch.
 */
export interface EditablePlanSnapshotFields {
    currency?: string;
    billing_period?: BillingPeriod;
    fixed_amount?: number | null;
    per_receipt_amount?: number | null;
    receipt_tiers?: ReceiptTier[] | null;
    per_transaction_amount?: number | null;
    transaction_tiers?: TransactionTier[] | null;
    custom_billing_period_in_hours?: number | null;
}
export interface UpdateCustomerAgreement {
    id: string;
    merchant_id: string;
    store_id: string;
    /**
     * Compare-and-set: the next_bill_date the caller read (null = none). The
     * update is refused (409) when the stored date is different, e.g. a free
     * month moved it meanwhile. Optional for backwards compatibility;
     * missing = no check.
     */
    expected_next_bill_date?: string | null;
    /**
     * Corrected agreement start date. Active agreements cannot be moved into
     * the future, and this must remain on or before the agreement's end and
     * next billing dates.
     */
    active_from?: string;
    active_to?: string | null;
    next_bill_date?: string | null;
    custom_billing_period_in_hours?: number | null;
    /**
     * Optional partial snapshot fields to update on this agreement only.
     * The catalog plan and other stores are unaffected.
     */
    plan_snapshot?: EditablePlanSnapshotFields;
}
/**
 * Immutable audit record written every time a CustomerAgreement's
 * plan_snapshot is edited.  Stored as a separate DynamoDB item so the
 * full history of changes is queryable.
 */
export interface CustomerAgreementAudit {
    agreement_id: string;
    merchant_id: string;
    store_id: string;
    changed_at: string;
    changed_by?: string;
    previous_snapshot: PricingPlanSnapshot;
    changed_fields: string[];
}
/** Paginated result of listAgreementAuditLog queries. */
export interface CustomerAgreementAuditPage {
    items: CustomerAgreementAudit[];
    cursor?: string;
}
/* ------------------------------------------------------------------ */
/*  Calculation                                                        */
/* ------------------------------------------------------------------ */
export interface PricingUsage {
    receipts: number;
    /** Forward-compat: ignored by the calculator today. */
    users?: number;
    /** Forward-compat: ignored by the calculator today. */
    locations?: number;
    /** Forward-compat: ignored by the calculator today. */
    transactions?: number;
}
export interface PricingCalculationRequest {
    merchant_id: string;
    /** Required for store-scoped pricing. The store whose agreement should be used. */
    store_id: string;
    period_start: string;
    period_end: string;
    usage: PricingUsage;
}
export interface PreviewPricingRequest {
    plan_id: string;
    /** The store for which the preview is being calculated (for context/metadata). */
    store_id?: string;
    period_start: string;
    period_end: string;
    usage: PricingUsage;
    discounts?: PricingDiscount[];
}
export interface PricingBreakdownLine {
    label: string;
    amount: number;
    /** Signed: positive for charges, negative for discounts. */
    kind: 'base' | 'discount';
}
export interface PricingCalculationResult {
    base_amount: number;
    discount_amount: number;
    final_amount: number;
    currency: string;
    billing_period: BillingPeriod;
    is_billable: boolean;
    plan_id: string;
    agreement_id?: string;
    period_start: string;
    period_end: string;
    breakdown: PricingBreakdownLine[];
    reason?: string;
}

export enum ProductExpiryDismissReason {
    /** Dismissed from the notification bell. */
    USER = 'USER',
    /** The expiry date passed without anyone acknowledging it. */
    EXPIRED = 'EXPIRED',
    /** The product ran out of stock. */
    OUT_OF_STOCK = 'OUT_OF_STOCK'
}
/**
 * One purchase-order line with an expiry date. The notification bell shows
 * the earliest undismissed date per product while the product has stock;
 * the daily job dismisses expired or sold-out ones.
 */
export interface ProductExpiry extends Timestamps, Versioned {
    /** `${po_id}#${item_id}` */
    id: string;
    merchant_id: string;
    store_id: string;
    product_id: string;
    product_name: string;
    po_id: string;
    item_id: string;
    /** YYYY-MM-DD */
    expiry_date: string;
    /** Quantity received on the line, in line units. */
    quantity: number;
    /** Days before `expiry_date` the warning starts (copied from the product). */
    warning_days: number;
    dismissed_at?: string | null;
    dismissed_by_id?: string | null;
    dismissed_by_name?: string | null;
    dismiss_reason?: ProductExpiryDismissReason | null;
    /** When the daily WhatsApp summary last included this line. */
    notified_at?: string | null;
}
export interface ProductExpiryDBItem extends ProductExpiry, DynamoDBItem {
}
/** An undismissed expiry joined with the product's current stock. */
export interface ActiveProductExpiry extends ProductExpiry {
    in_stock: number;
    /** Whole days from today (store time) to `expiry_date`; negative = past. */
    days_left: number;
}
export interface GetProductExpiries {
    merchant_id: string;
    store_id: string;
    /** Only lines whose warning window has started by this date (YYYY-MM-DD). */
    due_by?: string;
    /** IANA time zone used for "today" and `days_left` (UTC when missing). */
    timezone?: string;
}
export interface ActiveProductExpiryPage {
    expiries: ActiveProductExpiry[];
    count: number;
}
export interface DismissProductExpiry {
    merchant_id: string;
    store_id: string;
    po_id: string;
    item_id: string;
    updator_id: string;
}

export interface ProductNameOrUnitUpdatedEvent {
    bus_name: string;
    source: ShopAndSmileEventSource;
    detail_type: ProductChangeEvents.PRODUCT_NAME_UPDATED | ProductChangeEvents.PRODUCT_UNIT_UPDATED;
    detail: ProductNameOrUnitUpdatedEventDetail;
}
interface ProductNameOrUnitUpdatedEventDetail {
    filter?: Record<string, any>;
    data: ProductNameOrUnitUpdatedEventDetailData;
    metadata: ProductNameOrUnitUpdatedEventDetailMetadata;
}
export interface ProductNameOrUnitUpdatedEventDetailData {
    product: Product;
}
export interface ProductNameOrUnitUpdatedEventDetailMetadata extends ShopAndSmileEventMetadata {
}
export interface QuantityInUnitPackageUpdatedEvent {
    bus_name: string;
    source: ShopAndSmileEventSource;
    detail_type: ProductChangeEvents.PRODUCT_QUANTITY_IN_UNIT_PACKAGE_UPDATED;
    detail: QuantityInUnitPackageUpdatedEventDetail;
}
export interface QuantityInUnitPackageUpdatedEventDetail {
    filter?: Record<string, any>;
    data: QuantityInUnitPackageUpdatedEventDetailData;
    metadata: QuantityInUnitPackageUpdatedEventDetailMetadata;
}
export interface QuantityInUnitPackageUpdatedEventDetailData {
    parentProduct: Product;
    childProducts: Product[];
    store: Store;
}
export interface QuantityInUnitPackageUpdatedEventDetailMetadata extends ShopAndSmileEventMetadata {
}
export interface StoreProductCostUpdatedEvent {
    bus_name: string;
    source: ShopAndSmileEventSource;
    detail_type: StoreProductChangeEvents.STORE_PRODUCT_COST_UPDATED;
    detail: StoreProductCostUpdatedEventDetail;
}
interface StoreProductCostUpdatedEventDetail {
    filter?: Record<string, any>;
    data: StoreProductCostUpdatedEventDetailData;
    metadata: StoreProductCostUpdatedEventDetailMetadata;
}
// ts-to-zod fails to generate the correct schema for the StoreProduct. Thus it will be done independently.
export interface StoreProductCostUpdatedEventDetailData {
    parentStoreProduct: any;
}
export interface StoreProductCostUpdatedEventDetailMetadata extends ShopAndSmileEventMetadata {
}

export interface Barcode {
    value: string | number;
    type: string | number;
    description?: string | null | undefined;
}
export interface ProductFraction extends Timestamps, Versioned {
    parent_id: string;
    fraction_id: string;
    fraction: number;
    fraction_name: string;
    parent_name: string;
    merchant_id: string;
    /**
     * Cognito sub / employee id of the user who soft-deleted this fraction.
     * Optional for backwards compatibility with legacy rows that only have `deleted_at`.
     */
    deleted_by_id?: string | null;
    /**
     * Human-readable name of the user who soft-deleted this fraction.
     */
    deleted_by_name?: string | null;
}
export type StoreProductFraction = Product & StoreProductAttributes & ProductFraction;
export interface Product extends Timestamps {
    id: string;
    name: string;
    description: string;
    image: string;
    barcode: string | number;
    quantity_in_unit_package: number;
    global_sku: number;
    weight_kg: number;
    unit: string | number;
    unit_of_measurement: string;
    category_id?: string | null;
    merchant_id: string;
    fraction: number;
    parent_id: string;
    is_parent: boolean;
    product_fractions: ProductFraction[];
    taxes: string[] | Tax[];
    barcodes?: Barcode[] | null;
    /** ISO 3166-1 alpha-2 codes of the countries the product is sold in.
     * Optional for backwards compatibility; missing = []. */
    countries?: string[] | null;
    version: number;
    /** Id of the user who made the latest change (AGENTS.md §4.4.1). Optional for backwards compatibility. */
    updated_by_id?: string | null;
    /** Name of the user who made the latest change. Optional for backwards compatibility. */
    updated_by_name?: string | null;
    /**
     * Cognito sub / employee id of the user who soft-deleted this product.
     * Optional for backwards compatibility with legacy rows that only have `deleted_at`.
     */
    deleted_by_id?: string | null;
    /**
     * Human-readable name of the user who soft-deleted this product.
     */
    deleted_by_name?: string | null;
}
export interface StoreProductAttributes extends Timestamps {
    id: string;
    store_sku: string;
    store_id: string;
    unit_of_measurement: string;
    /** Sellable stock in parent units: on hand minus reserved, pending and blocked. */
    inventory: number;
    /**
     * The stock buckets behind `inventory`, set once the stock row has
     * buckets. Optional for backwards compatibility; missing = all of the
     * stock is sellable (on hand = inventory).
     */
    stock_breakdown?: StockBreakdown | null;
    /**
     * Version of the stock row (CURRENT_INVENTORY) that `inventory` and
     * `stock_breakdown` were mirrored from. Optional for backwards
     * compatibility; missing = 0 (any versioned snapshot replaces it).
     */
    stock_version?: number | null;
    /**
     * When the cost last changed other than by service-inventory's receipt
     * valuation (a hand edit, a purchase-order receive): a valuation computed
     * before it never overwrites it. Optional for backwards compatibility;
     * missing = never.
     */
    cost_changed_at?: string | null;
    /**
     * The stock row version of the last cost service-inventory set
     * (`inventory_valuation`). Optional for backwards compatibility;
     * missing = 0.
     */
    cost_stock_version?: number | null;
    is_available_for_sale: boolean;
    is_manually_controlled: boolean;
    is_sold_online: boolean;
    is_available_in_store: boolean;
    is_sold_by_range: boolean;
    should_display_cost_on_pos: boolean;
    is_sold_by_weight: boolean;
    loyalty_programs: string[] | LoyaltyProgram[];
    price: number;
    cost: number;
    low_stock_threshold: number;
    /**
     * Stock level at which the product must be re-ordered (parent products).
     * Optional for backwards compatibility; missing = no reorder warning.
     */
    reorder_level?: number | null;
    store_prefix: string;
    is_parent: boolean;
    merchant_id: string;
    version: number;
    /**
     * Read-only: the store product row's own version, used as its optimistic
     * lock (`version` above is the product's). Missing on legacy rows.
     */
    row_version?: number | null;
    /** Id of the user who made the latest change (AGENTS.md §4.4.1). Optional for backwards compatibility. */
    updated_by_id?: string | null;
    /** Name of the user who made the latest change. Optional for backwards compatibility. */
    updated_by_name?: string | null;
    store_product_fractions: StoreProductFraction[];
    max_selling_price: number;
    min_selling_price: number;
    profit_margin?: number | null;
    max_profit_margin?: number | null;
    min_profit_margin?: number | null;
    popularity_score?: number | null;
    last_counted_at?: string | null;
    risk_score?: number | null;
    /**
     * Opt-in clearance flag: when true, this store product may be priced and
     * sold below its cost (e.g. discounted stock that is about to expire).
     * The domain model stops flooring price/min_selling_price at cost and
     * keeps the product available for sale at a loss. Defaults to false.
     */
    allow_below_cost_sale?: boolean | null;
    /** Changes whenever the product's discount configuration/assignment changes. */
    discount_updated_at?: string | null;
    /**
     * Days before a purchase-order expiry date the expiry warning starts
     * (30, 14, 7 or 3). Optional for backwards compatibility; missing = 14.
     */
    expiry_warning_days?: number | null;
}
export type StoreProduct = Product & StoreProductAttributes;
export interface RealTimeProductEventMessage {
    storeId: string;
    product: StoreProduct;
    deduplication_id: string;
}
export interface GetProducts {
    merchant_id: string;
    is_parent?: boolean;
    cursor?: string;
    limit?: number;
    include_deleted?: SoftDeleteFlag;
    include_fractions?: boolean;
}
export interface CreateProduct {
    creator_id: string;
    name: string;
    description: string;
    image: string;
    barcode: string | number;
    quantity_in_unit_package: number;
    weight_kg: number;
    unit: string | number;
    category_id?: string;
    merchant_id: string;
    unit_of_measurement: string;
    taxes: string[];
    barcodes?: Barcode[];
    /** Countries the product is sold in (ISO codes). Omitted = the
     * merchant's country. */
    countries?: string[];
}
export interface UpdateProduct {
    id: string;
    merchant_id: string;
    updator_id: string;
    unit_of_measurement?: string;
    name?: string;
    description?: string;
    image?: string;
    barcode?: string | number;
    quantity_in_unit_package?: number;
    global_sku?: number;
    weight_kg?: number;
    unit?: string | number;
    category_id?: string;
    add_taxes?: string[];
    remove_taxes?: string[];
    add_barcodes?: Barcode[];
    remove_barcodes?: Barcode[];
}
export interface GetStoreProducts {
    store_id: string;
    is_parent?: boolean;
    cursor?: string;
    limit?: number;
    include_deleted?: SoftDeleteFlag;
}
export interface GetStoreProduct {
    store_id: string;
    id: string;
    include_deleted?: SoftDeleteFlag;
}
export interface GetStoreProductsByMerchant extends GetStoreProducts {
    merchant_id: string;
}
export type StoreProductExportTrigger = 'manual' | 'scheduled';
export interface CreateStoreProductsExportJob {
    include_deleted?: boolean;
    requested_by?: string;
    triggered_by?: StoreProductExportTrigger;
}
export interface StoreProductsExportJobResponse {
    job_id: string;
    s3_key: string;
    requested_at: string;
    triggered_by: StoreProductExportTrigger;
    include_deleted: boolean;
    requested_by?: string;
}
export interface StoreProductExportRecord {
    key: string;
    file_name: string;
    job_id: string;
    requested_at: string;
    triggered_by: StoreProductExportTrigger;
    include_deleted: boolean;
    download_url: string;
    requested_by?: string;
    size_in_bytes?: number;
    last_modified?: string;
    /**
     * Set when the signed inventory-count PDF generated alongside the CSV
     * exists in S3. Absent for exports created before PDF generation shipped
     * or when the PDF could not be generated.
     */
    pdf_key?: string;
    pdf_download_url?: string;
    pdf_size_in_bytes?: number;
}
export interface StoreProductExportsResponse {
    exports: StoreProductExportRecord[];
    next_cursor?: string;
}
export interface ExportStoreProductsSQSMessage {
    job_id: string;
    merchant_id: string;
    store_id: string;
    include_deleted?: boolean;
    triggered_by: StoreProductExportTrigger;
    requested_at: string;
    requested_by?: string;
}
export interface CreateStoreProduct {
    creator_id: string;
    product_id: string;
    store_id: string;
    inventory: number;
    is_available_for_sale: boolean;
    is_sold_by_range: boolean;
    max_selling_price: number;
    min_selling_price: number;
    is_manually_controlled: boolean;
    is_sold_by_weight: boolean;
    is_sold_online: boolean;
    loyalty_programs: string[];
    price: number;
    cost: number;
    low_stock_threshold: number;
    merchant_id: string;
}
export interface GetStoreProductByMerchant {
    merchant_id: string;
    store_id: string;
    id: string;
    include_deleted?: SoftDeleteFlag;
}
export interface GetProduct {
    merchant_id: string;
    id: string;
    include_deleted?: SoftDeleteFlag;
}
export interface UpdateStoreProduct {
    id: string;
    store_id: string;
    merchant_id: string;
    updator_id: string;
    inventory?: number;
    is_available_for_sale?: boolean;
    is_sold_by_range?: boolean;
    max_selling_price?: number;
    min_selling_price?: number;
    is_manually_controlled?: boolean;
    is_sold_by_weight?: boolean;
    is_sold_online?: boolean;
    add_loyalty_programs?: string[];
    remove_loyalty_programs?: string[];
    price?: number;
    cost?: number;
    low_stock_threshold?: number;
    is_available_in_store?: boolean;
    should_display_cost_on_pos?: boolean;
    /** 30, 14, 7 or 3 days; see `StoreProductAttributes.expiry_warning_days`. */
    expiry_warning_days?: number | null;
    /** Stock level at which to re-order; null clears it. */
    reorder_level?: number | null;
    /**
     * @deprecated No longer read. Cost/price changes now send an idempotent
     * recompute trigger to the reports service instead of a value delta, so
     * there is nothing to skip. Accepted for backwards compatibility only.
     */
    skip_inventory_value_delta?: boolean;
    last_counted_at?: string;
    risk_score_increment?: number;
    /**
     * Opt-in clearance flag: when true the product may be priced and sold
     * below cost (expiring stock discounts). Turning it off re-floors the
     * price and min selling price at the current cost.
     */
    allow_below_cost_sale?: boolean;
    /** Human-readable audit reason for this update. */
    change_reason?: string;
    /**
     * When the change was made at its source (ISO 8601), e.g. on a till that
     * was offline: the change records are dated with it. Optional for
     * backwards compatibility; missing = the time of the request.
     */
    occurred_at?: string;
    /**
     * The price the caller saw before changing it. When set and the stored
     * price differs, nothing is written and the request is refused with 409:
     * a newer price is never overwritten by an older edit (POS offline price
     * changes). Optional for backwards compatibility; missing = no check.
     */
    expected_price?: number;
    /** Immutable discount audit metadata supplied by the discounts service. */
    discount_change?: ProductDiscountChange;
    /**
     * Where a cost update originated. PURCHASE_ORDER_RECEIVE marks the
     * weighted-average-cost recompute that follows receiving a purchase
     * order; the stock revaluation it causes is already offset by Supplier
     * Due in the store valuation, so no cost-revaluation impact is recorded
     * for it. Manual cost edits omit this field.
     */
    cost_update_origin?: CostUpdateOrigin;
    /**
     * A purchase-order receive: the products service computes the weighted
     * average cost from the store product's current cost inside its locked
     * write, so a concurrent cost change is never overwritten. Takes
     * precedence over `cost`. Optional: older callers send `cost`.
     */
    weighted_receive?: WeightedReceive | null;
    /**
     * A transfer receipt valued by service-inventory inside its stock
     * transaction (docs/plans/orders-and-transfers.md §4.3): the new cost,
     * applied only when newer than the last valuation (`stock_version`) and
     * than the last other cost change (`valued_at`), so a late or repeated
     * call changes nothing. Takes precedence over `cost` and
     * `weighted_receive`.
     */
    inventory_valuation?: InventoryValuation | null;
}
export interface InventoryValuation {
    /** The weighted cost per parent unit. */
    cost: number;
    /** The stock row version it was computed at. */
    stock_version: number;
    /** When it was computed. */
    valued_at: string;
    /**
     * The store product's `cost_changed_at` the valuation started from
     * (null: none). A hand edit since then wins: the valuation is skipped.
     * Optional; missing = compared by `valued_at` only.
     */
    base_changed_at?: string | null;
}
export interface WeightedReceive {
    /** Stock just before the receive, from the receive's own inventory change. */
    quantity_before: number;
    /** Parent units received. */
    quantity: number;
    /** Per-unit cost of this receive. */
    cost: number;
}
export enum CostUpdateOrigin {
    PURCHASE_ORDER_RECEIVE = 'PURCHASE_ORDER_RECEIVE',
    /** The carried cost of a transfer receipt (Orders & Transfers, PR 6). */
    TRANSFER_RECEIVE = 'TRANSFER_RECEIVE',
    /** An owner-approved cost at transfer price approval (PR 7). */
    TRANSFER_PRICE_APPROVAL = 'TRANSFER_PRICE_APPROVAL'
}
export interface UpdateStoreProductInventory {
    id: string;
    store_id: string;
    merchant_id: string;
    source_id: string;
    source_type: EntityTypes;
    inventory: number;
    /**
     * The stock buckets behind `inventory` (sellable). Optional for backwards
     * compatibility; missing = leave the stored breakdown unchanged.
     */
    stock_breakdown?: StockBreakdown;
    /**
     * Version of the stock row this snapshot was taken from. A snapshot older
     * than the one already mirrored is skipped, so a delayed update never
     * overwrites newer stock. Optional for backwards compatibility; missing =
     * always applied.
     */
    stock_version?: number;
}
export interface StoreProductPage {
    products: StoreProduct[];
    cursor?: string | null;
    count: number;
}
export interface ProductPage {
    products: Product[];
    cursor?: string;
    count: number;
}
export interface DeletedProductsPage {
    products: Product[];
    /**
     * Soft-deleted in-store product rows across all stores of the merchant.
     * Aggregated by the use-case (cursor not threaded across stores in v1).
     */
    store_products: StoreProduct[];
    cursor?: string | null;
    count: number;
}
export interface ProductFractionPage {
    fractions: ProductFraction[];
    cursor?: string;
    count: number;
}
export interface GetProductFractions {
    parent_id?: string;
    fraction_id?: string;
    cursor?: string;
    limit?: number;
    include_deleted?: SoftDeleteFlag;
}
export interface GetProductFractionsByMerchant {
    merchant_id: string;
    parent_id?: string;
    fraction_id?: string;
    cursor?: string;
    limit?: number;
    include_deleted?: SoftDeleteFlag;
}
export interface GetProductFraction {
    merchant_id: string;
    id: string;
    include_deleted?: SoftDeleteFlag;
}
export interface CreateProductFraction {
    fraction_id: string;
    parent_id: string;
    merchant_id: string;
    creator_id: string;
}
export interface UpdateProductFraction {
    id: string;
    parent_id?: string;
    fraction_name?: string;
    parent_name?: string;
    merchant_id: string;
    updator_id: string;
}
export interface RepairParentFractions {
    parent_id: string;
    merchant_id: string;
    updator_id: string;
}
export interface RepairParentFractionsResult {
    parent_id: string;
    parent_name: string;
    parent_quantity_in_unit_package: number;
    children_repaired: number;
    children_already_correct: number;
    store_fractions_repaired: number;
    stores_notified: number;
}
export interface SKU extends Timestamps {
    global_sku: number;
    merchant_id: string;
    unique_by_merchant: string;
    product_id: string;
}
export enum StoreProductChangeEvents {
    STORE_PRODUCT_SOLD_ONLINE_UPDATED = 'STORE_PRODUCT_SOLD_ONLINE_UPDATED',
    STORE_PRODUCT_DISPLAY_COST_ON_POS_UPDATED = 'STORE_PRODUCT_DISPLAY_COST_ON_POS_UPDATED',
    STORE_PRODUCT_CREATED = 'STORE_PRODUCT_CREATED',
    STORE_SKU_UPDATED = 'STORE_SKU_UPDATED',
    STORE_PRODUCT_IS_AVAILABLE_IN_STORE_UPDATED = 'STORE_PRODUCT_IS_AVAILABLE_IN_STORE_UPDATED',
    STORE_PRODUCT_SOLD_BY_WEIGHT_UPDATED = 'STORE_PRODUCT_SOLD_BY_WEIGHT_UPDATED',
    STORE_PRODUCT_INVENTORY_UPDATED = 'STORE_PRODUCT_INVENTORY_UPDATED',
    STORE_PRODUCT_PRICE_UPDATED = 'STORE_PRODUCT_PRICE_UPDATED',
    STORE_PRODUCT_COST_UPDATED = 'STORE_PRODUCT_COST_UPDATED',
    STORE_PRODUCT_LOW_STOCK_THRESHOLD_UPDATED = 'STORE_PRODUCT_LOW_STOCK_THRESHOLD_UPDATED',
    STORE_PRODUCT_EXPIRY_WARNING_DAYS_UPDATED = 'STORE_PRODUCT_EXPIRY_WARNING_DAYS_UPDATED',
    STORE_PRODUCT_REORDER_LEVEL_UPDATED = 'STORE_PRODUCT_REORDER_LEVEL_UPDATED',
    STORE_PRODUCT_IS_AVAILABLE_FOR_SALE_UPDATED = 'STORE_PRODUCT_IS_AVAILABLE_FOR_SALE_UPDATED',
    STORE_PRODUCT_IS_SOLD_BY_RANGE_UPDATED = 'STORE_PRODUCT_IS_SOLD_BY_RANGE_UPDATED',
    STORE_PRODUCT_IS_SOLD_BY_WEIGHT_UPDATED = 'STORE_PRODUCT_IS_SOLD_BY_WEIGHT_UPDATED',
    STORE_PRODUCT_IS_SOLD_ONLINE_UPDATED = 'STORE_PRODUCT_IS_SOLD_ONLINE_UPDATED',
    STORE_PRODUCT_MANUAL_CONTROL_UPDATED = 'STORE_PRODUCT_MANUAL_CONTROL_UPDATED',
    STORE_PRODUCT_MAX_SELLING_PRICE_UPDATED = 'STORE_PRODUCT_MAX_SELLING_PRICE_UPDATED',
    STORE_PRODUCT_MIN_SELLING_PRICE_UPDATED = 'STORE_PRODUCT_MIN_SELLING_PRICE_UPDATED',
    STORE_PRODUCT_LOYALTY_PROGRAMS_UPDATED = 'STORE_PRODUCT_LOYALTY_PROGRAMS_UPDATED',
    STORE_PRODUCT_DELETED = 'STORE_PRODUCT_DELETED',
    STORE_PRODUCT_RESTORED = 'STORE_PRODUCT_RESTORED',
    STORE_PREFIX_UPDATED = 'STORE_PREFIX_UPDATED',
    STORE_PRODUCT_FRACTIONS_UPDATED = 'STORE_PRODUCT_FRACTIONS_UPDATED',
    STORE_PRODUCT_POPULARITY_SCORE_UPDATED = 'STORE_PRODUCT_POPULARITY_SCORE_UPDATED',
    STORE_PRODUCT_ALLOW_BELOW_COST_SALE_UPDATED = 'STORE_PRODUCT_ALLOW_BELOW_COST_SALE_UPDATED',
    STORE_PRODUCT_DISCOUNT_ASSIGNED = 'STORE_PRODUCT_DISCOUNT_ASSIGNED',
    STORE_PRODUCT_DISCOUNT_REASSIGNED = 'STORE_PRODUCT_DISCOUNT_REASSIGNED',
    STORE_PRODUCT_DISCOUNT_UNASSIGNED = 'STORE_PRODUCT_DISCOUNT_UNASSIGNED',
    STORE_PRODUCT_DISCOUNT_UPDATED = 'STORE_PRODUCT_DISCOUNT_UPDATED',
    STORE_PRODUCT_DISCOUNT_EXPIRED = 'STORE_PRODUCT_DISCOUNT_EXPIRED',
    STORE_PRODUCT_DISCOUNT_DELETED = 'STORE_PRODUCT_DISCOUNT_DELETED',
    STORE_PRODUCT_DISCOUNTED_PRICE_UPDATED = 'STORE_PRODUCT_DISCOUNTED_PRICE_UPDATED'
}
export type StoreProductDBItem = StoreProductAttributes & {
    PK: string; // PK = `PRODUCT#${product_id}`
    SK: string; // SK = `STORE#${store_id}`
    GSI1PK: string; // GSI1PK = `STORE#${store_id}`
    GSI1SK: string; // GSI1SK = `PRODUCT#${product_id}`
    GSI2PK: string; // GSI2PK = `IS_PARENT#${is_parent}`
    GSI2SK: string; // GSI2SK = `STORE#${id}#PRODUCT#${id}`
    EntityIndexPK: string; // EntityIndexPK = `STORE_PRODUCT`
    EntityIndexSK: string; // EntityIndexSK = `PRODUCT#${product_id}#STORE#${store_id}`
};
export interface ProductDBItem extends Product {
    PK: string; // PK = `PRODUCT#${id}`
    SK: string; // SK = `PRODUCT#${id}`
    GSI1PK: string; // GSI1PK = `MERCHANT#${id}`
    GSI1SK: string; // GSI1SK = `PRODUCT#${id}`
    GSI2PK: string; // GSI2PK = `IS_PARENT#${is_parent}`
    GSI2SK: string; // GSI2SK = `MERCHANT#${id}#PRODUCT#${id}`
    EntityIndexPK: string; // EntityIndexPK = `PRODUCT`
    EntityIndexSK: string; // EntityIndexSK = `MERCHANT#${merchant_id}#DATE#${createdAt}`
}
export interface ProductFractionDBItem extends ProductFraction {
    PK: string; // PK = `PRODUCT#${product_id}`
    SK: string; // SK = `PRODUCT_FRACTION#${id}`
    GSI1PK: string; // GSI1PK = `MERCHANT#${id}`
    GSI1SK: string; // GSI1SK = `PRODUCT_FRACTION#${id}`
    GSI2PK: string; // GSI2PK = `PRODUCT_FRACTION#${id}`
    GSI2SK: string; // GSI2SK = `PRODUCT#${product_id}`
    EntityIndexPK: string; // EntityIndexPK = `PRODUCT_FRACTION`
    EntityIndexSK: string; // EntityIndexSK = `PRODUCT#${product_id}#PRODUCT_FRACTION#${id}`
}
export interface SKUDBItem extends SKU {
    // PK = MERCHANT#{merchant_id}
    // SK = GLOBAL_SKU#{sku}
    // GSI1PK = GLOBAL_SKU#{sku}
    // GSI1SK = MERCHANT#{merchant_id}
    // GSI2PK = GLOBAL_SKU#{sku}
    // GSI2SK = PRODUCT#{product_id}
    // GSI3PK = unique_by_merchant
    // GSI3SK = GLOBAL_SKU#{sku}
    // EntityIndexPK = GLOBAL_SKU
    // EntityIndexSK = MERCHANT#{merchant_id}#PRODUCT#{product_id}#GLCOBAL_SKU#{sku}
    PK: string;
    SK: string;
    GSI1PK: string;
    GSI1SK: string;
    GSI2PK: string;
    GSI2SK: string;
    GSI3PK: string;
    GSI3SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}
export interface ChangeEvent {
    changes: ChangedAttributes;
    event: ProductChangeEvents | StoreProductChangeEvents;
}
export enum ProductChangeEvents {
    PRODUCT_CONVERTED_TO_PARENT = 'PRODUCT_CONVERTED_TO_PARENT',
    PRODUCT_CONVERTED_TO_CHILD = 'PRODUCT_CONVERTED_TO_CHILD',
    PRODUCT_CREATED = 'PRODUCT_CREATED',
    PRODUCT_NAME_UPDATED = 'PRODUCT_NAME_UPDATED',
    PRODUCT_DESCRIPTION_UPDATED = 'PRODUCT_DESCRIPTION_UPDATED',
    PRODUCT_IMAGE_UPDATED = 'PRODUCT_IMAGE_UPDATED',
    PRODUCT_BARCODE_UPDATED = 'PRODUCT_BARCODE_UPDATED',
    PRODUCT_QUANTITY_IN_UNIT_PACKAGE_UPDATED = 'PRODUCT_QUANTITY_IN_UNIT_PACKAGE_UPDATED',
    PRODUCT_GLOBAL_SKU_UPDATED = 'PRODUCT_GLOBAL_SKU_UPDATED',
    PRODUCT_WEIGHT_KG_UPDATED = 'PRODUCT_WEIGHT_KG_UPDATED',
    PRODUCT_UNIT_UPDATED = 'PRODUCT_UNIT_UPDATED',
    PRODUCT_CATEGORY_UPDATED = 'PRODUCT_CATEGORY_UPDATED',
    PRODUCT_FRACTION_UPDATED = 'PRODUCT_FRACTION_UPDATED',
    PRODUCT_PARENT_UPDATED = 'PRODUCT_PARENT_UPDATED',
    PRODUCT_TAXES_UPDATED = 'PRODUCT_TAXES_UPDATED',
    PRODUCT_DELETED = 'PRODUCT_DELETED',
    PRODUCT_RESTORED = 'PRODUCT_RESTORED',
    PRODUCT_FRACTIONS_UPDATED = 'PRODUCT_FRACTIONS_UPDATED',
    PRODUCT_DELETED_AT_UPDATED = 'PRODUCT_DELETED_AT_UPDATED',
    PRODUCT_CATEGORY_ID_UPDATED = 'PRODUCT_CATEGORY_ID_UPDATED',
    PRODUCT_UNIT_OF_MEASUREMENT_UPDATED = 'PRODUCT_UNIT_OF_MEASUREMENT_UPDATED',
    PRODUCT_BARCODES_UPDATED = 'PRODUCT_BARCODES_UPDATED'
}
export interface ProductChange extends Timestamps {
    event: ProductChangeEvents;
    version: string;
    updator_id: string;
    changed_attributes: ChangedAttributes;
    change_reason: string;
    id: string;
    merchant_id: string;
    updator_name: string;
    product_name: string;
}
export interface ProductChangeDBItem extends ProductChange {
    // PK = `PRODUCT#${id}`
    // SK = `PRODUCT_VERSION#${padded_version}`
    // GSI1PK = `MERCHANT#${merchant_id}`
    // GSI1SK = `PRODUCT_CHANGE#${id}#DATE#${createdAt}`
    // GSI2PK = `USER#${updator_id}`
    // GSI2SK = `PRODUCT_CHANGE#${id}#DATE#${createdAt}`
    // GSI3PK = `MERCHANT#${merchant_id}#EVENT#${event}`
    // GSI3SK = `PRODUCT_CHANGE#${id}#DATE#${createdAt}`
    // GSI4PK = `MERCHANT#${merchant_id}#EVENT#${event}`
    // GSI4SK = `PRODUCT_CHANGE#DATE#${createdAt}`
    // GSI5PK = `USER#${updator_id}`
    // GSI5SK = `PRODUCT_CHANGE#DATE#${createdAt}`
    // GSI6PK = `USER#${updator_id}#EVENT#${event}`
    // GSI6SK = `PRODUCT_CHANGE#${id}#DATE#${createdAt}`
    // EntityIndexPK = `PRODUCT_CHANGE`
    // EntityIndexSK = `MERCHANT#${merchant_id}#DATE#${createdAt}`
    PK: string;
    SK: string;
    GSI1PK: string;
    GSI1SK: string;
    GSI2PK: string;
    GSI2SK: string;
    GSI3PK: string;
    GSI3SK: string;
    GSI4PK: string;
    GSI4SK: string;
    GSI5PK: string;
    GSI5SK: string;
    GSI6PK: string;
    GSI6SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}
export interface ProductChangesPage {
    changes: ProductChange[];
    cursor?: string;
    count: number;
}
export interface GetProductChanges {
    /**
     * Query all product changes made by a specific user.
     *
     * **How to Query:**
     * - **Index:** GSI2
     * - **GSI2PK:** `USER#${updator_id}`
     * - **GSI2SK:** starts with `PRODUCT_CHANGE#`
     */
    by_user?: boolean;
    /**
     * Query all product changes made by an user within a date range.
     *
     * **How to Query:**
     * - **Index:** GSI5
     * - **GSI5PK:** `USER#${updator_id}`
     * - **GSI5SK Range:** Between `PRODUCT_CHANGE#DATE#${start_date}` and `PRODUCT_CHANGE#DATE#${end_date}`
     */
    by_user_and_date_range?: boolean;
    /**
     * Query By user and product
     * - **Index:** GSI2
     * - **GSI6PK:** `USER#${updator_id}`
     * - **GSI6SK:** starts with `PRODUCT_CHANGE#${product_id}`
     */
    by_user_and_product?: boolean;
    /**
     * Query By user and product within a date range
     * - **Index:** GSI2
     * - **GSI6PK:** `USER#${updator_id}`
     * - **GSI6SK Range:** Between `PRODUCT_CHANGE#${product_id}#DATE#${start_date}` and `PRODUCT_CHANGE#${product_id}#DATE#${end_date}`
     * - **Note:** Requires `start_date` and `end_date`
     * - **Note:** Requires `updator_id`
     */
    by_user_product_and_date_range?: boolean;
    /**
     * Query By user and event type
     * - **Index:** GSI7
     * - **GSI7PK:** `USER#${updator_id}#EVENT#${event}`
     * - **GSI7SK:** starts with `PRODUCT_CHANGE#`
     */
    by_user_and_event?: boolean;
    /**
     * Query By user and event type and product within a date range
     * - **Index:** GSI7
     * - **GSI7PK:** `USER#${updator_id}#EVENT#${event}`
     * - **GSI7SK Range:** Between `PRODUCT_CHANGE#${id}#DATE#${start_date}` and `PRODUCT_CHANGE#DATE#${end_date}`
     * - **Note:** Requires `start_date` and `end_date`
     * - **Note:** Requires `updator_id`
     */
    by_user_and_product_and_event_and_date_range?: boolean;
    /**
     * Query all versions of a specific product.
     *
     * **How to Query:**
     * - **Table:** Main Table
     * - **Partition Key (PK):** `PRODUCT#${product_id}`
     * - **Sort Key (SK):** `PRODUCT_VERSION#${padded_version}`
     */
    by_product?: boolean;
    /**
     * Query all product changes for a specific merchant.
     *
     * **How to Query:**
     * - **Index:** GSI1
     * - **GSI1PK:** `MERCHANT#${merchant_id}`
     * - **GSI1SK:** starts with "PRODUCT_CHANGE#"
     */
    by_merchant?: boolean;
    /**
     * Query all changes for a specific product within a merchant.
     *
     * **How to Query:**
     * - **Index:** GSI1
     * - **GSI1PK:** `MERCHANT#${merchant_id}`
     * - **GSI1SK:** starts with 'PRODUCT_CHANGE#${product_id}'
     */
    by_merchant_and_product?: boolean;
    /**
     * Query all product changes for a merchant within a date range.
     *
     * **How to Query:**
     * - **Index:** EntityIndex
     * - **EntityIndexPK:** `PRODUCT_CHANGE`
     * - **EntityIndexSK Range:** Between `MERCHANT#${id}#DATE#${start_date}` and `MERCHANT#${id}#DATE#${end_date}`
     */
    by_merchant_and_date_range?: boolean;
    /**
     * Query all changes for a specific product under a merchant within a date range.
     *
     * **How to Query:**
     * - **Index:** GSI1
     * - **GSI1PK:** `MERCHANT#${merchant_id}`
     * - **GSI1SK Range:** Between `PRODUCT_CHANGE#${product_id}#DATE#${start_date}` and `PRODUCT_CHANGE#${product_id}#DATE#${end_date}`
     */
    by_merchant_product_and_date_range?: boolean;
    /**
     * Query all product changes of a specific event type for a merchant.
     *
     * **How to Query:**
     * - **Index:** GSI3
     * - **GSI3PK:** `MERCHANT#${merchant_id}#EVENT#${event}`
     * - **GSI3SK:** starts with `PRODUCT_CHANGE#`
     */
    by_merchant_and_event?: boolean;
    /**
     * Query all product changes of a specific event type for a merchant within a date range.
     *
     * **How to Query:**
     * - **Index:** GSI4
     * - **GSI4PK:** `MERCHANT#${merchant_id}#EVENT#${event}`
     * - **GSI4SK Range:** Between `PRODUCT_CHANGE#DATE#${start_date}` and `PRODUCT_CHANGE#DATE#${end_date}`
     */
    by_merchant_event_and_date_range?: boolean;
    /**
     * Query all changes by merchant and event type and product
     * - **Index:** GSI3
     * - **GSI3PK:** `MERCHANT#${merchant_id}#EVENT#${event}`
     * - **GSI3SK:** starts with `PRODUCT_CHANGE#${product_id}`
     */
    by_merchant_event_and_product?: boolean;
    /**
     * Query all changes by merchant and event type and product within a date range
     * - **Index:** GSI3
     * - **GSI3PK:** `MERCHANT#${merchant_id}#EVENT#${event}`
     * - **GSI3SK Range:** Between `PRODUCT_CHANGE#${product_id}#DATE#${start_date}` and `PRODUCT_CHANGE#${product_id}#DATE#${end_date}`
     */
    by_merchant_event_product_and_date_range?: boolean;
    /**
     * Query all product changes by product and version range.
     *
     * **How to Query:**
     * - **Table:** Main Table
     * - **PK:** `PRODUCT#${product_id}`
     * - **SK Range:** Between `PRODUCT_VERSION#${start_version}` and `PRODUCT_VERSION#${end_version}`
     * - **Note:** Requires that `padded_version`
     */
    by_product_and_version_range?: boolean;
    // Query parameters
    limit?: number;
    cursor?: string;
    /**
     * Start date for date range filtering.
     * - **Format:** ISO 8601 string (e.g., '2023-09-24T12:34:56Z')
     */
    start_date?: string;
    /**
     * End date for date range filtering.
     * - **Format:** ISO 8601 string
     */
    end_date?: string;
    /**
     * Merchant ID.
     * - Required for queries involving merchants.
     */
    merchant_id: string;
    /**
     * Product ID.
     * - Required for queries involving specific products.
     */
    product_id?: string;
    /**
     * Event type.
     * - Enum of possible product change events.
     */
    event?: ProductChangeEvents;
    /**
     * user (updator) ID.
     * - Required for queries involving specific users.
     */
    updator_id?: string;
    sort_order?: 'ASC' | 'DESC';
    /**
     * Product version.
     * - Required for queries involving specific product versions.
     */
    version?: number;
    /**
     * Start version for version range filtering.
     */
    start_version?: string;
    /**
     * End version for version range filtering.
     */
    end_version?: string;
}
export interface GetStoreProductChanges {
    /**
     * Query all store_product changes made by a specific user.
     *
     * **How to Query:**
     * - **Index:** GSI2
     * - **GSI2PK:** `USER#${updator_id}`
     * - **GSI2SK:** starts with `STORE_PRODUCT_CHANGE#`
     */
    by_user?: boolean;
    /**
     * Query all store_product changes made by an user within a date range.
     *
     * **How to Query:**
     * - **Index:** GSI5
     * - **GSI5PK:** `USER#${updator_id}`
     * - **GSI5SK Range:** Between `STORE_PRODUCT_CHANGE#DATE#${start_date}` and `STORE_PRODUCT_CHANGE#DATE#${end_date}`
     */
    by_user_and_date_range?: boolean;
    /**
     * Query By user and store_product
     * - **Index:** GSI2
     * - **GSI6PK:** `USER#${updator_id}`
     * - **GSI6SK:** starts with `STORE_PRODUCT_CHANGE#${product_id}`
     */
    by_user_and_store_product?: boolean;
    by_user_store_product_and_date_range?: boolean;
    by_user_and_event?: boolean;
    by_user_and_store_product_and_event?: boolean;
    by_user_and_store_product_and_event_and_date_range?: boolean;
    by_store_product?: boolean;
    by_store?: boolean;
    by_store_and_store_product?: boolean;
    by_store_and_date_range?: boolean;
    by_store_and_store_product_and_date_range?: boolean;
    by_store_and_event?: boolean;
    by_store_and_event_and_date_range?: boolean;
    by_store_event_and_store_product?: boolean;
    by_store_event_store_product_and_date_range?: boolean;
    by_store_product_and_version_range?: boolean;
    limit?: number;
    cursor?: string;
    start_date?: string;
    end_date?: string;
    store_id?: string;
    product_id?: string;
    event?: ProductChangeEvents | StoreProductChangeEvents;
    updator_id?: string;
    sort_order?: 'ASC' | 'DESC';
    version?: number;
    start_version?: number;
    end_version?: number;
}
export interface StoreProductChangesPage {
    changes: StoreProductChange[];
    cursor?: string;
    count: number;
}
export interface StoreProductChange extends Timestamps {
    event: StoreProductChangeEvents;
    version: number;
    updator_id: string;
    changed_attributes: ChangedAttributes;
    change_reason: string;
    id: string;
    store_id: string;
    merchant_id: string;
    updator_name: string;
    product_name: string;
    /**
     * On-hand stock (in parent units) at the moment of a cost edit.
     * Recorded only on STORE_PRODUCT_COST_UPDATED events for parent
     * products whose cost was edited manually — not for the weighted-cost
     * update that follows a purchase order receive.
     */
    inventory_at_change?: number;
    /**
     * inventory_at_change × (new cost − old cost): how much this cost edit
     * revalued the stock already on hand. Summed into the Valuation
     * dashboard's "Cost Changes" breakdown row so the Est. Total
     * difference reconciles with the change breakdown.
     */
    inventory_value_change?: number;
}
export interface StoreProductChangeDBItem extends StoreProductChange {
    PK: string;
    SK: string;
    GSI1PK: string;
    GSI1SK: string;
    GSI2PK: string;
    GSI2SK: string;
    GSI3PK: string;
    GSI3SK: string;
    GSI4PK: string;
    GSI4SK: string;
    GSI5PK: string;
    GSI5SK: string;
    GSI6PK: string;
    GSI6SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}
export interface BulkImportStoreProduct {
    store_id: string;
    products: string[];
    merchant_id: string;
    creator_id: string;
    creator_type: EntityTypes;
}
export interface BulkCreateStoreProductsResponse {
    message: string;
}
export interface StoreProductWebSocketMessage {
    type: EntityTypes;
    message: StoreProduct;
}
/**
 * Body of POST /products/{merchant_id}/store-products/{store_id}/deleted-ids:
 * the POS asks which of the products it holds were deleted.
 */
export interface GetDeletedStoreProductIds {
    /** Store product ids held by the POS (at most 500 per request). */
    ids: string[];
}
/** A soft-deleted store product, for the POS to remove its copy. */
export interface DeletedStoreProduct {
    id: string;
    /**
     * When it was deleted: the POS keeps a copy updated after this (it was
     * restored meanwhile).
     */
    deleted_at: string;
}
/** The store products, among those asked, that are soft-deleted. */
export interface DeletedStoreProducts {
    deleted: DeletedStoreProduct[];
}

export interface Promotion extends Timestamps {
    id: string;
    title: string;
    description: string;
    start_date: string;
    end_date: string;
    promotion_type: PromotionTypes;
    promotion_value: number;
    promotion_code: string;
    promotion_status: PromotionStatus;
    store_id: string;
    merchant_id: string;
    product_id: string;
    image_url: string;
    is_manual: boolean;
}
export interface PromotionPage {
    promotions: Promotion[];
    cursor?: string;
    count: number;
}
export enum PromotionTypes {
    PERCENTAGE = 'percentage',
    FIXED = 'fixed'
}
export enum PromotionStatus {
    ACTIVE = 'active',
    INACTIVE = 'inactive'
}
export interface CreatePromotionRequest {
    title: string;
    description: string;
    start_date: string;
    end_date: string;
    product_id: string;
    image_url: string;
    promotion_type: PromotionTypes;
    promotion_value: number;
    promotion_code: string;
    store_id: string;
    merchant_id: string;
}
export interface UpdatePromotionRequest {
    id: string;
    title?: string;
    description?: string;
    start_date?: string;
    end_date?: string;
    product_id?: string;
    image_url?: string;
    promotion_type?: PromotionTypes;
    promotion_value?: number;
    promotion_code?: string;
    promotion_status?: PromotionStatus;
    is_manual?: boolean;
    store_id: string;
    merchant_id: string;
}
export interface GetPromotionsRequest {
    limit?: number;
    include_deleted?: SoftDeleteFlag;
    cursor?: string;
    by_status?: boolean;
    by_start_date_range?: boolean;
    by_start_date_range_and_status?: boolean;
    by_end_date_range?: boolean;
    by_end_date_range_and_status?: boolean;
    by_item?: boolean;
    by_item_and_status?: boolean;
    item_id?: string;
    status?: PromotionStatus;
    start_date?: string;
    end_date?: string;
    merchant_id: string;
    store_id: string;
}
export interface PromotionDBItem extends Promotion {
    PK: string; // MERCHANT#<merchant_id#STORE#<store_id>#MISC#<YYMM>
    SK: string; // PROMOTION#<id>
    GSI1PK: string; // MERCHANT#<merchant_id#STORE#<store_id>#STATUS#<PromotionStatus>
    GSI1SK: string; // PROMOTION#START_DATE<start_date>
    GSI2PK: string; // MERCHANT#<merchant_id#STORE#<store_id>
    GSI2SK: string; // PROMOTION#START_DATE#<start_date>
    GSI3PK: string; // MERCHANT#<merchant_id#STORE#<store_id>
    GSI3SK: string; // PROMOTION#END_DATE#<end_date>
    GSI4PK: string; // ITEM#<id>
    GSI4SK: string; // PROMOTION#MERCHANT#<merchant_id#STORE#<store_id>#STATUS#<PromotionStatus>
    GSI5PK: string; // MERCHANT#<merchant_id#STORE#<store_id>#STATUS#<PromotionStatus>
    GSI5SK: string; // PROMOTION#END_DATE<end_date>
    EntityIndexPK: string;
    EntityIndexSK: string;
}
export interface PromotionDiscount {
    id: string;
    type: DiscountType;
    name: string;
    discount_amount: number;
    discount_percent: number;
    stores: string[];
    restricted_access: boolean;
    created_at: string; // ISO 8601 date string
    updated_at: string; // ISO 8601 date string
    deleted_at: string | null; // ISO 8601 date string or null if not deleted
}
export interface UpdatePromotionDiscount {
    id: string;
    type: DiscountType;
    name: string;
    discount_amount: number;
    discount_percent: number;
    stores: string[];
    restricted_access: boolean;
}
export interface CreatePromotionDiscount {
    type: DiscountType;
    name: string;
    discount_amount: number;
    discount_percent: number;
    stores: string[];
    restricted_access: boolean;
}
export interface PromotionDiscountPage {
    discounts: PromotionDiscount[];
    cursor: string;
}

export enum PurchaseStatus {
    DRAFT = 'DRAFT',
    CLOSED = 'CLOSED',
    PENDING = 'PENDING',
    CANCELLED = 'CANCELLED'
}
export enum PurchaseOrderPaymentStatus {
    UNPAID = 'UNPAID',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID'
}
export interface CancelPurchaseOrderItemFraction {
    id: string;
    parent_id: string;
    fraction: number;
    cancelled: number;
}
export interface CancelPurchaseOrderItem {
    id: string;
    cancelled: number;
    fractions?: CancelPurchaseOrderItemFraction[];
}
export interface PurchaseOrderPayment extends Timestamps, Versioned {
    id: string;
    purchase_order_id: string;
    amount_paid: number;
    amount_refunded: number;
    payment_location: string;
    payment_method_id?: string;
    payment_method_type?: PaymentMethodType;
    merchant_id: string;
    store_id: string;
    supplier_id: string;
    amount_due: number;
    total_paid: number;
    total_refunded: number;
    total_amount: number;
    final_amount: number;
    creator_id: string;
    creator_name: string;
    refund_note?: string;
    total_cancelled_amount: number;
    shift_id?: string; // TODO: Make Optional // Shift during which the purchase order was created
    /** When this record is a full-reversal of a prior supplier payment, points at that payment's `id`. */
    reverses_payment_id?: string;
    /** Stamped on the original payment when it has been reversed. Prevents double-reversal. */
    reversed_by_payment_id?: string;
    /** Convenience flag set to true when `reverses_payment_id` is populated. */
    is_reversal?: boolean;
}
export interface CreatePurchaseOrderPayment {
    amount_paid: number;
    payment_location: string;
    merchant_id: string;
    purchase_order_id: string;
    payment_method_id: string;
    payment_method_type: PaymentMethodType;
    store_id: string;
    creator_id: string;
    refund_note?: string;
    shift_id?: string; // TODO: Make Optional // Shift during which the purchase order was created
    /**
     * When set, this create call is a full reversal of the referenced supplier payment.
     * The service validates that `amount_paid` is negative and equals the original's net,
     * and atomically stamps the original with `reversed_by_payment_id`.
     */
    reverses_payment_id?: string;
}
export interface GetAllPurchaseOrderPayments {
    by_merchant?: boolean;
    by_supplier?: boolean;
    by_date?: boolean;
    by_purchase_order?: boolean;
    by_store?: boolean;
    supplier_id?: string;
    cursor?: string;
    limit?: number;
    merchant_id?: string;
    purchase_order_id?: string;
    store_id?: string;
    start_date?: string;
    end_date?: string;
    fetch_all?: boolean;
}
export interface PurchaseOrderPaymentSummaries {
    merchants: PurchaseOrderPaymentMerchantSummary[];
    stores: PurchaseOrderPaymentStoreSummary[];
    suppliers: PurchaseOrderPaymentSupplierSummary[];
    purchase_orders: PurchaseOrderPaymentPurchaseOrderSummary[];
}
export interface PurchaseOrderPaymentSummary {
    total_money: number;
    total_due: number;
    total_paid: number;
    total_refunded: number;
    total_cancelled_amount: number;
    final_amount: number;
    count: number;
}
export interface PurchaseOrderPaymentMerchantSummary extends PurchaseOrderPaymentSummary {
    merchant_id: string;
}
export interface PurchaseOrderPaymentSupplierSummary extends PurchaseOrderPaymentSummary {
    supplier_id: string;
}
export interface PurchaseOrderPaymentPurchaseOrderSummary extends PurchaseOrderPaymentSummary {
    purchase_order_id: string;
}
export interface PurchaseOrderPaymentStoreSummary extends PurchaseOrderPaymentSummary {
    store_id: string;
}
export interface PurchaseOrderPaymentPage {
    purchase_order_payments: PurchaseOrderPayment[];
    cursor: string | null | undefined;
    count: number;
    summary: PurchaseOrderPaymentSummaries | null | undefined;
}
export enum PurchaseOrderEstimateStatus {
    /** The line is complete; its selling prices still have to be confirmed. */
    PENDING = 'PENDING',
    SAVED = 'SAVED'
}
/** One selling option (the parent or a fraction) of a line's estimate. */
export interface PurchaseOrderEstimateMember {
    /** Store product id of this family member. */
    id: string;
    name: string;
    quantity_in_unit_package: number;
    /** Cost per member unit, derived from the line's received cost. */
    cost: number;
    /** Selling price per member unit confirmed by the user. */
    price: number;
    /** How many member units the received stock can sell (2 dp). */
    possible_sales: number;
    /** Total profit when all received stock sells through this member. */
    profit: number;
}
/**
 * Potential gross profit of one purchase-order line, calculated once when
 * the line is complete (received ≥ ordered − cancelled). Each member sells
 * all the received stock; min / max are the lowest and highest member.
 */
export interface PurchaseOrderItemEstimate {
    status: PurchaseOrderEstimateStatus;
    /** Received quantity in line units, net of cancellations. */
    received_quantity: number;
    /** Weighted cost per line unit over every receive of the line. */
    unit_cost: number;
    members: PurchaseOrderEstimateMember[];
    min_profit: number;
    max_profit: number;
    saved_at?: string;
    saved_by_id?: string;
    saved_by_name?: string;
}
export interface SavePurchaseOrderItemEstimateMember {
    id: string;
    price: number;
}
export interface SavePurchaseOrderItemEstimate {
    merchant_id: string;
    store_id: string;
    /** Purchase order id. */
    id: string;
    item_id: string;
    /** A member left out keeps its current selling price. */
    members: SavePurchaseOrderItemEstimateMember[];
    /** Expiry date (YYYY-MM-DD) of the received stock; null clears it. */
    expiry_date?: string | null;
    updator_id: string;
}
export interface PurchaseOrder extends Timestamps, Versioned {
    id: string;
    purchase_date: string;
    ordered_by: string;
    note: string;
    supplier_id: string;
    purchase_status: PurchaseStatus;
    total_cost: number;
    items: PurchaseOrderItem[];
    total_received: number;
    payment_status: PurchaseOrderPaymentStatus;
    is_draft: boolean;
    store_id: string;
    merchant_id: string;
    total_ordered: number;
    supplier_name: string;
    total_cancelled: number;
    shift_id?: string; // TODO: Make Optional // Shift during which the purchase order was created
    po_total_paid?: number; // Cumulative amount paid (net of refunds) — source of truth
    po_total_refunded?: number; // Cumulative refund total — source of truth
    po_amount_due?: number; // Outstanding balance: (final_amount - po_total_paid) — source of truth
    cancelled_at?: string | null; // ISO 8601 timestamp when the PO was cancelled
    /** Σ of the lines' saved `estimate.min_profit`. Missing = no estimates. */
    estimate_min_profit?: number;
    /** Σ of the lines' saved `estimate.max_profit`. Missing = no estimates. */
    estimate_max_profit?: number;
    /** Lines whose estimate is still PENDING. Missing = 0. */
    estimate_pending_count?: number;
}
export interface PurchaseOrderItem extends Timestamps {
    id: string;
    quantity: number;
    cost: number;
    received: number;
    cancelled: number;
    name: string;
    in_stock: number;
    received_at?: string;
    fractions?: PurchaseOrderItemFraction[];
    /** Optional for backwards compatibility; missing = no estimate. */
    estimate?: PurchaseOrderItemEstimate | null;
    /**
     * Expiry date (YYYY-MM-DD) of the stock received on this line, set when
     * the line's selling prices are confirmed. Optional; missing = unknown.
     */
    expiry_date?: string | null;
}
export interface UpdatePurchaseOrderItem {
    quantity: number;
    id: string;
    purchase_cost?: number;
    fractions?: PurchaseOrderItemFraction[];
}
export interface PurchaseOrderItemFraction {
    id: string;
    parent_id: string;
    quantity: number;
    purchase_cost: number;
    fraction: number;
    name: string;
    received: number;
    cancelled: number;
}
export interface ReceivePurchaseOrderItemFraction {
    quantity: number;
    id: string;
    parent_id: string;
    fraction: number;
}
export interface ReceivePurchaseOrderItem {
    quantity: number;
    id: string;
    cost: number;
    fractions?: ReceivePurchaseOrderItemFraction[];
}
export interface CreatePurchaseOrder {
    purchase_date: string;
    ordered_by: string;
    note: string;
    supplier_id: string;
    items: UpdatePurchaseOrderItem[];
    store_id: string;
    merchant_id: string;
    shift_id?: string; // TODO: Make Optional // Shift during which the purchase order was created
    /**
     * Makes a retried create a no-op: the first create with this key makes
     * the PO, a repeat returns that PO (POS quick purchase orders send their
     * op id). Optional for backwards compatibility; missing = every request
     * creates a PO.
     */
    idempotency_key?: string;
}
export enum UpdatePurchaseOrderCommand {
    ADD = 'ADD',
    REMOVE = 'REMOVE',
    CANCEL = 'CANCEL',
    COMMENT = 'COMMENT',
    CANCEL_ITEMS = 'CANCEL_ITEMS',
    REFUND_ITEM = 'REFUND_ITEM'
}
export interface RefundItem {
    id: string;
    amount: number;
    merchant_id: string;
    store_id: string;
    updator_id: string;
}
export interface UpdatePurchaseOrder {
    store_id: string;
    id: string;
    items: UpdatePurchaseOrderItem[];
    command: UpdatePurchaseOrderCommand;
    cancellations?: CancelPurchaseOrderItem[];
    refunds?: RefundItem[];
    updator_id: string;
    note?: string;
    shift_id?: string; // TODO: Make Optional // Shift during which the purchase order was updated
}
export interface ReceivePurchaseOrder {
    // purchase order id
    id: string;
    items: ReceivePurchaseOrderItem[];
    creator_id: string;
    store_id: string;
    shift_id?: string; // TODO: Make Optional // Shift during which the purchase order was received
    /**
     * When the goods arrived (ISO 8601), for a receive made offline and
     * uploaded later (the POS quick purchase order). Every ledger of the
     * receive is dated at it, so a later offline count does not add it
     * twice. At most 35 days old and 5 minutes ahead.
     * Optional for backwards compatibility; missing = now.
     */
    received_at?: string;
}
export interface PurchaseOrderPage {
    purchase_orders: PurchaseOrder[];
    cursor: string | null | undefined;
    count: number;
}
export interface GetAllPurchaseOrders {
    by_merchant?: boolean;
    by_supplier?: boolean;
    by_date?: boolean;
    by_payment_status?: boolean;
    by_purchase_status?: boolean;
    by_payment_status_and_date?: boolean;
    by_purchase_status_and_date?: boolean;
    by_store?: boolean;
    by_store_and_date?: boolean;
    supplier_id?: string;
    merchant_id: string;
    cursor?: string;
    purchase_status?: PurchaseStatus;
    payment_status?: PurchaseOrderPaymentStatus;
    store_id?: string;
    start_date?: string;
    end_date?: string;
    limit?: number;
}
export interface GetPurchaseOrder {
    id: string;
}
export interface DeletePurchaseOrder {
    id: string;
}
export interface PurchaseOrderPaymentDBItem extends PurchaseOrderPayment, DynamoDBItem {
}
export interface ReconcilePaymentFieldsResponse {
    updated_count: number;
    errors: string[];
}
export interface SupplierValuationPeriodMetrics {
    total_money: number;
    total_cancelled_amount: number;
    final_amount: number;
    total_paid: number;
    total_refunded: number;
    total_due: number;
}
export interface SupplierValuation {
    supplier_due_start: number;
    supplier_due_end: number;
    period_metrics: SupplierValuationPeriodMetrics;
    period_metrics_delta: SupplierValuationPeriodMetrics;
    per_supplier?: SupplierValuationPerSupplier[];
}
export interface SupplierValuationPerSupplier {
    supplier_id: string;
    supplier_name?: string;
    supplier_due_start: number;
    supplier_due_end: number;
    /**
     * Metrics for this supplier at end_date, same shape and meaning as
     * `period_metrics`. `total_due` is the receive-based due and always equals
     * `supplier_due_end` — it is repeated so a single card component can render
     * a supplier row and a store row from the same field names.
     */
    total_money: number;
    total_cancelled_amount: number;
    final_amount: number;
    total_paid: number;
    total_refunded: number;
    total_due: number;
    /**
     * Gross paid to this supplier BETWEEN start_date and end_date, unlike
     * `total_paid`, which is everything paid up to end_date. This is the figure
     * a date-ranged report shows beside the supplier's opening and closing due.
     */
    paid_in_period: number;
    /** Number of purchase orders behind these numbers. */
    count: number;
}
export interface GetSupplierValuation {
    merchant_id: string;
    store_id: string;
    start_date: string;
    end_date: string;
}
// ── PO Payment Snapshot Types ──
export interface POPaymentStoreSnapshot {
    id: string;
    store_id: string;
    merchant_id: string;
    supplier_id: string;
    po_id: string;
    total_money: number;
    total_cancelled_amount: number;
    final_amount: number;
    total_paid: number;
    total_refunded: number;
    total_due: number;
    created_at: string;
    updated_at: string;
}
export interface GetStoreSnapshotAtTime {
    store_id: string;
    datetime: string;
    po_id?: string;
    supplier_id?: string;
}
export interface GetSupplierSnapshotsInRange {
    supplier_id: string;
    start_date: string;
    end_date: string;
    po_id?: string;
    limit?: number;
    cursor?: string;
}
export interface GetSupplierSnapshotAtTime {
    supplier_id: string;
    datetime: string;
    po_id?: string;
}
export interface GetStoreSnapshotsInRange {
    store_id: string;
    start_date: string;
    end_date: string;
    po_id?: string;
    supplier_id?: string;
    limit?: number;
    cursor?: string;
}
export interface POPaymentSupplierSnapshot {
    id: string;
    store_id: string;
    merchant_id: string;
    supplier_id: string;
    po_id: string;
    total_money: number;
    total_cancelled_amount: number;
    final_amount: number;
    total_paid: number;
    total_refunded: number;
    total_due: number;
    created_at: string;
    updated_at: string;
}
export interface POPaymentStoreSnapshotDBItem extends POPaymentStoreSnapshot, DynamoDBItem {
}
export interface POPaymentSupplierSnapshotDBItem extends POPaymentSupplierSnapshot, DynamoDBItem {
}
export interface POPaymentStoreSnapshotPage {
    snapshots: POPaymentStoreSnapshot[];
    cursor: string | null | undefined;
    count: number;
}
export interface POPaymentSupplierSnapshotPage {
    snapshots: POPaymentSupplierSnapshot[];
    cursor: string | null | undefined;
    count: number;
}
// ── PO Receive Event Types ──
/**
 * Immutable ledger record of goods received against a purchase order — one
 * per item per receive action. Together with the payment ledger it derives
 * supplier due at any point in time:
 *   due(T) = Σ receive-event value ≤ T − paid(T) + refunded(T)
 * so a PO owes nothing before delivery and each receive offsets exactly the
 * inventory value it adds.
 */
export interface PurchaseOrderReceiveEvent {
    id: string;
    merchant_id: string;
    store_id: string;
    supplier_id: string;
    po_id: string;
    item_id: string;
    product_name: string;
    /** Quantity received in this action, in parent units. */
    quantity_received: number;
    /**
     * Weighted per-parent-unit cost of this receive (fraction purchase costs
     * folded in), so `value = cost × quantity_received` holds.
     */
    cost: number;
    /**
     * Inventory value added by this receive (receive cost × quantity, matching
     * the PURCHASE_ORDER inventory change), which is also the supplier-due
     * value this receive recognizes.
     */
    value: number;
    creator_id: string;
    creator_name: string;
    shift_id?: string;
    created_at: string;
    updated_at: string;
}
export interface PurchaseOrderReceiveEventDBItem extends PurchaseOrderReceiveEvent, DynamoDBItem {
}
export interface PurchaseOrderReceiveEventPage {
    receive_events: PurchaseOrderReceiveEvent[];
    cursor: string | null | undefined;
    count: number;
}
export interface GetPurchaseOrderReceiveEvents {
    merchant_id: string;
    by_po?: boolean;
    by_store_and_date_range?: boolean;
    po_id?: string;
    store_id?: string;
    start_date?: string;
    end_date?: string;
    limit?: number;
    cursor?: string;
}
export interface GetSnapshotAtTime {
    merchant_id: string;
    store_id?: string;
    supplier_id?: string;
    datetime: string;
    po_id?: string;
}
export interface GetSnapshotsInRange {
    merchant_id: string;
    store_id?: string;
    supplier_id?: string;
    start_date: string;
    end_date: string;
    po_id?: string;
}
// ── Backfill PO Payment Snapshots ──
export interface BackfillPOPaymentSnapshotsRequest {
    purchase_order_id: string;
    store_id: string;
}
export interface PaymentSnapshotBackfillResult {
    payment_id: string;
    payment_created_at: string;
    reason?: string;
}
export interface BackfillPOPaymentSnapshotsResponse {
    po_id: string;
    store_id: string;
    supplier_id: string;
    total_payments: number;
    created: PaymentSnapshotBackfillResult[];
    skipped: PaymentSnapshotBackfillResult[];
    failed: PaymentSnapshotBackfillResult[];
    validation_warning?: string;
}

export interface ReceiptCreatedEvent {
    bus_name: string;
    source: ShopAndSmileEventSource;
    detail_type: ReceiptEvents.SaleReceiptCreated | ReceiptEvents.RefundReceiptCreated;
    detail: ReceiptCreatedEventDetail;
}
export interface ReceiptCreatedEventDetail {
    filter?: Record<string, any>;
    data: ReceiptCreatedEventDetailData;
    metadata: ReceiptCreatedEventDetailMetadata;
}
export interface ReceiptCreatedEventDetailData {
    receipt: Receipt;
}
export interface ReceiptCreatedEventDetailMetadata extends ShopAndSmileEventMetadata {
}

export enum ReasonMissing {
    NA = 'NA',
    OUT_OF_STOCK = 'OUT_OF_STOCK',
    CANCELLED = 'CANCELLED'
}
export enum ReceiptStatus {
    CONFIRMED = 'CONFIRMED',
    UNCONFIRMED = 'UNCONFIRMED',
    AUTOCONFIRMED = 'AUTOCONFIRMED',
    REFUND = 'REFUND',
    MISSING = 'MISSING'
}
export interface MissingItem {
    quantity: number;
    reason: ReasonMissing;
    employee_id: string;
    employee_name: string;
    item_id: string;
}
export interface CartItem extends Timestamps {
    item_id: string;
    item_name: string;
    quantity: number;
    missing: MissingItem;
    is_confirmed: boolean;
}
export interface ConfirmedQuantityUpdate {
    quantity: number;
    updator: EmployeeSummary;
    item_id: string;
}
export interface ExtendedLineItem extends LineItem {
    missing: MissingItem;
    is_confirmed: boolean;
}
export interface ReceiptHistory {
    receipt_number: string;
    history_item: ReceiptHistoryItem[];
}
export enum ReceiptHistoryItemType {
    SALE = 'SALE',
    DEBT_PAYMENT = 'DEBT PAYMENT',
    REFUND = 'REFUND',
    UPDATE_CUSTOMER = 'CUSTOMER UPDATE',
    COMMENT = 'COMMENT'
}
export interface HistoryPaymentType {
    payment_type_id: string;
    payment_type_name: string;
    payment_type: PaymentMethodType;
    amount: number;
    total_given?: number;
    change?: number;
}
export interface SaleReceiptHistoryItem {
    history_item_type: ReceiptHistoryItemType.SALE;
    event: string;
    value: number;
    remaining_debt: number;
    payments: HistoryPaymentType[];
    comment?: string;
    date: string;
    receipt_number: string;
}
export interface DebtPaymentHistoryItem {
    history_item_type: ReceiptHistoryItemType.DEBT_PAYMENT;
    event: string;
    paid_amount: number;
    remaining_debt: number;
    payment_id: string;
    comment?: string;
    date: string;
    received_by: EmployeeSummary;
}
export interface RefundReceiptHistoryItem {
    history_item_type: ReceiptHistoryItemType.REFUND;
    event: string;
    refund_receipt_number: string;
    refunded_payments: HistoryPaymentType[];
    amount_refunded: number;
    comment?: string;
    remaining_debt: number;
    date: string;
    refunded_by: EmployeeSummary;
}
export interface ReceiptHistoryUpdateCustomerItem {
    history_item_type: ReceiptHistoryItemType.UPDATE_CUSTOMER;
    event: string;
    previous_customer_id: string;
    new_customer_id: string;
    date: string;
    updated_by: EmployeeSummary;
}
export interface ReceiptHistoryCommentItem {
    history_item_type: ReceiptHistoryItemType.COMMENT;
    event: string;
    comment: string;
    date: string;
    commented_by: EmployeeSummary;
}
//////// SHOP AND SMILE RECEIPT ///////////
export interface LineItem {
    id: string;
    item_id: string;
    item_name: string;
    sku: string;
    quantity: number;
    parent_id?: string;
    line_quantity: number;
    fraction: number;
    price: number;
    gross_total_money: number;
    total_money: number;
    cost: number;
    cost_total: number;
    line_note?: string;
    line_taxes: ReceiptTax[];
    total_discount: number;
    line_discounts: ReceiptDiscount[];
    confirmed_quantity: number;
    confirmed_quantity_traceback: ConfirmedQuantityTraceback[];
    missing: MissingItem;
    missing_quantity_traceback: MissingItemTraceback[];
    is_confirmed: boolean;
    is_sold_by_weight: boolean;
}
export interface ReceiptDiscount extends Discount {
    money_amount: number;
}
export interface ReceiptTax extends Tax {
    money_amount: number;
    pre_tax_money: number;
}
export interface Receipt extends Timestamps, Versioned {
    receipt_number: string;
    note?: string;
    receipt_type: ReceiptType;
    refund_for?: string;
    order?: string;
    created_at: string;
    updated_at: string;
    source: string;
    cancelled_at?: any;
    total_money: number;
    total_tax: number;
    points_earned: number;
    points_deducted: number;
    points_balance: number;
    customer_id: string;
    total_discount: number;
    employee_id: string;
    store_id: string;
    pos_device_id: string;
    dining_option?: string;
    total_discounts: ReceiptDiscount[];
    total_taxes: ReceiptTax[];
    tip: number;
    surcharge: number;
    line_items: LineItem[];
    payments: ReceiptPayment[];
    associated_refunds: string[];
    total_receipt_items: number;
    confirmation_type: ConfirmationType;
    receipt_status: ReceiptStatus;
    comments: Comment[];
    client: Client;
    waiter?: EmployeeSummary;
    is_confirmable: boolean;
    confirmed_by?: EmployeeSummary;
    customer?: Customer;
    customer_name: string;
    employee_name: string;
    pos_device_name: string;
    customer_updated_traceback: CustomerUpdateTraceback[];
    has_debt: boolean;
    custom_receipt_number: string;
    failed_checks: ReceiptFailedChecks[];
    merchant_id: string;
    threshold: Threshold;
    initial_payment_plan?: PaymentPlan;
    shift_id?: string; // TODO: Make Optional
    outstanding_debt_before?: number | null | undefined;
}
export interface ReceiptFailedChecks {
    note: string;
    check_type: any;
    created_at: string;
}
export interface ReceiptPayment extends Timestamps {
    payment_type_id: string;
    payment_type: PaymentMethodType;
    money_amount: number;
    note?: string;
    total_given?: number;
    change?: number;
}
export interface ReceiptDBItem extends Receipt {
    PK: string; // RECEIPT#<receipt_number>
    SK: string; // RECEIPT#<receipt_number>
    EntityIndexPK: string; // RECEIPT
    EntityIndexSK: string; // RECEIPT#DATE#<created_at>
    GSI1PK: string; // <receipt_status>
    GSI1SK: string; // RECEIPT#DATE#<date>
    GSI2PK: string; // <customer_id>
    GSI2SK: string; // RECEIPT#DATE#<date>
    GSI3PK: string; // STORE#<store_id>
    GSI3SK: string; // RECEIPT#DATE#<date>
    GSI4PK: string; // POS_DEVICE#<pos_device_id>
    GSI4SK: string; // RECEIPT#DATE#<date>
    GSI5PK: string; // POS_DEVICE#<id>
    GSI5SK: string; // RECEIPT#<custom_receipt_number>
    GSI6PK: string; // STORE#<store_id>#STATUS#<receipt_status>
    GSI6SK: string; // RECEIPT#DATE#<date>
    GSI7PK: string; // STORE#<store_id>#CONFIRMATION_TYPE#<confirmation_type>
    GSI7SK: string; // RECEIPT#DATE#<date>
}
export interface CreateReceiptHistoryItem {
    receiptHistory: ReceiptHistoryItem;
    id: string;
    receipt_number: string;
    created_at: string;
    merchant_id: string;
}
export interface UpdateReceiptItem extends Partial<ReceiptDBItem> {
    receipt_number: string;
}
export type ReceiptHistoryDbItem = ReceiptHistoryItem & {
    PK: string;
    SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
};
export type ReceiptHistoryItem = SaleReceiptHistoryItem | DebtPaymentHistoryItem | RefundReceiptHistoryItem | ReceiptHistoryUpdateCustomerItem | ReceiptHistoryCommentItem;
export interface Client extends Timestamps {
    id: string;
    name: string;
    phone_number: string;
    email?: string;
    address?: string;
    business_name?: string;
}
export interface Comment extends Timestamps {
    comment: string;
    employee_id: string;
    employee_name: string;
}
export enum ConfirmationType {
    SOFT = 'SOFT',
    HARD = 'HARD'
}
export interface ConfirmedQuantityTraceback extends Timestamps {
    quantity: number;
    confirmed_by: string;
    note: string;
}
export interface CustomerUpdateTraceback extends Timestamps {
    customer: string;
    updator: string;
    note: string;
}
export interface MissingItemTraceback extends Timestamps {
    quantity: number;
    reported_by: string;
    note: string;
}
export interface GetReceipts {
    cursor?: string;
    limit?: number;
    start_date?: string;
    end_date?: string;
    receipt_status?: ReceiptStatus;
    customer_id?: string;
    store_id?: string;
    confirmation_type?: ConfirmationType;
    pos_device_id?: string;
    by_status?: boolean;
    by_date_range?: boolean;
    by_date_range_and_status?: boolean;
    by_customer?: boolean;
    by_customer_and_date_range?: boolean;
    by_date_range_and_status_and_missing?: boolean;
    by_store?: boolean;
    by_store_and_date_range?: boolean;
    by_store_and_status?: boolean;
    by_store_and_date_range_and_status?: boolean;
    by_store_and_confirmation_type?: boolean;
    by_pos_device?: boolean;
    sort_order?: SortOrder;
    with_debt?: boolean;
}
export interface ReceiptsPage {
    receipts: Receipt[];
    cursor?: string;
    count: number;
}
export enum UpdateReceiptCommand {
    CONFIRM_SOFT_RECEIPT = 'CONFIRM_SOFT_RECEIPT',
    CONFIRM_HARD_RECEIPT = 'CONFIRM_HARD_RECEIPT',
    ADD_COMMENT = 'ADD_COMMENT',
    UPDATE_CONFIRMED_QUANTITY = 'UPDATE_CONFIRMED_QUANTITY',
    ADD_MISSING_QUANTITY = 'ADD_MISSING_QUANTITY',
    DELETE_MISSING_QUANTITY = 'DELETE_MISSING_QUANTITY',
    SET_RECEIPT_TO_MISSING = 'SET_RECEIPT_TO_MISSING',
    ADD_WAITER = 'ADD_WAITER',
    ADD_CUSTOMER = 'ADD_CUSTOMER',
    BACKFILL_SHIFT_ID = 'BACKFILL_SHIFT_ID'
}
export interface UpdateReceipt {
    receipt_number: string;
    merchant_id: string;
    command: UpdateReceiptCommand;
    waiter?: EmployeeSummary;
    comments?: Comment[];
    receipt_status?: {
        receipt_status: ReceiptStatus;
        updator: EmployeeSummary;
    };
    customer?: {
        customer_id: string;
        updator_id: string;
    };
    shift_id?: string;
}
export interface UpdateLineItem {
    receipt_number: string;
    confirmed_quantity?: ConfirmedQuantityUpdate[];
    missing?: MissingItem[];
    command: UpdateReceiptCommand;
    merchant_id: string;
}
export interface ConfirmReceipt {
    receipt_number: string;
    updator: EmployeeSummary;
    confirmation_type: ConfirmationType;
    command: UpdateReceiptCommand;
    merchant_id: string;
}
export interface Threshold extends Timestamps, Versioned {
    min_quantity: number;
    min_total_money: number;
    updated_by: EmployeeSummary[];
    store_id: string;
    merchant_id: string;
}
export interface ThresholdItem extends Timestamps, Threshold {
    PK: string;
    SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}
export interface CreateThreshold {
    min_quantity: number;
    min_total_money: number;
    updated_by: EmployeeSummary;
    store_id: string;
    merchant_id: string;
}
export interface UpdateThreshold {
    min_quantity?: number;
    min_total_money?: number;
    updated_by: EmployeeSummary;
    store_id: string;
    merchant_id: string;
}
export enum ReceiptEvents {
    SaleReceiptCreated = 'SaleReceiptCreated',
    RefundReceiptCreated = 'RefundReceiptCreated'
}
export interface ReceiptEvent {
    request_id: string;
    merchant_id: string;
    created_at: string;
    body: Receipt;
    type: ReceiptType;
    receipt_number: string;
    success: boolean;
}
export interface GetReceiptEvents {
    merchant_id: string;
    type?: ReceiptType;
    start_date?: string;
    end_date?: string;
    cursor?: string;
    count?: number;
}
export interface ReceiptEventsPage {
    receipt_events: ReceiptEvent[];
    count: number;
    cursor?: string;
}
export interface GetReceiptEvent {
    request_id: string;
    merchant_id: string;
}

export interface SalesReport extends Timestamps {
    gross_sales: number;
    refunds: number;
    discounts: number;
    cost_of_products: number;
    expenses: number;
    entity_type: EntityTypes;
    sale_receipt_count: number;
    refund_receipt_count: number;
    expense_count: number;
    source_entity_id: string;
    source_entity_type: EntityTypes;
    version: number;
    merchant_id: string;
    store_id: string;
    shift_id?: string; // TODO: Make Optional // Shift during which the sales report was created
}
export interface StoreSalesReport extends SalesReport {
    store_id: string;
}
export interface EmployeeSalesReport extends SalesReport {
    employee_id: string;
    employee_name: string;
}
export interface ProductSalesReport extends SalesReport {
    product_id: string;
    quantity: number;
    product_name: string;
    sku: string;
}
export interface SalesReportDBItem {
    PK: string;
    SK: string;
    GSI1PK: string;
    GSI1SK: string;
    GSI2PK: string;
    GSI2SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}
export interface StoreSalesReportDBItem extends StoreSalesReport, SalesReportDBItem {
}
export interface StoreSalesReportDBItemSnapshot extends AggregateStoreSalesReport {
    PK: string;
    SK: string;
    GSI1PK: string;
    GSI1SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
    /**
     * True on snapshots that include their own event (written since the
     * snapshot fix). Optional for backwards compatibility; missing = an older
     * snapshot that may under-count, so it is never built on.
     */
    includes_own_event?: boolean;
}
export interface EmployeeSalesReportDBItem extends EmployeeSalesReport, SalesReportDBItem {
}
export interface EmployeeSalesReportDBItemSnapshot extends AggregateEmployeeSalesReport {
    PK: string;
    SK: string;
    GSI1PK: string;
    GSI1SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
    /**
     * True on snapshots that include their own event (written since the
     * snapshot fix). Optional for backwards compatibility; missing = an older
     * snapshot that may under-count, so it is never built on.
     */
    includes_own_event?: boolean;
}
export interface ProductSalesReportDBItem extends ProductSalesReport, SalesReportDBItem {
}
export interface ProductSalesReportDBItemSnapshot extends AggregateProductSalesReport {
    PK: string;
    SK: string;
    GSI1PK: string;
    GSI1SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
    /**
     * True on snapshots that include their own event (written since the
     * snapshot fix). Optional for backwards compatibility; missing = an older
     * snapshot that may under-count, so it is never built on.
     */
    includes_own_event?: boolean;
}
export interface SalesReportExtensions {
    net_sales: number;
    gross_profit: number;
    net_profit: number;
    gross_margin: number;
    net_margin: number;
}
export interface AggregateStoreSalesReport extends StoreSalesReport, SalesReportExtensions {
}
export interface AggregateEmployeeSalesReport extends EmployeeSalesReport, SalesReportExtensions {
}
export interface AggregateProductSalesReport extends ProductSalesReport, SalesReportExtensions {
}
export interface AggregateSalesReport {
    store: AggregateStoreSalesReport;
    employees: AggregateEmployeeSalesReport[];
    products: AggregateProductSalesReport[];
}
export interface GetSalesReport {
    merchant_id: string;
    store_id: string;
    products?: string[];
    from?: string;
    to?: string;
    date?: string;
    by_date?: boolean;
    by_date_range?: boolean;
    by_products_and_date?: boolean;
    by_products_and_date_range?: boolean;
    /**
     * Optional for backwards compatibility; missing = true.
     * Set to false to skip the per-employee reports (saves one query per
     * employee and the users lookup).
     */
    include_employees?: boolean;
    /**
     * Optional for backwards compatibility; missing = true.
     * Set to false to skip the per-product reports, the heaviest part of a
     * date-range report (one row per receipt line is scanned).
     */
    include_products?: boolean;
}
export interface GetReportEvents {
    merchant_id: string;
    by_source_entity?: boolean;
    source_entity_type?: EntityTypes;
    source_entity_id?: string;
}
export interface ReportEventsPage {
    events: ProductSalesReport[] | StoreSalesReport[] | EmployeeSalesReport[];
    count: number;
    cursor?: string;
}
export interface GetInventoryValue {
    merchant_id: string;
    store_id: string;
    date?: string;
}
export interface GetProductsInventoryValue {
    merchant_id: string;
    store_id: string;
    date: string;
    cursor?: string;
    limit?: number;
}
export interface ProductInventoryValue {
    price: number;
    cost: number;
    inventory_value: number;
    retail_value: number;
    potential_profit: number;
    margin: number;
    created_at: string;
    product_id: string;
    product_name: string;
    store_id: string;
    in_stock: number;
    merchant_id: string;
    /**
     * Stock received but waiting for price approval, and its value at cost.
     * Not in `in_stock` or `inventory_value`. Optional for backwards
     * compatibility; missing = 0. Set only when non-zero.
     */
    pending_quantity?: number;
    pending_value?: number;
    /**
     * Blocked stock (extra goods awaiting validation, damaged returns) and its
     * value at cost. Not in `in_stock` or `inventory_value`. Optional for
     * backwards compatibility; missing = 0. Set only when non-zero.
     */
    blocked_quantity?: number;
    blocked_value?: number;
}
export interface ProductInventoryValuePage {
    inventory_values: ProductInventoryValue[];
    count: number;
    cursor?: string;
}
export interface StoreInventoryValue {
    store_id: string;
    merchant_id: string;
    inventory_value: number;
    potential_profit: number;
    retail_value: number;
    margin: number;
    created_at: string;
    /**
     * Value at cost of stock waiting for price approval, outside
     * `inventory_value`. Optional for backwards compatibility; missing = 0.
     * Set only when non-zero.
     */
    pending_value?: number;
    /**
     * Value at cost of blocked stock, outside `inventory_value`. Optional for
     * backwards compatibility; missing = 0. Set only when non-zero.
     */
    blocked_value?: number;
}
export interface MerchantInventoryValue {
    merchant_id: string;
    merchant_name: string;
    inventory_value: number;
    potential_profit: number;
    retail_value: number;
    margin: number;
    created_at: string;
}
export interface StoreValueSnapshotDBItem extends StoreInventoryValue {
    PK: string; // MERCHANT#<merchant_id>#STORE_VALUE_SNAPSHOT#<store_id>
    SK: string; // STORE_VALUE_SNAPSHOT#<datetime>
    EntityIndexPK: string; //STORE_VALUE_SNAPSHOT
    EntityIndexSK: string; //MERCHNAT#<merchant_id>#STORE#<store_id>#DATE#<datetime>
}
export interface GetStoreInventoryValueDateRange {
    merchant_id: string;
    store_id: string;
    from: string;
    to: string;
    /**
     * Optional for backwards compatibility; missing = every snapshot in the
     * range. The most points to return (2 or more). When the full series is
     * longer, it is sampled instead: the start value, then the value at the
     * end of each interval (minutes to weeks, the finest that fits), ending
     * with the latest value.
     */
    max_points?: number;
}
export interface StoreInventoryValueDateRangePage {
    inventory_values: StoreInventoryValue[];
    count: number;
}
export interface UpdateStoreInventorySQSMessage {
    store_id: string;
    merchant_id: string;
}
/**
 * SQS message asking the reports service to recompute a store's inventory
 * value snapshot. Sent whenever anything that affects the store's inventory
 * value changes (stock movement, cost/price edit, product delete).
 * The worker recomputes the snapshot from live inventory, so the message is
 * an idempotent trigger — duplicates and lost deltas cannot skew the total.
 */
export interface InventoryValueChangeSQSMessage {
    store_id: string;
    merchant_id: string;
    /** @deprecated informational only — the worker recomputes from live inventory */
    inventory_value_delta?: number;
    /** @deprecated informational only — the worker recomputes from live inventory */
    retail_value_delta?: number;
}
/**
 * Interval types for date-range segmentation
 */
export enum SalesReportInterval {
    HOURLY = 'hourly',
    DAILY = 'daily',
    WEEKLY = 'weekly',
    MONTHLY = 'monthly',
    ANNUALLY = 'annually',
    NONE = 'none'
}
export interface GetSalesReportByDateRangeIntervalOptions {
    entityType: EntityTypes;
    entityId: string;
    from: string;
    to: string;
    interval?: SalesReportInterval;
    is_cumulative?: boolean;
}
/**
 * Trigger source of an inventory value CSV export. `manual` covers the
 * inventory-value page download button; `scheduled` covers the nightly
 * per-store generation.
 */
export type InventoryValueExportTrigger = 'manual' | 'scheduled';
export interface GenerateInventoryValueExportRequest {
    /**
     * ISO 8601 date shown on the inventory-value page when the export was
     * requested. Recorded as S3 metadata; the CSV rows themselves always
     * reflect live inventory at current cost/price.
     */
    date?: string;
    requested_by?: string;
}
export interface InventoryValueExportRecord {
    key: string;
    file_name: string;
    job_id: string;
    requested_at: string;
    triggered_by: InventoryValueExportTrigger;
    download_url: string;
    requested_by?: string;
    size_in_bytes?: number;
    last_modified?: string;
    /**
     * Set when the signed inventory-count PDF generated alongside the CSV
     * exists in S3. Absent for exports created before PDF generation shipped
     * or when the PDF could not be generated.
     */
    pdf_key?: string;
    pdf_download_url?: string;
    pdf_size_in_bytes?: number;
}
/**
 * Response of the manual export trigger. Generation runs asynchronously on
 * the export queue; the files appear on the Downloads page when the worker
 * finishes (CSV plus the inventory-count PDFs).
 */
export interface GenerateInventoryValueExportJobResponse {
    job_id: string;
    requested_at: string;
    triggered_by: InventoryValueExportTrigger;
    /** Predicted S3 key of the CSV the queued job will write. */
    csv_key: string;
    requested_by?: string;
}
export interface InventoryValueExportsResponse {
    exports: InventoryValueExportRecord[];
    next_cursor?: string;
}
/**
 * SQS message asking the reports service to generate an inventory value CSV
 * export for a store. Sent by the nightly cron for every merchant/store and
 * consumed by the inventory value export queue worker.
 */
export interface InventoryValueExportSQSMessage {
    job_id: string;
    merchant_id: string;
    store_id: string;
    triggered_by: InventoryValueExportTrigger;
    requested_at: string;
    date: string;
    requested_by?: string;
}

export interface SalesAgent extends Timestamps, Versioned {
    id: string;
    name: string;
    phone_number: string;
    email?: string | null;
    store_ids: string[];
    notes?: string | null;
}
export interface SalesAgentPage {
    sales_agents: SalesAgent[];
    count: number;
    cursor?: string;
}
export interface CreateSalesAgent {
    name: string;
    phone_number: string;
    email?: string;
    store_ids?: string[];
    notes?: string;
}
export interface UpdateSalesAgent {
    id: string;
    name?: string;
    phone_number?: string;
    email?: string;
    notes?: string;
    add_store_ids?: string[];
    remove_store_ids?: string[];
}
export interface GetSalesAgents {
    cursor?: string;
    limit?: number;
    store_id?: string;
}
export interface SalesAgentDBItem extends SalesAgent {
    PK: string;
    SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}

/* eslint-disable @typescript-eslint/no-explicit-any */
export interface FullScreen {
    mustBeFullScreen: boolean;
    isFullScreen: boolean;
}
/**
 * Represents an item in the inventory breakdown (parent or child fraction)
 */
export interface BreakdownItem {
    name: string;
    fraction: number;
    units: number;
    id: string;
}
export enum WebWorkerActions {
    SYNC_PRODUCTS = 'sync-products',
    SYNC_TAXES = 'sync-taxes',
    SYNC_DISCOUNTS = 'sync-discounts',
    SYNC_CUSTOMERS = 'sync-customers',
    SYNC_OFFLINE_RECEIPTS = 'sync-offline-receipts',
    SYNC_ONLINE_RECEIPTS = 'sync-online-receipts',
    SYNC_PAYMENT_TYPES = 'sync-payment-types',
    SYNC_LOYALTY_PROGRAMS = 'sync-loyalty-programs',
    SYNC_OFFLINE_CUSTOMERS = 'sync-offline-customers',
    BULK_CREATE_PRODUCTS = 'bulk-create-products',
    BULK_IMPORT_PRODUCTS = 'bulk-import-products',
    BULK_UPDATE_PRODUCTS = 'bulk-update-products',
    START_POLLING = 'start-polling',
    STOP_POLLING = 'stop-polling'
}
export interface InventoryLevel {
    variant_id: string;
    store_id: string;
    in_stock: number;
    updated_at: string;
    update_id?: string; // Does not come with the webhook
}
export interface InventoryLevelsOutput {
    inventory_levels: InventoryLevel[];
}
export interface InventoryLevelProps {
    variant_id: string;
    store_id: string;
    stock_after: number;
}
export interface InventoryLevelsProps {
    inventory_levels: InventoryLevelProps[];
}
export interface ShopAndSmileImageProps {
    image_url: string;
    item_id: string;
}
export interface ShopAndSmileOkResponse {
    OK: boolean;
    message?: string;
}
export interface Currency {
    code: string;
    decimal_places: number;
    symbol?: string | null | undefined;
}
export interface BackupDto {
    sku: string;
    name: string;
    price: number;
    inventory: number;
    image_s3_key: string;
    old_image_url: string;
    merchant_id: string;
    trigger_image_backup: boolean;
    new_image_url?: string;
}
export interface BackupItem {
    PK: string;
    SK: string;
    GSI1PK: string;
    GSI1SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
    EntityType: EntityTypes;
    sku: string;
    name: string;
    price: number;
    inventory: number;
    image_s3_key: string;
    merchant_id: string;
    old_image_url: string;
    trigger_image_backup: boolean;
    new_image_url?: string;
}
export interface MerchantInfo {
    id: string;
    business_name: string;
    email: string;
    country: string;
    currency: Currency;
    created_at: string;
}
export interface WriteResponse {
    message: string;
    isSuccessful: boolean;
}
export enum GSI_DESCRIPTORS {
    CONFIRMATION_TYPE = 'CONFIRMATION_TYPE',
    EVENT_TYPE = 'EVENT_TYPE',
    REASON = 'REASON',
    SOURCE_TYPE = 'SOURCE_TYPE',
    DATE = 'DATE',
    /** When a record was applied (processed), as opposed to when it happened. */
    PROCESSED = 'PROCESSED',
    FAILURE = 'FAILURE',
    SUCCESS = 'SUCCESS',
    CORRELATION = 'CORRELATION',
    DOMAIN = 'DOMAIN',
    PURCHASE_ORDER_COUNT = 'PURCHASE_ORDER_COUNT',
    PAYMENT_STATUS = 'PAYMENT_STATUS',
    PURCHASE_STATUS = 'PURCHASE_STATUS',
    LOAN_COUNT = 'LOAN_COUNT',
    PHONE_NUMBER = 'PHONE_NUMBER',
    START_DATE = 'START_DATE',
    END_DATE = 'END_DATE',
    YEAR_MONTH = 'YYMM',
    STATUS = 'STATUS',
    IS_MOTHER = 'IS_MOTHER',
    MAC_ADDRESS = 'MAC_ADDRESS',
    MOTHER = 'MOTHER',
    CHILD = 'CHILD',
    ENTITY_TYPE = 'ENTITY_TYPE',
    PURCHASE_ORDER_PAYMENT_SUMMARY_VERSION = 'PURCHASE_ORDER_PAYMENT_SUMMARY_VERSION',
    VERSION = 'VERSION',
    STORE_SALES_REPORT_VERSION = 'STORE_SALES_REPORT_VERSION',
    EMPLOYEE_SALES_REPORT_VERSION = 'EMPLOYEE_SALES_REPORT_VERSION',
    PRODUCT_SALES_REPORT_VERSION = 'PRODUCT_SALES_REPORT_VERSION',
    STORE_SALES_REPORT_SNAPSHOT_VERSION = 'STORE_SALES_REPORT_SNAPSHOT_VERSION',
    EMPLOYEE_SALES_REPORT_SNAPSHOT_VERSION = 'EMPLOYEE_SALES_REPORT_SNAPSHOT_VERSION',
    PRODUCT_SALES_REPORT_SNAPSHOT_VERSION = 'PRODUCT_SALES_REPORT_SNAPSHOT_VERSION',
    PRODUCT_INVENTORY_VALUE_VERSION = 'PRODUCT_INVENTORY_VALUE_VERSION',
    TOTAL_DUE = 'TOTAL_DUE',
    DUE_DATE = 'DUE_DATE',
    POS_RECEIPT = 'POS_RECEIPT',
    COGNITO_USER = 'COGNITO_USER',
    COGNITO_USERNAME = 'COGNITO_USERNAME',
    IS_PARENT = 'IS_PARENT',
    GLOBAL_SKU = 'GLOBAL_SKU',
    INVENTORY_TYPE = 'INVENTORY_TYPE',
    DEBT_STATUS = 'DEBT_STATUS',
    DEBT_ORIGIN = 'DEBT_ORIGIN',
    DEBT_VERSION = 'DEBT_VERSION',
    EntityIndexPK = 'EntityIndexPK',
    EntityIndexSK = 'EntityIndexSK',
    FLOW_TYPE = 'FLOW_TYPE',
    TOPUP_AMOUNT = 'TOPUP_AMOUNT',
    TOPUP_RECEIVER = 'TOPUP_RECEIVER',
    TOPUP_SENDER = 'TOPUP_SENDER',
    PRICING_PLAN_STATUS = 'PRICING_PLAN_STATUS',
    AGREEMENT_STATUS = 'AGREEMENT_STATUS',
    MERCHANT = 'MERCHANT',
    ACTIVE_CUSTOMER_AGREEMENT = 'ACTIVE_CUSTOMER_AGREEMENT',
    PLAN = 'PLAN',
    AGREEMENT = 'AGREEMENT',
    SHIFT_STATUS = 'SHIFT_STATUS',
    FLOW = 'FLOW',
    ORIGIN = 'ORIGIN',
    CREATOR = 'CREATOR',
    APPROVAL_STATUS = 'APPROVAL_STATUS',
    PAYMENT_METHOD = 'PAYMENT_METHOD',
    TRANSFERER = 'TRANSFERER',
    TRANSFEREE = 'TRANSFEREE',
    PK = 'PK',
    SK = 'SK',
    GSI1PK = 'GSI1PK',
    GSI1SK = 'GSI1SK',
    GSI2PK = 'GSI2PK',
    GSI2SK = 'GSI2SK',
    GSI3PK = 'GSI3PK',
    GSI3SK = 'GSI3SK',
    GSI4PK = 'GSI4PK',
    GSI4SK = 'GSI4SK',
    GSI5PK = 'GSI5PK',
    GSI5SK = 'GSI5SK',
    GSI6PK = 'GSI6PK',
    GSI6SK = 'GSI6SK',
    GSI7PK = 'GSI7PK',
    GSI7SK = 'GSI7SK',
    GSI8PK = 'GSI8PK',
    GSI8SK = 'GSI8SK',
    GSI9PK = 'GSI9PK',
    GSI9SK = 'GSI9SK',
    RECIPIENT = 'RECIPIENT',
    NOTIFICATION_TYPE = 'NOTIFICATION_TYPE',
    MESSAGE_ID = 'MESSAGE_ID',
    DAY = 'DAY'
}
export enum SortOrder {
    ASC = 'ASC',
    DESC = 'DESC'
}
export enum EntityTypes {
    STORE_WALLET = 'STORE_WALLET',
    MERCHANT_WALLET = 'MERCHANT_WALLET',
    MERCHANT_PAYMENT = 'MERCHANT_PAYMENT',
    TRANSFEREE = 'TRANSFEREE',
    TRANSFERER = 'TRANSFERER',
    ACCOUNT = 'ACCOUNT',
    BACKUP = 'BACKUP',
    WEBSOCKET_CONNECTION = 'WEBSOCKET_CONNECTION',
    BORROWER_LOAN = 'BORROWER_LOAN',
    CURRENT_INVENTORY = 'CURRENT_INVENTORY',
    CUSTOMER = 'CUSTOMER',
    CUSTOMER_DEBT = 'CUSTOMER_DEBT',
    CUSTOMER_LIABILITIES = 'CUSTOMER_LIABILITIES',
    DEBT = 'DEBT',
    DEBT_CHANGE = 'DEBT_CHANGE',
    DEBT_PAYMENT = 'DEBT_PAYMENT',
    DISCOUNT = 'DISCOUNT',
    EMPLOYEE_SALES_REPORT = 'EMPLOYEE_SALES_REPORT',
    EMPLOYEE_SALES_REPORT_SNAPSHOT = 'EMPLOYEE_SALES_REPORT_SNAPSHOT',
    ERROR = 'ERROR',
    EVENT = 'EVENT',
    IMAGE = 'IMAGE',
    INVENTORY_CHANGE = 'INVENTORY_CHANGE',
    INVENTORY_DISCREPANCY = 'INVENTORY_DISCREPANCY',
    INVENTORY_HISTORY = 'INVENTORY_HISTORY',
    INVENTORY_TEMPLATE = 'INVENTORY_TEMPLATE',
    ITEM_INVENTORY_VALUE = 'ITEM_INVENTORY_VALUE',
    DAILY_COUNT = 'DAILY_COUNT',
    LOAN = 'LOAN',
    LOYALTY_PROGRAM = 'LOYALTY_PROGRAM',
    /** Marks a receipt's loyalty as applied to a customer (dedupe, expires). */
    LOYALTY_RECEIPT = 'LOYALTY_RECEIPT',
    /** Marks an event's debt payment as recorded (dedupe, expires). */
    DEBT_PAYMENT_DEDUPE = 'DEBT_PAYMENT_DEDUPE',
    /** Marks a stock change (e.g. a receipt line) as applied (dedupe, expires). */
    INVENTORY_CHANGE_DEDUPE = 'INVENTORY_CHANGE_DEDUPE',
    /** Marks a purchase-order create as done, per idempotency key (kept). */
    PURCHASE_ORDER_DEDUPE = 'PURCHASE_ORDER_DEDUPE',
    /** A stock operation's record and replay marker (service-inventory). */
    STOCK_OPERATION = 'STOCK_OPERATION',
    MERCHANT = 'MERCHANT',
    PAYMENT = 'PAYMENT',
    PAYMENT_TYPE = 'PAYMENT_TYPE',
    PLATFORM_PAYMENT_TYPE = 'PLATFORM_PAYMENT_TYPE',
    POS_DEVICE = 'POS_DEVICE',
    PRODUCT = 'PRODUCT',
    PRODUCT_CHANGE = 'PRODUCT_CHANGE',
    PRODUCT_FRACTION = 'PRODUCT_FRACTION',
    PRODUCT_FRACTION_CHANGE = 'PRODUCT_FRACTION_CHANGE',
    PRODUCT_SALES_REPORT = 'PRODUCT_SALES_REPORT',
    PRODUCT_SALES_REPORT_SNAPSHOT = 'PRODUCT_SALES_REPORT_SNAPSHOT',
    PRODUCT_VERSION = 'PRODUCT_VERSION',
    PROMOTION = 'PROMOTION',
    PURCHASE_ORDER = 'PURCHASE_ORDER',
    PURCHASE_ORDER_ITEM = 'PURCHASE_ORDER_ITEM',
    PURCHASE_ORDER_PAYMENT = 'PURCHASE_ORDER_PAYMENT',
    PURCHASE_ORDER_PAYMENT_HISTORY = 'PURCHASE_ORDER_PAYMENT_HISTORY',
    PURCHASE_ORDER_PAYMENT_SUMMARY = 'PURCHASE_ORDER_PAYMENT_SUMMARY',
    RECEIPT = 'RECEIPT',
    RECEIPT_HISTORY = 'RECEIPT_HISTORY',
    STORE = 'STORE',
    STORE_PRODUCT = 'STORE_PRODUCT',
    STORE_PRODUCT_CHANGE = 'STORE_PRODUCT_CHANGE',
    STORE_PRODUCT_VERSION = 'STORE_PRODUCT_VERSION',
    STORE_SALES_REPORT = 'STORE_SALES_REPORT',
    STORE_SALES_REPORT_SNAPSHOT = 'STORE_SALES_REPORT_SNAPSHOT',
    STORE_SCALE_CONFIG = 'STORE_SCALE_CONFIG',
    STORE_SCALE_SHORTCUT = 'STORE_SCALE_SHORTCUT',
    STORE_FAVOURITE_CELL = 'STORE_FAVOURITE_CELL',
    STORE_VALUE_SNAPSHOT = 'STORE_VALUE_SNAPSHOT',
    SUPPLIER = 'SUPPLIER',
    SYSTEM = 'SYSTEM',
    TAX = 'TAX',
    THRESHOLD = 'THRESHOLD',
    USER = 'USER',
    PERMISSION = 'PERMISSION',
    PRINCIPAL = 'PRINCIPAL',
    ROLE = 'ROLE',
    SALE = 'SALE',
    CREATE_RECEIPT = 'CREATE_RECEIPT',
    INVOICE = 'INVOICE',
    PRICING_PLAN = 'PRICING_PLAN',
    CUSTOMER_AGREEMENT = 'CUSTOMER_AGREEMENT',
    WALLET_TRANSFER_OUT = 'WALLET_TRANSFER_OUT',
    PENDING_TOPUP = 'PENDING_TOPUP',
    SHIFT = 'SHIFT',
    SHIFT_TRANSACTION = 'SHIFT_TRANSACTION',
    TOPUP_REQUEST = 'TOPUP_REQUEST',
    WALLET_MESSAGE = 'WALLET_MESSAGE',
    TOPUP_PASSWORD = 'TOPUP_PASSWORD',
    ACCOUNT_SNAPSHOT = 'ACCOUNT_SNAPSHOT',
    ACCOUNT_TRANSACTION = 'ACCOUNT_TRANSACTION',
    ACCOUNT_TRANSFER_REQUEST = 'ACCOUNT_TRANSFER_REQUEST',
    TOPUP_NUMBER = 'TOPUP_NUMBER',
    TOPUP_DEVICE = 'TOPUP_DEVICE',
    INVENTORY_TRANSFER = 'INVENTORY_TRANSFER',
    INVENTORY_TRANSFER_ITEM = 'INVENTORY_TRANSFER_ITEM',
    GLOBAL_PRODUCT = 'GLOBAL_PRODUCT',
    GLOBAL_PRODUCT_FRACTION = 'GLOBAL_PRODUCT_FRACTION',
    GLOBAL_PRODUCT_BARCODE = 'GLOBAL_PRODUCT_BARCODE',
    GLOBAL_PRODUCT_TAG = 'GLOBAL_PRODUCT_TAG',
    SALES_AGENT = 'SALES_AGENT',
    PO_PAYMENT_STORE_SNAPSHOT = 'PO_PAYMENT_STORE_SNAPSHOT',
    PO_PAYMENT_SUPPLIER_SNAPSHOT = 'PO_PAYMENT_SUPPLIER_SNAPSHOT',
    PO_RECEIVE_EVENT = 'PO_RECEIVE_EVENT',
    PRODUCT_EXPIRY = 'PRODUCT_EXPIRY',
    POS_SESSION_EVENT = 'POS_SESSION_EVENT',
    WEIGHTED_SALE = 'WEIGHTED_SALE',
    MERCHANT_WALLET_TRANSACTION = 'MERCHANT_WALLET_TRANSACTION',
    MERCHANT_WALLET_SNAPSHOT = 'MERCHANT_WALLET_SNAPSHOT',
    STORE_WALLET_TRANSACTION = 'STORE_WALLET_TRANSACTION',
    STORE_WALLET_SNAPSHOT = 'STORE_WALLET_SNAPSHOT',
    BILLING_RUN = 'BILLING_RUN',
    CUSTOMER_AGREEMENT_AUDIT = 'CUSTOMER_AGREEMENT_AUDIT',
    WHATSAPP_WEBHOOK_EVENT = 'WHATSAPP_WEBHOOK_EVENT',
    IFTTT_SMS_MESSAGE = 'IFTTT_SMS_MESSAGE',
    // Integrations with other POS systems (service-integrations).
    INTEGRATION = 'INTEGRATION',
    INTEGRATION_CONNECTION = 'INTEGRATION_CONNECTION',
    INTEGRATION_MAPPINGS = 'INTEGRATION_MAPPINGS',
    INTEGRATION_PRODUCT_LINK = 'INTEGRATION_PRODUCT_LINK',
    INTEGRATION_IMPORT_JOB = 'INTEGRATION_IMPORT_JOB',
    FAILED_EVENT = 'FAILED_EVENT',
    NOTIFICATION = 'NOTIFICATION',
    NOTIFICATION_RECIPIENT = 'NOTIFICATION_RECIPIENT',
    NOTIFICATION_SUBSCRIPTION = 'NOTIFICATION_SUBSCRIPTION',
    NOTIFICATION_SCHEDULE = 'NOTIFICATION_SCHEDULE',
    NOTIFICATION_MESSAGE_ID_COUNTER = 'NOTIFICATION_MESSAGE_ID_COUNTER',
    NOTIFICATION_DEDUPE = 'NOTIFICATION_DEDUPE',
    NOTIFICATION_CONTACT = 'NOTIFICATION_CONTACT',
    NOTIFICATION_CONTACT_VERIFICATION = 'NOTIFICATION_CONTACT_VERIFICATION',
    NOTIFICATION_USAGE = 'NOTIFICATION_USAGE',
    FX_RATE = 'FX_RATE',
    ADMIN_LOGIN_CHALLENGE = 'ADMIN_LOGIN_CHALLENGE',
    ADMIN_SESSION = 'ADMIN_SESSION',
    PLATFORM_FOUNDER = 'PLATFORM_FOUNDER',
    PLATFORM_EXPENSE = 'PLATFORM_EXPENSE',
    PLATFORM_INCOME = 'PLATFORM_INCOME',
    PERMISSION_VISIBILITY = 'PERMISSION_VISIBILITY',
    WHATSAPP_SETTINGS = 'WHATSAPP_SETTINGS',
    ANNOUNCEMENT = 'ANNOUNCEMENT',
    ATTACHMENT = 'ATTACHMENT',
    TASK = 'TASK',
    STOCK_ORDER = 'STOCK_ORDER',
    STOCK_TRANSFER = 'STOCK_TRANSFER'
}
export enum RelationshipTypes {
    MOTHER = 'MOTHER',
    CHILD = 'CHILD',
    INVENTORY_VARIANT = 'INVENTORY_VARIANT'
}
export enum DefaultPricingType {
    FIXED = 'FIXED',
    VARIABLE = 'VARIABLE'
}
export interface Paginated {
    cursor?: string | null | undefined;
    count: number;
}
export interface EmployeePage {
    employees: Employee[];
    cursor?: string;
    count: number;
}
export enum Form {
    SQUARE = 'SQUARE',
    CIRCLE = 'CIRCLE',
    SUN = 'SUN',
    OCTAGON = 'OCTAGON'
}
export enum Color {
    GREY = 'GREY',
    RED = 'RED',
    PINK = 'PINK',
    ORANGE = 'ORANGE',
    YELLOW = 'YELLOW',
    GREEN = 'GREEN',
    BLUE = 'BLUE',
    PURPLE = 'PURPLE'
}
export interface Component {
    variant_id: string;
    quantity: number;
}
export type UpdateAvailabilityPropsStore = {
    store_id: string;
    available_for_sale: boolean;
};
export type UpdateAvailabilityPropsVariant = {
    variant_id: string;
    item_id: string;
    stores: UpdateAvailabilityPropsStore[];
};
/**
 * Written by the versioned-write helper on every change (AGENTS.md §4.4.1).
 * Optional for backwards compatibility: rows written before an entity
 * migrated have no version (missing = 0) and no recorded actor.
 */
export interface Versioned {
    /** Incremented on every write; the history table keeps one row per version. */
    version?: number | null;
    /** Id of the user who made the latest change (`system:<service>` for jobs). */
    updated_by_id?: string | null;
    /** Name of the user who made the latest change. */
    updated_by_name?: string | null;
}
export interface Timestamps {
    /**
     * The ISO 8601 formatted date-time string indicating when this payment type was created.
     * @example "2020-03-25T19:55:23.077Z"
     */
    created_at: string;
    /**
     * The ISO 8601 formatted date-time string indicating when this payment type was last updated.
     * @example "2020-03-30T08:05:10.020Z"
     */
    updated_at: string;
    /**
     * The ISO 8601 formatted date-time string indicating when this payment type was deleted.
     * This field is optional and will be present only if the payment type has been deleted.
     * @example "2020-04-02T23:45:20.050Z"
     */
    deleted_at?: string | null;
    /**
     * Audit trail: id of the user who soft-deleted this record. Optional for
     * backwards compatibility with legacy rows that only have `deleted_at`.
     */
    deleted_by_id?: string | null;
    /**
     * Audit trail: display name of the user who soft-deleted this record.
     */
    deleted_by_name?: string | null;
    /**
     * The ISO 8601 formatted date-time string indicating when this record
     * was restored from a soft-delete. Mutually exclusive with `deleted_at`
     * by convention: writers clear the delete triplet when setting restore
     * fields (and vice versa). If both happen to exist, the read layer
     * keeps only whichever event happened most recently.
     */
    restored_at?: string | null;
    /**
     * Audit trail: id of the user who restored this record. Optional for
     * backwards compatibility with legacy rows that pre-date the restore
     * audit feature.
     */
    restored_by_id?: string | null;
    /**
     * Audit trail: display name of the user who restored this record.
     */
    restored_by_name?: string | null;
}
export type AuthUser = CustomerUserAttributes | MerchantUserAttributes | AdminUserAttributes;
export interface Employee extends Timestamps, Versioned {
    id: string;
    name: string;
    roles: string[];
    username: string;
    email: string;
    phone_number: string;
    stores: string[];
    merchant_id: string;
    is_active: boolean;
    is_inactive_since?: string;
    cognito_id: string | null | undefined;
    cognito_username: string | null | undefined;
    is_owner: boolean;
    auth_user?: MerchantUserAttributes;
    /** Set to true once the user's phone number has been verified via OTP. */
    is_number_verified?: boolean;
    /**
     * Interface language the user picked (web or POS), applied in every app.
     * Optional for backwards compatibility; missing = the merchant default.
     */
    language?: UiLanguage | null;
}
export interface EmployeeSummary {
    id: string;
    name: string;
}
export enum ErrorCodes {
    NOT_FOUND = 'NOT_FOUND',
    FORBIDDEN = 'FORBIDDEN',
    UNAUTHORIZED = 'UNAUTHORIZED',
    BAD_REQUEST = 'BAD_REQUEST',
    INVALID_PARAMETER = 'INVALID_PARAMETER',
    INVALID_REQUEST = 'INVALID_REQUEST',
    INVALID_COMMAND = 'INVALID_COMMAND',
    CONFLICTING_REQUEST = 'CONFLICTING_REQUEST',
    INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
    NO_RESPONSE = 'NO_RESPONSE'
}
export interface DateRange {
    to: string;
    from: string;
}
export enum ReceiptType {
    SALE = 'SALE',
    REFUND = 'REFUND'
}
export interface TotalMoneyRange {
    to: number;
    from: number;
}
export interface EventBusDto {
    data: any;
    metadata: Record<string, unknown>;
}
export enum ShopAndSmileEventSource {
    SHOP_AND_SMILE = 'shop-and-smile',
    SHOP_AND_SMILE_PRODUCTS = 'shop-and-smile.products',
    SHOP_AND_SMILE_INVENTORY = 'shop-and-smile.inventory',
    SHOP_AND_SMILE_RECEIPTS = 'shop-and-smile.receipts',
    SHOP_AND_SMILE_REPORTS = 'shop-and-smile.reports',
    SHOP_AND_SMILE_USERS = 'shop-and-smile.users',
    SHOP_AND_SMILE_CUSTOMERS = 'shop-and-smile.customers',
    SHOP_AND_SMILE_PAYMENTS = 'shop-and-smile.payments',
    SHOP_AND_SMILE_LOYALTY = 'shop-and-smile.loyalty',
    SHOP_AND_SMILE_DEBTS = 'shop-and-smile.debts',
    SHOP_AND_SMILE_PURCHASE_ORDERS = 'shop-and-smile.purchase-orders',
    SHOP_AND_SMILE_SUPPLIERS = 'shop-and-smile.suppliers',
    SHOP_AND_SMILE_STORES = 'shop-and-smile.stores',
    SHOP_AND_SMILE_SHIFTS = 'shop-and-smile.shifts',
    SHOP_AND_SMILE_NOTIFICATIONS = 'shop-and-smile.notifications'
}
export interface PaginationParams {
    cursor?: string | null | undefined;
    limit?: number;
}
export interface UploadImageToItemProps {
    item_id: string;
    image_url: string;
}
export interface Connection {
    entityId: string;
    entityType: EntityTypes;
    connectionId: string;
    connected: boolean;
    stage: string;
    domainName: string;
}
export interface ConnectionItem extends Connection {
    PK: string;
    SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
    GSI1PK: string;
    GSI1SK: string;
}
export interface SSMParameterConfig {
    path: string;
    outputKey: string;
    description?: string;
    secure?: boolean;
}
// Define the user roles as an enum
export enum UserRole {
    MANAGER = 'MANAGER',
    ADMIN = 'ADMIN',
    WAITER = 'WAITER',
    SYSTEM = 'SYSTEM',
    CASHIER = 'CASHIER',
    RECEIPT_CHECKER = 'RECEIPT_CHECKER',
    INVENTORY_COUNTER = 'INVENTORY_COUNTER',
    SUPPLIER = 'SUPPLIER'
}
export enum PaymentName {
    CASH = 'Cash',
    DEBT = 'Debt',
    BANK_CARD = 'Bank Card',
    MOBILE_MONEY = 'Mobile Money',
    SPLIT = 'Split',
    OTHER = 'Other',
    EMOLA = 'Emola',
    MPEZA = 'Mpeza',
    MTN = 'MTN Mobile Money',
    AIRTEL = 'Airtel Money',
    TIGO = 'Tigo Pesa',
    ZAMTEL = 'Zamtel'
}
// Define the user interface
export interface User {
    name: string;
    surname: string;
    phonenumber: string;
    code: string;
    user_id: string;
    role: UserRole;
    auth_type?: AuthType;
    /** Set to true once the user's phone number has been verified via OTP. */
    is_number_verified?: boolean;
}
export interface CreateUserProps {
    name: string;
    surname: string;
    phonenumber?: string;
    code: string;
    role: UserRole;
    merchant_id: string;
    stores: string[];
}
export interface ReceiptQueryParams extends PaginationParams {
    receipt_numbers?: string;
    since_receipt_number?: string;
    before_receipt_number?: string;
    store_id?: string;
    order?: string;
    updated_at_min?: string;
    updated_at_max?: string;
    created_at_min?: string;
    created_at_max?: string;
}
export interface CommonEmployeeAsCreatorAttributes {
    creator_id: string;
    creator_type: EntityTypes;
    creator_name: string;
}
export interface UserStore {
    merchant_id: string;
    store_id: string;
    user_id: string;
}
export interface CognitoStoresAttribute extends Timestamps {
    stores: UserStore[];
}
export enum StringBoolean {
    TRUE = 'true',
    FALSE = 'false'
}
/**
 * Where the location coordinates persisted on a session/event came from.
 * - 'gps': captured by the client device via OS geolocation.
 * - 'ip': resolved server-side from the request source IP.
 * - 'unknown': neither path produced a coordinate.
 */
export type LocationSource = 'gps' | 'ip' | 'unknown';
export interface ChangedAttributes {
    [key: string]: {
        old: any;
        new: any;
    };
}
export enum SoftDeleteFlag {
    INCLUDE_DELETED = 'INCLUDE_DELETED',
    EXCLUDE_DELETED = 'EXCLUDE_DELETED'
}
export type LambdaFunctionLoggingStatus = {
    name: string;
    arn: string;
    loggingAllowed: boolean;
    /**
     * Source describing how loggingAllowed was derived.
     * - explicit_env: IS_LOGGING_ALLOWED env var was set on the function.
     * - stage_default: derived from stage defaults when env var absent.
     * - unknown: could not infer a source.
     */
    loggingSource: 'explicit_env' | 'stage_default' | 'unknown';
    rawLoggingValue: string | null;
    stage?: string;
};
export type LambdaFunctionsListResponse = {
    stage?: string;
    total: number;
    retrievedAt: string;
    functions: LambdaFunctionLoggingStatus[];
};
export type BulkLambdaLoggingRequest = {
    functions: string[];
    allow: boolean;
};
export type BulkLambdaLoggingResponse = {
    allow: boolean;
    requestedCount: number;
    updatedCount: number;
    failedCount: number;
    updated: LambdaFunctionLoggingStatus[];
    failed: {
        identifier: string;
        error: string;
    }[];
    status: 'completed' | 'completed_with_errors';
};
export type ToggleLoggingResponse = {
    allow: boolean;
    updatedCount: number;
    failedCount: number;
    updatedFunctions: string[];
    failedFunctions: {
        name: string;
        error: string;
    }[];
    status: 'completed' | 'completed_with_errors';
};
/**
 * The Shop and Smile Lite app script URL held in an environment-specific
 * SSM parameter. `url` is null when the parameter has not been created
 * for the stage yet.
 */
export type LiteAppUrlSettings = {
    stage: string;
    url: string | null;
    version: number | null;
    lastModifiedAt: string | null;
};
export type UpdateLiteAppUrlRequest = {
    url: string;
};
export interface DynamoDBItem {
    PK: string;
    SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
    GSI1PK?: string;
    GSI1SK?: string;
    GSI2PK?: string;
    GSI2SK?: string;
    GSI3PK?: string;
    GSI3SK?: string;
    GSI4PK?: string;
    GSI4SK?: string;
    GSI5PK?: string;
    GSI5SK?: string;
    GSI6PK?: string;
    GSI6SK?: string;
    GSI7PK?: string;
    GSI7SK?: string;
}
export interface AppBuild {
    version: string;
    releaseDate: string;
    platform: string;
    downloadUrl: string;
    archiveUrl: string;
    size: string;
    description: string;
    prerelease: boolean;
}
export interface AppBuildsResponse {
    android: AppBuild[];
    windows: AppBuild[];
    lite?: {
        android: AppBuild[];
        windows: AppBuild[];
    };
    // The Back Office wrapper ships for Android only
    backoffice?: {
        android: AppBuild[];
    };
}
export interface AndroidVersionInfo {
    apkSize?: string;
    zipSize?: string;
    lastModified: Date;
}
export interface WindowsVersionInfo {
    exeSize?: string;
    zipSize?: string;
    lastModified: Date;
}
export interface ReleaseVersion {
    version: string;
    releaseDate: string;
    platform: string;
}
export interface ReleasesVersionsResponse {
    android: ReleaseVersion[];
    windows: ReleaseVersion[];
}
export enum Language {
    EN_US = 'en_US',
    PT_PT = 'pt_PT'
}
/**
 * Interface language a user can pick (BCP 47). The web apps support all of
 * them; the POS supports `en` and `pt-PT` and uses the merchant default for
 * the others.
 */
export enum UiLanguage {
    EN = 'en',
    FR = 'fr',
    PT_PT = 'pt-PT'
}

export enum ShiftCommandType {
    OPEN_SHIFT = 'OPEN_SHIFT',
    ADD_TRANSACTION = 'ADD_TRANSACTION',
    START_CLOSE = 'START_CLOSE',
    FINALIZE_CLOSE = 'FINALIZE_CLOSE',
    INSTANT_CLOSE = 'INSTANT_CLOSE',
    ADD_COMMENT = 'ADD_COMMENT',
    RECORD_CLOSE_AUDIT = 'RECORD_CLOSE_AUDIT'
}
/**
 * Stages tracked in the closing audit trail. Each step transition in the
 * CloseShiftStepper records one entry, plus a final FINALIZED entry written
 * by the instant-close use-case.
 */
export enum CloseShiftStepEvent {
    BALANCES_SUBMITTED = 'BALANCES_SUBMITTED',
    RECONCILED = 'RECONCILED',
    FINALIZED = 'FINALIZED'
}
/**
 * Enum representing shift statuses
 */
export enum ShiftStatus {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    PENDING_CLOSE = 'PENDING_CLOSE',
    NEEDS_ATTENTION = 'NEEDS_ATTENTION',
    CLOSED_WITH_VARIANCE = 'CLOSED_WITH_VARIANCE'
}
/**
 * Enum representing reconciliation result per payment method
 */
export enum ReconciliationStatus {
    BALANCED = 'BALANCED',
    SHORT = 'SHORT',
    OVER = 'OVER',
    UNRECONCILED = 'UNRECONCILED'
}
/**
 * Base shift interface
 */
export interface Shift extends Timestamps, Versioned {
    id: string;
    pos_id?: string | null | undefined;
    status: ShiftStatus;
    // Opening details
    opened_at: string;
    opened_by: string;
    opened_by_name: string;
    opened_user_type: EntityTypes;
    opening_note?: string | null | undefined;
    // Closing details
    /**
     * Set the FIRST time an operator submits closing balances from the
     * CloseShiftStepper (step 1 → Reconcile). Never overwritten.
     * Together with `closed_at`, this brackets the "during close" session
     * window; transactions created/reversed in this interval are the
     * forgotten-transactions the operator reconciled against while closing.
     */
    closing_started_at?: string | null | undefined;
    closed_at?: string | null | undefined;
    closed_by?: string | null | undefined;
    closed_by_name?: string | null | undefined;
    closed_user_type?: EntityTypes;
    closing_note?: string | null | undefined;
    // Multi-payment balances
    opening_balances: ShiftReportPaymentMethod[];
    closing_balances?: ShiftReportPaymentMethodWithReconciliation[];
    // Metadata
    merchant_id: string;
    store_id: string;
    comments: ShiftComment[];
    closing_attempts: (CloseShiftAttempt | CloseShiftWithReconciliation)[];
    /**
     * Append-only audit trail of every step the operator passed through in the
     * close-shift stepper, including the final FINALIZED entry written when the
     * instant-close API is invoked. Captures what the operator entered, what
     * the server expected at that moment, the per-method differences, and the
     * ids of any transactions created or reversed during the closing session.
     */
    closing_audit_trail: ClosingAuditTrailEntry[];
}
export interface ClosingAuditTrailActor {
    id: string;
    name: string;
    type: EntityTypes;
}
export interface ClosingAuditTrailExpectedBalance {
    payment_method_id: string;
    payment_method_name: string;
    payment_method_type: PaymentMethodType;
    expected_amount: number;
}
export interface ClosingAuditTrailDifference {
    payment_method_id: string;
    difference: number;
    reconciliation_status: ReconciliationStatus;
}
export interface ClosingAuditTrailEntry extends Timestamps {
    id: string;
    event: CloseShiftStepEvent;
    recorded_at: string;
    actor: ClosingAuditTrailActor;
    /** Balances the operator typed at this step. */
    entered_balances: PaymentBalance[];
    /** Server-computed expected balance per payment method at the moment. */
    expected_balances: ClosingAuditTrailExpectedBalance[];
    /** Cached differences (actual - expected) and per-method reconciliation status. */
    differences: ClosingAuditTrailDifference[];
    /**
     * Account-transaction ids created or reversed since `closing_started_at`.
     * Empty on the very first BALANCES_SUBMITTED event (when
     * `closing_started_at` is being stamped).
     */
    session_transaction_ids?: string[] | null | undefined;
    client_step_index: number;
    note?: string | null | undefined;
}
/**
 * Request body for POST /shifts/{merchant_id}/{store_id}/{shift_id}/close/audit.
 * Server fills in `id`, `recorded_at`, `expected_balances`, `differences`, and
 * resolves `session_transaction_ids` from `closing_started_at`.
 */
export interface RecordCloseAuditEntry {
    event: CloseShiftStepEvent;
    actor: ClosingAuditTrailActor;
    entered_balances: PaymentBalance[];
    client_step_index: number;
    note?: string | null | undefined;
}
export interface CloseShiftAttempt extends AttemptToCloseShift, Timestamps {
}
export interface ShiftReportPaymentMethod extends Timestamps {
    payment_method_id: string;
    payment_method_name: string;
    payment_method_type: PaymentMethodType;
    opening_balance: number;
    note?: string | null | undefined;
}
export interface ShiftComment extends Timestamps {
    id: string;
    shift_id: string;
    user_id: string;
    user_name: string;
    user_type: EntityTypes;
    comment: string;
}
export interface ShiftReportPaymentMethodWithReconciliation extends ShiftReportPaymentMethod {
    reconciliation_status: ReconciliationStatus;
    reconciliation_note?: string | null | undefined;
    total_inflows: number;
    total_outflows: number;
    expected_balance: number;
    actual_balance: number;
    difference: number;
    verified_by?: string | null | undefined;
    verified_by_name?: string | null | undefined;
    verified_user_type?: EntityTypes;
}
export interface ShiftPage {
    shifts: Shift[];
    count: number;
    cursor?: string | null | undefined;
}
export interface CreateShift {
    pos_id?: string | null | undefined;
    opening_balances: PaymentBalance[];
    opening_note?: string | null | undefined;
    merchant_id: string;
    store_id: string;
    opened_by: string;
    opened_by_name: string;
    opened_user_type: EntityTypes;
}
export interface PaymentBalance {
    payment_method_id: string;
    payment_method_name: string;
    payment_method_type: PaymentMethodType;
    balance: number;
    note?: string | null | undefined;
}
export interface AttemptToCloseShift {
    closing_balances: PaymentBalance[];
    closing_note?: string | null | undefined;
    closed_by: string;
    closed_by_name: string;
    closed_user_type: EntityTypes;
}
export interface CloseShiftWithReconciliation {
    reconciliations: PaymentBalance[];
    note?: string | null | undefined;
    verified_by: string;
    verified_by_name: string;
    verified_user_type: EntityTypes;
    force_close: boolean;
}
export interface InstantCloseShift {
    closing_balances: PaymentBalance[];
    closed_by: string;
    closed_by_name: string;
    closed_user_type: EntityTypes;
    reason: string;
}
export interface AddShiftComment {
    shift_id: string;
    user_id: string;
    user_name: string;
    user_type: EntityTypes;
    comment: string;
    merchant_id: string;
    store_id: string;
}
export interface ShiftDbItem extends Shift {
    PK: string; // STORE#<store_id>
    SK: string; // SHIFT#<shift_id>
    GSI1PK: string; // <opened_user_type>#<opened_by>
    GSI1SK: string; // SHIFT#<opened_at>
    GSI2PK?: string; // POS_DEVICE#<pos_id>
    GSI2SK?: string; // SHIFT#<opened_at>
    GSI3PK: string; // SHIFT_STATUS#<status>
    GSI3SK: string; // SHIFT#<opened_at>
    EntityIndexPK: string; // SHIFT
    EntityIndexSK: string; // MERCHANT#<merchant_id>#STORE#<store_id>#DATE#<created_at>
}
export interface GetShifts {
    store_id: string;
    merchant_id: string;
    cursor?: string | null | undefined;
    limit?: number;
    status?: ShiftStatus;
    opened_by?: string | null | undefined;
    opened_user_type?: EntityTypes;
    pos_id?: string | null | undefined;
    from?: string | null | undefined;
    to?: string | null | undefined;
    by_date_range?: boolean;
    by_status?: boolean;
    by_status_and_date_range?: boolean;
    by_user?: boolean;
    by_user_and_date_range?: boolean;
    by_pos?: boolean;
    by_pos_and_date_range?: boolean;
    by_store?: boolean;
    by_store_and_date_range?: boolean;
}
/**
 * PDF shift-report stored in S3 and listed in the Reports ? Downloads page.
 * Generated server-side either on demand or automatically when a shift moves
 * to a terminal status (CLOSED / CLOSED_WITH_VARIANCE).
 */
export type ShiftReportTrigger = 'manual' | 'auto-on-close';
export interface ShiftReportRecord {
    /** S3 object key. */
    key: string;
    /** Human-friendly file name (yymmddhhmm-shift-report-{store}-{employee}.pdf). */
    file_name: string;
    shift_id: string;
    merchant_id: string;
    store_id: string;
    store_name: string;
    employee_name: string;
    shift_status: ShiftStatus;
    /** ISO timestamp the shift was closed. */
    closed_at: string;
    /** ISO timestamp the report was generated. */
    requested_at: string;
    triggered_by: ShiftReportTrigger;
    download_url: string;
    requested_by?: string | null | undefined;
    size_in_bytes?: number;
    last_modified?: string;
}
export interface ShiftReportsResponse {
    reports: ShiftReportRecord[];
    next_cursor?: string;
}
export interface GenerateShiftReportRequest {
    /** Force regeneration even if an existing report is found in S3. */
    force?: boolean;
}
export interface GenerateShiftReportResponse {
    record: ShiftReportRecord;
    /** True when the report was rendered and uploaded; false when an existing object was reused. */
    created: boolean;
}
/**
 * Detail of the EventBridge shift.closed event emitted by service-shifts
 * after a shift transitions to a terminal status. Consumed by service-reports
 * to auto-generate the PDF shift report.
 */
export enum ShiftEvents {
    SHIFT_CLOSED = 'shift.closed'
}
export interface ShiftClosedEventDetail {
    shift_id: string;
    merchant_id: string;
    store_id: string;
    status: ShiftStatus;
    closed_at: string;
    closed_by?: string | null | undefined;
    closed_by_name?: string | null | undefined;
}

/**
 * Orders & Transfers, PR 6 (docs/plans/orders-and-transfers.md §4.3, §4.4).
 * A store orders stock (`StockOrder`); a planner allocates it to source
 * stores, each allocation becoming a `StockTransfer` whose stock moves go
 * through service-inventory's operations, with a durable intent per move.
 * Quantities are in the product's parent unit.
 */
// ─── Stock orders ───────────────────────────────────────────────────────────
export enum StockOrderStatus {
    /** Waiting to be planned. */
    SUBMITTED = 'SUBMITTED',
    /** Part of the demand is allocated to transfers. */
    PARTIALLY_PLANNED = 'PARTIALLY_PLANNED',
    /** Every line is allocated (or cancelled). */
    PLANNED = 'PLANNED',
    /** Cancelled before anything was dispatched. */
    CANCELLED = 'CANCELLED'
}
export interface StockOrderLine {
    line_id: string;
    product_id: string;
    product_name: string;
    /** What the store asked for; never changed. */
    requested: number;
    /** Allocated to transfers so far. */
    allocated: number;
    /** Released from the demand (cancelled transfers keep it allocated = 0). */
    cancelled: number;
    /** What the user typed, when entered in a fraction. */
    entered_quantity?: number;
    entered_fraction_id?: string;
    /** Snapshot of the fraction (child units per parent) at entry. */
    fraction_factor?: number;
}
export interface StockOrderAllocation {
    allocation_id: string;
    /** STORE only until supplier allocations (PR 8). */
    source_type: 'STORE';
    source_store_id: string;
    transfer_id: string;
    lines: {
        line_id: string;
        quantity: number;
    }[];
    /** The plan request (Idempotency-Key) that made it: a retry resumes it. */
    request_id?: string;
    created_at: string;
    created_by_id: string;
    created_by_name: string;
}
/** An explicit change of an order's demand (§4.4), kept for the audit. */
export interface StockOrderRevision {
    revision_id: string;
    /** The request (user + Idempotency-Key) that made it: a retry resumes. */
    request_id?: string;
    revised_at: string;
    revised_by_id: string;
    revised_by_name: string;
    reason: string;
    lines: {
        line_id: string;
        product_id: string;
        product_name: string;
        /** 0 for a line the revision added. */
        old_requested: number;
        new_requested: number;
    }[];
}
export interface StockOrder extends Timestamps, Versioned {
    id: string;
    /** Human reference, e.g. `O-01JD3…` (last 6 of the id). */
    reference: string;
    merchant_id: string;
    /** The ordering (destination) store. */
    store_id: string;
    status: StockOrderStatus;
    lines: StockOrderLine[];
    allocations: StockOrderAllocation[];
    note?: string;
    /** When the order entered the state it waits in (task waiting time). */
    actionable_since?: string;
    /** Demand revisions, oldest first (PR 6b). Optional; missing = none. */
    revisions?: StockOrderRevision[];
    /**
     * Ageing (PR 6b): the reminder task is published at `remind_at` (80 %),
     * and at `expires_at` undispatched transfers are cancelled and the rest
     * of the demand closed. Optional; missing on orders created before 6b
     * (they never expire).
     */
    expires_at?: string;
    remind_at?: string;
    /**
     * When the reminder task was opened; moved forward when ageing restarts
     * (a cancel undone, demand added back) so the task opens again.
     */
    reminded_at?: string;
    /**
     * When the expiry started: from then on the order takes no plan and its
     * transfers no dispatch (`EXPIRED` is the reason of an expired order that
     * is CANCELLED because nothing had left a source).
     */
    expired_at?: string;
    /** When ageing ended: the expiry finished, or nothing was left to expire. */
    ageing_done_at?: string;
    /**
     * Close balance (PR 7, `orders:order.close`): the demand left was closed
     * without supplying it. Optional; missing = never closed.
     */
    balance_closed_at?: string;
    balance_closed_by_id?: string;
    balance_closed_by_name?: string;
    balance_close_reason?: string;
    /**
     * Set when a cancel starts: no plan or dispatch is accepted from then on,
     * so every transfer of the order can be cancelled before it closes.
     */
    cancel_requested_at?: string;
    cancelled_at?: string;
    cancel_reason?: string;
    created_by_id: string;
    created_by_name: string;
}
export interface CreateStockOrderLine {
    product_id: string;
    /** Parent units; with `entered_*` the server converts from the fraction. */
    quantity: number;
    entered_quantity?: number;
    entered_fraction_id?: string;
}
/** `POST /inventory-transfers/{merchant_id}/stock-orders` */
export interface CreateStockOrder {
    store_id: string;
    lines: CreateStockOrderLine[];
    note?: string;
}
export interface PlanStockOrderAllocation {
    source_store_id: string;
    lines: {
        line_id: string;
        quantity: number;
    }[];
}
/** `POST …/stock-orders/{order_id}/plan`: one transfer per source store. */
export interface PlanStockOrder {
    allocations: PlanStockOrderAllocation[];
}
/** `POST …/stock-orders/{order_id}/revise` (`orders:order.edit_any`). */
export interface ReviseStockOrder {
    reason: string;
    /** New requested quantities (parent units), never below what is allocated. */
    lines?: {
        line_id: string;
        requested: number;
    }[];
    /** Products added to the order. */
    add_lines?: CreateStockOrderLine[];
}
/** `POST …/stock-orders/{order_id}/cancel` */
export interface CancelStockOrder {
    reason: string;
}
// ─── Transfers ──────────────────────────────────────────────────────────────
export enum TransferLogisticsStatus {
    /** Stock reserved at the source. */
    AUTHORIZED = 'AUTHORIZED',
    /** Counted and packed at the source; the reservation stays (PR 6b). */
    PREPARED = 'PREPARED',
    DISPATCHED = 'DISPATCHED',
    RECEIVED = 'RECEIVED',
    /** Cancelled before dispatch; the reservation released. */
    CANCELLED = 'CANCELLED'
}
export enum TransferReconciliationStatus {
    NOT_REQUIRED = 'NOT_REQUIRED',
    /** Units are unresolved (rejected, missing, no space): settled in PR 7. */
    OPEN = 'OPEN',
    RESOLVED = 'RESOLVED'
}
export enum TransferValuationStatus {
    NOT_REQUIRED = 'NOT_REQUIRED',
    /** Received into PENDING, waiting for price approval (PR 7). */
    PENDING = 'PENDING',
    APPROVED = 'APPROVED'
}
/** Derived from the three dimensions; drives lists and the UI. */
export enum TransferOverallStatus {
    TO_DISPATCH = 'TO_DISPATCH',
    IN_TRANSIT = 'IN_TRANSIT',
    TO_RESOLVE = 'TO_RESOLVE',
    CLOSED = 'CLOSED',
    CANCELLED = 'CANCELLED'
}
/** Who holds unresolved units (§4.4). */
export enum TransferCustody {
    DRIVER = 'DRIVER',
    DESTINATION = 'DESTINATION',
    RETURNING = 'RETURNING',
    UNKNOWN = 'UNKNOWN'
}
/** Who holds each kind of unresolved units; a missing kind is UNKNOWN. */
export interface TransferUnresolvedCustody {
    rejected_awaiting_return?: TransferCustody;
    missing_awaiting_settlement?: TransferCustody;
    no_space_awaiting_redirect?: TransferCustody;
    return_shortage_awaiting_settlement?: TransferCustody;
}
/** Units of a line that are not settled yet, by reason. */
export interface TransferUnresolved {
    rejected_awaiting_return: number;
    missing_awaiting_settlement: number;
    no_space_awaiting_redirect: number;
    return_shortage_awaiting_settlement: number;
}
export interface StockTransferLine {
    /** The order line it supplies. */
    line_id: string;
    product_id: string;
    product_name: string;
    /** Reserved at the source by the plan. */
    authorized: number;
    /** Counted and packed (PREPARED); the dispatch defaults to it. */
    prepared?: number;
    /** Dispatch record, immutable once written. */
    dispatched?: number;
    /** Source cost per unit at dispatch (moves with the goods). */
    unit_cost?: number;
    /** Why less than authorized was dispatched. */
    shortfall_reason?: string;
    // Dispositions: dispatched = accepted + returned_good + returned_blocked
    // + written_off + redirected + Σ unresolved (checked after every write).
    accepted?: number;
    /** More than dispatched, received into BLOCKED for validation. */
    extra_received?: number;
    returned_good?: number;
    returned_blocked?: number;
    written_off?: number;
    redirected?: number;
    unresolved?: TransferUnresolved;
    /** Who holds each kind of unresolved units (PR 6b). Missing = UNKNOWN. */
    unresolved_custody?: TransferUnresolvedCustody;
    /**
     * Accepted units received into PENDING, waiting for price approval
     * (PR 7). Part of `accepted`. Missing = 0.
     */
    pending_approval?: number;
    /** What the owner decided for `extra_received` (PR 7). Missing = open. */
    extra_resolution?: TransferExtraResolution;
    /** The approved price, and the owner's cost if one was set (PR 7). */
    price_approval?: TransferLinePriceApproval;
}
export enum TransferExtraResolution {
    /** The source sent them unrecorded: taken off its stock, kept here. */
    VALIDATED = 'VALIDATED',
    /** Not really received: written off the destination's blocked stock. */
    DISCARDED = 'DISCARDED'
}
export interface TransferLinePriceApproval {
    price: number;
    /** The owner's cost per unit; missing = the carried cost stays. */
    cost?: number;
    /** (cost − carried cost) × units approved; 0 or missing = none. */
    valuation_adjustment?: number;
    /**
     * Products refused the price (a deleted product, a min/max rule): the
     * stock moved; the price must be set by hand. Missing = written.
     */
    price_write_error?: string;
}
export enum StockOperationIntentStep {
    RESERVE = 'RESERVE',
    RELEASE = 'RELEASE',
    DISPATCH = 'DISPATCH',
    RECEIVE = 'RECEIVE',
    RECEIVE_EXTRA = 'RECEIVE_EXTRA',
    // PR 7
    /** Returned goods counted good at the source → AVAILABLE. */
    RETURN_GOOD = 'RETURN_GOOD',
    /** Returned goods counted damaged at the source → BLOCKED. */
    RETURN_DAMAGED = 'RETURN_DAMAGED',
    /** Missing or short units found at the source → AVAILABLE. */
    FOUND = 'FOUND',
    /** Extra units validated: off the source's stock. */
    EXTRA_SOURCE = 'EXTRA_SOURCE',
    /** Extra units validated: BLOCKED → AVAILABLE at the destination. */
    EXTRA_ACCEPT = 'EXTRA_ACCEPT',
    /** Extra units discarded: off the destination's BLOCKED stock. */
    EXTRA_DISCARD = 'EXTRA_DISCARD',
    /** Price approved: PENDING → AVAILABLE at the destination. */
    PRICE_APPROVE = 'PRICE_APPROVE'
}
export enum StockOperationIntentStatus {
    /** Claimed with the transition; the operation may or may not be applied. */
    PENDING = 'PENDING',
    /** Applied and written back to the transfer. */
    FINALIZED = 'FINALIZED'
}
/**
 * One stock move of a transfer step (§4.3 saga). Written PENDING with the
 * step's transition, then FINALIZED with its result; the recovery worker
 * replays PENDING intents (the operation is idempotent by `operation_id`).
 */
export interface StockOperationIntent {
    operation_id: string;
    line_id: string;
    step: StockOperationIntentStep;
    status: StockOperationIntentStatus;
    store_id: string;
    product_id: string;
    quantity: number;
    /** DISPATCH: the line's reservation freed with it. */
    reserved_quantity?: number;
    /** RECEIVE: the carried cost per unit. */
    unit_cost?: number;
    /** RECEIVE: PENDING when the price waits for approval (PR 7); missing = AVAILABLE. */
    to_bucket?: StockBucket;
    /** PRICE_APPROVE with an owner cost: the cost the goods were carried at. */
    carried_unit_cost?: number;
    attempts: number;
    created_at: string;
    finalized_at?: string;
    /** DISPATCH: the source cost the operation recorded. */
    result_unit_cost?: number;
}
export interface TransferPreparationRecord {
    prepared_at: string;
    prepared_by_id: string;
    prepared_by_name: string;
}
export interface TransferDispatchRecord {
    dispatched_at: string;
    dispatched_by_id: string;
    dispatched_by_name: string;
    driver_name?: string;
    vehicle_plate?: string;
    /** VERIFIED signature attachments (§4.8). */
    signature_attachment_ids?: string[];
}
export interface TransferReceiptRecord {
    received_at: string;
    received_by_id: string;
    received_by_name: string;
    note?: string;
    signature_attachment_ids?: string[];
}
export interface StockTransfer extends Timestamps, Versioned {
    id: string;
    /** Human reference, e.g. `T-01JD3…`. */
    reference: string;
    merchant_id: string;
    stock_order_id: string;
    source_store_id: string;
    destination_store_id: string;
    /** Destination: what the Activity Timeline scopes it by. */
    store_id: string;
    logistics_status: TransferLogisticsStatus;
    reconciliation_status: TransferReconciliationStatus;
    valuation_status: TransferValuationStatus;
    lines: StockTransferLine[];
    preparation?: TransferPreparationRecord;
    dispatch?: TransferDispatchRecord;
    receipt?: TransferReceiptRecord;
    stock_operation_intents: StockOperationIntent[];
    /**
     * Set from a step's claim until all its follow-ups are done: its stock
     * operations, the demand given back to the order (cancel) and its tasks.
     * The recovery worker's index.
     */
    follow_up_since?: string;
    /** A cancel's demand is still to be given back to the order. */
    demand_return_pending?: boolean;
    /** The task list still has to learn this step. */
    tasks_pending?: boolean;
    actionable_since?: string;
    cancelled_at?: string;
    cancel_reason?: string;
    /** Redirect (PR 7): the transfer this one was split from. */
    parent_transfer_id?: string;
    child_transfer_ids?: string[];
    // PR 7, all optional (transfers of PR 6 have none).
    /** When units were last sent back to the source (custody RETURNING). */
    return_requested_at?: string;
    /** When the source last checked returned goods. */
    returned_at?: string;
    /** When every unresolved unit and extra was settled. */
    reconciled_at?: string;
    /** Decisions taken on differences, oldest first (audit). */
    settlements?: TransferSettlementRecord[];
    price_approval?: TransferPriceApprovalRecord;
    /** The approved selling prices are still to be written (a follow-up). */
    price_update_pending?: boolean;
    created_by_id: string;
    created_by_name: string;
}
/** A transfer with units out of every store's stock (in transit, §4.3). */
export interface InTransitTransfer {
    transfer_id: string;
    reference: string;
    source_store_id: string;
    destination_store_id: string;
    /** IN_TRANSIT (on its way) or TO_RESOLVE (differences to settle). */
    overall_status: TransferOverallStatus;
    dispatched_at?: string;
    /** Products with units in transit. */
    products: number;
    units: number;
    /** At the dispatch cost; missing without `orders:costs.view`. */
    value?: number;
}
export interface InTransitSide {
    units: number;
    /** Missing without `orders:costs.view`. */
    value?: number;
    transfers: InTransitTransfer[];
}
/**
 * `GET {merchant_id}/stores/{store_id}/in-transit`: units dispatched and
 * not yet in any store's stock, as of now (no history). Outgoing: sent by
 * the store, not delivered, returned or settled yet. Incoming: on their way
 * to the store. Neither is in the store's inventory value.
 */
export interface StoreInTransit {
    store_id: string;
    as_of: string;
    outgoing: InTransitSide;
    incoming: InTransitSide;
}
export interface DispatchTransferLine {
    line_id: string;
    /** May be 0; less than authorized needs a shortfall reason. */
    quantity: number;
    shortfall_reason?: string;
}
/** `POST …/transfers/{transfer_id}/prepare` (AUTHORIZED or PREPARED). */
export interface PrepareTransfer {
    lines: DispatchTransferLine[];
}
/** `POST …/transfers/{transfer_id}/dispatch` */
export interface DispatchTransfer {
    lines: DispatchTransferLine[];
    driver_name?: string;
    vehicle_plate?: string;
    signature_attachment_ids?: string[];
}
export interface ReceiveTransferLine {
    line_id: string;
    accepted: number;
    rejected?: number;
    missing?: number;
    no_space?: number;
    /** Units beyond what was dispatched, held for validation. */
    extra?: number;
}
/** `POST …/transfers/{transfer_id}/receive` */
export interface ReceiveTransfer {
    lines: ReceiveTransferLine[];
    note?: string;
    signature_attachment_ids?: string[];
}
export interface TransferSettlementRecord {
    kind: 'SEND_BACK' | 'RETURN_CHECK' | 'SETTLE' | 'REDIRECT';
    at: string;
    by_id: string;
    by_name: string;
    note?: string;
    /** REDIRECT: the transfer that carries the units on. */
    child_transfer_id?: string;
    /** REDIRECT: the request that made it, so a retry resumes it. */
    request_id?: string;
    /** RETURN_CHECK: the verified signatures of the check. */
    signature_attachment_ids?: string[];
    lines: {
        line_id: string;
        [what: string]: number | string;
    }[];
}
export interface TransferPriceApprovalRecord {
    approved_at: string;
    approved_by_id: string;
    approved_by_name: string;
}
/**
 * `POST …/transfers/{transfer_id}/send-back` (`orders:transfer.receive` at
 * the destination): rejected units, and no-space units still with the
 * driver, start their way back to the source (custody RETURNING).
 */
export interface SendBackTransfer {
    lines: {
        line_id: string;
        rejected?: boolean;
        no_space?: boolean;
    }[];
    note?: string;
}
/**
 * `POST …/transfers/{transfer_id}/return-check` (`orders:transfer.return`
 * at the source): of the units on their way back, `good` → AVAILABLE,
 * `damaged` → BLOCKED; the rest is a return shortage to settle.
 */
export interface ReturnCheckTransfer {
    lines: {
        line_id: string;
        good: number;
        damaged: number;
    }[];
    note?: string;
    signature_attachment_ids?: string[];
}
export enum SettleExtraDecision {
    VALIDATE = 'VALIDATE',
    DISCARD = 'DISCARD'
}
/**
 * `POST …/transfers/{transfer_id}/settle` (`orders:transfer.reconcile` at
 * both stores). Per line, all of a reason at once: missing units lost or
 * found at the source, a return shortage likewise, extras validated or
 * discarded.
 */
export interface SettleTransfer {
    lines: {
        line_id: string;
        missing_lost?: number;
        missing_found?: number;
        shortage_lost?: number;
        shortage_found?: number;
        extra?: SettleExtraDecision;
    }[];
    note: string;
}
/**
 * `POST …/transfers/{transfer_id}/redirect` (`orders:transfer.redirect` at
 * both stores): no-space units still with the driver go on to another
 * store, as a child transfer born DISPATCHED.
 */
export interface RedirectTransfer {
    destination_store_id: string;
    lines: {
        line_id: string;
        quantity: number;
    }[];
    note?: string;
}
export interface RedirectResult {
    transfer: StockTransfer;
    child: StockTransfer;
}
/**
 * `POST …/transfers/{transfer_id}/approve-prices` (`orders:price.approve`
 * at the destination): every line waiting in PENDING gets its selling
 * price, and optionally the owner's cost.
 */
export interface ApproveTransferPrices {
    lines: {
        line_id: string;
        price: number;
        cost?: number;
    }[];
}
/**
 * `POST …/stock-orders/{order_id}/close` (`orders:order.close` in the
 * ordering store): the demand left is closed without supplying it.
 */
export interface CloseStockOrderBalance {
    reason: string;
}
/** `POST …/transfers/{transfer_id}/cancel` (before dispatch) */
export interface CancelTransfer {
    reason: string;
}
/** An order with its transfers, as the read routes return it. */
export interface StockOrderView {
    order: StockOrder;
    transfers: StockTransfer[];
}
export interface StockOrderPage {
    items: StockOrder[];
    cursor?: string;
}
export interface StockTransferPage {
    items: StockTransfer[];
    cursor?: string;
}
// ─── Flow drafts (PR 6b) ────────────────────────────────────────────────────
/** The multi-step flows whose progress is saved as a draft (§4.7). */
export enum FlowType {
    ORDER_CREATE = 'ORDER_CREATE',
    ORDER_PLAN = 'ORDER_PLAN',
    ORDER_REVISE = 'ORDER_REVISE',
    TRANSFER_PREPARE = 'TRANSFER_PREPARE',
    TRANSFER_DISPATCH = 'TRANSFER_DISPATCH',
    TRANSFER_RECEIVE = 'TRANSFER_RECEIVE'
}
/**
 * A user's unfinished flow (§4.4, §4.7): one per (user, flow, entity),
 * versioned (a save names the version it read; another tab's save makes it
 * 409), temporary (`expires_at`, not in history).
 */
export interface FlowDraft extends Timestamps, Versioned {
    id: string;
    merchant_id: string;
    store_id: string;
    principal_id: string;
    flow_type: FlowType;
    /** The order or transfer the flow works on; missing for a new order. */
    entity_id?: string;
    step: number;
    /** The flow's own state, as the web app keeps it (max 64 KB). */
    payload: Record<string, unknown>;
    expires_at: string;
}
/** `PUT …/drafts/{flow_type}/{entity_id|new}` */
export interface SaveFlowDraft {
    store_id: string;
    step: number;
    payload: Record<string, unknown>;
    /** The version read; null or missing for a new draft. */
    expected_version?: number | null;
    /**
     * The id of the draft read, with `expected_version`: a draft discarded
     * and created again starts at version 1 too, so the version alone could
     * let a stale tab overwrite it.
     */
    expected_id?: string | null;
}
export interface FlowDraftPage {
    items: FlowDraft[];
    cursor?: string;
}

export enum StoreEvents {
    STORE_CREATED = 'STORE_CREATED',
    STORE_FAVOURITE_UPSERTED = 'STORE_FAVOURITE_UPSERTED',
    STORE_FAVOURITE_DELETED = 'STORE_FAVOURITE_DELETED'
}
export interface StoreCreatedEvent {
    bus_name: string;
    source: ShopAndSmileEventSource;
    detail_type: StoreEvents.STORE_CREATED;
    detail: StoreCreatedEventDetail;
}
interface StoreCreatedEventDetail {
    filter?: Record<string, any>;
    data: StoreCreatedEventDetailData;
    metadata: StoreCreatedEventDetailMetadata;
}
export interface StoreCreatedEventDetailData {
    /**
     * The merchant's owner user at store-creation time. Absent when the
     * merchant has no owner yet — the event is still published so
     * downstream provisioning (e.g. pricing agreements) covers every store.
     */
    owner?: Employee | null;
    store: Store;
}
export interface StoreCreatedEventDetailMetadata extends ShopAndSmileEventMetadata {
}
export interface StoreFavouriteUpsertedEvent {
    bus_name: string;
    source: ShopAndSmileEventSource;
    detail_type: StoreEvents.STORE_FAVOURITE_UPSERTED;
    detail: {
        filter?: Record<string, any>;
        data: {
            favourite: StoreFavouriteCell;
        };
        metadata: ShopAndSmileEventMetadata;
    };
}
export interface StoreFavouriteDeletedEvent {
    bus_name: string;
    source: ShopAndSmileEventSource;
    detail_type: StoreEvents.STORE_FAVOURITE_DELETED;
    detail: {
        filter?: Record<string, any>;
        data: {
            merchant_id: string;
            store_id: string;
            page: number;
            position: number;
        };
        metadata: ShopAndSmileEventMetadata;
    };
}

export interface Store extends Timestamps, Versioned {
    id: string;
    name: string;
    address: string | null;
    city: string;
    region: string | null;
    postal_code: string | null;
    country_code: string;
    phone_number: string | null;
    description: string | null;
    merchant_id: string;
    contact_person: string;
    email: string | null;
    contact_person_phone_number: string;
    tax_number: string | null;
    store_prefix: string;
    note?: string | null;
    daily_count_target?: number;
    daily_count_enabled?: boolean;
    daily_count_recency_days?: number;
    /**
     * When true (default), uncounted items from the previous day's daily count
     * list are carried over into today's list. When false, each day's list is
     * generated fresh from the selection algorithm with no carry-over.
     */
    daily_count_carry_over_enabled?: boolean;
    hide_stock_when_counting?: boolean;
    /**
     * When true, operators closing a shift will not be shown the system-expected
     * money. They only see whether each payment method is BALANCED, OVER, or
     * SHORT and may add/reverse transactions during the close. The audit trail
     * server-side still records the actual numbers.
     */
    blind_shift_closing?: boolean;
    /**
     * Maximum outstanding balance (minor units) allowed for this store.
     * When null or undefined, no credit limit is enforced.
     * Invoices for stores exceeding this limit will be blocked.
     */
    credit_limit?: number | null;
    /**
     * When true, the full-screen overdue overlay is suppressed for this store
     * (inline alerts and countdowns still appear). Admins toggle this in the
     * Finance Control Center. Defaults to false (blocking enabled).
     */
    prevent_overdue_blocking?: boolean;
    /**
     * WhatsApp number of the store (E.164). Customers are redirected to this
     * number when they reply to store notifications.
     */
    whatsapp_number?: string | null;
    /**
     * When true, the POS lite mode is enabled for this store. Allows access
     * to the /lite route with a limited Products + Daily Count interface
     * intended for mobile/tablet use on the shop floor.
     */
    allow_limited_settings?: boolean;
    /**
     * When true, printed customer receipts omit the Subtotal and Discount
     * rows and show only the final total. Internal records and reports keep
     * the full gross / discount / net breakdown. Defaults to false.
     */
    hide_discounts_on_receipt?: boolean;
    /**
     * When true, every completed purchase-order line asks for the family's
     * selling prices once and stores a potential-profit estimate (min / max)
     * on the line. Optional for backwards compatibility; missing = false.
     */
    po_profit_estimation_enabled?: boolean;
    /**
     * What the location is (docs/plans/orders-and-transfers.md §4.2): a shop
     * that sells, or a warehouse that holds and ships stock. Optional for
     * backwards compatibility; missing = STORE (the repository reads it so).
     */
    location_type?: LocationType;
    /**
     * Up to 5 free labels (key → value, e.g. region → North) the location
     * switcher filters on. Optional for backwards compatibility; missing = none.
     */
    labels?: Record<string, string>;
}
/** What a location is. Billing treats a warehouse as a store for now. */
export enum LocationType {
    STORE = 'STORE',
    WAREHOUSE = 'WAREHOUSE'
}
/** At most this many labels per location. */
export const MAX_STORE_LABELS = 5;
export interface StorePage {
    stores: Store[];
    count: number;
    cursor?: string;
}
export interface CreateStore {
    name: string;
    merchant_id: string;
    contact_person: string;
    contact_person_phone_number: string;
    city: string;
    address?: string;
    region?: string;
    postal_code?: string;
    country_code?: string;
    phone_number?: string;
    description?: string;
    email?: string;
    tax_number?: string;
    whatsapp_number?: string | null;
    /** Missing = STORE. */
    location_type?: LocationType;
    labels?: Record<string, string>;
}
export interface UpdateStore {
    name?: string;
    contact_person?: string;
    contact_person_phone_number?: string;
    address?: string;
    city?: string;
    region?: string;
    postal_code?: string;
    country_code?: string;
    phone_number?: string;
    description?: string;
    email?: string;
    id: string;
    merchant_id: string;
    tax_number?: string;
    note?: string | null;
    daily_count_target?: number;
    daily_count_enabled?: boolean;
    daily_count_recency_days?: number;
    daily_count_carry_over_enabled?: boolean;
    hide_stock_when_counting?: boolean;
    blind_shift_closing?: boolean;
    prevent_overdue_blocking?: boolean;
    allow_limited_settings?: boolean;
    hide_discounts_on_receipt?: boolean;
    po_profit_estimation_enabled?: boolean;
    whatsapp_number?: string | null;
    location_type?: LocationType;
    /** Replaces every label; `{}` removes them all. */
    labels?: Record<string, string>;
}
export interface StoreDBItem extends Store {
    PK: string; // MERCHANT#{merchant_id}
    SK: string; // STORE#{store_id}
    EntityIndexPK: string; // STORE
    EntityIndexSK: string; // MERCHANT#{merchant_id}#DATE#{created_at}
}
export interface GetStoresByMerchantDto {
    merchant_id: string;
    cursor?: string;
    limit?: number;
    include_deleted?: SoftDeleteFlag;
}
/**
 * Family of scale that a `StoreScaleConfig` snapshot is for. The string
 * values match what the native POS persists in `ScaleSettings.scaleType`
 * (`ScaleType.name`) so a snapshot can be uploaded without remapping.
 *
 * `'shop_and_smile'` is a virtual family used by the POS app's
 * "Scale Mode" feature — it has no physical hardware and re-uses
 * the same `(parameters, shortcuts)` shape to persist label-printing
 * settings and a per-store shortcut grid.
 */
export type StoreScaleType = 'tm_xa' | 'tm_a' | 'shop_and_smile';
/**
 * One TMS / config-block parameter as understood by the connected scale.
 *
 * `id` is the wire-format index (TM-xA: 1..500 TMS parameter id;
 * TM-A: 0..23 config-block field index). `value` is the integer
 * payload that gets sent to the scale verbatim. `name` and
 * `description` come from the scale-bridge parameter catalogs and are
 * persisted alongside the value so the React admin and backups can
 * render a parameter without round-tripping through the device.
 */
export interface ScaleConfigParameter {
    id: number;
    name: string;
    description: string;
    value: number;
    category?: string;
}
/**
 * One PLU shortcut key on the scale's keypad. `page` is 0-based,
 * `position` is 1..63 (matches `ScaleShortcutMapping` on the native
 * side). `plu` is the PLU number as a string, or `'0'` for an
 * unassigned slot. The optional `name` / `description` carry
 * human-readable context (typically the product name) so the
 * React admin can render the layout without having to also fetch
 * the product catalog.
 */
export interface ScaleConfigShortcut {
    page: number;
    position: number;
    plu: string;
    name?: string;
    description?: string;
}
/**
 * The persistent backup of a store's scale provisioning. One snapshot
 * per `(store_id, scale_type)` — both `tm_xa` and `tm_a` can coexist
 * for the same store.
 */
export interface StoreScaleConfig extends Versioned {
    merchant_id: string;
    store_id: string;
    scale_type: StoreScaleType;
    parameters: ScaleConfigParameter[];
    shortcuts: ScaleConfigShortcut[];
    updated_at: string;
    updated_by?: string;
}
export interface StoreScaleConfigDBItem extends StoreScaleConfig {
    PK: string; // MERCHANT#{merchant_id}
    SK: string; // STORE#{store_id}#SCALE_CONFIG#{scale_type}
    EntityIndexPK: string; // STORE_SCALE_CONFIG
    EntityIndexSK: string; // MERCHANT#{merchant_id}#STORE#{store_id}#SCALE_TYPE#{scale_type}
}
/**
 * Request body for `PUT /stores/{merchant_id}/{store_id}/scale-config/{scale_type}`.
 * Path parameters override any matching field in the body.
 */
export interface PutStoreScaleConfig {
    merchant_id: string;
    store_id: string;
    scale_type: StoreScaleType;
    parameters: ScaleConfigParameter[];
    shortcuts: ScaleConfigShortcut[];
    updated_by?: string;
}
export interface GetStoreScaleConfigDto {
    merchant_id: string;
    store_id: string;
    scale_type: StoreScaleType;
}
export interface DeleteStoreScaleConfigDto {
    merchant_id: string;
    store_id: string;
    scale_type: StoreScaleType;
}
/**
 * Storage is intentionally minimal: only the product id and the
 * `(page, position)` coordinates are persisted. The cell's image,
 * name, unit and price are rendered live from the local
 * `StoreProduct` cache so backend product edits flow through
 * automatically.
 */
export interface StoreFavouriteCell extends Versioned {
    merchant_id: string;
    store_id: string;
    page: number;
    position: number;
    product_id: string;
    created_at: string;
    updated_at: string;
    updated_by?: string;
}
export interface StoreFavouriteCellDBItem extends StoreFavouriteCell {
    PK: string; // MERCHANT#{merchant_id}
    SK: string; // STORE#{store_id}#STORE_FAVOURITE_CELL#{page}#{position}
    EntityIndexPK: string; // STORE_FAVOURITE_CELL
    EntityIndexSK: string; // MERCHANT#{merchant_id}#STORE#{store_id}#PAGE#{page}#POSITION#{position}
}
export interface StoreFavouriteCellsPage {
    favourites: StoreFavouriteCell[];
    count: number;
}
/**
 * Request body for
 * `PUT /{merchant_id}/{store_id}/favourites/{page}/{position}`.
 * Path parameters override matching fields in the body.
 */
export interface PutStoreFavouriteCell {
    merchant_id: string;
    store_id: string;
    page: number;
    position: number;
    product_id: string;
    updated_by?: string;
}
export interface DeleteStoreFavouriteCellDto {
    merchant_id: string;
    store_id: string;
    page: number;
    position: number;
}
export interface GetStoreFavouriteCellsDto {
    merchant_id: string;
    store_id: string;
}
/**
 * One PLU shortcut cell on a scale's keypad, persisted per-cell so it
 * can be auto-synced from the native POS without having to re-upload
 * the whole `StoreScaleConfig` blob on every edit. Mirrors the
 * favourites-grid storage shape so the auto-sync pipeline can be
 * implemented with the same dirty/pendingDelete primitives.
 *
 * `plu` is the PLU number as a string. Empty / `'0'` slots are not
 * persisted — those cells are simply absent from the listing.
 */
export interface StoreScaleShortcut extends Versioned {
    merchant_id: string;
    store_id: string;
    scale_type: StoreScaleType;
    page: number;
    position: number;
    plu: string;
    name?: string;
    description?: string;
    created_at: string;
    updated_at: string;
    updated_by?: string;
}
export interface StoreScaleShortcutDBItem extends StoreScaleShortcut {
    PK: string; // MERCHANT#{merchant_id}
    SK: string; // STORE#{store_id}#STORE_SCALE_SHORTCUT#{scale_type}#{page}#{position}
    EntityIndexPK: string; // STORE_SCALE_SHORTCUT
    EntityIndexSK: string; // MERCHANT#{merchant_id}#STORE#{store_id}#SCALE_TYPE#{scale_type}#PAGE#{page}#POSITION#{position}
}
export interface StoreScaleShortcutsPage {
    shortcuts: StoreScaleShortcut[];
    count: number;
}
/**
 * Request body for
 * `PUT /{merchant_id}/{store_id}/scale-config/{scale_type}/shortcuts/{page}/{position}`.
 * Path parameters override matching fields in the body.
 */
export interface PutStoreScaleShortcut {
    merchant_id: string;
    store_id: string;
    scale_type: StoreScaleType;
    page: number;
    position: number;
    plu: string;
    name?: string;
    description?: string;
    updated_by?: string;
}
export interface DeleteStoreScaleShortcutDto {
    merchant_id: string;
    store_id: string;
    scale_type: StoreScaleType;
    page: number;
    position: number;
}
export interface ListStoreScaleShortcutsDto {
    merchant_id: string;
    store_id: string;
    scale_type: StoreScaleType;
}

export interface Supplier extends Timestamps, Versioned {
    id: string;
    name: string;
    contact?: string;
    email?: string;
    phone_number?: string;
    website?: string;
    address_1: string;
    address_2?: string;
    city?: string;
    region?: string;
    postal_code?: string;
    country_code?: string;
    note?: string;
    merchant_id: string;
}
export interface SupplierPage {
    cursor?: string;
    count?: number;
    suppliers: Supplier[];
}
export interface CreateSupplier {
    name: string;
    merchant_id: string;
    email?: string;
    phone_number?: string;
    website?: string;
    address_1?: string;
    address_2?: string;
    city?: string;
    region?: string;
    postal_code?: string;
    note?: string;
    country_code?: string;
    contact?: string;
}
export interface UpdateSupplier {
    id: string;
    name?: string;
    email?: string;
    phone_number?: string;
    website?: string;
    address_1?: string;
    address_2?: string;
    city?: string;
    region?: string;
    postal_code?: string;
    note?: string;
    country_code?: string;
    contact?: string;
}
export interface SupplierDBItem extends Supplier {
    PK: string; // SUPPLIER#id
    SK: string; // SUPPLIER#id
    GSI1PK: string; // MERCHANT#id
    GSI1SK: string; // SUPPLIER#id
    EntityIndexPK: string; // SUPPLIER
    EntityIndexSK: string; // MERCHANT#id#DATE#created_at
}
export interface GetSupplierById {
    id: string;
    include_deleted?: SoftDeleteFlag;
}
export interface GetSuppliers {
    merchant_id: string;
    cursor?: string;
    limit?: number;
    include_deleted?: SoftDeleteFlag;
}

/**
 * One task list for the whole system (docs/plans/orders-and-transfers.md
 * §4.13): what is waiting on someone in a store. Each type is described in
 * `TASK_TYPES`; add values, never rename or reuse them.
 */
export enum TaskType {
    /** An order waits to be planned (Orders & Transfers, PR 6). */
    ORDER_PLAN = 'ORDER_PLAN',
    /** A planned transfer waits to be dispatched by its source. */
    TRANSFER_DISPATCH = 'TRANSFER_DISPATCH',
    /** A dispatched transfer waits to be received by its destination. */
    TRANSFER_RECEIVE = 'TRANSFER_RECEIVE',
    /**
     * A stock change of a product could not be recorded: check its stock.
     * Done when the product is counted in the store.
     */
    INVENTORY_CHECK = 'INVENTORY_CHECK',
    /**
     * Created by a person for someone else (PR 5c): its title is `title`, it
     * is assigned to a person or a role, and the assignee ticks it.
     */
    MANUAL = 'MANUAL',
    /**
     * An order nears its expiry with demand or transfers still open (PR 6b):
     * for its requester. Done when it is planned and dispatched, cancelled
     * or expired.
     */
    ORDER_EXPIRING = 'ORDER_EXPIRING',
    /**
     * Sales took stock a reservation holds (reserved > on hand): for the
     * owner, to count or release. Done when the stock covers it again.
     */
    STOCK_OVERSOLD = 'STOCK_OVERSOLD',
    /** Goods sent back to a source wait for its return check (PR 7). */
    TRANSFER_RETURN = 'TRANSFER_RETURN',
    /** A received transfer has differences to decide (PR 7). */
    TRANSFER_SETTLE = 'TRANSFER_SETTLE',
    /** Received goods wait in pending for their price (PR 7). */
    PRICE_APPROVAL = 'PRICE_APPROVAL'
}
/** OPEN creates or reopens a task; DONE and WITHDRAWN close it. */
export enum TaskEventOp {
    OPEN = 'OPEN',
    DONE = 'DONE',
    WITHDRAWN = 'WITHDRAWN'
}
export enum TaskStatus {
    OPEN = 'OPEN',
    DONE = 'DONE',
    /** Its reason disappeared (the order was cancelled). */
    WITHDRAWN = 'WITHDRAWN'
}
/**
 * SYSTEM tasks are opened and closed by the service that owns the work;
 * MANUAL ones are created by a person and ticked by the assignee.
 */
export enum TaskOrigin {
    SYSTEM = 'SYSTEM',
    MANUAL = 'MANUAL'
}
/** Urgent tasks sort first with a red mark (and send WhatsApp when on). */
export enum TaskPriority {
    NORMAL = 'NORMAL',
    URGENT = 'URGENT'
}
/** MINE: the user's tasks; TEAM: every task of the store (`tasks:view_all`). */
export enum TaskScope {
    MINE = 'MINE',
    TEAM = 'TEAM'
}
/** Values filling a task type's title (e.g. `{ reference: 'T-0042' }`). */
export type TaskParams = Record<string, string | number>;
/**
 * Published by a producing service with `tryPublishTaskEvent` (backend-shared)
 * to the notifications topic (`category=TASK`). Idempotent by `source_key`:
 * an event older than the task's last `occurred_at` is ignored.
 */
export interface TaskEvent {
    op: TaskEventOp;
    type: TaskType;
    /** Stable per piece of work, e.g. `transfer:<id>:receive`. */
    source_key: string;
    merchant_id: string;
    store_id: string;
    params?: TaskParams;
    /**
     * Narrows the task to this one user (null: anyone holding the action).
     * Required on every event, closes included, so a close delivered before
     * its OPEN still knows who the task is for.
     */
    assignee_id: string | null;
    /** When the work entered (OPEN) or left (DONE, WITHDRAWN) its state. */
    occurred_at: string;
    /**
     * OPEN only: when the work entered the state it is waiting in (e.g. the
     * transfer's `actionable_since`), so an OPEN delivered out of order still
     * sets the right waiting time. Missing = `occurred_at` when the task
     * (re)opens, unchanged while it stays open.
     */
    waiting_since?: string;
    /** The user whose action caused the event. */
    actor?: TaskActor;
    /**
     * DONE or WITHDRAWN only: ignored unless the task is open, so a producer
     * may close tasks it never opened (every count closes the product's stock
     * check) without creating or re-closing one. Optional; missing = false.
     */
    only_if_open?: boolean;
}
export interface TaskActor {
    id: string;
    name: string;
}
/** A `TASK` item: PK `MERCHANT#<merchant_id>`, SK `TASK#<source_key>`. */
export interface Task extends Timestamps, Versioned {
    /** The `source_key`. */
    id: string;
    merchant_id: string;
    store_id: string;
    type: TaskType;
    origin: TaskOrigin;
    status: TaskStatus;
    /** Who sees it: holders of this action in the store (`TASK_TYPES`). */
    required_action: string;
    /** The app where the work is done (`TASK_TYPES`). */
    app: string;
    params?: TaskParams;
    assignee_id?: string;
    /** Manual tasks: the assignee's name, for the creator and the report. */
    assignee_name?: string;
    /**
     * Manual tasks: assigned to everyone holding this role in the store (the
     * first to tick it closes it for all). Never set with `assignee_id`.
     */
    assignee_role_id?: string;
    assignee_role_name?: string;
    /** Manual tasks: the short written title (required for MANUAL). */
    title?: string;
    description?: string;
    /** A VERIFIED AUDIO attachment (`entity_type: TASK`), at most 2 minutes. */
    audio_attachment_id?: string;
    /** VERIFIED photos or PDFs (`entity_type: TASK`). */
    attachment_ids?: string[];
    /** Overdue after it. */
    due_at?: string;
    /** Optional for backwards compatibility; missing = NORMAL. */
    priority?: TaskPriority;
    /** The note left by whoever ticked a manual task. */
    done_note?: string;
    /** When it last became OPEN. */
    waiting_since?: string;
    closed_at?: string;
    closed_by_id?: string;
    closed_by_name?: string;
    /** The newest event applied; older ones are ignored. */
    last_occurred_at: string;
    created_by_id: string;
    created_by_name: string;
}
/** `GET /notifications/tasks/{merchant_id}/stores/{store_id}` */
export interface GetTasks {
    merchant_id: string;
    store_id: string;
    /** The calling app: its tasks come first. */
    app?: string;
    /** Missing = MINE. TEAM needs `tasks:view_all` in the store. */
    scope?: TaskScope;
}
/** The signed-in user's tasks in one store. */
export interface TaskList {
    /** Open, this app's first, then oldest waiting first. */
    open: Task[];
    /** Closed in the last 24 hours, newest first. */
    recently_closed: Task[];
    /** More open tasks exist than the list holds. */
    has_more: boolean;
}
/** `GET /notifications/tasks/{merchant_id}/summary` */
export interface GetTaskSummary {
    merchant_id: string;
}
export interface StoreTaskSummary {
    store_id: string;
    /** Open tasks the user sees in this store. */
    open: number;
    /** A task the user sees closed here in the last 24 hours. */
    recently_closed: boolean;
}
/** Per store of the signed-in user: the badge and the "other stores" line. */
export interface TaskSummary {
    stores: StoreTaskSummary[];
    /**
     * Open manual tasks the user created (at most 100), for *Created by me*.
     * Optional for backwards compatibility; missing = 0.
     */
    created_open?: number;
}
/**
 * `POST /notifications/tasks/{merchant_id}` (`tasks:create`, Idempotency-Key):
 * a manual task for one person or one role of the store.
 */
export interface CreateTask {
    /**
     * A ULID made by the client before uploading the files, so they can be
     * attached to it (`entity_id`). The task's id is `manual:<id>`.
     */
    id: string;
    store_id: string;
    title: string;
    description?: string;
    audio_attachment_id?: string;
    attachment_ids?: string[];
    due_at?: string;
    /** Missing = NORMAL. */
    priority?: TaskPriority;
    /** Exactly one of `assignee_id` and `assignee_role_id`. */
    assignee_id?: string;
    assignee_role_id?: string;
}
/** `POST /notifications/tasks/{merchant_id}/{task_id}/done` (assignee or role member). */
export interface CompleteTask {
    note?: string;
}
/** `GET /notifications/tasks/{merchant_id}/created?cursor=`: the user's manual tasks. */
export interface GetCreatedTasks {
    merchant_id: string;
    cursor?: string;
}
/** Open ones first, newest first, then closed ones, last closed first. */
export interface TaskPage {
    tasks: Task[];
    cursor?: string;
}
/**
 * `GET /notifications/tasks/{merchant_id}/report` (`tasks:view_all`): the
 * store's tasks active in [`from`, `to`]: created before `to` and open, or
 * closed at or after `from`.
 */
export interface GetTaskReport {
    merchant_id: string;
    store_id: string;
    from: string;
    to: string;
    cursor?: string;
    assignee_id?: string;
    assignee_role_id?: string;
    created_by_id?: string;
    origin?: TaskOrigin;
    type?: TaskType;
    priority?: TaskPriority;
    status?: TaskStatus;
}
export interface TaskReportTotals {
    /** Created in the range. */
    created: number;
    /** Done in the range. */
    done: number;
    /** Open now. */
    open: number;
    /** Past their due date: still open, or closed after it. */
    overdue: number;
}
/** Pages of 50, newest created first; totals cover the whole selection. */
export interface TaskReport {
    tasks: Task[];
    totals: TaskReportTotals;
    cursor?: string;
    /** The selection was cut at its maximum: narrow the range. */
    truncated: boolean;
}

//help.loyverse.com/help/how-taxes-are-calculated
export enum TaxType {
    INCLUDED = 'INCLUDED',
    ADDED = 'ADDED'
}
/**
 * Tax interface
 * @interface
 * @name Tax
 * @property {string} id - The tax id
 * @property {TaxType} type - The tax type
 * @property {string} name - The tax name
 * @property {number} rate - The tax rate. For example, a value of "5.255" corresponds to a percentage of 5.255%
 * @property {string} merchant_id - The merchant id
 * @property {string} created_at - The created at timestamp
 * @property {string} updated_at - The updated at timestamp
 * @property {string} deleted_at - The deleted at timestamp
 * @example
 * {
 *  id: 'tax_id',
 * type: TaxType.INCLUDED,
 * name: 'tax_name',
 * rate: 0.1,
 * merchant_id: 'merchant_id',
 *
 */
export interface Tax extends Timestamps, Versioned {
    id: string;
    type: TaxType;
    name: string;
    rate: number;
    merchant_id: string;
}
/**
 * Tax page interface
 * @interface
 * @name TaxPage
 * @property {Tax[]} taxes - The tax list
 * @property {number} count - The tax count
 * @property {string} cursor - The cursor
 * @example
 * {
 *  taxes: [],
 * count: 0,
 * cursor: 'cursor',
 * }
 */
export interface TaxPage {
    taxes: Tax[];
    count: number;
    cursor?: string;
}
/**
 * Create tax interface
 * @interface
 * @name CreateTax
 * @property {string} name - The tax name
 * @property {TaxType} type - The tax type
 * @property {number} rate - The tax rate
 * @property {string} merchant_id - The merchant id
 * @example
 * {
 *  name: 'tax_name',
 * type: TaxType.INCLUDED,
 * rate: 0.1,
 * merchant_id: 'merchant_id',
 * }
 */
export interface CreateTax {
    name: string;
    type: TaxType;
    rate: number;
    merchant_id: string;
}
/**
 * Update tax interface
 * @interface
 * @name UpdateTax
 * @property {string} id - The tax id
 * @property {string} name - The tax name
 * @property {TaxType} type - The tax type
 * @property {number} rate - The tax rate
 * @property {string} merchant_id - The merchant id
 * @example
 * {
 *  id: 'tax_id',
 * name: 'tax_name',
 * type: TaxType.INCLUDED,
 * rate: 0.1,
 * merchant_id: 'merchant_id',
 * }
 */
export interface UpdateTax {
    id: string;
    name?: string;
    type?: TaxType;
    rate?: number;
    merchant_id: string;
}
/**
 * Tax DB item interface
 * @interface
 * @name TaxDBItem
 * @property {string} PK - The partition key
 * @property {string} SK - The sort key
 * @property {string} GSI1PK - The global secondary index 1 partition key
 * @property {string} GSI1SK - The global secondary index 1 sort key
 * @property {string} EntityIndexPK - The tax entity index partition key
 * @property {string} EntityIndexSK - The tax entity index sort key
 * @property {string} id - The tax id
 * @property {TaxType} type - The tax type
 * @property {string} name - The tax name
 * @property {number} rate - The tax rate
 * @property {string} merchant_id - The merchant id
 * @property {string} created_at - The created at timestamp
 * @property {string} updated_at - The updated at timestamp
 * @property {string} deleted_at - The deleted at timestamp
 * @example
 * {
 * PK: 'TAX#{tax_id}',
 * SK: 'TAX#{tax_id}',
 * GSI1PK: 'STORE#{merchant_id}',
 * GSI1SK: 'TAX#{tax_id}',
 * EntityIndexPK: 'TAX',
 * EntityIndexSK: 'STORE#{merchant_id}#DATE#{created_at}',
 * id: 'tax_id',
 * type: TaxType.INCLUDED,
 * name: 'tax_name',
 * rate: 0.1,
 * merchant_id: 'merchant_id',
 * created_at: 'timestamp',
 * updated_at: 'timestamp',
 * deleted_at: 'timestamp',
 * }
 */
export interface TaxDBItem extends Tax {
    PK: string;
    SK: string;
    GSI1PK: string;
    GSI1SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}
/**
 * Get tax by id interface
 * @interface
 * @name GetTaxById
 * @property {string} id - The tax id
 * @example
 * {
 * id: 'tax_id',
 * }
 */
export interface GetTaxById {
    id: string;
    include_deleted?: SoftDeleteFlag;
}
/**
 * Get taxes by merchant id interface
 * @interface
 * @name GetTaxesByStoreId
 * @property {string} merchant_id - The merchant id
 * @property {number} limit - The limit
 * @property {string} cursor - The cursor
 * @example
 * {
 * merchant_id: 'merchant_id',
 * limit: 10,
 * cursor: 'cursor',
 * }
 */
export interface GetTaxes {
    merchant_id: string;
    limit?: number;
    cursor?: string;
    include_deleted?: SoftDeleteFlag;
}
/**
 * Calculate tax commands
 * @enum
 * @name CalculateTaxCommands
 *
 */
export enum CalculateTaxCommands {
    ADDED_TO_THE_PRICE = 'ADDED_TO_THE_PRICE',
    INCLUDED_IN_THE_PRICE = 'INCLUDED_IN_THE_PRICE',
    MULTIPLE_ADDED_TO_THE_PRICE = 'MULTIPLE_ADDED_TO_THE_PRICE',
    MULTIPLE_INCLUDED_IN_THE_PRICE = 'MULTIPLE_INCLUDED_IN_THE_PRICE',
    ADDED_TO_THE_PRICE_WITH_INCLUDED = 'ADDED_TO_THE_PRICE_WITH_INCLUDED'
}
/**
 * Calculate tax interface
 * @interface
 * @name CalculateTax
 * @property {number} amount - The amount
 * @property {Tax[]} taxes - The tax list
 * @property {CalculateTaxCommands} command - The calculate tax command
 * @example
 * {
 * amount: 100,
 * taxes: [],
 * command: CalculateTaxCommands.ADDED,
 * }
 */
export interface CalculateTax {
    item_price: number;
    tax_ids: string[];
    added_tax_id: string;
    included_tax_ids: string[];
    command: CalculateTaxCommands;
}
export interface CalculateTaxResult {
    command: CalculateTaxCommands;
    item_price: number;
    tax_value: number | null; // Tax value for single added/included tax
    pre_tax_price: number | null; // Pre-tax price for included tax calculations
    total_tax: number | null; // Total tax value for multiple taxes (added/included)
    added_tax: number | null; // Added tax value for "added-with-included"
}

export interface WalletMessage {
    id: string;
    content: string;
    created_at: string;
    receiver_number: string;
}
export interface WalletMessageDBItem extends WalletMessage {
    PK: string;
    SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}
export interface GetWalletMessage {
    id: string;
}
export interface GetAllWalletMessages {
    by_date_range?: boolean;
    by_receiver_number?: boolean;
    start_date?: string;
    end_date?: string;
    receiver_number?: string;
    count?: number;
    cursor?: string;
}
export interface WalletMessagesPage {
    count?: number;
    cursor?: string;
    wallet_messages: WalletMessage[];
}
export enum MessageOperator {
    EMOLA = 'EMOLA',
    MPESA = 'MPESA',
    BIM = 'BIM',
    MTN = 'MTN',
    AIRTEL = 'AIRTEL',
    TIGO = 'TIGO',
    UNKNOWN = 'UNKNOWN'
}
/**
 * Two-letter prefix at the start of an e-Mola transaction ID.
 * Determines how the message body should be interpreted.
 */
export enum EmolaPrefix {
    PP = 'PP',// Person-to-Person transfer (IN or OUT)
    CI = 'CI',// Cash-In (IN: agent deposit, mPesa SIMO, BIM SIMO)
    CO = 'CO',// Cash-Out (OUT: SIMO transfer, agent withdrawal, utility, POS)
    BP = 'BP',// Bill Payment (OUT: Credelec, water, etc.)
    RC = 'RC',// Recharge (OUT: own airtime)
    TC = 'TC',// Transaction Cancelled / Reversal
    OT = 'OT',// POS withdrawal authorization token (non-financial)
    EM = 'EM'
}
/**
 * Fine-grained classification of a parsed transaction.
 */
export enum TxSubtype {
    P2P = 'P2P',
    AGENT_DEPOSIT = 'AGENT_DEPOSIT',
    BANK_FUNDED = 'BANK_FUNDED',
    SIMO_TO_MPESA = 'SIMO_TO_MPESA',
    SIMO_TO_BIM = 'SIMO_TO_BIM',
    AGENT_WITHDRAWAL = 'AGENT_WITHDRAWAL',
    UTILITY_PAYMENT = 'UTILITY_PAYMENT',
    POS_PAYMENT = 'POS_PAYMENT',
    CREDELEC = 'CREDELEC',
    WATER = 'WATER',
    AIRTIME_RECHARGE = 'AIRTIME_RECHARGE',
    REVERSAL = 'REVERSAL',
    POS_AUTHORIZATION = 'POS_AUTHORIZATION',
    BALANCE_SNAPSHOT = 'BALANCE_SNAPSHOT'
}
/**
 * Type of counterparty extracted from the SMS body.
 */
export enum CounterpartyType {
    MSISDN = 'MSISDN',
    AGENT = 'AGENT',
    BANK_ACCOUNT = 'BANK_ACCOUNT',
    MERCHANT = 'MERCHANT',
    METER = 'METER',
    SELF = 'SELF'
}
export enum TopupTransactionType {
    MONEY_IN = 'MONEY_IN',
    MONEY_OUT = 'MONEY_OUT'
}
export enum ClaimStatus {
    UNCLAIMED = 'UNCLAIMED',
    CLAIMED_AUTO = 'CLAIMED_AUTO',
    CLAIMED_MANUAL = 'CLAIMED_MANUAL',
    REVOKED = 'REVOKED',
    REJECTED = 'REJECTED',
    NEEDS_REVIEW = 'NEEDS_REVIEW'
}
export enum AssignmentSource {
    AUTOMATIC = 'AUTOMATIC',
    MANUAL = 'MANUAL',
    FALLBACK_DETAILS = 'FALLBACK_DETAILS',
    AI_EXTRACTED = 'AI_EXTRACTED'
}
export enum ClaimHistoryTypes {
    SUCCESS = 'SUCCESS',
    TRANSACTION_ID_NOT_FOUND = 'TRANSACTION_ID_NOT_FOUND',
    AMOUNT_NOT_EQUAL = 'AMOUNT_NOT_EQUAL',
    DATE_TOO_OLD = 'DATE_TOO_OLD',
    ALREADY_CLAIMED = 'ALREADY_CLAIMED',
    DATE_MISSING = 'DATE_MISSING',
    SUSPICIOUS_MISMATCH = 'SUSPICIOUS_MISMATCH',
    REVERSED = 'REVERSED',
    // Event-style entries appended by the claims/* use-cases.
    CLAIM_SUBMITTED = 'CLAIM_SUBMITTED',
    AUTO_CLAIM_SUCCESS = 'AUTO_CLAIM_SUCCESS',
    AUTO_CLAIM_FAILED = 'AUTO_CLAIM_FAILED',
    MANUAL_APPROVED = 'MANUAL_APPROVED',
    MANUAL_REJECTED = 'MANUAL_REJECTED',
    WALLET_CREDIT_SUCCESS = 'WALLET_CREDIT_SUCCESS',
    WALLET_CREDIT_FAILED = 'WALLET_CREDIT_FAILED',
    NEEDS_REVIEW = 'NEEDS_REVIEW',
    REVERSAL_DETECTED = 'REVERSAL_DETECTED',
    // AI extraction outcomes
    AI_EXTRACTION_FAILED = 'AI_EXTRACTION_FAILED',
    AI_NOT_A_TRANSACTION = 'AI_NOT_A_TRANSACTION',
    AI_GIBBERISH = 'AI_GIBBERISH',
    AI_UNRECOGNIZED_FORMAT = 'AI_UNRECOGNIZED_FORMAT',
    AI_TIMEOUT = 'AI_TIMEOUT',
    AI_AMOUNT_MISMATCH = 'AI_AMOUNT_MISMATCH',
    AI_PARSING_CORRECTED = 'AI_PARSING_CORRECTED',
    // Admin review actions
    MANUAL_REVOKED = 'MANUAL_REVOKED',
    REVOKE_FAILED = 'REVOKE_FAILED',
    REOPENED = 'REOPENED',
    CORRECTED = 'CORRECTED'
}
/**
 * How a `TopupRequest` was matched to a claim, recorded on the request when it
 * transitions from `UNCLAIMED`. Free-form for forward-compatibility.
 */
export enum TopupClaimMatchMethod {
    TRANSACTION_ID = 'TRANSACTION_ID',
    AMOUNT_AND_TIME = 'AMOUNT_AND_TIME',
    AMOUNT_TIME_AND_SENDER = 'AMOUNT_TIME_AND_SENDER',
    AMOUNT_TIME_AND_RECEIVER = 'AMOUNT_TIME_AND_RECEIVER',
    AMOUNT_TIME_AND_OPERATOR = 'AMOUNT_TIME_AND_OPERATOR',
    MANUAL_APPROVAL = 'MANUAL_APPROVAL'
}
export interface ClaimHistory {
    by: string;
    entity_type: EntityTypes;
    created_at: string;
    type: ClaimHistoryTypes;
    /** Free-form context for the history entry (error message, reviewer comment, …). */
    note?: string;
}
export interface TopupRequest {
    receiver_number: string;
    sender_contact: string;
    operator: MessageOperator;
    message_content: string;
    transaction_id: string;
    amount: number;
    transaction_type: TopupTransactionType;
    claim_status: ClaimStatus;
    claim_history: ClaimHistory[];
    created_at: string;
    /** Optional for backwards compatibility; missing on rows never updated. */
    updated_at?: string;
    /** Optional for backwards compatibility; missing = 0. */
    version?: number;
    /** Optional for backwards compatibility; missing on older rows. */
    updated_by_id?: string;
    /** Optional for backwards compatibility; missing on older rows. */
    updated_by_name?: string;
    assignment_source?: AssignmentSource;
    claimed_at?: string;
    merchant_id?: string;
    store_id?: string;
    claimed_by?: string;
    client_claim_text?: string;
    entity_type?: EntityTypes;
    wallet_balance?: number;
    /** Original transaction ID if this topup was reversed by a TC message. */
    reversed_by?: string;
    /** ISO date the reversal was applied. */
    reversed_at?: string;
    // ----- Wallet credit reference (populated once Wallets credits the merchant) -----
    /** Reference type sent to the Wallets API (always `topup_request`). */
    wallet_credit_reference_type?: string;
    /** Reference id sent to the Wallets API (always the `transaction_id`). */
    wallet_credit_reference_id?: string;
    /** Monotonic wallet transaction version returned by Wallets. */
    wallet_credit_transaction_version?: number;
    /** ISO date Wallets recorded the credit. */
    wallet_credit_created_at?: string;
    /** Wallet snapshot balance returned by Wallets after the credit. */
    wallet_credit_balance_after?: number;
    /** Last error message returned by the Wallets API when a credit attempt failed. */
    wallet_credit_error?: string;
    // ----- Claim matching / review attribution -----
    /** How the request was matched to the claim. */
    claim_match_method?: TopupClaimMatchMethod;
    /** Optional matcher score (0..1). Reserved for future scoring extensions. */
    claim_match_score?: number;
    /** Reason the request was placed in `NEEDS_REVIEW`. */
    claim_review_reason?: string;
    /** ISO date the request was put into manual review. */
    manual_review_requested_at?: string;
    // ----- Payment type used for the wallet credit -----
    /** The PaymentType.id used when crediting the wallet for this claim. */
    wallet_credit_payment_type_id?: string;
    /** The PaymentType.name snapshot used when crediting the wallet. */
    wallet_credit_payment_type_name?: string;
    /** The PaymentMethodType snapshot used when crediting the wallet. */
    wallet_credit_payment_type?: PaymentMethodType;
    /**
     * Merchant whose wallet a claim in progress is crediting, written before
     * the credit. Lets a claim that died mid-way be recovered against the
     * right wallet. Optional for backwards compatibility; missing on older rows.
     */
    claim_merchant_id?: string;
    // ----- Rejection attribution -----
    /** ISO date the request was rejected. */
    rejected_at?: string;
    /** Id of the principal that rejected the request. */
    rejected_by?: string;
    /** Operator-provided rejection reason. */
    rejection_reason?: string;
    // ----- Revocation attribution (optional; missing = never revoked) -----
    /** ISO date the claim was revoked and its wallet credit taken back. */
    revoked_at?: string;
    /** Id of the principal that revoked the claim. */
    revoked_by?: string;
    /** Operator-provided revocation reason. */
    revocation_reason?: string;
    // ----- Ledger details (optional; missing on rows created before IFTTT ingestion) -----
    /** Operator fee charged on this transaction. Missing = unknown (treat as 0). */
    fee?: number;
    /** Account balance reported by the SMS after this transaction. */
    balance_after?: number;
    /** Counterparty phone/account number reported by the SMS. */
    counterparty_number?: string;
    /** Counterparty display name reported by the SMS. */
    counterparty_name?: string;
    /** Free-text note ("Content: ...") typed by the sender. */
    content?: string;
    /** When the transaction happened (ISO UTC). Missing = use `created_at`. */
    occurred_at?: string;
    /** Where the SMS came from. Missing = SMS_READER (legacy app). */
    source?: TopupSource;
    /** IFTTT DeviceLabel of the phone that received the SMS. */
    device_label?: string;
}
/** Origin of a mobile-money SMS ingested by service-topups. */
export enum TopupSource {
    SMS_READER = 'SMS_READER',
    IFTTT = 'IFTTT'
}
/**
 * @deprecated Topups no longer issues wallet credits directly. Use the new
 * `claim-topup-by-*` / `approve-topup-claim` endpoints which call the Wallets
 * service via `ShopAndSmileAPIAdapter.addMoneyToWallet`.
 */
export interface TopupWallet {
    operator: MessageOperator;
    transaction_id?: string;
    amount: number;
    assignment_source: AssignmentSource;
    merchant_id: string;
    store_id: string;
    claimed_by: string;
    client_claim_text?: string;
    entity_type: EntityTypes;
    date?: string;
}
export interface TopupRequestDBItem extends TopupRequest {
    PK: string;
    SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
    // Namespaced GSI columns added to support claim-by-details matching.
    // Older rows may not have these columns; the repository falls back to
    // EntityIndex queries when they are absent.
    GSI1PK?: string; // TOPUP_AMOUNT#<amount>
    GSI1SK?: string; // DATE#<created_at>
    GSI2PK?: string; // TOPUP_RECEIVER#<receiver_number>
    GSI2SK?: string; // DATE#<created_at>
    GSI3PK?: string; // TOPUP_SENDER#<sender_contact>
    GSI3SK?: string; // DATE#<created_at>
}
export interface CreateTopupRequest {
    receiver_number: string; // phone number receiving the top-up, the number the Mobile Money is sent to
    sender_contact: string; // phone number/contact of the person/company sending the top-up message
    password: string; // admin password to authenticate the request
    message_content: string;
}
export interface GetTopupRequest {
    transaction_id: string;
}
export interface GetAllTopupRequests {
    by_claim_status?: boolean;
    by_merchant?: boolean;
    by_receiver_number?: boolean;
    by_operator?: boolean;
    by_date_range?: boolean;
    by_amount_range?: boolean;
    by_transaction_type?: boolean;
    by_sender_contact?: boolean;
    claim_status?: ClaimStatus;
    merchant_id?: string;
    receiver_number?: string;
    operator?: MessageOperator;
    start_date?: string;
    end_date?: string;
    start_amount?: number;
    end_amount?: number;
    transaction_type?: TopupTransactionType;
    sender_contact?: string;
    password?: string; // only when the phone number is provided
    /** Optional; filters on `store_id` (needs `by_store`). */
    by_store?: boolean;
    store_id?: string;
    /**
     * Optional; missing = false (oldest first, `count` rows read before the
     * filters). When true: newest first, and `count` is the number of matching
     * rows returned (fewer only at the end).
     */
    newest_first?: boolean;
    count?: number;
    cursor?: string;
}
export interface TopupRequestsPage {
    count?: number;
    cursor?: string;
    topup_requests: TopupRequest[];
}
export interface TopupPassword extends Versioned {
    current_password: string;
    updated_at: string;
    update_history: TopupPasswordUpdateHistory[];
    phone_number: string;
}
export interface TopupPasswordUpdateHistory {
    updated_at: string;
    old_password: string;
}
export interface TopupPasswordDBItem extends TopupPassword {
    SK: string; // TOPUP_PASSWORD
    PK: string; // TOPUP_NUMBER#phone_number
    EntityIndexPK: string; // TOPUP_PASSWORD
    EntityIndexSK: string; // DATE#updated_at
}
export interface UpdateTopupPassword {
    old_password: string;
    new_password: string;
    phone_number: string;
}
export enum WalletTransferDirection {
    IN = 'IN',
    OUT = 'OUT',
    NOISE = 'NOISE'
}
export interface WalletTransferOut {
    transaction_id: string;
    amount: number;
    recipient_number: string;
    recipient_name: string;
    fee: number;
    balance_after: number;
    message_content: string;
    receiver_number: string;
    created_at: string;
    /** Fine-grained OUT classification (missing on legacy rows). */
    subtype?: TxSubtype;
    /** Shape of the counterparty captured (missing on legacy rows). */
    counterparty_type?: CounterpartyType;
    /** Original transaction ID if this transfer was reversed by a TC message. */
    reversed_by?: string;
    /** ISO date the reversal was applied. */
    reversed_at?: string;
    /** Free-text note ("Content: ...") typed in the transfer. */
    content?: string;
    /** When the transaction happened (ISO UTC). Missing = use `created_at`. */
    occurred_at?: string;
    /** Where the SMS came from. Missing = SMS_READER (legacy app). */
    source?: TopupSource;
    /** Mobile-money operator. Missing = EMOLA (legacy rows). */
    operator?: MessageOperator;
}
export interface WalletTransferOutDBItem extends WalletTransferOut {
    PK: string;
    SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
    GSI1PK: string;
    GSI1SK: string;
    GSI2PK: string;
    GSI2SK: string;
    GSI3PK: string;
    GSI3SK: string;
}
export interface WalletGetTransferOut {
    transaction_id: string;
}
export interface WalletGetAllTransferOuts {
    by_recipient_number?: boolean;
    by_receiver_number?: boolean;
    by_amount?: boolean;
    by_date_range?: boolean;
    recipient_number?: string;
    receiver_number?: string;
    amount?: number;
    start_date?: string;
    end_date?: string;
    count?: number;
    cursor?: string;
}
export interface WalletTransferOutsPage {
    count?: number;
    cursor?: string;
    transfer_outs: WalletTransferOut[];
}
export interface WalletHandleSmsResponse {
    direction: WalletTransferDirection;
    topup_request: TopupRequest | null;
    transfer_out: WalletTransferOut | null;
    /** True when the message was recognized as OTP/promo/token/etc. */
    noise?: boolean;
    /** True when the message had a valid-looking ID but no body pattern matched. */
    unparsed?: boolean;
}
export enum TopupNumberStatus {
    ACTIVE = 'ACTIVE',
    /** Auto-created from an IFTTT SMS; the real phone number is not known yet. */
    PENDING_SETUP = 'PENDING_SETUP'
}
export interface TopupNumber extends Timestamps, Versioned {
    /**
     * The account number. For PENDING_SETUP numbers this is a synthetic key
     * `device:<device-label>:<operator>` until the real number is known.
     */
    phone_number: string;
    location: string;
    platform_payment_type_id: string;
    update_history: TopupNumberUpdateHistory;
    /** Mobile-money operator of this account. Optional for backwards compatibility. */
    operator?: MessageOperator;
    /** IFTTT DeviceLabel of the phone holding this SIM. Optional. */
    device_label?: string;
    /** Missing = ACTIVE (legacy rows). */
    status?: TopupNumberStatus;
    /** Set on a PENDING_SETUP number once promoted: the real phone number. */
    merged_into?: string;
}
export type TopupNumberUpdateHistory = {
    updated_at: string;
    phone_number: string;
    location: string;
    platform_payment_type_id?: string;
    operator?: MessageOperator;
    device_label?: string;
}[];
export interface TopupNumberDBItem extends TopupNumber {
    SK: string; // TOPUP_NUMBER#phone_number
    PK: string; // TOPUP_NUMBER
    EntityIndexPK: string; // TOPUP_NUMBER
    EntityIndexSK: string; // DATE#created_at
    GSI1PK?: string; // PLATFORM_PAYMENT_TYPE#{platform_payment_type_id}
    GSI1SK?: string; // DATE#created_at
}
export interface CreateTopupNumber {
    phone_number: string;
    location: string;
    password: string;
    /** The PlatformPaymentType.id this number belongs to. Required. */
    platform_payment_type_id: string;
    operator?: MessageOperator;
    /** IFTTT DeviceLabel of the phone holding this SIM (unique with operator). */
    device_label?: string;
}
export interface GetTopupNumber {
    phone_number: string;
}
export interface GetAllTopupNumbers {
    include_deleted?: SoftDeleteFlag;
    /** Filter by linked platform payment type. */
    by_platform_payment_type?: string;
    cursor?: string;
    limit?: number;
}
export interface TopupNumbersPage {
    numbers: TopupNumber[];
    count?: number;
    cursor?: string;
}
export enum UpdateTopupNumberCommand {
    UPDATE_LOCATION = 'UPDATE_LOCATION',
    UPDATE_PLATFORM_PAYMENT_TYPE = 'UPDATE_PLATFORM_PAYMENT_TYPE',
    /** Update `operator` and/or `device_label`. */
    UPDATE_DEVICE = 'UPDATE_DEVICE',
    DELETE = 'DELETE'
}
export interface UpdateTopupNumber {
    phone_number: string;
    location?: string;
    password: string;
    platform_payment_type_id?: string;
    operator?: MessageOperator;
    device_label?: string;
    command: UpdateTopupNumberCommand;
}
/**
 * Promote a PENDING_SETUP number (synthetic `device:...` key) to its real
 * phone number. Idempotent: re-running moves any rows still left behind.
 */
export interface PromoteTopupNumber {
    /** The synthetic `device:<label>:<operator>` key. */
    pending_phone_number: string;
    /** The real phone number (digits, national format). */
    phone_number: string;
    /** Password for the new real number (used by the SMS reader app). */
    password: string;
    location?: string;
}
/**
 * Merge a PENDING_SETUP number into an existing Top-up Number: its money
 * in, money out and SMS move there, their operator becomes the number's,
 * its phone is assigned to the number and it is hidden. Idempotent.
 */
export interface MergeTopupNumber {
    /** The synthetic `device:<label>:<operator>` key. */
    pending_phone_number: string;
    /** An existing Top-up Number. */
    phone_number: string;
    /** Count only (the default); false applies the merge. */
    dry_run?: boolean;
    /** Also give the number the pending number's platform payment type. */
    use_pending_payment_type?: boolean;
}
export interface TopupNumberMergeResult {
    dry_run: boolean;
    pending_phone_number: string;
    phone_number: string;
    /** The phone (IFTTT device) now assigned to the number. */
    device_label?: string;
    /** Rows of the pending number (moved, or to move). */
    topup_requests: number;
    transfer_outs: number;
    wallet_messages: number;
    /** Rows whose operator differs from the number's (corrected). */
    operator_corrections: number;
    operator?: MessageOperator;
    /** The payment type the number gets (when asked and different). */
    platform_payment_type_id?: string;
}
export enum TopupDeviceStatus {
    /** Seen, not assigned: its transaction SMS are held (not stored). */
    UNASSIGNED = 'UNASSIGNED',
    /** Every SMS it forwards goes to `phone_number`. */
    ASSIGNED = 'ASSIGNED'
}
/** A phone (IFTTT DeviceLabel) that forwards SMS, and its Top-up Number. */
export interface TopupDevice extends Versioned {
    /** Trimmed, lower-case label: the key. */
    device_key: string;
    /** The label as first seen. */
    device_label: string;
    status: TopupDeviceStatus;
    /** ASSIGNED: the Top-up Number every SMS of this phone goes to. */
    phone_number?: string;
    assigned_at?: string;
    assigned_by_name?: string;
    first_seen_at: string;
    last_seen_at: string;
    /** IFTTT message ids held while UNASSIGNED (replayed on assignment). */
    held_message_ids?: string[];
    /** A number one of the held SMS states (pre-selected when assigning). */
    suggested_phone_number?: string;
    /**
     * When the admins were alerted about the unassigned phone. Optional;
     * missing = not yet (each held SMS retries the alert until it is sent).
     */
    alerted_at?: string;
    created_at: string;
    updated_at: string;
}
export interface TopupDeviceDBItem extends TopupDevice {
    PK: string; // TOPUP_DEVICE#<device_key>
    SK: string; // TOPUP_DEVICE
    EntityIndexPK: string; // TOPUP_DEVICE
    EntityIndexSK: string; // DATE#<first_seen_at>
}
export interface TopupDevicesPage {
    devices: TopupDevice[];
}
/** Assign a phone to a Top-up Number (its future SMS go there). */
export interface AssignTopupDevice {
    device_label: string;
    phone_number: string;
}
/** Process an IFTTT-forwarded SMS (internal; used by the event consumer). */
export interface ProcessIftttSms {
    /** IftttSmsMessage.id — idempotency key for the raw message. */
    id: string;
    sender: string;
    sender_name?: string;
    message_content?: string;
    received_at?: string;
    device_name?: string;
    created_at: string;
}
export interface ProcessIftttSmsResult {
    /** IGNORED = not a mobile-money transaction. */
    /** HELD = the phone is not assigned to a Top-up Number yet. */
    outcome: 'CREATED' | 'DUPLICATE' | 'IGNORED' | 'NEEDS_REVIEW' | 'HELD';
    direction?: WalletTransferDirection;
    transaction_id?: string;
    receiver_number?: string;
}
/** One row of the per-number mobile-money ledger (money in + money out merged). */
export interface MobileMoneyLedgerEntry {
    transaction_id: string;
    receiver_number: string;
    direction: WalletTransferDirection.IN | WalletTransferDirection.OUT;
    operator?: MessageOperator;
    amount: number;
    fee: number;
    balance_after?: number;
    counterparty_number?: string;
    counterparty_name?: string;
    content?: string;
    message_content: string;
    /** ISO UTC. */
    occurred_at: string;
    created_at: string;
    subtype?: TxSubtype;
    reversed_by?: string;
    /** Money-in only. */
    claim_status?: ClaimStatus;
    merchant_id?: string;
    store_id?: string;
    claimed_at?: string;
    claimed_by?: string;
}
export interface GetMobileMoneyLedger {
    receiver_number: string;
    start_date?: string;
    end_date?: string;
    /** Max rows of each direction to read (default 200, max 1000). */
    limit?: number;
}
export interface MobileMoneyLedgerPage {
    entries: MobileMoneyLedgerEntry[];
    count: number;
}
export interface GetTopupNumberBalance {
    phone_number: string;
}
export interface ResetTopupPassword {
    phone_number: string;
}
export interface GetTopupsBalance {
    receiver_number: string;
    by_date_range?: boolean;
    start_date?: string;
    end_date?: string;
}
export interface GetTopupsBalanceResponse {
    total_in: number;
    total_out: number;
    calculated_balance: number;
    /** Latest balance reported by an SMS; falls back to `calculated_balance`. */
    real_balance: number;
    /** ISO time of the SMS that reported `real_balance`, when known. */
    real_balance_as_of?: string;
}
// ============================================================================
// Claim flow (new API exposed by service-topups)
// ============================================================================
/**
 * Direct claim by `transaction_id`. The caller knows the exact SMS-derived id
 * (typically copied from the customer's confirmation message).
 */
export interface ClaimTopupByTransactionId {
    transaction_id: string;
    merchant_id: string;
    store_id?: string;
    claimed_by: string;
    claimed_by_name?: string;
    entity_type: EntityTypes;
    /** Optional amount cross-check. Returns 422 when it mismatches the stored amount. */
    amount?: number;
    client_claim_text?: string;
    /**
     * The PaymentType.id to associate with the wallet credit.
     * Must belong to the merchant. Validated server-side before crediting.
     */
    payment_type_id: string;
}
/**
 * Fallback claim by amount + time window (+ optional narrowing fields) when the
 * customer cannot supply the `transaction_id`.
 */
export interface ClaimTopupByDetails {
    amount: number;
    transaction_time: string; // ISO
    merchant_id: string;
    store_id?: string;
    claimed_by: string;
    claimed_by_name?: string;
    entity_type: EntityTypes;
    /** Symmetric window in minutes around `transaction_time`. Default 30, max 120. */
    window_minutes?: number;
    sender_contact?: string;
    receiver_number?: string;
    operator?: MessageOperator;
    client_claim_text?: string;
    /**
     * The PaymentType.id to associate with the wallet credit.
     * Must belong to the merchant. Validated server-side before crediting.
     */
    payment_type_id: string;
}
/**
 * Claim a topup by pasting the original SMS message. The backend extracts
 * the transaction_id and amount (regex first, AI fallback), then delegates
 * to the standard claim-by-transaction-id flow.
 */
export interface ClaimTopupByMessage {
    /** The raw SMS message content to extract transaction details from. */
    message_content: string;
    merchant_id: string;
    store_id?: string;
    claimed_by: string;
    claimed_by_name?: string;
    entity_type: EntityTypes;
    client_claim_text?: string;
    /**
     * The PaymentType.id to associate with the wallet credit.
     * Must belong to the merchant. Validated server-side before crediting.
     */
    payment_type_id: string;
}
/**
 * Read-only matcher used by review UIs. Same selection logic as
 * `ClaimTopupByDetails` but never mutates and never calls the Wallets API.
 */
export interface FindTopupClaimMatches {
    amount: number;
    transaction_time: string;
    window_minutes?: number;
    sender_contact?: string;
    receiver_number?: string;
    operator?: MessageOperator;
    count?: number;
    cursor?: string;
}
export interface TopupClaimMatch {
    topup_request: TopupRequest;
    /** Human-readable reasons that led the matcher to surface this row. */
    reasons: string[];
}
export interface TopupClaimMatchesPage {
    matches: TopupClaimMatch[];
    count?: number;
    cursor?: string;
}
/** Manual review approval. Path-bound to the topup `transaction_id`. */
export interface ApproveTopupClaim {
    transaction_id: string;
    merchant_id: string;
    store_id?: string;
    approved_by: string;
    approved_by_name?: string;
    entity_type: EntityTypes;
    client_claim_text?: string;
    note?: string;
    /**
     * The PaymentType.id to associate with the wallet credit.
     * When not supplied the server reads it from the stored TopupRequest.
     */
    payment_type_id?: string;
}
/** Manual review rejection. Never calls the Wallets API. */
export interface RejectTopupClaim {
    transaction_id: string;
    rejected_by: string;
    entity_type: EntityTypes;
    reason: string;
    note?: string;
}
/**
 * Revoke a claimed topup: takes its credit back from the wallet it went to
 * (refused when that wallet no longer holds the amount) and marks it REVOKED.
 */
export interface RevokeTopupClaim {
    transaction_id: string;
    revoked_by: string;
    revoked_by_name?: string;
    entity_type: EntityTypes;
    reason: string;
    note?: string;
}
/** Put a REJECTED topup back to UNCLAIMED. Never calls the Wallets API. */
export interface ReopenTopupClaim {
    transaction_id: string;
    reopened_by: string;
    reopened_by_name?: string;
    entity_type: EntityTypes;
    note?: string;
}
/**
 * Correct what the SMS reader got wrong on an unclaimed, needs-review or
 * rejected topup. Only the fields sent change.
 */
export interface CorrectTopupRequest {
    transaction_id: string;
    corrected_by: string;
    corrected_by_name?: string;
    entity_type: EntityTypes;
    amount?: number;
    transaction_type?: TopupTransactionType;
    counterparty_name?: string;
    counterparty_number?: string;
    /** When the transaction happened (ISO UTC). */
    occurred_at?: string;
    content?: string;
    note?: string;
}
export interface GetTopupStatusCounts {
    merchant_id?: string;
    store_id?: string;
}
/** Number of topup requests per claim status. */
export interface TopupStatusCounts {
    counts: Record<ClaimStatus, number>;
    total: number;
}

export enum UserEvents {
    FIRST_MERCHANT_USER_CREATED = 'FIRST_MERCHANT_USER_CREATED'
}
export interface FirstMerchantUserCreatedEvent {
    bus_name: string;
    source: ShopAndSmileEventSource;
    detail_type: UserEvents.FIRST_MERCHANT_USER_CREATED;
    detail: FirstMerchantUserCreatedEventDetail;
}
interface FirstMerchantUserCreatedEventDetail {
    filter?: Record<string, any>;
    data: FirstMerchantUserCreatedEventDetailData;
    metadata: FirstMerchantUserCreatedEventDetailMetadata;
}
export interface FirstMerchantUserCreatedEventDetailData {
    user: Employee;
}
export interface FirstMerchantUserCreatedEventDetailMetadata extends ShopAndSmileEventMetadata {
}

export interface UserItem extends Employee {
    PK: string;
    SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
    GSI1PK: string;
    GSI1SK: string;
    GSI2PK: string;
    GSI2SK: string;
    GSI3PK?: string; // COGNITO_USER#{cognito_id}
    GSI3SK?: string; // COGNITO_USER#{cognito_id}
    GSI4PK?: string; // COGNITO_USERNAME#{cognito_username}
    GSI4SK?: string; // COGNITO_USERNAME#{cognito_username}
    PIN: string;
    /**
     * PBKDF2-SHA256 verifier of the PIN for offline sign-in on the POS
     * (docs/plans/offline-first-pos.md §3.3). Optional for backwards
     * compatibility; missing = derived lazily from `PIN` on the next
     * offline-credentials read.
     */
    pin_hash?: string;
    pin_salt?: string;
    pin_updated_at?: string;
}
/**
 * What a till keeps to verify an employee's PIN without the backend. The
 * plain PIN never leaves the server; the hash is PBKDF2-SHA256 with
 * `pin_salt` and `OFFLINE_PIN_HASH_ITERATIONS` rounds, hex encoded.
 */
export interface OfflineCredential {
    employee_id: string;
    /** What the POS calls the user (Cognito username); null on legacy rows. */
    cognito_id?: string | null;
    cognito_username?: string | null;
    name: string;
    username: string;
    phone_number: string;
    roles: string[];
    /** The stores the user may pick on the till, with their names. */
    stores: MerchantAuthStore[];
    merchant_id: string;
    is_owner: boolean;
    /** WhatsApp-OTP users sign in with their PIN while offline. */
    use_whatsapp_otp: boolean;
    pin_hash: string;
    pin_salt: string;
    pin_updated_at: string;
    /**
     * The ACTION permissions the employee holds in the till's store (e.g.
     * `pos:price.change`), checked on the till so they work offline. Set by
     * `GET /pos-devices/{merchant_id}/{id}/offline-credentials`. Optional for
     * backwards compatibility; missing = none.
     */
    actions?: string[];
}
export interface OfflineCredentialsResponse {
    credentials: OfflineCredential[];
    generated_at: string;
}
/** Query of the service-only `GET /users/offline-credentials`. */
export interface GetOfflineCredentials {
    merchant_id: string;
    /**
     * Optional for backwards compatibility; missing = every active employee
     * of the merchant (a till signs in anyone of the merchant offline).
     */
    store_id?: string;
}
export const OFFLINE_PIN_HASH_ITERATIONS = 100000;
export interface UpdateUserItem extends Partial<UserItem> {
    GSI1PK: string;
    GSI1SK: string;
    GSI2PK?: string;
    GSI2SK?: string;
    GSI3PK?: string;
    GSI3SK?: string;
    GSI4PK?: string;
    GSI4SK?: string;
    PIN: string;
}
export interface CreateUser {
    name: string;
    roles: string[];
    username: string;
    email: string;
    phone_number: string;
    PIN: string;
    stores: string[];
    merchant_id: string;
}
export type UpdateUser = Partial<Employee> & Partial<UpdateMerchantUserRequestBody> & {
    id: string;
    auth_type: AuthType;
    is_active?: boolean;
    PIN?: string;
    stores?: string[];
};
export interface MarkNumberVerified {
    is_number_verified: boolean;
}
/** Body of `PUT /users/{id}/language`. */
export interface UpdateUserLanguage {
    /** `null` clears the choice, so the merchant default applies. */
    language: UiLanguage | null;
}
/** `GET users/cognito/{cognito_id}?merchant_id=`: the employee behind a verified token. */
export interface GetUserByCognitoId {
    cognito_id: string;
    merchant_id: string;
}

export interface ListWalletTransactionsBase {
    cursor?: string;
    limit?: number;
    start_date?: string;
    end_date?: string;
}
export interface ListWalletTransactionsByCreator extends ListWalletTransactionsBase {
    created_by_type: EntityTypes;
    created_by_id: string;
}
export interface ListWalletTransactionsByReference extends ListWalletTransactionsBase {
    merchant_id: string;
    reference_type: string;
    reference_id: string;
}
export interface WalletSnapshotsByPaymentMethod {
    merchant_id: string;
    created_at: string;
    account_snapshots: WalletSnapshot[];
}
export enum WalletTransactionType {
    CREDIT = 'credit',
    DEBIT = 'debit'
}
export interface WalletTransaction {
    merchant_id: string;
    type: WalletTransactionType;
    amount: number;
    /** Opaque caller-defined namespace, e.g. 'topup', 'invoice', 'admin_adjustment'. */
    reference_type: string;
    /** Opaque caller-defined id within that namespace. */
    reference_id: string;
    reference_url?: string;
    /** Payment method snapshot at the time of the entry. */
    payment_method_id: string;
    payment_method_name: string;
    payment_method_type: PaymentMethodType;
    /** Currency code of the wallet at the time of the entry. */
    currency: string;
    /** Monotonic version assigned per (merchant, payment_type, payment_method) partition. */
    version: number;
    /** Authoring principal snapshot. */
    created_by_id: string;
    created_by_type: EntityTypes;
    created_by_name: string;
    /** Optional — when set, the transaction belongs to a specific store's sub-wallet. */
    store_id?: string;
    description: string;
    created_at: string;
    /** The topup receiver phone number, preserved for GSI queryability. */
    receiver_number?: string | number;
}
export interface WalletTransactionDBItem extends WalletTransaction {
    PK: string; // MERCHANT_WALLET_TRANSACTION#{merchant_id}#{payment_type}#{payment_method_id}
    SK: string; // MERCHANT_WALLET_TRANSACTION#{version padded16}
    GSI1PK: string; // MERCHANT_WALLET_TRANSACTION#{creator_type}#{creator_id}
    GSI1SK: string; // DATE#{created_at}
    GSI2PK: string; // MERCHANT_WALLET_TRANSACTION#{payment_type}#{payment_method_id}
    GSI2SK: string; // DATE#{created_at}
    GSI3PK: string; // MERCHANT_WALLET_TRANSACTION#{merchant_id}
    GSI3SK: string; // DATE#{created_at}
    GSI4PK: string; // MERCHANT_WALLET_TRANSACTION#{reference_type}#{reference_id}
    GSI4SK: string; // DATE#{created_at}
    GSI5PK?: string; // MERCHANT_WALLET_TRANSACTION#TOPUP_RECEIVER#{receiver_number}
    GSI5SK?: string; // DATE#{created_at}
    /** Platform wallet merchant+store index — set when a platform transaction references a store. */
    GSI6PK?: string; // PLATFORM#MERCHANT#{merchant_id}#STORE#{store_id}
    GSI6SK?: string; // DATE#{created_at}
    EntityIndexPK: string; // MERCHANT_WALLET_TRANSACTION
    EntityIndexSK: string; // MERCHANT#{merchant_id}#DATE#{created_at}
}
export interface WalletSnapshot extends Timestamps {
    merchant_id: string;
    balance: number;
    currency: string;
    payment_method_id: string;
    payment_method_name: string;
    payment_method_type: PaymentMethodType;
    version: number;
}
export interface WalletSnapshotDBItem extends WalletSnapshot {
    PK: string; // MERCHANT_WALLET_SNAPSHOT#MERCHANT#{merchant_id}#{payment_type}#{payment_method_id}
    SK: string; // MERCHANT_WALLET_SNAPSHOT#{version padded16}
    GSI1PK: string; // MERCHANT_WALLET_SNAPSHOT#MERCHANT#{merchant_id}#{payment_type}#{payment_method_id}
    GSI1SK: string; // DATE#{created_at}
    EntityIndexPK: string; // MERCHANT_WALLET_SNAPSHOT
    EntityIndexSK: string; // MERCHANT#{merchant_id}#{payment_type}#{payment_method_id}#DATE#{created_at}
}
export interface CreditWallet {
    amount: number;
    reference_type: string;
    reference_id: string;
    payment_method_id: string;
    payment_method_name: string;
    payment_method_type: PaymentMethodType;
    currency: string;
    created_by_id: string;
    created_by_type: EntityTypes;
    created_by_name: string;
    /** Optional — when set, the credit goes to the store's sub-wallet instead of the merchant wallet. */
    store_id?: string;
    description: string;
    /** The topup receiver phone number, preserved for GSI queryability. */
    receiver_number?: string | number;
}
export interface DebitWallet {
    amount: number;
    reference_type: string;
    reference_id: string;
    payment_method_id: string;
    payment_method_name: string;
    payment_method_type: PaymentMethodType;
    currency: string;
    created_by_id: string;
    created_by_type: EntityTypes;
    created_by_name: string;
    description: string;
}
export interface GetWalletTransaction {
    merchant_id: string;
    payment_method_id: string;
    payment_method_type: PaymentMethodType;
    count?: number;
    cursor?: string;
    /** Optional ISO start (inclusive) for time-range filter. */
    start_time?: string;
    /** Optional ISO end (inclusive) for time-range filter. */
    end_time?: string;
}
export interface WalletTransactionPage {
    transaction_rows: WalletTransaction[];
    count?: number;
    cursor?: string;
}
export interface CreditDebitResult {
    balance: number;
    transaction: WalletTransaction;
}
export interface GetWalletBalanceAt {
    merchant_id: string;
    payment_method_id: string;
    payment_method_type: PaymentMethodType;
    timestamp: string;
}
export interface WalletBalanceAtResult {
    balance: number;
    as_of: string;
    version: number;
}
export interface WalletTransactionsPage {
    items: WalletTransaction[];
    cursor?: string;
    count?: number;
}
// ============================================================================
// Store Wallet Types — per-store sub-wallets for billing/invoice payment
// ============================================================================
/** A wallet transaction scoped to a specific store within a merchant. */
export interface StoreWalletTransaction extends WalletTransaction {
    store_id: string;
}
/** A wallet snapshot scoped to a specific store within a merchant. */
export interface StoreWalletSnapshot extends WalletSnapshot {
    store_id: string;
}
/** DynamoDB item representation of a store wallet transaction. */
export interface StoreWalletTransactionDBItem extends StoreWalletTransaction {
    PK: string; // STORE_WALLET_TRANSACTION#{store_id}#{payment_type}#{payment_method_id}
    SK: string; // STORE_WALLET_TRANSACTION#{version padded16}
    GSI1PK: string; // STORE_WALLET_TRANSACTION#{creator_type}#{creator_id}
    GSI1SK: string; // DATE#{created_at}
    GSI2PK: string; // STORE_WALLET_TRANSACTION#{payment_type}#{payment_method_id}
    GSI2SK: string; // DATE#{created_at}
    GSI3PK: string; // STORE_WALLET_TRANSACTION#{reference_type}#{reference_id}
    GSI3SK: string; // DATE#{created_at}
    GSI4PK?: string; // STORE_WALLET_TRANSACTION#TOPUP_RECEIVER#{receiver_number}
    GSI4SK?: string; // DATE#{created_at}
    EntityIndexPK: string; // STORE_WALLET_TRANSACTION
    EntityIndexSK: string; // STORE#{store_id}#DATE#{created_at}
}
/** DynamoDB item representation of a store wallet snapshot. */
export interface StoreWalletSnapshotDBItem extends StoreWalletSnapshot {
    PK: string; // STORE_WALLET_SNAPSHOT#{store_id}#{payment_type}#{payment_method_id}
    SK: string; // STORE_WALLET_SNAPSHOT#{version padded16}
    GSI1PK: string; // STORE_WALLET_SNAPSHOT#{store_id}#{payment_type}#{payment_method_id}
    GSI1SK: string; // DATE#{created_at}
    EntityIndexPK: string; // STORE_WALLET_SNAPSHOT
    EntityIndexSK: string; // STORE#{store_id}#{payment_type}#{payment_method_id}#DATE#{created_at}
}
/** Payload for assigning funds from merchant wallet to a store wallet. */
export interface AssignFundsToStorePayload {
    merchant_id: string;
    store_id: string;
    amount: number;
    currency: string;
    payment_method_id: string;
    payment_method_name: string;
    payment_method_type: PaymentMethodType;
    created_by_id: string;
    created_by_type: EntityTypes;
    created_by_name: string;
    description?: string;
}
/** Payload for unassigning funds from a store wallet back to merchant wallet. */
export interface UnassignFundsFromStorePayload {
    merchant_id: string;
    store_id: string;
    amount: number;
    currency: string;
    payment_method_id: string;
    payment_method_name: string;
    payment_method_type: PaymentMethodType;
    created_by_id: string;
    created_by_type: EntityTypes;
    created_by_name: string;
    description?: string;
}
/** Result of an assign or unassign operation — both sides of the transfer. */
export interface AssignUnassignResult {
    /** The debit side of the transfer (source wallet transaction). */
    debit_transaction: WalletTransaction;
    /** The credit side of the transfer (destination wallet transaction). */
    credit_transaction: WalletTransaction;
    /** Balance of the source wallet after the debit. */
    source_balance: number;
    /** Balance of the destination wallet after the credit. */
    destination_balance: number;
}
/** Parameters for querying a store wallet balance. */
export interface GetStoreWalletBalanceParams {
    merchant_id: string;
    store_id: string;
    payment_method_type: PaymentMethodType;
    payment_method_id: string;
}
/** Result of a store wallet balance query. */
export interface StoreWalletBalance {
    store_id: string;
    merchant_id: string;
    balance: number;
    currency: string;
    payment_method_type: PaymentMethodType;
    payment_method_id: string;
    payment_method_name: string;
    version: number;
}
/** Parameters for listing all store wallets for a merchant. */
export interface ListStoreWalletsByMerchantParams {
    merchant_id: string;
    cursor?: string;
    limit?: number;
}
/** A page of store wallet balances. */
export interface StoreWalletsPage {
    items: StoreWalletBalance[];
    cursor?: string;
    count?: number;
}
/** Parameters for listing store wallet transactions by payment method. */
export interface ListStoreWalletTransactionsByPaymentMethodParams {
    merchant_id: string;
    store_id: string;
    payment_method_type: PaymentMethodType;
    payment_method_id: string;
    start_date?: string;
    end_date?: string;
    cursor?: string;
    limit?: number;
}
// ============================================================================
// Platform Wallet Types — shop-level wallet for invoice payments
// ============================================================================
/** Sentinel merchant ID for the platform wallet. Reuses existing wallet PK scheme. */
export const PLATFORM_MERCHANT_ID = 'platform-admin-id';
/** Parameters for listing platform wallet transactions with optional filters. */
export interface ListPlatformTransactionsParams {
    payment_method_type?: PaymentMethodType;
    payment_method_id?: string;
    /** Filter by the merchant whose store triggered the transaction. */
    merchant_id?: string;
    /** Filter by store that triggered the transaction. */
    store_id?: string;
    cursor?: string;
    limit?: number;
    start_date?: string;
    end_date?: string;
}
/** A page of platform wallet transactions. */
export interface PlatformTransactionsPage {
    items: WalletTransaction[];
    cursor?: string;
    count?: number;
}
/** Parameters for crediting the platform wallet. */
export interface CreditPlatformWalletParams {
    amount: number;
    currency: string;
    payment_method_id: string;
    payment_method_name: string;
    payment_method_type: PaymentMethodType;
    reference_type: string;
    reference_id: string;
    created_by_id: string;
    created_by_type: EntityTypes;
    created_by_name: string;
    description?: string;
}
/**
 * Parameters for debiting the platform wallet (platform expenses such as
 * agent salaries or transport). The platform wallet is an accounting ledger,
 * so a debit may take its balance below zero. Idempotent per
 * `reference_type` + `reference_id`.
 */
export interface DebitPlatformWalletParams {
    amount: number;
    currency: string;
    payment_method_id: string;
    payment_method_name: string;
    payment_method_type: PaymentMethodType;
    reference_type: string;
    reference_id: string;
    created_by_id: string;
    created_by_type: EntityTypes;
    created_by_name: string;
    description?: string;
}

/**
 * Stale is NOT a stored status. It is derived client-side / server-side as
 * `status === 'pending' && (now - created_at) > WEIGHTED_SALE_STALE_THRESHOLD_MS`.
 */
export enum WeightedSaleStatus {
    PENDING = 'pending',
    IN_CART = 'in_cart',
    SOLD = 'sold'
}
export enum WeightedSaleSource {
    /** Created from the in-POS product-quantity dialog after a sale is completed. */
    POS = 'pos',
    /** Created from the user pressing the "Sync" button on the Weighted Sales tab. */
    MANUAL = 'manual',
    /** Created from a passive scale push (TM-XA report) or background poll (TM-A). */
    AUTOMATIC = 'automatic',
    /** Created from a barcode/QR scan of a weighted product. */
    SCANNING = 'scanning'
}
export enum WeightedSaleScaleType {
    TM_A = 'tm_a',
    TM_XA = 'tm_xa',
    SCALE_MODE = 'scale_mode'
}
/** A pending/in-cart/sold weighted-product candidate tracked on the POS. */
export interface WeightedSale extends Versioned {
    // identity
    id: string;
    merchant_id: string;
    store_id: string;
    pos_device_id: string;
    created_at: string; // ISO-8601
    updated_at: string; // ISO-8601
    /** Set when the sale was deleted (soft delete). Missing on live rows. */
    deleted_at?: string;
    /** Who deleted it. Missing on live rows. */
    deleted_by_id?: string;
    deleted_by_name?: string;
    // product
    product_id: string;
    product_name: string;
    product_image_url?: string;
    plu?: string;
    original_barcode?: string;
    // measurement
    weight_kg: number;
    unit_price: number;
    total_price: number;
    // status
    status: WeightedSaleStatus;
    source: WeightedSaleSource;
    scale_type?: WeightedSaleScaleType;
    // sale linkage (filled by PATCH after the receipt is created)
    receipt_number?: string;
    custom_receipt_number?: string;
    receipt_item_id?: string;
    employee_id?: string;
    employee_name?: string;
    customer_id?: string;
    customer_name?: string;
    shift_id?: string;
    payment_method_ids?: string[];
    sold_at?: string;
    /** Externally-supplied dedupe key (e.g. TM-XA report id). */
    scale_report_id?: string;
}
/** DynamoDB shape stored in the POS table. */
export interface WeightedSaleDBItem extends WeightedSale {
    PK: string; // MERCHANT#<merchant_id>
    SK: string; // WEIGHTED_SALE#<id>#STORE#<store_id>#POS_DEVICE#<pos_device_id>
    EntityIndexPK: string; // WEIGHTED_SALE
    EntityIndexSK: string; // WEIGHTED_SALE#DATE#<created_at>
    GSI1PK: string; // POS_DEVICE#<pos_device_id>
    GSI1SK: string; // WEIGHTED_SALE#DATE#<created_at>
    GSI2PK?: string; // RECEIPT#<receipt_number>     — only when linked
    GSI2SK?: string; // WEIGHTED_SALE#<id>            — only when linked
    GSI3PK: string; // STORE#<store_id>#STATUS#<status>
    GSI3SK: string; // WEIGHTED_SALE#DATE#<created_at>
}
export interface WeightedSalesPage {
    items: WeightedSale[];
    cursor?: string;
    count: number;
}
export interface ListWeightedSalesQuery {
    merchant_id: string;
    pos_device_id: string;
    status?: WeightedSaleStatus;
    /** Inclusive ISO-8601 lower bound for `created_at`. */
    since?: string;
    cursor?: string;
    limit?: number;
}
export interface CreateWeightedSale {
    id: string;
    merchant_id: string;
    store_id: string;
    pos_device_id: string;
    created_at?: string;
    updated_at?: string;
    product_id: string;
    product_name: string;
    product_image_url?: string;
    plu?: string;
    original_barcode?: string;
    weight_kg: number;
    unit_price: number;
    total_price: number;
    status: WeightedSaleStatus;
    source: WeightedSaleSource;
    scale_type?: WeightedSaleScaleType;
    receipt_number?: string;
    custom_receipt_number?: string;
    receipt_item_id?: string;
    employee_id?: string;
    employee_name?: string;
    customer_id?: string;
    customer_name?: string;
    shift_id?: string;
    payment_method_ids?: string[];
    sold_at?: string;
    scale_report_id?: string;
}
/** Patch payload — id + merchant_id required, all other fields optional. */
export interface UpdateWeightedSale {
    id: string;
    merchant_id: string;
    status?: WeightedSaleStatus;
    receipt_number?: string;
    custom_receipt_number?: string;
    receipt_item_id?: string;
    employee_id?: string;
    employee_name?: string;
    customer_id?: string;
    customer_name?: string;
    shift_id?: string;
    payment_method_ids?: string[];
    sold_at?: string;
    product_image_url?: string;
    product_name?: string;
    unit_price?: number;
    total_price?: number;
    weight_kg?: number;
}
export interface BulkUpsertWeightedSales {
    merchant_id: string;
    items: CreateWeightedSale[];
}
export interface BulkUpsertWeightedSalesSkipped {
    id: string;
    reason: string;
}
export interface BulkUpsertWeightedSalesResult {
    created: string[];
    updated: string[];
    skipped: BulkUpsertWeightedSalesSkipped[];
}

/**
 * The one global switch for every WhatsApp message (service-notifications).
 * Off (or no record) = nothing is sent to Meta: OTPs fail with 503, users
 * sign in with their PIN and the apps show an outage banner.
 */
export interface WhatsappSettings extends Timestamps, Versioned {
    /** Always `WHATSAPP_SETTINGS`: there is one record. */
    id: string;
    enabled: boolean;
}
/** `GET /notifications/whatsapp/settings`: no record = disabled. */
export interface WhatsappSettingsResponse {
    enabled: boolean;
}
/** `PUT /notifications/whatsapp/settings` (admin session only). */
export interface UpdateWhatsappSettings {
    enabled: boolean;
}
export interface WhatsappSettingsDBItem extends WhatsappSettings {
    PK: string;
    SK: string;
    EntityIndexPK: string;
    EntityIndexSK: string;
}